import { CanceledError } from 'axios';
import { generateRemoteUrl } from '@nextcloud/router';
import { getCurrentUser } from '@nextcloud/auth';
import axios from '@nextcloud/axios';
import PCancelable from 'p-cancelable';
import PQueue from 'p-queue';
import crypto from 'crypto-browserify';
import PLimit from 'p-limit';
import { getLoggerBuilder } from '@nextcloud/logger';
import { getNewFileMenuEntries } from '@nextcloud/files';
import { sanitizeSVG } from '@skjnldsv/sanitize-svg';

(function() {
    const env = {"TRANSLATIONS":[{"locale":"af","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Afrikaans (https://www.transifex.com/nextcloud/teams/64236/af/)","Content-Type":"text/plain; charset=UTF-8","Language":"af","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Afrikaans (https://www.transifex.com/nextcloud/teams/64236/af/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: af\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ar","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Arabic (https://www.transifex.com/nextcloud/teams/64236/ar/)","Content-Type":"text/plain; charset=UTF-8","Language":"ar","Plural-Forms":"nplurals=6; plural=n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 && n%100<=99 ? 4 : 5;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Arabic (https://www.transifex.com/nextcloud/teams/64236/ar/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ar\nPlural-Forms: nplurals=6; plural=n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 && n%100<=99 ? 4 : 5;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ar_SA","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Arabic (Saudi Arabia) (https://www.transifex.com/nextcloud/teams/64236/ar_SA/)","Content-Type":"text/plain; charset=UTF-8","Language":"ar_SA","Plural-Forms":"nplurals=6; plural=(n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 && n%100<=99 ? 4 : 5);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Arabic (Saudi Arabia) (https://www.transifex.com/nextcloud/teams/64236/ar_SA/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ar_SA\nPlural-Forms: nplurals=6; plural=(n==0 ? 0 : n==1 ? 1 : n==2 ? 2 : n%100>=3 && n%100<=10 ? 3 : n%100>=11 && n%100<=99 ? 4 : 5);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ast","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Asturian (https://www.transifex.com/nextcloud/teams/64236/ast/)","Content-Type":"text/plain; charset=UTF-8","Language":"ast","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Asturian (https://www.transifex.com/nextcloud/teams/64236/ast/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ast\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"az","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Azerbaijani (https://www.transifex.com/nextcloud/teams/64236/az/)","Content-Type":"text/plain; charset=UTF-8","Language":"az","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Azerbaijani (https://www.transifex.com/nextcloud/teams/64236/az/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: az\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"be","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Belarusian (https://www.transifex.com/nextcloud/teams/64236/be/)","Content-Type":"text/plain; charset=UTF-8","Language":"be","Plural-Forms":"nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Belarusian (https://www.transifex.com/nextcloud/teams/64236/be/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: be\nPlural-Forms: nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"bg_BG","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Bulgarian (Bulgaria) (https://www.transifex.com/nextcloud/teams/64236/bg_BG/)","Content-Type":"text/plain; charset=UTF-8","Language":"bg_BG","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Bulgarian (Bulgaria) (https://www.transifex.com/nextcloud/teams/64236/bg_BG/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: bg_BG\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"bn_BD","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Bengali (Bangladesh) (https://www.transifex.com/nextcloud/teams/64236/bn_BD/)","Content-Type":"text/plain; charset=UTF-8","Language":"bn_BD","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Bengali (Bangladesh) (https://www.transifex.com/nextcloud/teams/64236/bn_BD/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: bn_BD\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"br","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Breton (https://www.transifex.com/nextcloud/teams/64236/br/)","Content-Type":"text/plain; charset=UTF-8","Language":"br","Plural-Forms":"nplurals=5; plural=((n%10 == 1) && (n%100 != 11) && (n%100 !=71) && (n%100 !=91) ? 0 :(n%10 == 2) && (n%100 != 12) && (n%100 !=72) && (n%100 !=92) ? 1 :(n%10 ==3 || n%10==4 || n%10==9) && (n%100 < 10 || n% 100 > 19) && (n%100 < 70 || n%100 > 79) && (n%100 < 90 || n%100 > 99) ? 2 :(n != 0 && n % 1000000 == 0) ? 3 : 4);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Breton (https://www.transifex.com/nextcloud/teams/64236/br/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: br\nPlural-Forms: nplurals=5; plural=((n%10 == 1) && (n%100 != 11) && (n%100 !=71) && (n%100 !=91) ? 0 :(n%10 == 2) && (n%100 != 12) && (n%100 !=72) && (n%100 !=92) ? 1 :(n%10 ==3 || n%10==4 || n%10==9) && (n%100 < 10 || n% 100 > 19) && (n%100 < 70 || n%100 > 79) && (n%100 < 90 || n%100 > 99) ? 2 :(n != 0 && n % 1000000 == 0) ? 3 : 4);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"bs","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Bosnian (https://www.transifex.com/nextcloud/teams/64236/bs/)","Content-Type":"text/plain; charset=UTF-8","Language":"bs","Plural-Forms":"nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Bosnian (https://www.transifex.com/nextcloud/teams/64236/bs/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: bs\nPlural-Forms: nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ca","json":{"charset":"utf-8","headers":{"Last-Translator":"Toni Hermoso Pulido <toniher@softcatala.cat>, 2022","Language-Team":"Catalan (https://www.transifex.com/nextcloud/teams/64236/ca/)","Content-Type":"text/plain; charset=UTF-8","Language":"ca","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nMarc Riera <marcriera@softcatala.org>, 2022\nToni Hermoso Pulido <toniher@softcatala.cat>, 2022\n"},"msgstr":["Last-Translator: Toni Hermoso Pulido <toniher@softcatala.cat>, 2022\nLanguage-Team: Catalan (https://www.transifex.com/nextcloud/teams/64236/ca/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ca\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["Queden {seconds} segons"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["Queden {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["Queden uns segons"]},"Add":{"msgid":"Add","msgstr":["Afegeix"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Cancel·la les pujades"]},"estimating time left":{"msgid":"estimating time left","msgstr":["S'està estimant el temps restant"]},"paused":{"msgid":"paused","msgstr":["En pausa"]},"Upload files":{"msgid":"Upload files","msgstr":["Puja els fitxers"]}}}}},{"locale":"cs","json":{"charset":"utf-8","headers":{"Last-Translator":"Pavel Borecki <pavel.borecki@gmail.com>, 2022","Language-Team":"Czech (https://www.transifex.com/nextcloud/teams/64236/cs/)","Content-Type":"text/plain; charset=UTF-8","Language":"cs","Plural-Forms":"nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nPavel Borecki <pavel.borecki@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Pavel Borecki <pavel.borecki@gmail.com>, 2022\nLanguage-Team: Czech (https://www.transifex.com/nextcloud/teams/64236/cs/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: cs\nPlural-Forms: nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["zbývá {seconds}"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["zbývá {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["zbývá několik sekund"]},"Add":{"msgid":"Add","msgstr":["Přidat"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Zrušit nahrávání"]},"estimating time left":{"msgid":"estimating time left","msgstr":["odhadovaný zbývající čas"]},"paused":{"msgid":"paused","msgstr":["pozastaveno"]}}}}},{"locale":"cs_CZ","json":{"charset":"utf-8","headers":{"Last-Translator":"Pavel Borecki <pavel.borecki@gmail.com>, 2022","Language-Team":"Czech (Czech Republic) (https://www.transifex.com/nextcloud/teams/64236/cs_CZ/)","Content-Type":"text/plain; charset=UTF-8","Language":"cs_CZ","Plural-Forms":"nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nPavel Borecki <pavel.borecki@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Pavel Borecki <pavel.borecki@gmail.com>, 2022\nLanguage-Team: Czech (Czech Republic) (https://www.transifex.com/nextcloud/teams/64236/cs_CZ/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: cs_CZ\nPlural-Forms: nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n >= 2 && n <= 4 && n % 1 == 0) ? 1: (n % 1 != 0 ) ? 2 : 3;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["zbývá {seconds}"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["zbývá {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["zbývá několik sekund"]},"Add":{"msgid":"Add","msgstr":["Přidat"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Zrušit nahrávání"]},"estimating time left":{"msgid":"estimating time left","msgstr":["odhadovaný zbývající čas"]},"paused":{"msgid":"paused","msgstr":["pozastaveno"]},"Upload files":{"msgid":"Upload files","msgstr":["Nahrát soubory"]}}}}},{"locale":"cy_GB","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Welsh (United Kingdom) (https://www.transifex.com/nextcloud/teams/64236/cy_GB/)","Content-Type":"text/plain; charset=UTF-8","Language":"cy_GB","Plural-Forms":"nplurals=4; plural=(n==1) ? 0 : (n==2) ? 1 : (n != 8 && n != 11) ? 2 : 3;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Welsh (United Kingdom) (https://www.transifex.com/nextcloud/teams/64236/cy_GB/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: cy_GB\nPlural-Forms: nplurals=4; plural=(n==1) ? 0 : (n==2) ? 1 : (n != 8 && n != 11) ? 2 : 3;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"da","json":{"charset":"utf-8","headers":{"Last-Translator":"Henrik Dunch, 2022","Language-Team":"Danish (https://www.transifex.com/nextcloud/teams/64236/da/)","Content-Type":"text/plain; charset=UTF-8","Language":"da","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nHenrik Dunch, 2022\n"},"msgstr":["Last-Translator: Henrik Dunch, 2022\nLanguage-Team: Danish (https://www.transifex.com/nextcloud/teams/64236/da/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: da\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{sekunder} sekunder tilbage"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{tid} tilbage"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["et par sekunder tilbage"]},"Add":{"msgid":"Add","msgstr":["Tilføj"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Annuller uploads"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimering af resterende tid"]},"paused":{"msgid":"paused","msgstr":["pauset"]},"Upload files":{"msgid":"Upload files","msgstr":["Upload filer"]}}}}},{"locale":"de","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"German (https://www.transifex.com/nextcloud/teams/64236/de/)","Content-Type":"text/plain; charset=UTF-8","Language":"de","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: German (https://www.transifex.com/nextcloud/teams/64236/de/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: de\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"de_DE","json":{"charset":"utf-8","headers":{"Last-Translator":"Mario Siegmann <mario_siegmann@web.de>, 2022","Language-Team":"German (Germany) (https://www.transifex.com/nextcloud/teams/64236/de_DE/)","Content-Type":"text/plain; charset=UTF-8","Language":"de_DE","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nMario Siegmann <mario_siegmann@web.de>, 2022\n"},"msgstr":["Last-Translator: Mario Siegmann <mario_siegmann@web.de>, 2022\nLanguage-Team: German (Germany) (https://www.transifex.com/nextcloud/teams/64236/de_DE/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: de_DE\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} Sekunden verbleibend"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} verbleibend"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["ein paar Sekunden verbleibend"]},"Add":{"msgid":"Add","msgstr":["Hinzufügen"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Hochladen abbrechen"]},"estimating time left":{"msgid":"estimating time left","msgstr":["Geschätzte verbleibende Zeit"]},"paused":{"msgid":"paused","msgstr":["Pausiert"]},"Upload files":{"msgid":"Upload files","msgstr":["Dateien hochladen"]}}}}},{"locale":"el","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Greek (https://www.transifex.com/nextcloud/teams/64236/el/)","Content-Type":"text/plain; charset=UTF-8","Language":"el","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Greek (https://www.transifex.com/nextcloud/teams/64236/el/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: el\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"el_GR","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Greek (Greece) (https://www.transifex.com/nextcloud/teams/64236/el_GR/)","Content-Type":"text/plain; charset=UTF-8","Language":"el_GR","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Greek (Greece) (https://www.transifex.com/nextcloud/teams/64236/el_GR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: el_GR\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"en_GB","json":{"charset":"utf-8","headers":{"Last-Translator":"Andi Chandler <andi@gowling.com>, 2022","Language-Team":"English (United Kingdom) (https://www.transifex.com/nextcloud/teams/64236/en_GB/)","Content-Type":"text/plain; charset=UTF-8","Language":"en_GB","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nAndi Chandler <andi@gowling.com>, 2022\n"},"msgstr":["Last-Translator: Andi Chandler <andi@gowling.com>, 2022\nLanguage-Team: English (United Kingdom) (https://www.transifex.com/nextcloud/teams/64236/en_GB/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: en_GB\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} seconds left"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} left"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["a few seconds left"]},"Add":{"msgid":"Add","msgstr":["Add"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Cancel uploads"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimating time left"]},"paused":{"msgid":"paused","msgstr":["paused"]},"Upload files":{"msgid":"Upload files","msgstr":["Upload files"]}}}}},{"locale":"eo","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Esperanto (https://www.transifex.com/nextcloud/teams/64236/eo/)","Content-Type":"text/plain; charset=UTF-8","Language":"eo","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Esperanto (https://www.transifex.com/nextcloud/teams/64236/eo/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: eo\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es","json":{"charset":"utf-8","headers":{"Last-Translator":"Next Cloud <nextcloud.translator.es@cgj.es>, 2022","Language-Team":"Spanish (https://www.transifex.com/nextcloud/teams/64236/es/)","Content-Type":"text/plain; charset=UTF-8","Language":"es","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nFlorin Baras, 2022\nHecbert Gonzalez, 2022\nNext Cloud <nextcloud.translator.es@cgj.es>, 2022\n"},"msgstr":["Last-Translator: Next Cloud <nextcloud.translator.es@cgj.es>, 2022\nLanguage-Team: Spanish (https://www.transifex.com/nextcloud/teams/64236/es/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} segundos restantes"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} restante"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["quedan unos segundos"]},"Add":{"msgid":"Add","msgstr":["Añadir"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Cancelar subidas"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimación del tiempo restante"]},"paused":{"msgid":"paused","msgstr":["pausado"]},"Upload files":{"msgid":"Upload files","msgstr":["Subir archivos"]}}}}},{"locale":"es_419","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Latin America) (https://www.transifex.com/nextcloud/teams/64236/es_419/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_419","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Latin America) (https://www.transifex.com/nextcloud/teams/64236/es_419/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_419\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_AR","json":{"charset":"utf-8","headers":{"Last-Translator":"Matias Iglesias, 2022","Language-Team":"Spanish (Argentina) (https://www.transifex.com/nextcloud/teams/64236/es_AR/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_AR","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nMatias Iglesias, 2022\n"},"msgstr":["Last-Translator: Matias Iglesias, 2022\nLanguage-Team: Spanish (Argentina) (https://www.transifex.com/nextcloud/teams/64236/es_AR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_AR\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} segundos restantes"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} restante"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["quedan unos segundos"]},"Add":{"msgid":"Add","msgstr":["Añadir"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Cancelar subidas"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimando tiempo restante"]},"paused":{"msgid":"paused","msgstr":["pausado"]},"Upload files":{"msgid":"Upload files","msgstr":["Subir archivos"]}}}}},{"locale":"es_CL","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Chile) (https://www.transifex.com/nextcloud/teams/64236/es_CL/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_CL","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Chile) (https://www.transifex.com/nextcloud/teams/64236/es_CL/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_CL\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_CO","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Colombia) (https://www.transifex.com/nextcloud/teams/64236/es_CO/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_CO","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Colombia) (https://www.transifex.com/nextcloud/teams/64236/es_CO/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_CO\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_CR","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Costa Rica) (https://www.transifex.com/nextcloud/teams/64236/es_CR/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_CR","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Costa Rica) (https://www.transifex.com/nextcloud/teams/64236/es_CR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_CR\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_DO","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Dominican Republic) (https://www.transifex.com/nextcloud/teams/64236/es_DO/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_DO","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Dominican Republic) (https://www.transifex.com/nextcloud/teams/64236/es_DO/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_DO\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_EC","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Ecuador) (https://www.transifex.com/nextcloud/teams/64236/es_EC/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_EC","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Ecuador) (https://www.transifex.com/nextcloud/teams/64236/es_EC/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_EC\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_GT","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Guatemala) (https://www.transifex.com/nextcloud/teams/64236/es_GT/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_GT","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Guatemala) (https://www.transifex.com/nextcloud/teams/64236/es_GT/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_GT\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_HN","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Honduras) (https://www.transifex.com/nextcloud/teams/64236/es_HN/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_HN","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Honduras) (https://www.transifex.com/nextcloud/teams/64236/es_HN/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_HN\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_MX","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Mexico) (https://www.transifex.com/nextcloud/teams/64236/es_MX/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_MX","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Mexico) (https://www.transifex.com/nextcloud/teams/64236/es_MX/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_MX\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_NI","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Nicaragua) (https://www.transifex.com/nextcloud/teams/64236/es_NI/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_NI","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Nicaragua) (https://www.transifex.com/nextcloud/teams/64236/es_NI/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_NI\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_PA","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Panama) (https://www.transifex.com/nextcloud/teams/64236/es_PA/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_PA","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Panama) (https://www.transifex.com/nextcloud/teams/64236/es_PA/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_PA\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_PE","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Peru) (https://www.transifex.com/nextcloud/teams/64236/es_PE/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_PE","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Peru) (https://www.transifex.com/nextcloud/teams/64236/es_PE/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_PE\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_PR","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Puerto Rico) (https://www.transifex.com/nextcloud/teams/64236/es_PR/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_PR","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Puerto Rico) (https://www.transifex.com/nextcloud/teams/64236/es_PR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_PR\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_PY","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Paraguay) (https://www.transifex.com/nextcloud/teams/64236/es_PY/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_PY","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Paraguay) (https://www.transifex.com/nextcloud/teams/64236/es_PY/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_PY\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_SV","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (El Salvador) (https://www.transifex.com/nextcloud/teams/64236/es_SV/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_SV","Plural-Forms":"nplurals=2; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (El Salvador) (https://www.transifex.com/nextcloud/teams/64236/es_SV/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_SV\nPlural-Forms: nplurals=2; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"es_UY","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Spanish (Uruguay) (https://www.transifex.com/nextcloud/teams/64236/es_UY/)","Content-Type":"text/plain; charset=UTF-8","Language":"es_UY","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Spanish (Uruguay) (https://www.transifex.com/nextcloud/teams/64236/es_UY/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: es_UY\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"et_EE","json":{"charset":"utf-8","headers":{"Last-Translator":"Mait R, 2022","Language-Team":"Estonian (Estonia) (https://www.transifex.com/nextcloud/teams/64236/et_EE/)","Content-Type":"text/plain; charset=UTF-8","Language":"et_EE","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nMait R, 2022\n"},"msgstr":["Last-Translator: Mait R, 2022\nLanguage-Team: Estonian (Estonia) (https://www.transifex.com/nextcloud/teams/64236/et_EE/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: et_EE\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} jäänud sekundid"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} aega jäänud"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["jäänud mõni sekund"]},"Add":{"msgid":"Add","msgstr":["Lisa"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Tühista üleslaadimine"]},"estimating time left":{"msgid":"estimating time left","msgstr":["hinnanguline järelejäänud aeg"]},"paused":{"msgid":"paused","msgstr":["pausil"]}}}}},{"locale":"eu","json":{"charset":"utf-8","headers":{"Last-Translator":"Unai Tolosa Pontesta <utolosa002@gmail.com>, 2022","Language-Team":"Basque (https://www.transifex.com/nextcloud/teams/64236/eu/)","Content-Type":"text/plain; charset=UTF-8","Language":"eu","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nUnai Tolosa Pontesta <utolosa002@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Unai Tolosa Pontesta <utolosa002@gmail.com>, 2022\nLanguage-Team: Basque (https://www.transifex.com/nextcloud/teams/64236/eu/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: eu\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} segundo geratzen dira"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} geratzen da"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["segundo batzuk geratzen dira"]},"Add":{"msgid":"Add","msgstr":["Gehitu"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Ezeztatu igoerak"]},"estimating time left":{"msgid":"estimating time left","msgstr":["kalkulatutako geratzen den denbora"]},"paused":{"msgid":"paused","msgstr":["geldituta"]},"Upload files":{"msgid":"Upload files","msgstr":["Igo fitxategiak"]}}}}},{"locale":"fa","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Persian (https://www.transifex.com/nextcloud/teams/64236/fa/)","Content-Type":"text/plain; charset=UTF-8","Language":"fa","Plural-Forms":"nplurals=2; plural=(n > 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Persian (https://www.transifex.com/nextcloud/teams/64236/fa/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fa\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"fi_FI","json":{"charset":"utf-8","headers":{"Last-Translator":"Jiri Grönroos <jiri.gronroos@iki.fi>, 2022","Language-Team":"Finnish (Finland) (https://www.transifex.com/nextcloud/teams/64236/fi_FI/)","Content-Type":"text/plain; charset=UTF-8","Language":"fi_FI","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nJiri Grönroos <jiri.gronroos@iki.fi>, 2022\n"},"msgstr":["Last-Translator: Jiri Grönroos <jiri.gronroos@iki.fi>, 2022\nLanguage-Team: Finnish (Finland) (https://www.transifex.com/nextcloud/teams/64236/fi_FI/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fi_FI\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} sekuntia jäljellä"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} jäljellä"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["muutama sekunti jäljellä"]},"Add":{"msgid":"Add","msgstr":["Lisää"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Peruuta lähetykset"]},"estimating time left":{"msgid":"estimating time left","msgstr":["arvioidaan jäljellä olevaa aikaa"]},"paused":{"msgid":"paused","msgstr":["keskeytetty"]},"Upload files":{"msgid":"Upload files","msgstr":["Lähetä tiedostoja"]}}}}},{"locale":"fo","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Faroese (https://www.transifex.com/nextcloud/teams/64236/fo/)","Content-Type":"text/plain; charset=UTF-8","Language":"fo","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Faroese (https://www.transifex.com/nextcloud/teams/64236/fo/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fo\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"fr","json":{"charset":"utf-8","headers":{"Last-Translator":"John Molakvoæ <skjnldsv@protonmail.com>, 2022","Language-Team":"French (https://www.transifex.com/nextcloud/teams/64236/fr/)","Content-Type":"text/plain; charset=UTF-8","Language":"fr","Plural-Forms":"nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nJohn Molakvoæ <skjnldsv@protonmail.com>, 2022\n"},"msgstr":["Last-Translator: John Molakvoæ <skjnldsv@protonmail.com>, 2022\nLanguage-Team: French (https://www.transifex.com/nextcloud/teams/64236/fr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: fr\nPlural-Forms: nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} secondes restantes"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} restant"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["quelques secondes restantes"]},"Add":{"msgid":"Add","msgstr":["Ajouter"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Annuler les envois"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimation du temps restant"]},"paused":{"msgid":"paused","msgstr":["en pause"]}}}}},{"locale":"gd","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Gaelic, Scottish (https://www.transifex.com/nextcloud/teams/64236/gd/)","Content-Type":"text/plain; charset=UTF-8","Language":"gd","Plural-Forms":"nplurals=4; plural=(n==1 || n==11) ? 0 : (n==2 || n==12) ? 1 : (n > 2 && n < 20) ? 2 : 3;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Gaelic, Scottish (https://www.transifex.com/nextcloud/teams/64236/gd/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: gd\nPlural-Forms: nplurals=4; plural=(n==1 || n==11) ? 0 : (n==2 || n==12) ? 1 : (n > 2 && n < 20) ? 2 : 3;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"gl","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Galician (https://www.transifex.com/nextcloud/teams/64236/gl/)","Content-Type":"text/plain; charset=UTF-8","Language":"gl","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Galician (https://www.transifex.com/nextcloud/teams/64236/gl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: gl\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"he","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Hebrew (https://www.transifex.com/nextcloud/teams/64236/he/)","Content-Type":"text/plain; charset=UTF-8","Language":"he","Plural-Forms":"nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n == 2 && n % 1 == 0) ? 1: (n % 10 == 0 && n % 1 == 0 && n > 10) ? 2 : 3;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Hebrew (https://www.transifex.com/nextcloud/teams/64236/he/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: he\nPlural-Forms: nplurals=4; plural=(n == 1 && n % 1 == 0) ? 0 : (n == 2 && n % 1 == 0) ? 1: (n % 10 == 0 && n % 1 == 0 && n > 10) ? 2 : 3;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"hi_IN","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Hindi (India) (https://www.transifex.com/nextcloud/teams/64236/hi_IN/)","Content-Type":"text/plain; charset=UTF-8","Language":"hi_IN","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Hindi (India) (https://www.transifex.com/nextcloud/teams/64236/hi_IN/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hi_IN\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"hr","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Croatian (https://www.transifex.com/nextcloud/teams/64236/hr/)","Content-Type":"text/plain; charset=UTF-8","Language":"hr","Plural-Forms":"nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Croatian (https://www.transifex.com/nextcloud/teams/64236/hr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hr\nPlural-Forms: nplurals=3; plural=n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"hsb","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Upper Sorbian (https://www.transifex.com/nextcloud/teams/64236/hsb/)","Content-Type":"text/plain; charset=UTF-8","Language":"hsb","Plural-Forms":"nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Upper Sorbian (https://www.transifex.com/nextcloud/teams/64236/hsb/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hsb\nPlural-Forms: nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"hu","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Hungarian (https://www.transifex.com/nextcloud/teams/64236/hu/)","Content-Type":"text/plain; charset=UTF-8","Language":"hu","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Hungarian (https://www.transifex.com/nextcloud/teams/64236/hu/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hu\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"hu_HU","json":{"charset":"utf-8","headers":{"Last-Translator":"Balázs Meskó <meskobalazs@mailbox.org>, 2022","Language-Team":"Hungarian (Hungary) (https://www.transifex.com/nextcloud/teams/64236/hu_HU/)","Content-Type":"text/plain; charset=UTF-8","Language":"hu_HU","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nBalázs Meskó <meskobalazs@mailbox.org>, 2022\n"},"msgstr":["Last-Translator: Balázs Meskó <meskobalazs@mailbox.org>, 2022\nLanguage-Team: Hungarian (Hungary) (https://www.transifex.com/nextcloud/teams/64236/hu_HU/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hu_HU\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{} másodperc van hátra"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} van hátra"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["pár másodperc van hátra"]},"Add":{"msgid":"Add","msgstr":["Hozzáadás"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Feltöltések megszakítása"]},"estimating time left":{"msgid":"estimating time left","msgstr":["hátralévő idő becslése"]},"paused":{"msgid":"paused","msgstr":["szüneteltetve"]}}}}},{"locale":"hy","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Armenian (https://www.transifex.com/nextcloud/teams/64236/hy/)","Content-Type":"text/plain; charset=UTF-8","Language":"hy","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Armenian (https://www.transifex.com/nextcloud/teams/64236/hy/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: hy\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ia","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Interlingua (https://www.transifex.com/nextcloud/teams/64236/ia/)","Content-Type":"text/plain; charset=UTF-8","Language":"ia","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Interlingua (https://www.transifex.com/nextcloud/teams/64236/ia/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ia\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"id","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Indonesian (https://www.transifex.com/nextcloud/teams/64236/id/)","Content-Type":"text/plain; charset=UTF-8","Language":"id","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Indonesian (https://www.transifex.com/nextcloud/teams/64236/id/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: id\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ig","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Igbo (https://www.transifex.com/nextcloud/teams/64236/ig/)","Content-Type":"text/plain; charset=UTF-8","Language":"ig","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Igbo (https://www.transifex.com/nextcloud/teams/64236/ig/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ig\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"is","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Icelandic (https://www.transifex.com/nextcloud/teams/64236/is/)","Content-Type":"text/plain; charset=UTF-8","Language":"is","Plural-Forms":"nplurals=2; plural=(n % 10 != 1 || n % 100 == 11);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Icelandic (https://www.transifex.com/nextcloud/teams/64236/is/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: is\nPlural-Forms: nplurals=2; plural=(n % 10 != 1 || n % 100 == 11);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"it","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Italian (https://www.transifex.com/nextcloud/teams/64236/it/)","Content-Type":"text/plain; charset=UTF-8","Language":"it","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Italian (https://www.transifex.com/nextcloud/teams/64236/it/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: it\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"it_IT","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Italian (Italy) (https://www.transifex.com/nextcloud/teams/64236/it_IT/)","Content-Type":"text/plain; charset=UTF-8","Language":"it_IT","Plural-Forms":"nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Italian (Italy) (https://www.transifex.com/nextcloud/teams/64236/it_IT/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: it_IT\nPlural-Forms: nplurals=3; plural=n == 1 ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ja_JP","json":{"charset":"utf-8","headers":{"Last-Translator":"かたかめ, 2022","Language-Team":"Japanese (Japan) (https://www.transifex.com/nextcloud/teams/64236/ja_JP/)","Content-Type":"text/plain; charset=UTF-8","Language":"ja_JP","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nT.S, 2022\nかたかめ, 2022\n"},"msgstr":["Last-Translator: かたかめ, 2022\nLanguage-Team: Japanese (Japan) (https://www.transifex.com/nextcloud/teams/64236/ja_JP/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ja_JP\nPlural-Forms: nplurals=1; plural=0;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["残り {seconds} 秒"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["残り {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["残り数秒"]},"Add":{"msgid":"Add","msgstr":["追加"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["アップロードをキャンセル"]},"estimating time left":{"msgid":"estimating time left","msgstr":["概算残り時間"]},"paused":{"msgid":"paused","msgstr":["一時停止中"]},"Upload files":{"msgid":"Upload files","msgstr":["ファイルをアップデート"]}}}}},{"locale":"ka","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Georgian (https://www.transifex.com/nextcloud/teams/64236/ka/)","Content-Type":"text/plain; charset=UTF-8","Language":"ka","Plural-Forms":"nplurals=2; plural=(n!=1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Georgian (https://www.transifex.com/nextcloud/teams/64236/ka/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ka\nPlural-Forms: nplurals=2; plural=(n!=1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ka_GE","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Georgian (Georgia) (https://www.transifex.com/nextcloud/teams/64236/ka_GE/)","Content-Type":"text/plain; charset=UTF-8","Language":"ka_GE","Plural-Forms":"nplurals=2; plural=(n!=1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Georgian (Georgia) (https://www.transifex.com/nextcloud/teams/64236/ka_GE/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ka_GE\nPlural-Forms: nplurals=2; plural=(n!=1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"kab","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Kabyle (https://www.transifex.com/nextcloud/teams/64236/kab/)","Content-Type":"text/plain; charset=UTF-8","Language":"kab","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Kabyle (https://www.transifex.com/nextcloud/teams/64236/kab/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: kab\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"kk","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Kazakh (https://www.transifex.com/nextcloud/teams/64236/kk/)","Content-Type":"text/plain; charset=UTF-8","Language":"kk","Plural-Forms":"nplurals=2; plural=(n!=1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Kazakh (https://www.transifex.com/nextcloud/teams/64236/kk/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: kk\nPlural-Forms: nplurals=2; plural=(n!=1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"km","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Khmer (https://www.transifex.com/nextcloud/teams/64236/km/)","Content-Type":"text/plain; charset=UTF-8","Language":"km","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Khmer (https://www.transifex.com/nextcloud/teams/64236/km/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: km\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"kn","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Kannada (https://www.transifex.com/nextcloud/teams/64236/kn/)","Content-Type":"text/plain; charset=UTF-8","Language":"kn","Plural-Forms":"nplurals=2; plural=(n > 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Kannada (https://www.transifex.com/nextcloud/teams/64236/kn/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: kn\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ko","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Korean (https://www.transifex.com/nextcloud/teams/64236/ko/)","Content-Type":"text/plain; charset=UTF-8","Language":"ko","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Korean (https://www.transifex.com/nextcloud/teams/64236/ko/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ko\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"la","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Latin (https://www.transifex.com/nextcloud/teams/64236/la/)","Content-Type":"text/plain; charset=UTF-8","Language":"la","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Latin (https://www.transifex.com/nextcloud/teams/64236/la/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: la\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"lb","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Luxembourgish (https://www.transifex.com/nextcloud/teams/64236/lb/)","Content-Type":"text/plain; charset=UTF-8","Language":"lb","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Luxembourgish (https://www.transifex.com/nextcloud/teams/64236/lb/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: lb\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"lo","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Lao (https://www.transifex.com/nextcloud/teams/64236/lo/)","Content-Type":"text/plain; charset=UTF-8","Language":"lo","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Lao (https://www.transifex.com/nextcloud/teams/64236/lo/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: lo\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"lt_LT","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Lithuanian (Lithuania) (https://www.transifex.com/nextcloud/teams/64236/lt_LT/)","Content-Type":"text/plain; charset=UTF-8","Language":"lt_LT","Plural-Forms":"nplurals=4; plural=(n % 10 == 1 && (n % 100 > 19 || n % 100 < 11) ? 0 : (n % 10 >= 2 && n % 10 <=9) && (n % 100 > 19 || n % 100 < 11) ? 1 : n % 1 != 0 ? 2: 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Lithuanian (Lithuania) (https://www.transifex.com/nextcloud/teams/64236/lt_LT/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: lt_LT\nPlural-Forms: nplurals=4; plural=(n % 10 == 1 && (n % 100 > 19 || n % 100 < 11) ? 0 : (n % 10 >= 2 && n % 10 <=9) && (n % 100 > 19 || n % 100 < 11) ? 1 : n % 1 != 0 ? 2: 3);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"lv","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Latvian (https://www.transifex.com/nextcloud/teams/64236/lv/)","Content-Type":"text/plain; charset=UTF-8","Language":"lv","Plural-Forms":"nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n != 0 ? 1 : 2);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Latvian (https://www.transifex.com/nextcloud/teams/64236/lv/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: lv\nPlural-Forms: nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n != 0 ? 1 : 2);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"mk","json":{"charset":"utf-8","headers":{"Last-Translator":"Сашко Тодоров <sasetodorov@gmail.com>, 2022","Language-Team":"Macedonian (https://www.transifex.com/nextcloud/teams/64236/mk/)","Content-Type":"text/plain; charset=UTF-8","Language":"mk","Plural-Forms":"nplurals=2; plural=(n % 10 == 1 && n % 100 != 11) ? 0 : 1;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nСашко Тодоров <sasetodorov@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Сашко Тодоров <sasetodorov@gmail.com>, 2022\nLanguage-Team: Macedonian (https://www.transifex.com/nextcloud/teams/64236/mk/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: mk\nPlural-Forms: nplurals=2; plural=(n % 10 == 1 && n % 100 != 11) ? 0 : 1;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["преостануваат {seconds} секунди"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["преостанува {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["уште неколку секунди"]},"Add":{"msgid":"Add","msgstr":["Додади"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Прекини прикачување"]},"estimating time left":{"msgid":"estimating time left","msgstr":["приближно преостанато време"]},"paused":{"msgid":"paused","msgstr":["паузирано"]},"Upload files":{"msgid":"Upload files","msgstr":["Прикачување датотеки"]}}}}},{"locale":"mn","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Mongolian (https://www.transifex.com/nextcloud/teams/64236/mn/)","Content-Type":"text/plain; charset=UTF-8","Language":"mn","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Mongolian (https://www.transifex.com/nextcloud/teams/64236/mn/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: mn\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"mr","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Marathi (https://www.transifex.com/nextcloud/teams/64236/mr/)","Content-Type":"text/plain; charset=UTF-8","Language":"mr","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Marathi (https://www.transifex.com/nextcloud/teams/64236/mr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: mr\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ms_MY","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Malay (Malaysia) (https://www.transifex.com/nextcloud/teams/64236/ms_MY/)","Content-Type":"text/plain; charset=UTF-8","Language":"ms_MY","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Malay (Malaysia) (https://www.transifex.com/nextcloud/teams/64236/ms_MY/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ms_MY\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"my","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Burmese (https://www.transifex.com/nextcloud/teams/64236/my/)","Content-Type":"text/plain; charset=UTF-8","Language":"my","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Burmese (https://www.transifex.com/nextcloud/teams/64236/my/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: my\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"nb_NO","json":{"charset":"utf-8","headers":{"Last-Translator":"Ari Selseng <ari@selseng.net>, 2022","Language-Team":"Norwegian Bokmål (Norway) (https://www.transifex.com/nextcloud/teams/64236/nb_NO/)","Content-Type":"text/plain; charset=UTF-8","Language":"nb_NO","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nAri Selseng <ari@selseng.net>, 2022\n"},"msgstr":["Last-Translator: Ari Selseng <ari@selseng.net>, 2022\nLanguage-Team: Norwegian Bokmål (Norway) (https://www.transifex.com/nextcloud/teams/64236/nb_NO/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: nb_NO\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} sekunder igjen"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} igjen"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["noen få sekunder igjen"]},"Add":{"msgid":"Add","msgstr":["Legg til"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Avbryt opplastninger"]},"estimating time left":{"msgid":"estimating time left","msgstr":["Estimerer tid igjen"]},"paused":{"msgid":"paused","msgstr":["pauset"]},"Upload files":{"msgid":"Upload files","msgstr":["Last opp filer"]}}}}},{"locale":"ne","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Nepali (https://www.transifex.com/nextcloud/teams/64236/ne/)","Content-Type":"text/plain; charset=UTF-8","Language":"ne","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Nepali (https://www.transifex.com/nextcloud/teams/64236/ne/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ne\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"nl","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Dutch (https://www.transifex.com/nextcloud/teams/64236/nl/)","Content-Type":"text/plain; charset=UTF-8","Language":"nl","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Dutch (https://www.transifex.com/nextcloud/teams/64236/nl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: nl\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"nn","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Norwegian Nynorsk (https://www.transifex.com/nextcloud/teams/64236/nn/)","Content-Type":"text/plain; charset=UTF-8","Language":"nn","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Norwegian Nynorsk (https://www.transifex.com/nextcloud/teams/64236/nn/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: nn\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"nn_NO","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Norwegian Nynorsk (Norway) (https://www.transifex.com/nextcloud/teams/64236/nn_NO/)","Content-Type":"text/plain; charset=UTF-8","Language":"nn_NO","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Norwegian Nynorsk (Norway) (https://www.transifex.com/nextcloud/teams/64236/nn_NO/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: nn_NO\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"oc","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Occitan (post 1500) (https://www.transifex.com/nextcloud/teams/64236/oc/)","Content-Type":"text/plain; charset=UTF-8","Language":"oc","Plural-Forms":"nplurals=2; plural=(n > 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Occitan (post 1500) (https://www.transifex.com/nextcloud/teams/64236/oc/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: oc\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"pl","json":{"charset":"utf-8","headers":{"Last-Translator":"Valdnet, 2022","Language-Team":"Polish (https://www.transifex.com/nextcloud/teams/64236/pl/)","Content-Type":"text/plain; charset=UTF-8","Language":"pl","Plural-Forms":"nplurals=4; plural=(n==1 ? 0 : (n%10>=2 && n%10<=4) && (n%100<12 || n%100>14) ? 1 : n!=1 && (n%10>=0 && n%10<=1) || (n%10>=5 && n%10<=9) || (n%100>=12 && n%100<=14) ? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nValdnet, 2022\n"},"msgstr":["Last-Translator: Valdnet, 2022\nLanguage-Team: Polish (https://www.transifex.com/nextcloud/teams/64236/pl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: pl\nPlural-Forms: nplurals=4; plural=(n==1 ? 0 : (n%10>=2 && n%10<=4) && (n%100<12 || n%100>14) ? 1 : n!=1 && (n%10>=0 && n%10<=1) || (n%10>=5 && n%10<=9) || (n%100>=12 && n%100<=14) ? 2 : 3);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["Pozostało {seconds} sekund"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["Pozostało {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["Pozostało kilka sekund"]},"Add":{"msgid":"Add","msgstr":["Dodaj"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Anuluj wysyłanie"]},"estimating time left":{"msgid":"estimating time left","msgstr":["Szacowanie pozostałego czasu"]},"paused":{"msgid":"paused","msgstr":["Wstrzymane"]},"Upload files":{"msgid":"Upload files","msgstr":["Wyślij pliki"]}}}}},{"locale":"ps","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Pashto (https://www.transifex.com/nextcloud/teams/64236/ps/)","Content-Type":"text/plain; charset=UTF-8","Language":"ps","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Pashto (https://www.transifex.com/nextcloud/teams/64236/ps/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ps\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"pt_BR","json":{"charset":"utf-8","headers":{"Last-Translator":"Flávio Veras <flaviove@gmail.com>, 2022","Language-Team":"Portuguese (Brazil) (https://www.transifex.com/nextcloud/teams/64236/pt_BR/)","Content-Type":"text/plain; charset=UTF-8","Language":"pt_BR","Plural-Forms":"nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nLeonardo Colman <leonardo.dev@colman.com.br>, 2022\nJeann Cavalcante <wjeann@gmail.com>, 2022\nFlávio Veras <flaviove@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Flávio Veras <flaviove@gmail.com>, 2022\nLanguage-Team: Portuguese (Brazil) (https://www.transifex.com/nextcloud/teams/64236/pt_BR/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: pt_BR\nPlural-Forms: nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} segundos restantes"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} restante"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["alguns segundos restantes"]},"Add":{"msgid":"Add","msgstr":["Adicionar"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Cancelar uploads"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimando tempo restante"]},"paused":{"msgid":"paused","msgstr":["pausado"]},"Upload files":{"msgid":"Upload files","msgstr":["Enviar arquivos"]}}}}},{"locale":"pt_PT","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Portuguese (Portugal) (https://www.transifex.com/nextcloud/teams/64236/pt_PT/)","Content-Type":"text/plain; charset=UTF-8","Language":"pt_PT","Plural-Forms":"nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Portuguese (Portugal) (https://www.transifex.com/nextcloud/teams/64236/pt_PT/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: pt_PT\nPlural-Forms: nplurals=3; plural=(n == 0 || n == 1) ? 0 : n != 0 && n % 1000000 == 0 ? 1 : 2;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ro","json":{"charset":"utf-8","headers":{"Last-Translator":"Mădălin Vasiliu <contact@madalinvasiliu.com>, 2022","Language-Team":"Romanian (https://www.transifex.com/nextcloud/teams/64236/ro/)","Content-Type":"text/plain; charset=UTF-8","Language":"ro","Plural-Forms":"nplurals=3; plural=(n==1?0:(((n%100>19)||((n%100==0)&&(n!=0)))?2:1));"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nMădălin Vasiliu <contact@madalinvasiliu.com>, 2022\n"},"msgstr":["Last-Translator: Mădălin Vasiliu <contact@madalinvasiliu.com>, 2022\nLanguage-Team: Romanian (https://www.transifex.com/nextcloud/teams/64236/ro/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ro\nPlural-Forms: nplurals=3; plural=(n==1?0:(((n%100>19)||((n%100==0)&&(n!=0)))?2:1));\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} secunde rămase"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} rămas"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["câteva secunde rămase"]},"Add":{"msgid":"Add","msgstr":["Adaugă"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Anulați încărcările"]},"estimating time left":{"msgid":"estimating time left","msgstr":["estimarea timpului rămas"]},"paused":{"msgid":"paused","msgstr":["pus pe pauză"]},"Upload files":{"msgid":"Upload files","msgstr":["Încarcă fișiere"]}}}}},{"locale":"ru","json":{"charset":"utf-8","headers":{"Last-Translator":"Тёма Лапин, 2022","Language-Team":"Russian (https://www.transifex.com/nextcloud/teams/64236/ru/)","Content-Type":"text/plain; charset=UTF-8","Language":"ru","Plural-Forms":"nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nАлексей Хрусталёв, 2022\nТёма Лапин, 2022\n"},"msgstr":["Last-Translator: Тёма Лапин, 2022\nLanguage-Team: Russian (https://www.transifex.com/nextcloud/teams/64236/ru/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ru\nPlural-Forms: nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["осталось {seconds} секунд"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["осталось {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["осталось несколько секунд"]},"Add":{"msgid":"Add","msgstr":["Добавить"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Отменить загрузки"]},"estimating time left":{"msgid":"estimating time left","msgstr":["Оценка оставшегося времени"]},"paused":{"msgid":"paused","msgstr":["Приостановлено"]},"Upload files":{"msgid":"Upload files","msgstr":["Загрузка файлов"]}}}}},{"locale":"ru_RU","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Russian (Russia) (https://www.transifex.com/nextcloud/teams/64236/ru_RU/)","Content-Type":"text/plain; charset=UTF-8","Language":"ru_RU","Plural-Forms":"nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Russian (Russia) (https://www.transifex.com/nextcloud/teams/64236/ru_RU/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ru_RU\nPlural-Forms: nplurals=4; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<12 || n%100>14) ? 1 : n%10==0 || (n%10>=5 && n%10<=9) || (n%100>=11 && n%100<=14)? 2 : 3);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sc","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Sardinian (https://www.transifex.com/nextcloud/teams/64236/sc/)","Content-Type":"text/plain; charset=UTF-8","Language":"sc","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Sardinian (https://www.transifex.com/nextcloud/teams/64236/sc/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sc\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"si","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Sinhala (https://www.transifex.com/nextcloud/teams/64236/si/)","Content-Type":"text/plain; charset=UTF-8","Language":"si","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Sinhala (https://www.transifex.com/nextcloud/teams/64236/si/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: si\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"si_LK","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Sinhala (Sri Lanka) (https://www.transifex.com/nextcloud/teams/64236/si_LK/)","Content-Type":"text/plain; charset=UTF-8","Language":"si_LK","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Sinhala (Sri Lanka) (https://www.transifex.com/nextcloud/teams/64236/si_LK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: si_LK\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sk_SK","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Slovak (Slovakia) (https://www.transifex.com/nextcloud/teams/64236/sk_SK/)","Content-Type":"text/plain; charset=UTF-8","Language":"sk_SK","Plural-Forms":"nplurals=4; plural=(n % 1 == 0 && n == 1 ? 0 : n % 1 == 0 && n >= 2 && n <= 4 ? 1 : n % 1 != 0 ? 2: 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Slovak (Slovakia) (https://www.transifex.com/nextcloud/teams/64236/sk_SK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sk_SK\nPlural-Forms: nplurals=4; plural=(n % 1 == 0 && n == 1 ? 0 : n % 1 == 0 && n >= 2 && n <= 4 ? 1 : n % 1 != 0 ? 2: 3);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sl","json":{"charset":"utf-8","headers":{"Last-Translator":"Matej Urbančič <>, 2022","Language-Team":"Slovenian (https://www.transifex.com/nextcloud/teams/64236/sl/)","Content-Type":"text/plain; charset=UTF-8","Language":"sl","Plural-Forms":"nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nMatej Urbančič <>, 2022\n"},"msgstr":["Last-Translator: Matej Urbančič <>, 2022\nLanguage-Team: Slovenian (https://www.transifex.com/nextcloud/teams/64236/sl/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sl\nPlural-Forms: nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["še {seconds} sekund"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["še {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["še nekaj sekund"]},"Add":{"msgid":"Add","msgstr":["Dodaj"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Prekliči pošiljanje"]},"estimating time left":{"msgid":"estimating time left","msgstr":["ocenjen čas do konca"]},"paused":{"msgid":"paused","msgstr":["v premoru"]},"Upload files":{"msgid":"Upload files","msgstr":["Pošlji datoteke"]}}}}},{"locale":"sl_SI","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Slovenian (Slovenia) (https://www.transifex.com/nextcloud/teams/64236/sl_SI/)","Content-Type":"text/plain; charset=UTF-8","Language":"sl_SI","Plural-Forms":"nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Slovenian (Slovenia) (https://www.transifex.com/nextcloud/teams/64236/sl_SI/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sl_SI\nPlural-Forms: nplurals=4; plural=(n%100==1 ? 0 : n%100==2 ? 1 : n%100==3 || n%100==4 ? 2 : 3);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sq","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Albanian (https://www.transifex.com/nextcloud/teams/64236/sq/)","Content-Type":"text/plain; charset=UTF-8","Language":"sq","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Albanian (https://www.transifex.com/nextcloud/teams/64236/sq/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sq\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sr","json":{"charset":"utf-8","headers":{"Last-Translator":"aleksandar jevtic, 2022","Language-Team":"Serbian (https://www.transifex.com/nextcloud/teams/64236/sr/)","Content-Type":"text/plain; charset=UTF-8","Language":"sr","Plural-Forms":"nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\naleksandar jevtic, 2022\n"},"msgstr":["Last-Translator: aleksandar jevtic, 2022\nLanguage-Team: Serbian (https://www.transifex.com/nextcloud/teams/64236/sr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sr\nPlural-Forms: nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} sekundi preostalo"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} preostalo"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["preostalo je nekoliko sekundi"]},"Add":{"msgid":"Add","msgstr":["Dodaj"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Obustavi otpremanja"]},"estimating time left":{"msgid":"estimating time left","msgstr":["procena preostalog vremena"]},"paused":{"msgid":"paused","msgstr":["pauziran"]},"Upload files":{"msgid":"Upload files","msgstr":["Otpremi fajlove"]}}}}},{"locale":"sr@latin","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Serbian (Latin) (https://www.transifex.com/nextcloud/teams/64236/sr@latin/)","Content-Type":"text/plain; charset=UTF-8","Language":"sr@latin","Plural-Forms":"nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Serbian (Latin) (https://www.transifex.com/nextcloud/teams/64236/sr@latin/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sr@latin\nPlural-Forms: nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sv","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Swedish (https://www.transifex.com/nextcloud/teams/64236/sv/)","Content-Type":"text/plain; charset=UTF-8","Language":"sv","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Swedish (https://www.transifex.com/nextcloud/teams/64236/sv/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sv\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"sw","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Swahili (https://www.transifex.com/nextcloud/teams/64236/sw/)","Content-Type":"text/plain; charset=UTF-8","Language":"sw","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Swahili (https://www.transifex.com/nextcloud/teams/64236/sw/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: sw\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ta","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Tamil (https://www.transifex.com/nextcloud/teams/64236/ta/)","Content-Type":"text/plain; charset=UTF-8","Language":"ta","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Tamil (https://www.transifex.com/nextcloud/teams/64236/ta/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ta\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"ta_LK","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Tamil (Sri-Lanka) (https://www.transifex.com/nextcloud/teams/64236/ta_LK/)","Content-Type":"text/plain; charset=UTF-8","Language":"ta_LK","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Tamil (Sri-Lanka) (https://www.transifex.com/nextcloud/teams/64236/ta_LK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ta_LK\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"th","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Thai (https://www.transifex.com/nextcloud/teams/64236/th/)","Content-Type":"text/plain; charset=UTF-8","Language":"th","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Thai (https://www.transifex.com/nextcloud/teams/64236/th/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: th\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"th_TH","json":{"charset":"utf-8","headers":{"Last-Translator":"Phongpanot Phairat <ppnplus@protonmail.com>, 2022","Language-Team":"Thai (Thailand) (https://www.transifex.com/nextcloud/teams/64236/th_TH/)","Content-Type":"text/plain; charset=UTF-8","Language":"th_TH","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nPhongpanot Phairat <ppnplus@protonmail.com>, 2022\n"},"msgstr":["Last-Translator: Phongpanot Phairat <ppnplus@protonmail.com>, 2022\nLanguage-Team: Thai (Thailand) (https://www.transifex.com/nextcloud/teams/64236/th_TH/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: th_TH\nPlural-Forms: nplurals=1; plural=0;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["เหลืออีก {seconds} วินาที"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["เหลืออีก {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["เหลืออีกไม่กี่วินาที"]},"Add":{"msgid":"Add","msgstr":["เพิ่ม"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["ยกเลิกการอัปโหลด"]},"estimating time left":{"msgid":"estimating time left","msgstr":["กำลังคำนวณเวลาที่เหลือ"]},"paused":{"msgid":"paused","msgstr":["หยุดชั่วคราว"]},"Upload files":{"msgid":"Upload files","msgstr":["อัปโหลดไฟล์"]}}}}},{"locale":"tk","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Turkmen (https://www.transifex.com/nextcloud/teams/64236/tk/)","Content-Type":"text/plain; charset=UTF-8","Language":"tk","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Turkmen (https://www.transifex.com/nextcloud/teams/64236/tk/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: tk\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"tr","json":{"charset":"utf-8","headers":{"Last-Translator":"Kaya Zeren <kayazeren@gmail.com>, 2022","Language-Team":"Turkish (https://www.transifex.com/nextcloud/teams/64236/tr/)","Content-Type":"text/plain; charset=UTF-8","Language":"tr","Plural-Forms":"nplurals=2; plural=(n > 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nKaya Zeren <kayazeren@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Kaya Zeren <kayazeren@gmail.com>, 2022\nLanguage-Team: Turkish (https://www.transifex.com/nextcloud/teams/64236/tr/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: tr\nPlural-Forms: nplurals=2; plural=(n > 1);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["{seconds} saniye kaldı"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["{time} kaldı"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["bir kaç saniye kaldı"]},"Add":{"msgid":"Add","msgstr":["Ekle"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Yüklemeleri iptal et"]},"estimating time left":{"msgid":"estimating time left","msgstr":["öngörülen kalan süre"]},"paused":{"msgid":"paused","msgstr":["duraklatıldı"]},"Upload files":{"msgid":"Upload files","msgstr":["Dosyaları yükle"]}}}}},{"locale":"ug","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Uyghur (https://www.transifex.com/nextcloud/teams/64236/ug/)","Content-Type":"text/plain; charset=UTF-8","Language":"ug","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Uyghur (https://www.transifex.com/nextcloud/teams/64236/ug/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ug\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"uk","json":{"charset":"utf-8","headers":{"Last-Translator":"Vitaliy <gviabcua@gmail.com>, 2022","Language-Team":"Ukrainian (https://www.transifex.com/nextcloud/teams/64236/uk/)","Content-Type":"text/plain; charset=UTF-8","Language":"uk","Plural-Forms":"nplurals=4; plural=(n % 1 == 0 && n % 10 == 1 && n % 100 != 11 ? 0 : n % 1 == 0 && n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 1 : n % 1 == 0 && (n % 10 ==0 || (n % 10 >=5 && n % 10 <=9) || (n % 100 >=11 && n % 100 <=14 )) ? 2: 3);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nVitaliy <gviabcua@gmail.com>, 2022\n"},"msgstr":["Last-Translator: Vitaliy <gviabcua@gmail.com>, 2022\nLanguage-Team: Ukrainian (https://www.transifex.com/nextcloud/teams/64236/uk/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: uk\nPlural-Forms: nplurals=4; plural=(n % 1 == 0 && n % 10 == 1 && n % 100 != 11 ? 0 : n % 1 == 0 && n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 1 : n % 1 == 0 && (n % 10 ==0 || (n % 10 >=5 && n % 10 <=9) || (n % 100 >=11 && n % 100 <=14 )) ? 2: 3);\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["Залишилося {seconds} секунд"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["Залишилося {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["залишилося кілька секунд"]},"Add":{"msgid":"Add","msgstr":["Додати"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["Скасувати завантаження"]},"estimating time left":{"msgid":"estimating time left","msgstr":["оцінка часу, що залишився"]},"paused":{"msgid":"paused","msgstr":["призупинено"]},"Upload files":{"msgid":"Upload files","msgstr":["Завантажте файли"]}}}}},{"locale":"ur_PK","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Urdu (Pakistan) (https://www.transifex.com/nextcloud/teams/64236/ur_PK/)","Content-Type":"text/plain; charset=UTF-8","Language":"ur_PK","Plural-Forms":"nplurals=2; plural=(n != 1);"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Urdu (Pakistan) (https://www.transifex.com/nextcloud/teams/64236/ur_PK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: ur_PK\nPlural-Forms: nplurals=2; plural=(n != 1);\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"uz","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Uzbek (https://www.transifex.com/nextcloud/teams/64236/uz/)","Content-Type":"text/plain; charset=UTF-8","Language":"uz","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Uzbek (https://www.transifex.com/nextcloud/teams/64236/uz/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: uz\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"vi","json":{"charset":"utf-8","headers":{"Last-Translator":"Transifex Bot <>, 2022","Language-Team":"Vietnamese (https://www.transifex.com/nextcloud/teams/64236/vi/)","Content-Type":"text/plain; charset=UTF-8","Language":"vi","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nTransifex Bot <>, 2022\n"},"msgstr":["Last-Translator: Transifex Bot <>, 2022\nLanguage-Team: Vietnamese (https://www.transifex.com/nextcloud/teams/64236/vi/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: vi\nPlural-Forms: nplurals=1; plural=0;\n"]},"{estimate} seconds left":{"msgid":"{estimate} seconds left","msgstr":[""]},"{hours} hours and {minutes} minutes left":{"msgid":"{hours} hours and {minutes} minutes left","msgstr":[""]},"{minutes} minutes left":{"msgid":"{minutes} minutes left","msgstr":[""]},"a few seconds left":{"msgid":"a few seconds left","msgstr":[""]},"Add":{"msgid":"Add","msgstr":[""]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":[""]},"estimating time left":{"msgid":"estimating time left","msgstr":[""]},"paused":{"msgid":"paused","msgstr":[""]}}}}},{"locale":"zh_CN","json":{"charset":"utf-8","headers":{"Last-Translator":"Jack Frost, 2022","Language-Team":"Chinese (China) (https://www.transifex.com/nextcloud/teams/64236/zh_CN/)","Content-Type":"text/plain; charset=UTF-8","Language":"zh_CN","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nJack Frost, 2022\n"},"msgstr":["Last-Translator: Jack Frost, 2022\nLanguage-Team: Chinese (China) (https://www.transifex.com/nextcloud/teams/64236/zh_CN/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: zh_CN\nPlural-Forms: nplurals=1; plural=0;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["剩余 {seconds} 秒"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["剩余 {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["还剩几秒"]},"Add":{"msgid":"Add","msgstr":["添加"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["取消上传"]},"estimating time left":{"msgid":"estimating time left","msgstr":["估计剩余时间"]},"paused":{"msgid":"paused","msgstr":["已暂停"]}}}}},{"locale":"zh_HK","json":{"charset":"utf-8","headers":{"Last-Translator":"Café Tango, 2022","Language-Team":"Chinese (Hong Kong) (https://www.transifex.com/nextcloud/teams/64236/zh_HK/)","Content-Type":"text/plain; charset=UTF-8","Language":"zh_HK","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nCafé Tango, 2022\n"},"msgstr":["Last-Translator: Café Tango, 2022\nLanguage-Team: Chinese (Hong Kong) (https://www.transifex.com/nextcloud/teams/64236/zh_HK/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: zh_HK\nPlural-Forms: nplurals=1; plural=0;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["剩餘 {seconds} 秒"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["剩餘 {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["還剩幾秒"]},"Add":{"msgid":"Add","msgstr":["添加"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["取消上傳"]},"estimating time left":{"msgid":"estimating time left","msgstr":["估計剩餘時間"]},"paused":{"msgid":"paused","msgstr":["已暫停"]}}}}},{"locale":"zh_TW","json":{"charset":"utf-8","headers":{"Last-Translator":"Tragic Life, 2022","Language-Team":"Chinese (Taiwan) (https://www.transifex.com/nextcloud/teams/64236/zh_TW/)","Content-Type":"text/plain; charset=UTF-8","Language":"zh_TW","Plural-Forms":"nplurals=1; plural=0;"},"translations":{"":{"":{"msgid":"","comments":{"translator":"\nTranslators:\nPin-Hsien Lee, 2022\nTragic Life, 2022\n"},"msgstr":["Last-Translator: Tragic Life, 2022\nLanguage-Team: Chinese (Taiwan) (https://www.transifex.com/nextcloud/teams/64236/zh_TW/)\nContent-Type: text/plain; charset=UTF-8\nLanguage: zh_TW\nPlural-Forms: nplurals=1; plural=0;\n"]},"{seconds} seconds left":{"msgid":"{seconds} seconds left","msgstr":["剩餘 {seconds} 秒"]},"{time} left":{"msgid":"{time} left","comments":{"extracted":"time has the format 00:00:00"},"msgstr":["剩餘 {time}"]},"a few seconds left":{"msgid":"a few seconds left","msgstr":["還剩幾秒"]},"Add":{"msgid":"Add","msgstr":["新增"]},"Cancel uploads":{"msgid":"Cancel uploads","msgstr":["取消上傳"]},"estimating time left":{"msgid":"estimating time left","msgstr":["估計剩餘時間"]},"paused":{"msgid":"paused","msgstr":["已暫停"]},"Upload files":{"msgid":"Upload files","msgstr":["上傳檔案"]}}}}}]};
    try {
        if (process) {
            process.env = Object.assign({}, process.env);
            Object.assign(process.env, env);
            return;
        }
    } catch (e) {} // avoid ReferenceError: process is not defined
    globalThis.process = { env:env };
})();

const readerLimit = PLimit(1);
const reader = new FileReader();
/**
 * Upload some data to a given path
 */
const uploadData = async function (url, data, signal, onUploadProgress = () => { }) {
    if (typeof data === 'function') {
        data = await data();
    }
    return await axios.request({
        method: 'PUT',
        url,
        data,
        signal,
        onUploadProgress,
    });
};
/**
 * Get chunk of the file. Doing this on the fly
 * give us a big performance boost and proper
 * garbage collection
 */
const getChunk = function (file, start, length) {
    if (!file.type) {
        return Promise.reject(new Error('Unknown file type'));
    }
    // Since we use a global FileReader, we need to only read one chunk at a time
    return readerLimit(() => new Promise((resolve, reject) => {
        reader.onload = () => {
            if (reader.result !== null) {
                resolve(new Blob([reader.result], {
                    type: 'application/octet-stream',
                }));
            }
            reject(new Error('Error while reading the file'));
        };
        reader.readAsArrayBuffer(file.slice(start, start + length));
    }));
};
/**
 * Create a temporary upload workspace to upload the chunks to
 */
const initChunkWorkspace = async function () {
    const chunksWorkspace = generateRemoteUrl(`dav/uploads/${getCurrentUser()?.uid}`);
    const tempWorkspace = `web-file-upload-${crypto.randomBytes(16).toString('hex')}`;
    const url = `${chunksWorkspace}/${tempWorkspace}`;
    await axios.request({
        method: 'MKCOL',
        url,
    });
    return url;
};

const getMaxChunksSize = function () {
    const maxChunkSize = global.OC?.appConfig?.files?.max_chunk_size;
    if (maxChunkSize <= 0) {
        return 0;
    }
    // If invalid return default
    if (!Number(maxChunkSize)) {
        return 10 * 1024 * 1024;
    }
    return Number(maxChunkSize);
};

var Status$1;
(function (Status) {
    Status[Status["INITIALIZED"] = 0] = "INITIALIZED";
    Status[Status["UPLOADING"] = 1] = "UPLOADING";
    Status[Status["ASSEMBLING"] = 2] = "ASSEMBLING";
    Status[Status["FINISHED"] = 3] = "FINISHED";
    Status[Status["CANCELLED"] = 4] = "CANCELLED";
    Status[Status["FAILED"] = 5] = "FAILED";
})(Status$1 || (Status$1 = {}));
class Upload$1 {
    _path;
    _isChunked;
    _chunks;
    _size;
    _uploaded = 0;
    _startTime = 0;
    _status = Status$1.INITIALIZED;
    _controller;
    _response = null;
    constructor(path, chunked = false, size) {
        const chunks = getMaxChunksSize() > 0 ? Math.ceil(size / getMaxChunksSize()) : 1;
        this._path = path;
        this._isChunked = chunked && getMaxChunksSize() > 0 && chunks > 1;
        this._chunks = this._isChunked ? chunks : 1;
        this._size = size;
        this._controller = new AbortController();
    }
    get path() {
        return this._path;
    }
    get isChunked() {
        return this._isChunked;
    }
    get chunks() {
        return this._chunks;
    }
    get size() {
        return this._size;
    }
    get uploaded() {
        return this._uploaded;
    }
    get startTime() {
        return this._startTime;
    }
    set response(response) {
        this._response = response;
    }
    get response() {
        return this._response;
    }
    /**
     * Update the uploaded bytes of this upload
     */
    set uploaded(length) {
        if (length >= this._size) {
            this._status = this._isChunked
                ? Status$1.ASSEMBLING
                : Status$1.FINISHED;
            this._uploaded = this._size;
            return;
        }
        this._status = Status$1.UPLOADING;
        this._uploaded = length;
        // If first progress, let's log the start time
        if (this._startTime === 0) {
            this._startTime = new Date().getTime();
        }
    }
    get status() {
        return this._status;
    }
    /**
     * Update this upload status
     */
    set status(status) {
        this._status = status;
    }
    /**
     * Returns the axios cancel token source
     */
    get signal() {
        return this._controller.signal;
    }
    /**
     * Cancel any ongoing requests linked to this upload
     */
    cancel() {
        this._controller.abort();
        this._status = Status$1.CANCELLED;
    }
}

const getLogger = user => {
    if (user === null) {
        return getLoggerBuilder()
            .setApp('uploader')
            .build();
    }
    return getLoggerBuilder()
        .setApp('uploader')
        .setUid(user.uid)
        .build();
};
var logger = getLogger(getCurrentUser());

var Status;
(function (Status) {
    Status[Status["IDLE"] = 0] = "IDLE";
    Status[Status["UPLOADING"] = 1] = "UPLOADING";
    Status[Status["PAUSED"] = 2] = "PAUSED";
})(Status || (Status = {}));
class Uploader {
    // Initialized via setter in the constructor
    rootFolder;
    destinationFolder;
    _isPublic;
    // Global upload queue
    _uploadQueue = [];
    _jobQueue = new PQueue({ concurrency: 3 });
    _queueSize = 0;
    _queueProgress = 0;
    _queueStatus = Status.IDLE;
    /**
     * Initialize uploader
     *
     * @param {boolean} isPublic are we in public mode ?
     * @param {string} rootFolder the operation root folder
     * @param {string} destinationFolder the context folder to operate, relative to the root folder
     */
    constructor(isPublic = false, rootFolder = `dav/files/${getCurrentUser()?.uid}`, destinationFolder = '/') {
        this._isPublic = isPublic;
        this.root = rootFolder;
        this.destination = destinationFolder;
        logger.debug('Upload workspace initialized', {
            destinationFolder: this.destination,
            rootFolder: this.root,
            isPublic,
            maxChunksSize: getMaxChunksSize(),
        });
    }
    /**
     * Get the upload destination path relative to the root folder
     */
    get destination() {
        return this.destinationFolder;
    }
    /**
     * Set the upload destination path relative to the root folder
     */
    set destination(path) {
        if (typeof path !== 'string' || path === '') {
            this.destinationFolder = '/';
            return;
        }
        if (!path.startsWith('/')) {
            path = `/${path}`;
        }
        this.destinationFolder = path.replace(/\/$/, '');
    }
    /**
     * Get the root folder
     */
    get root() {
        return this.rootFolder;
    }
    /**
     * Set the root folder
     *
     * @param {string} path should be the remoteUrl path.
     * This method uses the generateRemoteUrl method
     */
    set root(path) {
        if (typeof path !== 'string' || path === '') {
            this.rootFolder = generateRemoteUrl(`dav/files/${getCurrentUser()?.uid}`);
            return;
        }
        if (path.startsWith('http')) {
            throw new Error('The path should be a remote url string. E.g `dav/files/admin`.');
        }
        if (path.startsWith('/')) {
            path = path.slice(1);
        }
        this.rootFolder = generateRemoteUrl(path);
    }
    /**
     * Get the upload queue
     */
    get queue() {
        return this._uploadQueue;
    }
    reset() {
        this._uploadQueue = [];
        this._jobQueue.clear();
        this._queueSize = 0;
        this._queueProgress = 0;
        this._queueStatus = Status.IDLE;
    }
    /**
     * Pause any ongoing upload(s)
     */
    pause() {
        this._jobQueue.pause();
        this._queueStatus = Status.PAUSED;
    }
    /**
     * Resume any pending upload(s)
     */
    start() {
        this._jobQueue.start();
        this._queueStatus = Status.UPLOADING;
        this.updateStats();
    }
    /**
     * Get the upload queue stats
     */
    get info() {
        return {
            size: this._queueSize,
            progress: this._queueProgress,
            status: this._queueStatus,
        };
    }
    updateStats() {
        const size = this._uploadQueue.map(upload => upload.size)
            .reduce((partialSum, a) => partialSum + a, 0);
        const uploaded = this._uploadQueue.map(upload => upload.uploaded)
            .reduce((partialSum, a) => partialSum + a, 0);
        this._queueSize = size;
        this._queueProgress = uploaded;
        // If already paused keep it that way
        if (this._queueStatus === Status.PAUSED) {
            return;
        }
        this._queueStatus = this._jobQueue.size > 0
            ? Status.UPLOADING
            : Status.IDLE;
    }
    /**
     * Upload a file to the given path
     */
    upload(destinationPath, file) {
        const destinationFolder = this.destinationFolder === '/' ? '' : this.destinationFolder;
        const destinationFile = `${this.rootFolder}${destinationFolder}/${destinationPath.replace(/^\//, '')}`;
        logger.debug(`Uploading ${file.name} to ${destinationFile}`);
        // If manually disabled or if the file is too small
        // TODO: support chunk uploading in public pages
        const maxChunkSize = getMaxChunksSize();
        const disabledChunkUpload = maxChunkSize === 0
            || file.size < maxChunkSize
            || this._isPublic;
        const upload = new Upload$1(destinationFile, !disabledChunkUpload, file.size);
        this._uploadQueue.push(upload);
        this.updateStats();
        // eslint-disable-next-line no-async-promise-executor
        const promise = new PCancelable(async (resolve, reject, onCancel) => {
            // Register cancellation caller
            onCancel(upload.cancel);
            if (!disabledChunkUpload) {
                logger.debug('Initializing chunked upload', { file, upload });
                // Let's initialize a chunk upload
                const tempUrl = await initChunkWorkspace();
                const chunksQueue = [];
                // Generate chunks array
                for (let chunk = 0; chunk < upload.chunks; chunk++) {
                    const bufferStart = chunk * maxChunkSize;
                    // Don't go further than the file size
                    const bufferEnd = Math.min(bufferStart + maxChunkSize, upload.size);
                    // Make it a Promise function for better memory management
                    const blob = () => getChunk(file, bufferStart, maxChunkSize);
                    // Init request queue
                    const request = () => {
                        return uploadData(`${tempUrl}/${bufferEnd}`, blob, upload.signal, () => this.updateStats())
                            // Update upload progress on chunk completion
                            .then(() => { upload.uploaded = upload.uploaded + maxChunkSize; })
                            .catch((error) => {
                            if (!(error instanceof CanceledError)) {
                                logger.error(`Chunk ${bufferStart} - ${bufferEnd} uploading failed`);
                                upload.status = Status$1.FAILED;
                            }
                            throw error;
                        });
                    };
                    chunksQueue.push(this._jobQueue.add(request));
                }
                try {
                    // Once all chunks are sent, assemble the final file
                    await Promise.all(chunksQueue);
                    this.updateStats();
                    upload.response = await axios.request({
                        method: 'MOVE',
                        url: `${tempUrl}/.file`,
                        headers: {
                            Destination: destinationFile,
                        },
                    });
                    this.updateStats();
                    upload.status = Status$1.FINISHED;
                    logger.debug(`Successfully uploaded ${file.name}`, { file, upload });
                    resolve(upload);
                }
                catch (error) {
                    if (!(error instanceof CanceledError)) {
                        upload.status = Status$1.FAILED;
                        reject('Failed assembling the chunks together');
                    }
                    else {
                        upload.status = Status$1.FAILED;
                        reject('Upload has been cancelled');
                    }
                    // Cleaning up temp directory
                    axios.request({
                        method: 'DELETE',
                        url: `${tempUrl}`,
                    });
                }
            }
            else {
                logger.debug('Initializing regular upload', { file, upload });
                // Generating upload limit
                const blob = await getChunk(file, 0, upload.size);
                const request = async () => {
                    try {
                        upload.response = await uploadData(destinationFile, blob, upload.signal, () => this.updateStats());
                        // Update progress
                        upload.uploaded = upload.size;
                        this.updateStats();
                        // Resolve
                        logger.debug(`Successfully uploaded ${file.name}`, { file, upload });
                        resolve(upload);
                    }
                    catch (error) {
                        if (error instanceof CanceledError) {
                            upload.status = Status$1.FAILED;
                            reject('Upload has been cancelled');
                            return;
                        }
                        upload.status = Status$1.FAILED;
                        reject('Failed uploading the file');
                    }
                };
                this._jobQueue.add(request);
                this.updateStats();
            }
            // Reset when upload queue is done
            this._jobQueue.onIdle()
                .then(() => this.reset());
            return upload;
        });
        return promise;
    }
}

var e=[],t$1=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t$1[u]={}),a=t$1[u]&&t$1[u][s]?t$1[u][s]:t$1[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var css$1 = ".upload-picker {\n  display: inline-flex;\n  align-items: center;\n  height: 44px;\n}\n.upload-picker__progress {\n  width: 200px;\n  max-width: 0;\n  transition: max-width var(--animation-quick) ease-in-out;\n  margin-top: 8px;\n}\n.upload-picker__progress p {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.upload-picker--uploading .upload-picker__progress {\n  max-width: 200px;\n  margin-right: 20px;\n  margin-left: 8px;\n}\n.upload-picker--paused .upload-picker__progress {\n  animation: breathing 3s ease-out infinite normal;\n}\n\n@keyframes breathing {\n  0% {\n    opacity: 0.5;\n  }\n  25% {\n    opacity: 1;\n  }\n  60% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}";
n(css$1,{});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

// @flow

/*::
type Options = {
  max?: number,
  min?: number,
  historyTimeConstant?: number,
  autostart?: boolean,
  ignoreSameProgress?: boolean,
}
*/

function makeLowPassFilter(RC/*: number*/) {
  return function (previousOutput, input, dt) {
    const alpha = dt / (dt + RC);
    return previousOutput + alpha * (input - previousOutput);
  }
}

function def$1/*:: <T>*/(x/*: ?T*/, d/*: T*/)/*: T*/ {
  return (x === undefined || x === null) ? d : x;
}

function makeEta(options/*::?: Options */) {
  options = options || {};
  var max = def$1(options.max, 1);
  var min = def$1(options.min, 0);
  var autostart = def$1(options.autostart, true);
  var ignoreSameProgress = def$1(options.ignoreSameProgress, false);

  var rate/*: number | null */ = null;
  var lastTimestamp/*: number | null */ = null;
  var lastProgress/*: number | null */ = null;

  var filter = makeLowPassFilter(def$1(options.historyTimeConstant, 2.5));

  function start() {
    report(min);
  }

  function reset() {
    rate = null;
    lastTimestamp = null;
    lastProgress = null;
    if (autostart) {
      start();
    }
  }

  function report(progress /*: number */, timestamp/*::?: number */) {
    if (typeof timestamp !== 'number') {
      timestamp = Date.now();
    }

    if (lastTimestamp === timestamp) { return; }
    if (ignoreSameProgress && lastProgress === progress) { return; }

    if (lastTimestamp === null || lastProgress === null) {
      lastProgress = progress;
      lastTimestamp = timestamp;
      return;
    }

    var deltaProgress = progress - lastProgress;
    var deltaTimestamp = 0.001 * (timestamp - lastTimestamp);
    var currentRate = deltaProgress / deltaTimestamp;

    rate = rate === null
      ? currentRate
      : filter(rate, currentRate, deltaTimestamp);
    lastProgress = progress;
    lastTimestamp = timestamp;
  }

  function estimate(timestamp/*::?: number*/) {
    if (lastProgress === null) { return Infinity; }
    if (lastProgress >= max) { return 0; }
    if (rate === null) { return Infinity; }

    var estimatedTime = (max - lastProgress) / rate;
    if (typeof timestamp === 'number' && typeof lastTimestamp === 'number') {
      estimatedTime -= (timestamp - lastTimestamp) * 0.001;
    }
    return Math.max(0, estimatedTime);
  }

  function getRate() {
    return rate === null ? 0 : rate;
  }

  return {
    start: start,
    reset: reset,
    report: report,
    estimate: estimate,
    rate: getRate,
  }
}

var simpleEta = makeEta;

var NcActionButton$1 = {exports: {}};

var vue_runtime_common = {exports: {}};

var vue_runtime_common_dev;
var hasRequiredVue_runtime_common_dev;

function requireVue_runtime_common_dev () {
	if (hasRequiredVue_runtime_common_dev) return vue_runtime_common_dev;
	hasRequiredVue_runtime_common_dev = 1;

	const emptyObject = Object.freeze({});
	const isArray = Array.isArray;
	// These helpers produce better VM code in JS engines due to their
	// explicitness and function inlining.
	function isUndef(v) {
	    return v === undefined || v === null;
	}
	function isDef(v) {
	    return v !== undefined && v !== null;
	}
	function isTrue(v) {
	    return v === true;
	}
	function isFalse(v) {
	    return v === false;
	}
	/**
	 * Check if value is primitive.
	 */
	function isPrimitive(value) {
	    return (typeof value === 'string' ||
	        typeof value === 'number' ||
	        // $flow-disable-line
	        typeof value === 'symbol' ||
	        typeof value === 'boolean');
	}
	function isFunction(value) {
	    return typeof value === 'function';
	}
	/**
	 * Quick object check - this is primarily used to tell
	 * objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	/**
	 * Get the raw type string of a value, e.g., [object Object].
	 */
	const _toString = Object.prototype.toString;
	function toRawType(value) {
	    return _toString.call(value).slice(8, -1);
	}
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject(obj) {
	    return _toString.call(obj) === '[object Object]';
	}
	function isRegExp(v) {
	    return _toString.call(v) === '[object RegExp]';
	}
	/**
	 * Check if val is a valid array index.
	 */
	function isValidArrayIndex(val) {
	    const n = parseFloat(String(val));
	    return n >= 0 && Math.floor(n) === n && isFinite(val);
	}
	function isPromise(val) {
	    return (isDef(val) &&
	        typeof val.then === 'function' &&
	        typeof val.catch === 'function');
	}
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function toString(val) {
	    return val == null
	        ? ''
	        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
	            ? JSON.stringify(val, null, 2)
	            : String(val);
	}
	/**
	 * Convert an input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber(val) {
	    const n = parseFloat(val);
	    return isNaN(n) ? val : n;
	}
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap(str, expectsLowerCase) {
	    const map = Object.create(null);
	    const list = str.split(',');
	    for (let i = 0; i < list.length; i++) {
	        map[list[i]] = true;
	    }
	    return expectsLowerCase ? val => map[val.toLowerCase()] : val => map[val];
	}
	/**
	 * Check if a tag is a built-in tag.
	 */
	const isBuiltInTag = makeMap('slot,component', true);
	/**
	 * Check if an attribute is a reserved attribute.
	 */
	const isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
	/**
	 * Remove an item from an array.
	 */
	function remove$2(arr, item) {
	    if (arr.length) {
	        const index = arr.indexOf(item);
	        if (index > -1) {
	            return arr.splice(index, 1);
	        }
	    }
	}
	/**
	 * Check whether an object has the property.
	 */
	const hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(obj, key) {
	    return hasOwnProperty.call(obj, key);
	}
	/**
	 * Create a cached version of a pure function.
	 */
	function cached(fn) {
	    const cache = Object.create(null);
	    return function cachedFn(str) {
	        const hit = cache[str];
	        return hit || (cache[str] = fn(str));
	    };
	}
	/**
	 * Camelize a hyphen-delimited string.
	 */
	const camelizeRE = /-(\w)/g;
	const camelize = cached((str) => {
	    return str.replace(camelizeRE, (_, c) => (c ? c.toUpperCase() : ''));
	});
	/**
	 * Capitalize a string.
	 */
	const capitalize = cached((str) => {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	});
	/**
	 * Hyphenate a camelCase string.
	 */
	const hyphenateRE = /\B([A-Z])/g;
	const hyphenate = cached((str) => {
	    return str.replace(hyphenateRE, '-$1').toLowerCase();
	});
	/**
	 * Simple bind polyfill for environments that do not support it,
	 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
	 * since native bind is now performant enough in most browsers.
	 * But removing it would mean breaking code that was able to run in
	 * PhantomJS 1.x, so this must be kept for backward compatibility.
	 */
	/* istanbul ignore next */
	function polyfillBind(fn, ctx) {
	    function boundFn(a) {
	        const l = arguments.length;
	        return l
	            ? l > 1
	                ? fn.apply(ctx, arguments)
	                : fn.call(ctx, a)
	            : fn.call(ctx);
	    }
	    boundFn._length = fn.length;
	    return boundFn;
	}
	function nativeBind(fn, ctx) {
	    return fn.bind(ctx);
	}
	// @ts-expect-error bind cannot be `undefined`
	const bind = Function.prototype.bind ? nativeBind : polyfillBind;
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray(list, start) {
	    start = start || 0;
	    let i = list.length - start;
	    const ret = new Array(i);
	    while (i--) {
	        ret[i] = list[i + start];
	    }
	    return ret;
	}
	/**
	 * Mix properties into target object.
	 */
	function extend(to, _from) {
	    for (const key in _from) {
	        to[key] = _from[key];
	    }
	    return to;
	}
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject(arr) {
	    const res = {};
	    for (let i = 0; i < arr.length; i++) {
	        if (arr[i]) {
	            extend(res, arr[i]);
	        }
	    }
	    return res;
	}
	/* eslint-disable no-unused-vars */
	/**
	 * Perform no operation.
	 * Stubbing args to make Flow happy without leaving useless transpiled code
	 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
	 */
	function noop(a, b, c) { }
	/**
	 * Always return false.
	 */
	const no = (a, b, c) => false;
	/* eslint-enable no-unused-vars */
	/**
	 * Return the same value.
	 */
	const identity = (_) => _;
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual(a, b) {
	    if (a === b)
	        return true;
	    const isObjectA = isObject(a);
	    const isObjectB = isObject(b);
	    if (isObjectA && isObjectB) {
	        try {
	            const isArrayA = Array.isArray(a);
	            const isArrayB = Array.isArray(b);
	            if (isArrayA && isArrayB) {
	                return (a.length === b.length &&
	                    a.every((e, i) => {
	                        return looseEqual(e, b[i]);
	                    }));
	            }
	            else if (a instanceof Date && b instanceof Date) {
	                return a.getTime() === b.getTime();
	            }
	            else if (!isArrayA && !isArrayB) {
	                const keysA = Object.keys(a);
	                const keysB = Object.keys(b);
	                return (keysA.length === keysB.length &&
	                    keysA.every(key => {
	                        return looseEqual(a[key], b[key]);
	                    }));
	            }
	            else {
	                /* istanbul ignore next */
	                return false;
	            }
	        }
	        catch (e) {
	            /* istanbul ignore next */
	            return false;
	        }
	    }
	    else if (!isObjectA && !isObjectB) {
	        return String(a) === String(b);
	    }
	    else {
	        return false;
	    }
	}
	/**
	 * Return the first index at which a loosely equal value can be
	 * found in the array (if value is a plain object, the array must
	 * contain an object of the same shape), or -1 if it is not present.
	 */
	function looseIndexOf(arr, val) {
	    for (let i = 0; i < arr.length; i++) {
	        if (looseEqual(arr[i], val))
	            return i;
	    }
	    return -1;
	}
	/**
	 * Ensure a function is called only once.
	 */
	function once(fn) {
	    let called = false;
	    return function () {
	        if (!called) {
	            called = true;
	            fn.apply(this, arguments);
	        }
	    };
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
	function hasChanged(x, y) {
	    if (x === y) {
	        return x === 0 && 1 / x !== 1 / y;
	    }
	    else {
	        return x === x || y === y;
	    }
	}

	const SSR_ATTR = 'data-server-rendered';
	const ASSET_TYPES = ['component', 'directive', 'filter'];
	const LIFECYCLE_HOOKS = [
	    'beforeCreate',
	    'created',
	    'beforeMount',
	    'mounted',
	    'beforeUpdate',
	    'updated',
	    'beforeDestroy',
	    'destroyed',
	    'activated',
	    'deactivated',
	    'errorCaptured',
	    'serverPrefetch',
	    'renderTracked',
	    'renderTriggered'
	];

	var config = {
	    /**
	     * Option merge strategies (used in core/util/options)
	     */
	    // $flow-disable-line
	    optionMergeStrategies: Object.create(null),
	    /**
	     * Whether to suppress warnings.
	     */
	    silent: false,
	    /**
	     * Show production mode tip message on boot?
	     */
	    productionTip: true,
	    /**
	     * Whether to enable devtools
	     */
	    devtools: true,
	    /**
	     * Whether to record perf
	     */
	    performance: false,
	    /**
	     * Error handler for watcher errors
	     */
	    errorHandler: null,
	    /**
	     * Warn handler for watcher warns
	     */
	    warnHandler: null,
	    /**
	     * Ignore certain custom elements
	     */
	    ignoredElements: [],
	    /**
	     * Custom user key aliases for v-on
	     */
	    // $flow-disable-line
	    keyCodes: Object.create(null),
	    /**
	     * Check if a tag is reserved so that it cannot be registered as a
	     * component. This is platform-dependent and may be overwritten.
	     */
	    isReservedTag: no,
	    /**
	     * Check if an attribute is reserved so that it cannot be used as a component
	     * prop. This is platform-dependent and may be overwritten.
	     */
	    isReservedAttr: no,
	    /**
	     * Check if a tag is an unknown element.
	     * Platform-dependent.
	     */
	    isUnknownElement: no,
	    /**
	     * Get the namespace of an element
	     */
	    getTagNamespace: noop,
	    /**
	     * Parse the real tag name for the specific platform.
	     */
	    parsePlatformTagName: identity,
	    /**
	     * Check if an attribute must be bound using property, e.g. value
	     * Platform-dependent.
	     */
	    mustUseProp: no,
	    /**
	     * Perform updates asynchronously. Intended to be used by Vue Test Utils
	     * This will significantly reduce performance if set to false.
	     */
	    async: true,
	    /**
	     * Exposed for legacy reasons
	     */
	    _lifecycleHooks: LIFECYCLE_HOOKS
	};

	/**
	 * unicode letters used for parsing html tags, component names and property paths.
	 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
	 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
	 */
	const unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved(str) {
	    const c = (str + '').charCodeAt(0);
	    return c === 0x24 || c === 0x5f;
	}
	/**
	 * Define a property.
	 */
	function def(obj, key, val, enumerable) {
	    Object.defineProperty(obj, key, {
	        value: val,
	        enumerable: !!enumerable,
	        writable: true,
	        configurable: true
	    });
	}
	/**
	 * Parse simple path.
	 */
	const bailRE = new RegExp(`[^${unicodeRegExp.source}.$_\\d]`);
	function parsePath(path) {
	    if (bailRE.test(path)) {
	        return;
	    }
	    const segments = path.split('.');
	    return function (obj) {
	        for (let i = 0; i < segments.length; i++) {
	            if (!obj)
	                return;
	            obj = obj[segments[i]];
	        }
	        return obj;
	    };
	}

	// can we use __proto__?
	const hasProto = '__proto__' in {};
	// Browser environment sniffing
	const inBrowser = typeof window !== 'undefined';
	const UA = inBrowser && window.navigator.userAgent.toLowerCase();
	const isIE = UA && /msie|trident/.test(UA);
	const isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	const isEdge = UA && UA.indexOf('edge/') > 0;
	UA && UA.indexOf('android') > 0;
	const isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	UA && /chrome\/\d+/.test(UA) && !isEdge;
	UA && /phantomjs/.test(UA);
	const isFF = UA && UA.match(/firefox\/(\d+)/);
	// Firefox has a "watch" function on Object.prototype...
	// @ts-expect-error firebox support
	const nativeWatch = {}.watch;
	let supportsPassive = false;
	if (inBrowser) {
	    try {
	        const opts = {};
	        Object.defineProperty(opts, 'passive', {
	            get() {
	                /* istanbul ignore next */
	                supportsPassive = true;
	            }
	        }); // https://github.com/facebook/flow/issues/285
	        window.addEventListener('test-passive', null, opts);
	    }
	    catch (e) { }
	}
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	let _isServer;
	const isServerRendering = () => {
	    if (_isServer === undefined) {
	        /* istanbul ignore if */
	        if (!inBrowser && typeof commonjsGlobal !== 'undefined') {
	            // detect presence of vue-server-renderer and avoid
	            // Webpack shimming the process
	            _isServer =
	                commonjsGlobal['process'] && commonjsGlobal['process'].env.VUE_ENV === 'server';
	        }
	        else {
	            _isServer = false;
	        }
	    }
	    return _isServer;
	};
	// detect devtools
	const devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	/* istanbul ignore next */
	function isNative(Ctor) {
	    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
	}
	const hasSymbol = typeof Symbol !== 'undefined' &&
	    isNative(Symbol) &&
	    typeof Reflect !== 'undefined' &&
	    isNative(Reflect.ownKeys);
	let _Set; // $flow-disable-line
	/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
	    // use native Set when available.
	    _Set = Set;
	}
	else {
	    // a non-standard Set polyfill that only works with primitive keys.
	    _Set = class Set {
	        constructor() {
	            this.set = Object.create(null);
	        }
	        has(key) {
	            return this.set[key] === true;
	        }
	        add(key) {
	            this.set[key] = true;
	        }
	        clear() {
	            this.set = Object.create(null);
	        }
	    };
	}

	let currentInstance = null;
	/**
	 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
	 * relies on it). Do not use this internally, just use `currentInstance`.
	 *
	 * @internal this function needs manual type declaration because it relies
	 * on previously manually authored types from Vue 2
	 */
	function getCurrentInstance() {
	    return currentInstance && { proxy: currentInstance };
	}
	/**
	 * @internal
	 */
	function setCurrentInstance(vm = null) {
	    if (!vm)
	        currentInstance && currentInstance._scope.off();
	    currentInstance = vm;
	    vm && vm._scope.on();
	}

	/**
	 * @internal
	 */
	class VNode {
	    constructor(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
	        this.tag = tag;
	        this.data = data;
	        this.children = children;
	        this.text = text;
	        this.elm = elm;
	        this.ns = undefined;
	        this.context = context;
	        this.fnContext = undefined;
	        this.fnOptions = undefined;
	        this.fnScopeId = undefined;
	        this.key = data && data.key;
	        this.componentOptions = componentOptions;
	        this.componentInstance = undefined;
	        this.parent = undefined;
	        this.raw = false;
	        this.isStatic = false;
	        this.isRootInsert = true;
	        this.isComment = false;
	        this.isCloned = false;
	        this.isOnce = false;
	        this.asyncFactory = asyncFactory;
	        this.asyncMeta = undefined;
	        this.isAsyncPlaceholder = false;
	    }
	    // DEPRECATED: alias for componentInstance for backwards compat.
	    /* istanbul ignore next */
	    get child() {
	        return this.componentInstance;
	    }
	}
	const createEmptyVNode = (text = '') => {
	    const node = new VNode();
	    node.text = text;
	    node.isComment = true;
	    return node;
	};
	function createTextVNode(val) {
	    return new VNode(undefined, undefined, undefined, String(val));
	}
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode(vnode) {
	    const cloned = new VNode(vnode.tag, vnode.data, 
	    // #7975
	    // clone children array to avoid mutating original in case of cloning
	    // a child.
	    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
	    cloned.ns = vnode.ns;
	    cloned.isStatic = vnode.isStatic;
	    cloned.key = vnode.key;
	    cloned.isComment = vnode.isComment;
	    cloned.fnContext = vnode.fnContext;
	    cloned.fnOptions = vnode.fnOptions;
	    cloned.fnScopeId = vnode.fnScopeId;
	    cloned.asyncMeta = vnode.asyncMeta;
	    cloned.isCloned = true;
	    return cloned;
	}

	let uid$2 = 0;
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 * @internal
	 */
	class Dep {
	    constructor() {
	        this.id = uid$2++;
	        this.subs = [];
	    }
	    addSub(sub) {
	        this.subs.push(sub);
	    }
	    removeSub(sub) {
	        remove$2(this.subs, sub);
	    }
	    depend(info) {
	        if (Dep.target) {
	            Dep.target.addDep(this);
	            if (info && Dep.target.onTrack) {
	                Dep.target.onTrack(Object.assign({ effect: Dep.target }, info));
	            }
	        }
	    }
	    notify(info) {
	        // stabilize the subscriber list first
	        const subs = this.subs.slice();
	        if (!config.async) {
	            // subs aren't sorted in scheduler if not running async
	            // we need to sort them now to make sure they fire in correct
	            // order
	            subs.sort((a, b) => a.id - b.id);
	        }
	        for (let i = 0, l = subs.length; i < l; i++) {
	            if (info) {
	                const sub = subs[i];
	                sub.onTrigger &&
	                    sub.onTrigger(Object.assign({ effect: subs[i] }, info));
	            }
	            subs[i].update();
	        }
	    }
	}
	// The current target watcher being evaluated.
	// This is globally unique because only one watcher
	// can be evaluated at a time.
	Dep.target = null;
	const targetStack = [];
	function pushTarget(target) {
	    targetStack.push(target);
	    Dep.target = target;
	}
	function popTarget() {
	    targetStack.pop();
	    Dep.target = targetStack[targetStack.length - 1];
	}

	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	const arrayProto = Array.prototype;
	const arrayMethods = Object.create(arrayProto);
	const methodsToPatch = [
	    'push',
	    'pop',
	    'shift',
	    'unshift',
	    'splice',
	    'sort',
	    'reverse'
	];
	/**
	 * Intercept mutating methods and emit events
	 */
	methodsToPatch.forEach(function (method) {
	    // cache original method
	    const original = arrayProto[method];
	    def(arrayMethods, method, function mutator(...args) {
	        const result = original.apply(this, args);
	        const ob = this.__ob__;
	        let inserted;
	        switch (method) {
	            case 'push':
	            case 'unshift':
	                inserted = args;
	                break;
	            case 'splice':
	                inserted = args.slice(2);
	                break;
	        }
	        if (inserted)
	            ob.observeArray(inserted);
	        // notify change
	        {
	            ob.dep.notify({
	                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
	                target: this,
	                key: method
	            });
	        }
	        return result;
	    });
	});

	const arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	const NO_INIITIAL_VALUE = {};
	/**
	 * In some cases we may want to disable observation inside a component's
	 * update computation.
	 */
	let shouldObserve = true;
	function toggleObserving(value) {
	    shouldObserve = value;
	}
	// ssr mock dep
	const mockDep = {
	    notify: noop,
	    depend: noop,
	    addSub: noop,
	    removeSub: noop
	};
	/**
	 * Observer class that is attached to each observed
	 * object. Once attached, the observer converts the target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatch updates.
	 */
	class Observer {
	    constructor(value, shallow = false, mock = false) {
	        this.value = value;
	        this.shallow = shallow;
	        this.mock = mock;
	        // this.value = value
	        this.dep = mock ? mockDep : new Dep();
	        this.vmCount = 0;
	        def(value, '__ob__', this);
	        if (isArray(value)) {
	            if (!mock) {
	                if (hasProto) {
	                    value.__proto__ = arrayMethods;
	                    /* eslint-enable no-proto */
	                }
	                else {
	                    for (let i = 0, l = arrayKeys.length; i < l; i++) {
	                        const key = arrayKeys[i];
	                        def(value, key, arrayMethods[key]);
	                    }
	                }
	            }
	            if (!shallow) {
	                this.observeArray(value);
	            }
	        }
	        else {
	            /**
	             * Walk through all properties and convert them into
	             * getter/setters. This method should only be called when
	             * value type is Object.
	             */
	            const keys = Object.keys(value);
	            for (let i = 0; i < keys.length; i++) {
	                const key = keys[i];
	                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
	            }
	        }
	    }
	    /**
	     * Observe a list of Array items.
	     */
	    observeArray(value) {
	        for (let i = 0, l = value.length; i < l; i++) {
	            observe(value[i], false, this.mock);
	        }
	    }
	}
	// helpers
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe(value, shallow, ssrMockReactivity) {
	    if (!isObject(value) || isRef(value) || value instanceof VNode) {
	        return;
	    }
	    let ob;
	    if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	        ob = value.__ob__;
	    }
	    else if (shouldObserve &&
	        (ssrMockReactivity || !isServerRendering()) &&
	        (isArray(value) || isPlainObject(value)) &&
	        Object.isExtensible(value) &&
	        !value.__v_skip /* ReactiveFlags.SKIP */) {
	        ob = new Observer(value, shallow, ssrMockReactivity);
	    }
	    return ob;
	}
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive(obj, key, val, customSetter, shallow, mock) {
	    const dep = new Dep();
	    const property = Object.getOwnPropertyDescriptor(obj, key);
	    if (property && property.configurable === false) {
	        return;
	    }
	    // cater for pre-defined getter/setters
	    const getter = property && property.get;
	    const setter = property && property.set;
	    if ((!getter || setter) &&
	        (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
	        val = obj[key];
	    }
	    let childOb = !shallow && observe(val, false, mock);
	    Object.defineProperty(obj, key, {
	        enumerable: true,
	        configurable: true,
	        get: function reactiveGetter() {
	            const value = getter ? getter.call(obj) : val;
	            if (Dep.target) {
	                {
	                    dep.depend({
	                        target: obj,
	                        type: "get" /* TrackOpTypes.GET */,
	                        key
	                    });
	                }
	                if (childOb) {
	                    childOb.dep.depend();
	                    if (isArray(value)) {
	                        dependArray(value);
	                    }
	                }
	            }
	            return isRef(value) && !shallow ? value.value : value;
	        },
	        set: function reactiveSetter(newVal) {
	            const value = getter ? getter.call(obj) : val;
	            if (!hasChanged(value, newVal)) {
	                return;
	            }
	            if (customSetter) {
	                customSetter();
	            }
	            if (setter) {
	                setter.call(obj, newVal);
	            }
	            else if (getter) {
	                // #7981: for accessor properties without setter
	                return;
	            }
	            else if (!shallow && isRef(value) && !isRef(newVal)) {
	                value.value = newVal;
	                return;
	            }
	            else {
	                val = newVal;
	            }
	            childOb = !shallow && observe(newVal, false, mock);
	            {
	                dep.notify({
	                    type: "set" /* TriggerOpTypes.SET */,
	                    target: obj,
	                    key,
	                    newValue: newVal,
	                    oldValue: value
	                });
	            }
	        }
	    });
	    return dep;
	}
	function set(target, key, val) {
	    if ((isUndef(target) || isPrimitive(target))) {
	        warn(`Cannot set reactive property on undefined, null, or primitive value: ${target}`);
	    }
	    if (isReadonly(target)) {
	        warn(`Set operation on key "${key}" failed: target is readonly.`);
	        return;
	    }
	    const ob = target.__ob__;
	    if (isArray(target) && isValidArrayIndex(key)) {
	        target.length = Math.max(target.length, key);
	        target.splice(key, 1, val);
	        // when mocking for SSR, array methods are not hijacked
	        if (ob && !ob.shallow && ob.mock) {
	            observe(val, false, true);
	        }
	        return val;
	    }
	    if (key in target && !(key in Object.prototype)) {
	        target[key] = val;
	        return val;
	    }
	    if (target._isVue || (ob && ob.vmCount)) {
	        warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
	                'at runtime - declare it upfront in the data option.');
	        return val;
	    }
	    if (!ob) {
	        target[key] = val;
	        return val;
	    }
	    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
	    {
	        ob.dep.notify({
	            type: "add" /* TriggerOpTypes.ADD */,
	            target: target,
	            key,
	            newValue: val,
	            oldValue: undefined
	        });
	    }
	    return val;
	}
	function del(target, key) {
	    if ((isUndef(target) || isPrimitive(target))) {
	        warn(`Cannot delete reactive property on undefined, null, or primitive value: ${target}`);
	    }
	    if (isArray(target) && isValidArrayIndex(key)) {
	        target.splice(key, 1);
	        return;
	    }
	    const ob = target.__ob__;
	    if (target._isVue || (ob && ob.vmCount)) {
	        warn('Avoid deleting properties on a Vue instance or its root $data ' +
	                '- just set it to null.');
	        return;
	    }
	    if (isReadonly(target)) {
	        warn(`Delete operation on key "${key}" failed: target is readonly.`);
	        return;
	    }
	    if (!hasOwn(target, key)) {
	        return;
	    }
	    delete target[key];
	    if (!ob) {
	        return;
	    }
	    {
	        ob.dep.notify({
	            type: "delete" /* TriggerOpTypes.DELETE */,
	            target: target,
	            key
	        });
	    }
	}
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray(value) {
	    for (let e, i = 0, l = value.length; i < l; i++) {
	        e = value[i];
	        if (e && e.__ob__) {
	            e.__ob__.dep.depend();
	        }
	        if (isArray(e)) {
	            dependArray(e);
	        }
	    }
	}

	function reactive(target) {
	    makeReactive(target, false);
	    return target;
	}
	/**
	 * Return a shallowly-reactive copy of the original object, where only the root
	 * level properties are reactive. It also does not auto-unwrap refs (even at the
	 * root level).
	 */
	function shallowReactive(target) {
	    makeReactive(target, true);
	    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
	    return target;
	}
	function makeReactive(target, shallow) {
	    // if trying to observe a readonly proxy, return the readonly version.
	    if (!isReadonly(target)) {
	        {
	            if (isArray(target)) {
	                warn(`Avoid using Array as root value for ${shallow ? `shallowReactive()` : `reactive()`} as it cannot be tracked in watch() or watchEffect(). Use ${shallow ? `shallowRef()` : `ref()`} instead. This is a Vue-2-only limitation.`);
	            }
	            const existingOb = target && target.__ob__;
	            if (existingOb && existingOb.shallow !== shallow) {
	                warn(`Target is already a ${existingOb.shallow ? `` : `non-`}shallow reactive object, and cannot be converted to ${shallow ? `` : `non-`}shallow.`);
	            }
	        }
	        const ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
	        if (!ob) {
	            if (target == null || isPrimitive(target)) {
	                warn(`value cannot be made reactive: ${String(target)}`);
	            }
	            if (isCollectionType(target)) {
	                warn(`Vue 2 does not support reactive collection types such as Map or Set.`);
	            }
	        }
	    }
	}
	function isReactive(value) {
	    if (isReadonly(value)) {
	        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
	    }
	    return !!(value && value.__ob__);
	}
	function isShallow(value) {
	    return !!(value && value.__v_isShallow);
	}
	function isReadonly(value) {
	    return !!(value && value.__v_isReadonly);
	}
	function isProxy(value) {
	    return isReactive(value) || isReadonly(value);
	}
	function toRaw(observed) {
	    const raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
	    return raw ? toRaw(raw) : observed;
	}
	function markRaw(value) {
	    def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
	    return value;
	}
	/**
	 * @internal
	 */
	function isCollectionType(value) {
	    const type = toRawType(value);
	    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
	}

	/**
	 * @internal
	 */
	const RefFlag = `__v_isRef`;
	function isRef(r) {
	    return !!(r && r.__v_isRef === true);
	}
	function ref$1(value) {
	    return createRef(value, false);
	}
	function shallowRef(value) {
	    return createRef(value, true);
	}
	function createRef(rawValue, shallow) {
	    if (isRef(rawValue)) {
	        return rawValue;
	    }
	    const ref = {};
	    def(ref, RefFlag, true);
	    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
	    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
	    return ref;
	}
	function triggerRef(ref) {
	    if (!ref.dep) {
	        warn(`received object is not a triggerable ref.`);
	    }
	    {
	        ref.dep &&
	            ref.dep.notify({
	                type: "set" /* TriggerOpTypes.SET */,
	                target: ref,
	                key: 'value'
	            });
	    }
	}
	function unref(ref) {
	    return isRef(ref) ? ref.value : ref;
	}
	function proxyRefs(objectWithRefs) {
	    if (isReactive(objectWithRefs)) {
	        return objectWithRefs;
	    }
	    const proxy = {};
	    const keys = Object.keys(objectWithRefs);
	    for (let i = 0; i < keys.length; i++) {
	        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
	    }
	    return proxy;
	}
	function proxyWithRefUnwrap(target, source, key) {
	    Object.defineProperty(target, key, {
	        enumerable: true,
	        configurable: true,
	        get: () => {
	            const val = source[key];
	            if (isRef(val)) {
	                return val.value;
	            }
	            else {
	                const ob = val && val.__ob__;
	                if (ob)
	                    ob.dep.depend();
	                return val;
	            }
	        },
	        set: value => {
	            const oldValue = source[key];
	            if (isRef(oldValue) && !isRef(value)) {
	                oldValue.value = value;
	            }
	            else {
	                source[key] = value;
	            }
	        }
	    });
	}
	function customRef(factory) {
	    const dep = new Dep();
	    const { get, set } = factory(() => {
	        {
	            dep.depend({
	                target: ref,
	                type: "get" /* TrackOpTypes.GET */,
	                key: 'value'
	            });
	        }
	    }, () => {
	        {
	            dep.notify({
	                target: ref,
	                type: "set" /* TriggerOpTypes.SET */,
	                key: 'value'
	            });
	        }
	    });
	    const ref = {
	        get value() {
	            return get();
	        },
	        set value(newVal) {
	            set(newVal);
	        }
	    };
	    def(ref, RefFlag, true);
	    return ref;
	}
	function toRefs(object) {
	    if (!isReactive(object)) {
	        warn(`toRefs() expects a reactive object but received a plain one.`);
	    }
	    const ret = isArray(object) ? new Array(object.length) : {};
	    for (const key in object) {
	        ret[key] = toRef(object, key);
	    }
	    return ret;
	}
	function toRef(object, key, defaultValue) {
	    const val = object[key];
	    if (isRef(val)) {
	        return val;
	    }
	    const ref = {
	        get value() {
	            const val = object[key];
	            return val === undefined ? defaultValue : val;
	        },
	        set value(newVal) {
	            object[key] = newVal;
	        }
	    };
	    def(ref, RefFlag, true);
	    return ref;
	}

	const rawToReadonlyFlag = `__v_rawToReadonly`;
	const rawToShallowReadonlyFlag = `__v_rawToShallowReadonly`;
	function readonly(target) {
	    return createReadonly(target, false);
	}
	function createReadonly(target, shallow) {
	    if (!isPlainObject(target)) {
	        {
	            if (isArray(target)) {
	                warn(`Vue 2 does not support readonly arrays.`);
	            }
	            else if (isCollectionType(target)) {
	                warn(`Vue 2 does not support readonly collection types such as Map or Set.`);
	            }
	            else {
	                warn(`value cannot be made readonly: ${typeof target}`);
	            }
	        }
	        return target;
	    }
	    // already a readonly object
	    if (isReadonly(target)) {
	        return target;
	    }
	    // already has a readonly proxy
	    const existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
	    const existingProxy = target[existingFlag];
	    if (existingProxy) {
	        return existingProxy;
	    }
	    const proxy = Object.create(Object.getPrototypeOf(target));
	    def(target, existingFlag, proxy);
	    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
	    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
	    if (isRef(target)) {
	        def(proxy, RefFlag, true);
	    }
	    if (shallow || isShallow(target)) {
	        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
	    }
	    const keys = Object.keys(target);
	    for (let i = 0; i < keys.length; i++) {
	        defineReadonlyProperty(proxy, target, keys[i], shallow);
	    }
	    return proxy;
	}
	function defineReadonlyProperty(proxy, target, key, shallow) {
	    Object.defineProperty(proxy, key, {
	        enumerable: true,
	        configurable: true,
	        get() {
	            const val = target[key];
	            return shallow || !isPlainObject(val) ? val : readonly(val);
	        },
	        set() {
	            warn(`Set operation on key "${key}" failed: target is readonly.`);
	        }
	    });
	}
	/**
	 * Returns a reactive-copy of the original object, where only the root level
	 * properties are readonly, and does NOT unwrap refs nor recursively convert
	 * returned properties.
	 * This is used for creating the props proxy object for stateful components.
	 */
	function shallowReadonly(target) {
	    return createReadonly(target, true);
	}

	function computed(getterOrOptions, debugOptions) {
	    let getter;
	    let setter;
	    const onlyGetter = isFunction(getterOrOptions);
	    if (onlyGetter) {
	        getter = getterOrOptions;
	        setter = () => {
	                warn('Write operation failed: computed value is readonly');
	            }
	            ;
	    }
	    else {
	        getter = getterOrOptions.get;
	        setter = getterOrOptions.set;
	    }
	    const watcher = isServerRendering()
	        ? null
	        : new Watcher(currentInstance, getter, noop, { lazy: true });
	    if (watcher && debugOptions) {
	        watcher.onTrack = debugOptions.onTrack;
	        watcher.onTrigger = debugOptions.onTrigger;
	    }
	    const ref = {
	        // some libs rely on the presence effect for checking computed refs
	        // from normal refs, but the implementation doesn't matter
	        effect: watcher,
	        get value() {
	            if (watcher) {
	                if (watcher.dirty) {
	                    watcher.evaluate();
	                }
	                if (Dep.target) {
	                    if (Dep.target.onTrack) {
	                        Dep.target.onTrack({
	                            effect: Dep.target,
	                            target: ref,
	                            type: "get" /* TrackOpTypes.GET */,
	                            key: 'value'
	                        });
	                    }
	                    watcher.depend();
	                }
	                return watcher.value;
	            }
	            else {
	                return getter();
	            }
	        },
	        set value(newVal) {
	            setter(newVal);
	        }
	    };
	    def(ref, RefFlag, true);
	    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
	    return ref;
	}

	const WATCHER = `watcher`;
	const WATCHER_CB = `${WATCHER} callback`;
	const WATCHER_GETTER = `${WATCHER} getter`;
	const WATCHER_CLEANUP = `${WATCHER} cleanup`;
	// Simple effect.
	function watchEffect(effect, options) {
	    return doWatch(effect, null, options);
	}
	function watchPostEffect(effect, options) {
	    return doWatch(effect, null, (Object.assign(Object.assign({}, options), { flush: 'post' }) ));
	}
	function watchSyncEffect(effect, options) {
	    return doWatch(effect, null, (Object.assign(Object.assign({}, options), { flush: 'sync' }) ));
	}
	// initial value for watchers to trigger on undefined initial values
	const INITIAL_WATCHER_VALUE = {};
	// implementation
	function watch(source, cb, options) {
	    if (typeof cb !== 'function') {
	        warn(`\`watch(fn, options?)\` signature has been moved to a separate API. ` +
	            `Use \`watchEffect(fn, options?)\` instead. \`watch\` now only ` +
	            `supports \`watch(source, cb, options?) signature.`);
	    }
	    return doWatch(source, cb, options);
	}
	function doWatch(source, cb, { immediate, deep, flush = 'pre', onTrack, onTrigger } = emptyObject) {
	    if (!cb) {
	        if (immediate !== undefined) {
	            warn(`watch() "immediate" option is only respected when using the ` +
	                `watch(source, callback, options?) signature.`);
	        }
	        if (deep !== undefined) {
	            warn(`watch() "deep" option is only respected when using the ` +
	                `watch(source, callback, options?) signature.`);
	        }
	    }
	    const warnInvalidSource = (s) => {
	        warn(`Invalid watch source: ${s}. A watch source can only be a getter/effect ` +
	            `function, a ref, a reactive object, or an array of these types.`);
	    };
	    const instance = currentInstance;
	    const call = (fn, type, args = null) => invokeWithErrorHandling(fn, null, args, instance, type);
	    let getter;
	    let forceTrigger = false;
	    let isMultiSource = false;
	    if (isRef(source)) {
	        getter = () => source.value;
	        forceTrigger = isShallow(source);
	    }
	    else if (isReactive(source)) {
	        getter = () => {
	            source.__ob__.dep.depend();
	            return source;
	        };
	        deep = true;
	    }
	    else if (isArray(source)) {
	        isMultiSource = true;
	        forceTrigger = source.some(s => isReactive(s) || isShallow(s));
	        getter = () => source.map(s => {
	            if (isRef(s)) {
	                return s.value;
	            }
	            else if (isReactive(s)) {
	                return traverse(s);
	            }
	            else if (isFunction(s)) {
	                return call(s, WATCHER_GETTER);
	            }
	            else {
	                warnInvalidSource(s);
	            }
	        });
	    }
	    else if (isFunction(source)) {
	        if (cb) {
	            // getter with cb
	            getter = () => call(source, WATCHER_GETTER);
	        }
	        else {
	            // no cb -> simple effect
	            getter = () => {
	                if (instance && instance._isDestroyed) {
	                    return;
	                }
	                if (cleanup) {
	                    cleanup();
	                }
	                return call(source, WATCHER, [onCleanup]);
	            };
	        }
	    }
	    else {
	        getter = noop;
	        warnInvalidSource(source);
	    }
	    if (cb && deep) {
	        const baseGetter = getter;
	        getter = () => traverse(baseGetter());
	    }
	    let cleanup;
	    let onCleanup = (fn) => {
	        cleanup = watcher.onStop = () => {
	            call(fn, WATCHER_CLEANUP);
	        };
	    };
	    // in SSR there is no need to setup an actual effect, and it should be noop
	    // unless it's eager
	    if (isServerRendering()) {
	        // we will also not call the invalidate callback (+ runner is not set up)
	        onCleanup = noop;
	        if (!cb) {
	            getter();
	        }
	        else if (immediate) {
	            call(cb, WATCHER_CB, [
	                getter(),
	                isMultiSource ? [] : undefined,
	                onCleanup
	            ]);
	        }
	        return noop;
	    }
	    const watcher = new Watcher(currentInstance, getter, noop, {
	        lazy: true
	    });
	    watcher.noRecurse = !cb;
	    let oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
	    // overwrite default run
	    watcher.run = () => {
	        if (!watcher.active) {
	            return;
	        }
	        if (cb) {
	            // watch(source, cb)
	            const newValue = watcher.get();
	            if (deep ||
	                forceTrigger ||
	                (isMultiSource
	                    ? newValue.some((v, i) => hasChanged(v, oldValue[i]))
	                    : hasChanged(newValue, oldValue))) {
	                // cleanup before running cb again
	                if (cleanup) {
	                    cleanup();
	                }
	                call(cb, WATCHER_CB, [
	                    newValue,
	                    // pass undefined as the old value when it's changed for the first time
	                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
	                    onCleanup
	                ]);
	                oldValue = newValue;
	            }
	        }
	        else {
	            // watchEffect
	            watcher.get();
	        }
	    };
	    if (flush === 'sync') {
	        watcher.update = watcher.run;
	    }
	    else if (flush === 'post') {
	        watcher.post = true;
	        watcher.update = () => queueWatcher(watcher);
	    }
	    else {
	        // pre
	        watcher.update = () => {
	            if (instance && instance === currentInstance && !instance._isMounted) {
	                // pre-watcher triggered before
	                const buffer = instance._preWatchers || (instance._preWatchers = []);
	                if (buffer.indexOf(watcher) < 0)
	                    buffer.push(watcher);
	            }
	            else {
	                queueWatcher(watcher);
	            }
	        };
	    }
	    {
	        watcher.onTrack = onTrack;
	        watcher.onTrigger = onTrigger;
	    }
	    // initial run
	    if (cb) {
	        if (immediate) {
	            watcher.run();
	        }
	        else {
	            oldValue = watcher.get();
	        }
	    }
	    else if (flush === 'post' && instance) {
	        instance.$once('hook:mounted', () => watcher.get());
	    }
	    else {
	        watcher.get();
	    }
	    return () => {
	        watcher.teardown();
	    };
	}

	let activeEffectScope;
	class EffectScope {
	    constructor(detached = false) {
	        /**
	         * @internal
	         */
	        this.active = true;
	        /**
	         * @internal
	         */
	        this.effects = [];
	        /**
	         * @internal
	         */
	        this.cleanups = [];
	        if (!detached && activeEffectScope) {
	            this.parent = activeEffectScope;
	            this.index =
	                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
	        }
	    }
	    run(fn) {
	        if (this.active) {
	            const currentEffectScope = activeEffectScope;
	            try {
	                activeEffectScope = this;
	                return fn();
	            }
	            finally {
	                activeEffectScope = currentEffectScope;
	            }
	        }
	        else {
	            warn(`cannot run an inactive effect scope.`);
	        }
	    }
	    /**
	     * This should only be called on non-detached scopes
	     * @internal
	     */
	    on() {
	        activeEffectScope = this;
	    }
	    /**
	     * This should only be called on non-detached scopes
	     * @internal
	     */
	    off() {
	        activeEffectScope = this.parent;
	    }
	    stop(fromParent) {
	        if (this.active) {
	            let i, l;
	            for (i = 0, l = this.effects.length; i < l; i++) {
	                this.effects[i].teardown();
	            }
	            for (i = 0, l = this.cleanups.length; i < l; i++) {
	                this.cleanups[i]();
	            }
	            if (this.scopes) {
	                for (i = 0, l = this.scopes.length; i < l; i++) {
	                    this.scopes[i].stop(true);
	                }
	            }
	            // nested scope, dereference from parent to avoid memory leaks
	            if (this.parent && !fromParent) {
	                // optimized O(1) removal
	                const last = this.parent.scopes.pop();
	                if (last && last !== this) {
	                    this.parent.scopes[this.index] = last;
	                    last.index = this.index;
	                }
	            }
	            this.active = false;
	        }
	    }
	}
	function effectScope(detached) {
	    return new EffectScope(detached);
	}
	/**
	 * @internal
	 */
	function recordEffectScope(effect, scope = activeEffectScope) {
	    if (scope && scope.active) {
	        scope.effects.push(effect);
	    }
	}
	function getCurrentScope() {
	    return activeEffectScope;
	}
	function onScopeDispose(fn) {
	    if (activeEffectScope) {
	        activeEffectScope.cleanups.push(fn);
	    }
	    else {
	        warn(`onScopeDispose() is called when there is no active effect scope` +
	            ` to be associated with.`);
	    }
	}

	function provide(key, value) {
	    if (!currentInstance) {
	        {
	            warn(`provide() can only be used inside setup().`);
	        }
	    }
	    else {
	        // TS doesn't allow symbol as index type
	        resolveProvided(currentInstance)[key] = value;
	    }
	}
	function resolveProvided(vm) {
	    // by default an instance inherits its parent's provides object
	    // but when it needs to provide values of its own, it creates its
	    // own provides object using parent provides object as prototype.
	    // this way in `inject` we can simply look up injections from direct
	    // parent and let the prototype chain do the work.
	    const existing = vm._provided;
	    const parentProvides = vm.$parent && vm.$parent._provided;
	    if (parentProvides === existing) {
	        return (vm._provided = Object.create(parentProvides));
	    }
	    else {
	        return existing;
	    }
	}
	function inject(key, defaultValue, treatDefaultAsFactory = false) {
	    // fallback to `currentRenderingInstance` so that this can be called in
	    // a functional component
	    const instance = currentInstance;
	    if (instance) {
	        // #2400
	        // to support `app.use` plugins,
	        // fallback to appContext's `provides` if the instance is at root
	        const provides = instance.$parent && instance.$parent._provided;
	        if (provides && key in provides) {
	            // TS doesn't allow symbol as index type
	            return provides[key];
	        }
	        else if (arguments.length > 1) {
	            return treatDefaultAsFactory && isFunction(defaultValue)
	                ? defaultValue.call(instance)
	                : defaultValue;
	        }
	        else {
	            warn(`injection "${String(key)}" not found.`);
	        }
	    }
	    else {
	        warn(`inject() can only be used inside setup() or functional components.`);
	    }
	}

	const normalizeEvent = cached((name) => {
	    const passive = name.charAt(0) === '&';
	    name = passive ? name.slice(1) : name;
	    const once = name.charAt(0) === '~'; // Prefixed last, checked first
	    name = once ? name.slice(1) : name;
	    const capture = name.charAt(0) === '!';
	    name = capture ? name.slice(1) : name;
	    return {
	        name,
	        once,
	        capture,
	        passive
	    };
	});
	function createFnInvoker(fns, vm) {
	    function invoker() {
	        const fns = invoker.fns;
	        if (isArray(fns)) {
	            const cloned = fns.slice();
	            for (let i = 0; i < cloned.length; i++) {
	                invokeWithErrorHandling(cloned[i], null, arguments, vm, `v-on handler`);
	            }
	        }
	        else {
	            // return handler return value for single handlers
	            return invokeWithErrorHandling(fns, null, arguments, vm, `v-on handler`);
	        }
	    }
	    invoker.fns = fns;
	    return invoker;
	}
	function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
	    let name, cur, old, event;
	    for (name in on) {
	        cur = on[name];
	        old = oldOn[name];
	        event = normalizeEvent(name);
	        if (isUndef(cur)) {
	            warn(`Invalid handler for event "${event.name}": got ` + String(cur), vm);
	        }
	        else if (isUndef(old)) {
	            if (isUndef(cur.fns)) {
	                cur = on[name] = createFnInvoker(cur, vm);
	            }
	            if (isTrue(event.once)) {
	                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
	            }
	            add(event.name, cur, event.capture, event.passive, event.params);
	        }
	        else if (cur !== old) {
	            old.fns = cur;
	            on[name] = old;
	        }
	    }
	    for (name in oldOn) {
	        if (isUndef(on[name])) {
	            event = normalizeEvent(name);
	            remove(event.name, oldOn[name], event.capture);
	        }
	    }
	}

	function mergeVNodeHook(def, hookKey, hook) {
	    if (def instanceof VNode) {
	        def = def.data.hook || (def.data.hook = {});
	    }
	    let invoker;
	    const oldHook = def[hookKey];
	    function wrappedHook() {
	        hook.apply(this, arguments);
	        // important: remove merged hook to ensure it's called only once
	        // and prevent memory leak
	        remove$2(invoker.fns, wrappedHook);
	    }
	    if (isUndef(oldHook)) {
	        // no existing hook
	        invoker = createFnInvoker([wrappedHook]);
	    }
	    else {
	        /* istanbul ignore if */
	        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
	            // already a merged invoker
	            invoker = oldHook;
	            invoker.fns.push(wrappedHook);
	        }
	        else {
	            // existing plain hook
	            invoker = createFnInvoker([oldHook, wrappedHook]);
	        }
	    }
	    invoker.merged = true;
	    def[hookKey] = invoker;
	}

	function extractPropsFromVNodeData(data, Ctor, tag) {
	    // we are only extracting raw values here.
	    // validation and default values are handled in the child
	    // component itself.
	    const propOptions = Ctor.options.props;
	    if (isUndef(propOptions)) {
	        return;
	    }
	    const res = {};
	    const { attrs, props } = data;
	    if (isDef(attrs) || isDef(props)) {
	        for (const key in propOptions) {
	            const altKey = hyphenate(key);
	            {
	                const keyInLowerCase = key.toLowerCase();
	                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
	                    tip(`Prop "${keyInLowerCase}" is passed to component ` +
	                        `${formatComponentName(
	                        // @ts-expect-error tag is string
	                        tag || Ctor)}, but the declared prop name is` +
	                        ` "${key}". ` +
	                        `Note that HTML attributes are case-insensitive and camelCased ` +
	                        `props need to use their kebab-case equivalents when using in-DOM ` +
	                        `templates. You should probably use "${altKey}" instead of "${key}".`);
	                }
	            }
	            checkProp(res, props, key, altKey, true) ||
	                checkProp(res, attrs, key, altKey, false);
	        }
	    }
	    return res;
	}
	function checkProp(res, hash, key, altKey, preserve) {
	    if (isDef(hash)) {
	        if (hasOwn(hash, key)) {
	            res[key] = hash[key];
	            if (!preserve) {
	                delete hash[key];
	            }
	            return true;
	        }
	        else if (hasOwn(hash, altKey)) {
	            res[key] = hash[altKey];
	            if (!preserve) {
	                delete hash[altKey];
	            }
	            return true;
	        }
	    }
	    return false;
	}

	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// normalization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren(children) {
	    for (let i = 0; i < children.length; i++) {
	        if (isArray(children[i])) {
	            return Array.prototype.concat.apply([], children);
	        }
	    }
	    return children;
	}
	// 2. When the children contains constructs that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren(children) {
	    return isPrimitive(children)
	        ? [createTextVNode(children)]
	        : isArray(children)
	            ? normalizeArrayChildren(children)
	            : undefined;
	}
	function isTextNode(node) {
	    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
	}
	function normalizeArrayChildren(children, nestedIndex) {
	    const res = [];
	    let i, c, lastIndex, last;
	    for (i = 0; i < children.length; i++) {
	        c = children[i];
	        if (isUndef(c) || typeof c === 'boolean')
	            continue;
	        lastIndex = res.length - 1;
	        last = res[lastIndex];
	        //  nested
	        if (isArray(c)) {
	            if (c.length > 0) {
	                c = normalizeArrayChildren(c, `${nestedIndex || ''}_${i}`);
	                // merge adjacent text nodes
	                if (isTextNode(c[0]) && isTextNode(last)) {
	                    res[lastIndex] = createTextVNode(last.text + c[0].text);
	                    c.shift();
	                }
	                res.push.apply(res, c);
	            }
	        }
	        else if (isPrimitive(c)) {
	            if (isTextNode(last)) {
	                // merge adjacent text nodes
	                // this is necessary for SSR hydration because text nodes are
	                // essentially merged when rendered to HTML strings
	                res[lastIndex] = createTextVNode(last.text + c);
	            }
	            else if (c !== '') {
	                // convert primitive to vnode
	                res.push(createTextVNode(c));
	            }
	        }
	        else {
	            if (isTextNode(c) && isTextNode(last)) {
	                // merge adjacent text nodes
	                res[lastIndex] = createTextVNode(last.text + c.text);
	            }
	            else {
	                // default key for nested array children (likely generated by v-for)
	                if (isTrue(children._isVList) &&
	                    isDef(c.tag) &&
	                    isUndef(c.key) &&
	                    isDef(nestedIndex)) {
	                    c.key = `__vlist${nestedIndex}_${i}__`;
	                }
	                res.push(c);
	            }
	        }
	    }
	    return res;
	}

	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList(val, render) {
	    let ret = null, i, l, keys, key;
	    if (isArray(val) || typeof val === 'string') {
	        ret = new Array(val.length);
	        for (i = 0, l = val.length; i < l; i++) {
	            ret[i] = render(val[i], i);
	        }
	    }
	    else if (typeof val === 'number') {
	        ret = new Array(val);
	        for (i = 0; i < val; i++) {
	            ret[i] = render(i + 1, i);
	        }
	    }
	    else if (isObject(val)) {
	        if (hasSymbol && val[Symbol.iterator]) {
	            ret = [];
	            const iterator = val[Symbol.iterator]();
	            let result = iterator.next();
	            while (!result.done) {
	                ret.push(render(result.value, ret.length));
	                result = iterator.next();
	            }
	        }
	        else {
	            keys = Object.keys(val);
	            ret = new Array(keys.length);
	            for (i = 0, l = keys.length; i < l; i++) {
	                key = keys[i];
	                ret[i] = render(val[key], key, i);
	            }
	        }
	    }
	    if (!isDef(ret)) {
	        ret = [];
	    }
	    ret._isVList = true;
	    return ret;
	}

	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot(name, fallbackRender, props, bindObject) {
	    const scopedSlotFn = this.$scopedSlots[name];
	    let nodes;
	    if (scopedSlotFn) {
	        // scoped slot
	        props = props || {};
	        if (bindObject) {
	            if (!isObject(bindObject)) {
	                warn('slot v-bind without argument expects an Object', this);
	            }
	            props = extend(extend({}, bindObject), props);
	        }
	        nodes =
	            scopedSlotFn(props) ||
	                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
	    }
	    else {
	        nodes =
	            this.$slots[name] ||
	                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
	    }
	    const target = props && props.slot;
	    if (target) {
	        return this.$createElement('template', { slot: target }, nodes);
	    }
	    else {
	        return nodes;
	    }
	}

	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter(id) {
	    return resolveAsset(this.$options, 'filters', id, true) || identity;
	}

	function isKeyNotMatch(expect, actual) {
	    if (isArray(expect)) {
	        return expect.indexOf(actual) === -1;
	    }
	    else {
	        return expect !== actual;
	    }
	}
	/**
	 * Runtime helper for checking keyCodes from config.
	 * exposed as Vue.prototype._k
	 * passing in eventKeyName as last argument separately for backwards compat
	 */
	function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
	    const mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
	    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
	        return isKeyNotMatch(builtInKeyName, eventKeyName);
	    }
	    else if (mappedKeyCode) {
	        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
	    }
	    else if (eventKeyName) {
	        return hyphenate(eventKeyName) !== key;
	    }
	    return eventKeyCode === undefined;
	}

	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps(data, tag, value, asProp, isSync) {
	    if (value) {
	        if (!isObject(value)) {
	            warn('v-bind without argument expects an Object or Array value', this);
	        }
	        else {
	            if (isArray(value)) {
	                value = toObject(value);
	            }
	            let hash;
	            for (const key in value) {
	                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
	                    hash = data;
	                }
	                else {
	                    const type = data.attrs && data.attrs.type;
	                    hash =
	                        asProp || config.mustUseProp(tag, type, key)
	                            ? data.domProps || (data.domProps = {})
	                            : data.attrs || (data.attrs = {});
	                }
	                const camelizedKey = camelize(key);
	                const hyphenatedKey = hyphenate(key);
	                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
	                    hash[key] = value[key];
	                    if (isSync) {
	                        const on = data.on || (data.on = {});
	                        on[`update:${key}`] = function ($event) {
	                            value[key] = $event;
	                        };
	                    }
	                }
	            }
	        }
	    }
	    return data;
	}

	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic(index, isInFor) {
	    const cached = this._staticTrees || (this._staticTrees = []);
	    let tree = cached[index];
	    // if has already-rendered static tree and not inside v-for,
	    // we can reuse the same tree.
	    if (tree && !isInFor) {
	        return tree;
	    }
	    // otherwise, render a fresh tree.
	    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
	    );
	    markStatic(tree, `__static__${index}`, false);
	    return tree;
	}
	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce(tree, index, key) {
	    markStatic(tree, `__once__${index}${key ? `_${key}` : ``}`, true);
	    return tree;
	}
	function markStatic(tree, key, isOnce) {
	    if (isArray(tree)) {
	        for (let i = 0; i < tree.length; i++) {
	            if (tree[i] && typeof tree[i] !== 'string') {
	                markStaticNode(tree[i], `${key}_${i}`, isOnce);
	            }
	        }
	    }
	    else {
	        markStaticNode(tree, key, isOnce);
	    }
	}
	function markStaticNode(node, key, isOnce) {
	    node.isStatic = true;
	    node.key = key;
	    node.isOnce = isOnce;
	}

	function bindObjectListeners(data, value) {
	    if (value) {
	        if (!isPlainObject(value)) {
	            warn('v-on without argument expects an Object value', this);
	        }
	        else {
	            const on = (data.on = data.on ? extend({}, data.on) : {});
	            for (const key in value) {
	                const existing = on[key];
	                const ours = value[key];
	                on[key] = existing ? [].concat(existing, ours) : ours;
	            }
	        }
	    }
	    return data;
	}

	function resolveScopedSlots(fns, res, 
	// the following are added in 2.6
	hasDynamicKeys, contentHashKey) {
	    res = res || { $stable: !hasDynamicKeys };
	    for (let i = 0; i < fns.length; i++) {
	        const slot = fns[i];
	        if (isArray(slot)) {
	            resolveScopedSlots(slot, res, hasDynamicKeys);
	        }
	        else if (slot) {
	            // marker for reverse proxying v-slot without scope on this.$slots
	            // @ts-expect-error
	            if (slot.proxy) {
	                // @ts-expect-error
	                slot.fn.proxy = true;
	            }
	            res[slot.key] = slot.fn;
	        }
	    }
	    if (contentHashKey) {
	        res.$key = contentHashKey;
	    }
	    return res;
	}

	// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
	function bindDynamicKeys(baseObj, values) {
	    for (let i = 0; i < values.length; i += 2) {
	        const key = values[i];
	        if (typeof key === 'string' && key) {
	            baseObj[values[i]] = values[i + 1];
	        }
	        else if (key !== '' && key !== null) {
	            // null is a special value for explicitly removing a binding
	            warn(`Invalid value for dynamic directive argument (expected string or null): ${key}`, this);
	        }
	    }
	    return baseObj;
	}
	// helper to dynamically append modifier runtime markers to event names.
	// ensure only append when value is already string, otherwise it will be cast
	// to string and cause the type check to miss.
	function prependModifier(value, symbol) {
	    return typeof value === 'string' ? symbol + value : value;
	}

	function installRenderHelpers(target) {
	    target._o = markOnce;
	    target._n = toNumber;
	    target._s = toString;
	    target._l = renderList;
	    target._t = renderSlot;
	    target._q = looseEqual;
	    target._i = looseIndexOf;
	    target._m = renderStatic;
	    target._f = resolveFilter;
	    target._k = checkKeyCodes;
	    target._b = bindObjectProps;
	    target._v = createTextVNode;
	    target._e = createEmptyVNode;
	    target._u = resolveScopedSlots;
	    target._g = bindObjectListeners;
	    target._d = bindDynamicKeys;
	    target._p = prependModifier;
	}

	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots(children, context) {
	    if (!children || !children.length) {
	        return {};
	    }
	    const slots = {};
	    for (let i = 0, l = children.length; i < l; i++) {
	        const child = children[i];
	        const data = child.data;
	        // remove slot attribute if the node is resolved as a Vue slot node
	        if (data && data.attrs && data.attrs.slot) {
	            delete data.attrs.slot;
	        }
	        // named slots should only be respected if the vnode was rendered in the
	        // same context.
	        if ((child.context === context || child.fnContext === context) &&
	            data &&
	            data.slot != null) {
	            const name = data.slot;
	            const slot = slots[name] || (slots[name] = []);
	            if (child.tag === 'template') {
	                slot.push.apply(slot, child.children || []);
	            }
	            else {
	                slot.push(child);
	            }
	        }
	        else {
	            (slots.default || (slots.default = [])).push(child);
	        }
	    }
	    // ignore slots that contains only whitespace
	    for (const name in slots) {
	        if (slots[name].every(isWhitespace)) {
	            delete slots[name];
	        }
	    }
	    return slots;
	}
	function isWhitespace(node) {
	    return (node.isComment && !node.asyncFactory) || node.text === ' ';
	}

	function isAsyncPlaceholder(node) {
	    // @ts-expect-error not really boolean type
	    return node.isComment && node.asyncFactory;
	}

	function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
	    let res;
	    const hasNormalSlots = Object.keys(normalSlots).length > 0;
	    const isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
	    const key = scopedSlots && scopedSlots.$key;
	    if (!scopedSlots) {
	        res = {};
	    }
	    else if (scopedSlots._normalized) {
	        // fast path 1: child component re-render only, parent did not change
	        return scopedSlots._normalized;
	    }
	    else if (isStable &&
	        prevScopedSlots &&
	        prevScopedSlots !== emptyObject &&
	        key === prevScopedSlots.$key &&
	        !hasNormalSlots &&
	        !prevScopedSlots.$hasNormal) {
	        // fast path 2: stable scoped slots w/ no normal slots to proxy,
	        // only need to normalize once
	        return prevScopedSlots;
	    }
	    else {
	        res = {};
	        for (const key in scopedSlots) {
	            if (scopedSlots[key] && key[0] !== '$') {
	                res[key] = normalizeScopedSlot(ownerVm, normalSlots, key, scopedSlots[key]);
	            }
	        }
	    }
	    // expose normal slots on scopedSlots
	    for (const key in normalSlots) {
	        if (!(key in res)) {
	            res[key] = proxyNormalSlot(normalSlots, key);
	        }
	    }
	    // avoriaz seems to mock a non-extensible $scopedSlots object
	    // and when that is passed down this would cause an error
	    if (scopedSlots && Object.isExtensible(scopedSlots)) {
	        scopedSlots._normalized = res;
	    }
	    def(res, '$stable', isStable);
	    def(res, '$key', key);
	    def(res, '$hasNormal', hasNormalSlots);
	    return res;
	}
	function normalizeScopedSlot(vm, normalSlots, key, fn) {
	    const normalized = function () {
	        const cur = currentInstance;
	        setCurrentInstance(vm);
	        let res = arguments.length ? fn.apply(null, arguments) : fn({});
	        res =
	            res && typeof res === 'object' && !isArray(res)
	                ? [res] // single vnode
	                : normalizeChildren(res);
	        const vnode = res && res[0];
	        setCurrentInstance(cur);
	        return res &&
	            (!vnode ||
	                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
	            ? undefined
	            : res;
	    };
	    // this is a slot using the new v-slot syntax without scope. although it is
	    // compiled as a scoped slot, render fn users would expect it to be present
	    // on this.$slots because the usage is semantically a normal slot.
	    if (fn.proxy) {
	        Object.defineProperty(normalSlots, key, {
	            get: normalized,
	            enumerable: true,
	            configurable: true
	        });
	    }
	    return normalized;
	}
	function proxyNormalSlot(slots, key) {
	    return () => slots[key];
	}

	function initSetup(vm) {
	    const options = vm.$options;
	    const setup = options.setup;
	    if (setup) {
	        const ctx = (vm._setupContext = createSetupContext(vm));
	        setCurrentInstance(vm);
	        pushTarget();
	        const setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, `setup`);
	        popTarget();
	        setCurrentInstance();
	        if (isFunction(setupResult)) {
	            // render function
	            // @ts-ignore
	            options.render = setupResult;
	        }
	        else if (isObject(setupResult)) {
	            // bindings
	            if (setupResult instanceof VNode) {
	                warn(`setup() should not return VNodes directly - ` +
	                    `return a render function instead.`);
	            }
	            vm._setupState = setupResult;
	            // __sfc indicates compiled bindings from <script setup>
	            if (!setupResult.__sfc) {
	                for (const key in setupResult) {
	                    if (!isReserved(key)) {
	                        proxyWithRefUnwrap(vm, setupResult, key);
	                    }
	                    else {
	                        warn(`Avoid using variables that start with _ or $ in setup().`);
	                    }
	                }
	            }
	            else {
	                // exposed for compiled render fn
	                const proxy = (vm._setupProxy = {});
	                for (const key in setupResult) {
	                    if (key !== '__sfc') {
	                        proxyWithRefUnwrap(proxy, setupResult, key);
	                    }
	                }
	            }
	        }
	        else if (setupResult !== undefined) {
	            warn(`setup() should return an object. Received: ${setupResult === null ? 'null' : typeof setupResult}`);
	        }
	    }
	}
	function createSetupContext(vm) {
	    let exposeCalled = false;
	    return {
	        get attrs() {
	            if (!vm._attrsProxy) {
	                const proxy = (vm._attrsProxy = {});
	                def(proxy, '_v_attr_proxy', true);
	                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
	            }
	            return vm._attrsProxy;
	        },
	        get listeners() {
	            if (!vm._listenersProxy) {
	                const proxy = (vm._listenersProxy = {});
	                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
	            }
	            return vm._listenersProxy;
	        },
	        get slots() {
	            return initSlotsProxy(vm);
	        },
	        emit: bind(vm.$emit, vm),
	        expose(exposed) {
	            {
	                if (exposeCalled) {
	                    warn(`expose() should be called only once per setup().`, vm);
	                }
	                exposeCalled = true;
	            }
	            if (exposed) {
	                Object.keys(exposed).forEach(key => proxyWithRefUnwrap(vm, exposed, key));
	            }
	        }
	    };
	}
	function syncSetupProxy(to, from, prev, instance, type) {
	    let changed = false;
	    for (const key in from) {
	        if (!(key in to)) {
	            changed = true;
	            defineProxyAttr(to, key, instance, type);
	        }
	        else if (from[key] !== prev[key]) {
	            changed = true;
	        }
	    }
	    for (const key in to) {
	        if (!(key in from)) {
	            changed = true;
	            delete to[key];
	        }
	    }
	    return changed;
	}
	function defineProxyAttr(proxy, key, instance, type) {
	    Object.defineProperty(proxy, key, {
	        enumerable: true,
	        configurable: true,
	        get() {
	            return instance[type][key];
	        }
	    });
	}
	function initSlotsProxy(vm) {
	    if (!vm._slotsProxy) {
	        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
	    }
	    return vm._slotsProxy;
	}
	function syncSetupSlots(to, from) {
	    for (const key in from) {
	        to[key] = from[key];
	    }
	    for (const key in to) {
	        if (!(key in from)) {
	            delete to[key];
	        }
	    }
	}
	/**
	 * @internal use manual type def because public setup context type relies on
	 * legacy VNode types
	 */
	function useSlots() {
	    return getContext().slots;
	}
	/**
	 * @internal use manual type def because public setup context type relies on
	 * legacy VNode types
	 */
	function useAttrs() {
	    return getContext().attrs;
	}
	/**
	 * Vue 2 only
	 * @internal use manual type def because public setup context type relies on
	 * legacy VNode types
	 */
	function useListeners() {
	    return getContext().listeners;
	}
	function getContext() {
	    if (!currentInstance) {
	        warn(`useContext() called without active instance.`);
	    }
	    const vm = currentInstance;
	    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
	}
	/**
	 * Runtime helper for merging default declarations. Imported by compiled code
	 * only.
	 * @internal
	 */
	function mergeDefaults(raw, defaults) {
	    const props = isArray(raw)
	        ? raw.reduce((normalized, p) => ((normalized[p] = {}), normalized), {})
	        : raw;
	    for (const key in defaults) {
	        const opt = props[key];
	        if (opt) {
	            if (isArray(opt) || isFunction(opt)) {
	                props[key] = { type: opt, default: defaults[key] };
	            }
	            else {
	                opt.default = defaults[key];
	            }
	        }
	        else if (opt === null) {
	            props[key] = { default: defaults[key] };
	        }
	        else {
	            warn(`props default key "${key}" has no corresponding declaration.`);
	        }
	    }
	    return props;
	}

	function initRender(vm) {
	    vm._vnode = null; // the root of the child tree
	    vm._staticTrees = null; // v-once cached trees
	    const options = vm.$options;
	    const parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
	    const renderContext = parentVnode && parentVnode.context;
	    vm.$slots = resolveSlots(options._renderChildren, renderContext);
	    vm.$scopedSlots = parentVnode
	        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
	        : emptyObject;
	    // bind the createElement fn to this instance
	    // so that we get proper render context inside it.
	    // args order: tag, data, children, normalizationType, alwaysNormalize
	    // internal version is used by render functions compiled from templates
	    // @ts-expect-error
	    vm._c = (a, b, c, d) => createElement$1(vm, a, b, c, d, false);
	    // normalization is always applied for the public version, used in
	    // user-written render functions.
	    // @ts-expect-error
	    vm.$createElement = (a, b, c, d) => createElement$1(vm, a, b, c, d, true);
	    // $attrs & $listeners are exposed for easier HOC creation.
	    // they need to be reactive so that HOCs using them are always updated
	    const parentData = parentVnode && parentVnode.data;
	    /* istanbul ignore else */
	    {
	        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, () => {
	            !isUpdatingChildComponent && warn(`$attrs is readonly.`, vm);
	        }, true);
	        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, () => {
	            !isUpdatingChildComponent && warn(`$listeners is readonly.`, vm);
	        }, true);
	    }
	}
	let currentRenderingInstance = null;
	function renderMixin(Vue) {
	    // install runtime convenience helpers
	    installRenderHelpers(Vue.prototype);
	    Vue.prototype.$nextTick = function (fn) {
	        return nextTick(fn, this);
	    };
	    Vue.prototype._render = function () {
	        const vm = this;
	        const { render, _parentVnode } = vm.$options;
	        if (_parentVnode && vm._isMounted) {
	            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
	            if (vm._slotsProxy) {
	                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
	            }
	        }
	        // set parent vnode. this allows render functions to have access
	        // to the data on the placeholder node.
	        vm.$vnode = _parentVnode;
	        // render self
	        let vnode;
	        try {
	            // There's no need to maintain a stack because all render fns are called
	            // separately from one another. Nested component's render fns are called
	            // when parent component is patched.
	            setCurrentInstance(vm);
	            currentRenderingInstance = vm;
	            vnode = render.call(vm._renderProxy, vm.$createElement);
	        }
	        catch (e) {
	            handleError(e, vm, `render`);
	            // return error render result,
	            // or previous vnode to prevent render error causing blank component
	            /* istanbul ignore else */
	            if (vm.$options.renderError) {
	                try {
	                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
	                }
	                catch (e) {
	                    handleError(e, vm, `renderError`);
	                    vnode = vm._vnode;
	                }
	            }
	            else {
	                vnode = vm._vnode;
	            }
	        }
	        finally {
	            currentRenderingInstance = null;
	            setCurrentInstance();
	        }
	        // if the returned array contains only a single node, allow it
	        if (isArray(vnode) && vnode.length === 1) {
	            vnode = vnode[0];
	        }
	        // return empty vnode in case the render function errored out
	        if (!(vnode instanceof VNode)) {
	            if (isArray(vnode)) {
	                warn('Multiple root nodes returned from render function. Render function ' +
	                    'should return a single root node.', vm);
	            }
	            vnode = createEmptyVNode();
	        }
	        // set parent
	        vnode.parent = _parentVnode;
	        return vnode;
	    };
	}

	function ensureCtor(comp, base) {
	    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
	        comp = comp.default;
	    }
	    return isObject(comp) ? base.extend(comp) : comp;
	}
	function createAsyncPlaceholder(factory, data, context, children, tag) {
	    const node = createEmptyVNode();
	    node.asyncFactory = factory;
	    node.asyncMeta = { data, context, children, tag };
	    return node;
	}
	function resolveAsyncComponent(factory, baseCtor) {
	    if (isTrue(factory.error) && isDef(factory.errorComp)) {
	        return factory.errorComp;
	    }
	    if (isDef(factory.resolved)) {
	        return factory.resolved;
	    }
	    const owner = currentRenderingInstance;
	    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
	        // already pending
	        factory.owners.push(owner);
	    }
	    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
	        return factory.loadingComp;
	    }
	    if (owner && !isDef(factory.owners)) {
	        const owners = (factory.owners = [owner]);
	        let sync = true;
	        let timerLoading = null;
	        let timerTimeout = null;
	        owner.$on('hook:destroyed', () => remove$2(owners, owner));
	        const forceRender = (renderCompleted) => {
	            for (let i = 0, l = owners.length; i < l; i++) {
	                owners[i].$forceUpdate();
	            }
	            if (renderCompleted) {
	                owners.length = 0;
	                if (timerLoading !== null) {
	                    clearTimeout(timerLoading);
	                    timerLoading = null;
	                }
	                if (timerTimeout !== null) {
	                    clearTimeout(timerTimeout);
	                    timerTimeout = null;
	                }
	            }
	        };
	        const resolve = once((res) => {
	            // cache resolved
	            factory.resolved = ensureCtor(res, baseCtor);
	            // invoke callbacks only if this is not a synchronous resolve
	            // (async resolves are shimmed as synchronous during SSR)
	            if (!sync) {
	                forceRender(true);
	            }
	            else {
	                owners.length = 0;
	            }
	        });
	        const reject = once(reason => {
	            warn(`Failed to resolve async component: ${String(factory)}` +
	                    (reason ? `\nReason: ${reason}` : ''));
	            if (isDef(factory.errorComp)) {
	                factory.error = true;
	                forceRender(true);
	            }
	        });
	        const res = factory(resolve, reject);
	        if (isObject(res)) {
	            if (isPromise(res)) {
	                // () => Promise
	                if (isUndef(factory.resolved)) {
	                    res.then(resolve, reject);
	                }
	            }
	            else if (isPromise(res.component)) {
	                res.component.then(resolve, reject);
	                if (isDef(res.error)) {
	                    factory.errorComp = ensureCtor(res.error, baseCtor);
	                }
	                if (isDef(res.loading)) {
	                    factory.loadingComp = ensureCtor(res.loading, baseCtor);
	                    if (res.delay === 0) {
	                        factory.loading = true;
	                    }
	                    else {
	                        // @ts-expect-error NodeJS timeout type
	                        timerLoading = setTimeout(() => {
	                            timerLoading = null;
	                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
	                                factory.loading = true;
	                                forceRender(false);
	                            }
	                        }, res.delay || 200);
	                    }
	                }
	                if (isDef(res.timeout)) {
	                    // @ts-expect-error NodeJS timeout type
	                    timerTimeout = setTimeout(() => {
	                        timerTimeout = null;
	                        if (isUndef(factory.resolved)) {
	                            reject(`timeout (${res.timeout}ms)` );
	                        }
	                    }, res.timeout);
	                }
	            }
	        }
	        sync = false;
	        // return in case resolved synchronously
	        return factory.loading ? factory.loadingComp : factory.resolved;
	    }
	}

	function getFirstComponentChild(children) {
	    if (isArray(children)) {
	        for (let i = 0; i < children.length; i++) {
	            const c = children[i];
	            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
	                return c;
	            }
	        }
	    }
	}

	const SIMPLE_NORMALIZE = 1;
	const ALWAYS_NORMALIZE = 2;
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
	    if (isArray(data) || isPrimitive(data)) {
	        normalizationType = children;
	        children = data;
	        data = undefined;
	    }
	    if (isTrue(alwaysNormalize)) {
	        normalizationType = ALWAYS_NORMALIZE;
	    }
	    return _createElement(context, tag, data, children, normalizationType);
	}
	function _createElement(context, tag, data, children, normalizationType) {
	    if (isDef(data) && isDef(data.__ob__)) {
	        warn(`Avoid using observed data object as vnode data: ${JSON.stringify(data)}\n` + 'Always create fresh vnode data objects in each render!', context);
	        return createEmptyVNode();
	    }
	    // object syntax in v-bind
	    if (isDef(data) && isDef(data.is)) {
	        tag = data.is;
	    }
	    if (!tag) {
	        // in case of component :is set to falsy value
	        return createEmptyVNode();
	    }
	    // warn against non-primitive key
	    if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
	        warn('Avoid using non-primitive value as key, ' +
	            'use string/number value instead.', context);
	    }
	    // support single function children as default scoped slot
	    if (isArray(children) && isFunction(children[0])) {
	        data = data || {};
	        data.scopedSlots = { default: children[0] };
	        children.length = 0;
	    }
	    if (normalizationType === ALWAYS_NORMALIZE) {
	        children = normalizeChildren(children);
	    }
	    else if (normalizationType === SIMPLE_NORMALIZE) {
	        children = simpleNormalizeChildren(children);
	    }
	    let vnode, ns;
	    if (typeof tag === 'string') {
	        let Ctor;
	        ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
	        if (config.isReservedTag(tag)) {
	            // platform built-in elements
	            if (isDef(data) &&
	                isDef(data.nativeOn) &&
	                data.tag !== 'component') {
	                warn(`The .native modifier for v-on is only valid on components but it was used on <${tag}>.`, context);
	            }
	            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
	        }
	        else if ((!data || !data.pre) &&
	            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
	            // component
	            vnode = createComponent(Ctor, data, context, children, tag);
	        }
	        else {
	            // unknown or unlisted namespaced elements
	            // check at runtime because it may get assigned a namespace when its
	            // parent normalizes children
	            vnode = new VNode(tag, data, children, undefined, undefined, context);
	        }
	    }
	    else {
	        // direct component options / constructor
	        vnode = createComponent(tag, data, context, children);
	    }
	    if (isArray(vnode)) {
	        return vnode;
	    }
	    else if (isDef(vnode)) {
	        if (isDef(ns))
	            applyNS(vnode, ns);
	        if (isDef(data))
	            registerDeepBindings(data);
	        return vnode;
	    }
	    else {
	        return createEmptyVNode();
	    }
	}
	function applyNS(vnode, ns, force) {
	    vnode.ns = ns;
	    if (vnode.tag === 'foreignObject') {
	        // use default namespace inside foreignObject
	        ns = undefined;
	        force = true;
	    }
	    if (isDef(vnode.children)) {
	        for (let i = 0, l = vnode.children.length; i < l; i++) {
	            const child = vnode.children[i];
	            if (isDef(child.tag) &&
	                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
	                applyNS(child, ns, force);
	            }
	        }
	    }
	}
	// ref #5318
	// necessary to ensure parent re-render when deep bindings like :style and
	// :class are used on slot nodes
	function registerDeepBindings(data) {
	    if (isObject(data.style)) {
	        traverse(data.style);
	    }
	    if (isObject(data.class)) {
	        traverse(data.class);
	    }
	}

	/**
	 * @internal this function needs manual public type declaration because it relies
	 * on previously manually authored types from Vue 2
	 */
	function h(type, props, children) {
	    if (!currentInstance) {
	        warn(`globally imported h() can only be invoked when there is an active ` +
	                `component instance, e.g. synchronously in a component's render or setup function.`);
	    }
	    return createElement$1(currentInstance, type, props, children, 2, true);
	}

	function handleError(err, vm, info) {
	    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
	    // See: https://github.com/vuejs/vuex/issues/1505
	    pushTarget();
	    try {
	        if (vm) {
	            let cur = vm;
	            while ((cur = cur.$parent)) {
	                const hooks = cur.$options.errorCaptured;
	                if (hooks) {
	                    for (let i = 0; i < hooks.length; i++) {
	                        try {
	                            const capture = hooks[i].call(cur, err, vm, info) === false;
	                            if (capture)
	                                return;
	                        }
	                        catch (e) {
	                            globalHandleError(e, cur, 'errorCaptured hook');
	                        }
	                    }
	                }
	            }
	        }
	        globalHandleError(err, vm, info);
	    }
	    finally {
	        popTarget();
	    }
	}
	function invokeWithErrorHandling(handler, context, args, vm, info) {
	    let res;
	    try {
	        res = args ? handler.apply(context, args) : handler.call(context);
	        if (res && !res._isVue && isPromise(res) && !res._handled) {
	            res.catch(e => handleError(e, vm, info + ` (Promise/async)`));
	            res._handled = true;
	        }
	    }
	    catch (e) {
	        handleError(e, vm, info);
	    }
	    return res;
	}
	function globalHandleError(err, vm, info) {
	    if (config.errorHandler) {
	        try {
	            return config.errorHandler.call(null, err, vm, info);
	        }
	        catch (e) {
	            // if the user intentionally throws the original error in the handler,
	            // do not log it twice
	            if (e !== err) {
	                logError(e, null, 'config.errorHandler');
	            }
	        }
	    }
	    logError(err, vm, info);
	}
	function logError(err, vm, info) {
	    {
	        warn(`Error in ${info}: "${err.toString()}"`, vm);
	    }
	    /* istanbul ignore else */
	    if (inBrowser && typeof console !== 'undefined') {
	        console.error(err);
	    }
	    else {
	        throw err;
	    }
	}

	/* globals MutationObserver */
	let isUsingMicroTask = false;
	const callbacks = [];
	let pending = false;
	function flushCallbacks() {
	    pending = false;
	    const copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (let i = 0; i < copies.length; i++) {
	        copies[i]();
	    }
	}
	// Here we have async deferring wrappers using microtasks.
	// In 2.5 we used (macro) tasks (in combination with microtasks).
	// However, it has subtle problems when state is changed right before repaint
	// (e.g. #6813, out-in transitions).
	// Also, using (macro) tasks in event handler would cause some weird behaviors
	// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
	// So we now use microtasks everywhere, again.
	// A major drawback of this tradeoff is that there are some scenarios
	// where microtasks have too high a priority and fire in between supposedly
	// sequential events (e.g. #4521, #6690, which have workarounds)
	// or even between bubbling of the same event (#6566).
	let timerFunc;
	// The nextTick behavior leverages the microtask queue, which can be accessed
	// via either native Promise.then or MutationObserver.
	// MutationObserver has wider support, however it is seriously bugged in
	// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	// completely stops working after triggering a few times... so, if native
	// Promise is available, we will use it:
	/* istanbul ignore next, $flow-disable-line */
	if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    const p = Promise.resolve();
	    timerFunc = () => {
	        p.then(flushCallbacks);
	        // In problematic UIWebViews, Promise.then doesn't completely break, but
	        // it can get stuck in a weird state where callbacks are pushed into the
	        // microtask queue but the queue isn't being flushed, until the browser
	        // needs to do some other work, e.g. handle a timer. Therefore we can
	        // "force" the microtask queue to be flushed by adding an empty timer.
	        if (isIOS)
	            setTimeout(noop);
	    };
	    isUsingMicroTask = true;
	}
	else if (!isIE &&
	    typeof MutationObserver !== 'undefined' &&
	    (isNative(MutationObserver) ||
	        // PhantomJS and iOS 7.x
	        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
	    // Use MutationObserver where native Promise is not available,
	    // e.g. PhantomJS, iOS7, Android 4.4
	    // (#6466 MutationObserver is unreliable in IE11)
	    let counter = 1;
	    const observer = new MutationObserver(flushCallbacks);
	    const textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	        characterData: true
	    });
	    timerFunc = () => {
	        counter = (counter + 1) % 2;
	        textNode.data = String(counter);
	    };
	    isUsingMicroTask = true;
	}
	else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
	    // Fallback to setImmediate.
	    // Technically it leverages the (macro) task queue,
	    // but it is still a better choice than setTimeout.
	    timerFunc = () => {
	        setImmediate(flushCallbacks);
	    };
	}
	else {
	    // Fallback to setTimeout.
	    timerFunc = () => {
	        setTimeout(flushCallbacks, 0);
	    };
	}
	/**
	 * @internal
	 */
	function nextTick(cb, ctx) {
	    let _resolve;
	    callbacks.push(() => {
	        if (cb) {
	            try {
	                cb.call(ctx);
	            }
	            catch (e) {
	                handleError(e, ctx, 'nextTick');
	            }
	        }
	        else if (_resolve) {
	            _resolve(ctx);
	        }
	    });
	    if (!pending) {
	        pending = true;
	        timerFunc();
	    }
	    // $flow-disable-line
	    if (!cb && typeof Promise !== 'undefined') {
	        return new Promise(resolve => {
	            _resolve = resolve;
	        });
	    }
	}

	function useCssModule(name = '$style') {
	    /* istanbul ignore else */
	    {
	        if (!currentInstance) {
	            warn(`useCssModule must be called inside setup()`);
	            return emptyObject;
	        }
	        const mod = currentInstance[name];
	        if (!mod) {
	            warn(`Current instance does not have CSS module named "${name}".`);
	            return emptyObject;
	        }
	        return mod;
	    }
	}

	/**
	 * Runtime helper for SFC's CSS variable injection feature.
	 * @private
	 */
	function useCssVars(getter) {
	    if (!inBrowser && !false)
	        return;
	    const instance = currentInstance;
	    if (!instance) {
	        warn(`useCssVars is called without current active component instance.`);
	        return;
	    }
	    watchPostEffect(() => {
	        const el = instance.$el;
	        const vars = getter(instance, instance._setupProxy);
	        if (el && el.nodeType === 1) {
	            const style = el.style;
	            for (const key in vars) {
	                style.setProperty(`--${key}`, vars[key]);
	            }
	        }
	    });
	}

	/**
	 * v3-compatible async component API.
	 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
	 * because it relies on existing manual types
	 */
	function defineAsyncComponent(source) {
	    if (isFunction(source)) {
	        source = { loader: source };
	    }
	    const { loader, loadingComponent, errorComponent, delay = 200, timeout, // undefined = never times out
	    suspensible = false, // in Vue 3 default is true
	    onError: userOnError } = source;
	    if (suspensible) {
	        warn(`The suspensiblbe option for async components is not supported in Vue2. It is ignored.`);
	    }
	    let pendingRequest = null;
	    let retries = 0;
	    const retry = () => {
	        retries++;
	        pendingRequest = null;
	        return load();
	    };
	    const load = () => {
	        let thisRequest;
	        return (pendingRequest ||
	            (thisRequest = pendingRequest =
	                loader()
	                    .catch(err => {
	                    err = err instanceof Error ? err : new Error(String(err));
	                    if (userOnError) {
	                        return new Promise((resolve, reject) => {
	                            const userRetry = () => resolve(retry());
	                            const userFail = () => reject(err);
	                            userOnError(err, userRetry, userFail, retries + 1);
	                        });
	                    }
	                    else {
	                        throw err;
	                    }
	                })
	                    .then((comp) => {
	                    if (thisRequest !== pendingRequest && pendingRequest) {
	                        return pendingRequest;
	                    }
	                    if (!comp) {
	                        warn(`Async component loader resolved to undefined. ` +
	                            `If you are using retry(), make sure to return its return value.`);
	                    }
	                    // interop module default
	                    if (comp &&
	                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
	                        comp = comp.default;
	                    }
	                    if (comp && !isObject(comp) && !isFunction(comp)) {
	                        throw new Error(`Invalid async component load result: ${comp}`);
	                    }
	                    return comp;
	                })));
	    };
	    return () => {
	        const component = load();
	        return {
	            component,
	            delay,
	            timeout,
	            error: errorComponent,
	            loading: loadingComponent
	        };
	    };
	}

	function createLifeCycle(hookName) {
	    return (fn, target = currentInstance) => {
	        if (!target) {
	            warn(`${formatName(hookName)} is called when there is no active component instance to be ` +
	                    `associated with. ` +
	                    `Lifecycle injection APIs can only be used during execution of setup().`);
	            return;
	        }
	        return injectHook(target, hookName, fn);
	    };
	}
	function formatName(name) {
	    if (name === 'beforeDestroy') {
	        name = 'beforeUnmount';
	    }
	    else if (name === 'destroyed') {
	        name = 'unmounted';
	    }
	    return `on${name[0].toUpperCase() + name.slice(1)}`;
	}
	function injectHook(instance, hookName, fn) {
	    const options = instance.$options;
	    options[hookName] = mergeLifecycleHook(options[hookName], fn);
	}
	const onBeforeMount = createLifeCycle('beforeMount');
	const onMounted = createLifeCycle('mounted');
	const onBeforeUpdate = createLifeCycle('beforeUpdate');
	const onUpdated = createLifeCycle('updated');
	const onBeforeUnmount = createLifeCycle('beforeDestroy');
	const onUnmounted = createLifeCycle('destroyed');
	const onActivated = createLifeCycle('activated');
	const onDeactivated = createLifeCycle('deactivated');
	const onServerPrefetch = createLifeCycle('serverPrefetch');
	const onRenderTracked = createLifeCycle('renderTracked');
	const onRenderTriggered = createLifeCycle('renderTriggered');
	const injectErrorCapturedHook = createLifeCycle('errorCaptured');
	function onErrorCaptured(hook, target = currentInstance) {
	    injectErrorCapturedHook(hook, target);
	}

	/**
	 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
	 */
	const version = '2.7.10';
	/**
	 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
	 */
	function defineComponent(options) {
	    return options;
	}

	var vca = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  version: version,
	  defineComponent: defineComponent,
	  ref: ref$1,
	  shallowRef: shallowRef,
	  isRef: isRef,
	  toRef: toRef,
	  toRefs: toRefs,
	  unref: unref,
	  proxyRefs: proxyRefs,
	  customRef: customRef,
	  triggerRef: triggerRef,
	  reactive: reactive,
	  isReactive: isReactive,
	  isReadonly: isReadonly,
	  isShallow: isShallow,
	  isProxy: isProxy,
	  shallowReactive: shallowReactive,
	  markRaw: markRaw,
	  toRaw: toRaw,
	  readonly: readonly,
	  shallowReadonly: shallowReadonly,
	  computed: computed,
	  watch: watch,
	  watchEffect: watchEffect,
	  watchPostEffect: watchPostEffect,
	  watchSyncEffect: watchSyncEffect,
	  EffectScope: EffectScope,
	  effectScope: effectScope,
	  onScopeDispose: onScopeDispose,
	  getCurrentScope: getCurrentScope,
	  provide: provide,
	  inject: inject,
	  h: h,
	  getCurrentInstance: getCurrentInstance,
	  useSlots: useSlots,
	  useAttrs: useAttrs,
	  useListeners: useListeners,
	  mergeDefaults: mergeDefaults,
	  nextTick: nextTick,
	  set: set,
	  del: del,
	  useCssModule: useCssModule,
	  useCssVars: useCssVars,
	  defineAsyncComponent: defineAsyncComponent,
	  onBeforeMount: onBeforeMount,
	  onMounted: onMounted,
	  onBeforeUpdate: onBeforeUpdate,
	  onUpdated: onUpdated,
	  onBeforeUnmount: onBeforeUnmount,
	  onUnmounted: onUnmounted,
	  onActivated: onActivated,
	  onDeactivated: onDeactivated,
	  onServerPrefetch: onServerPrefetch,
	  onRenderTracked: onRenderTracked,
	  onRenderTriggered: onRenderTriggered,
	  onErrorCaptured: onErrorCaptured
	});

	const seenObjects = new _Set();
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	function traverse(val) {
	    _traverse(val, seenObjects);
	    seenObjects.clear();
	    return val;
	}
	function _traverse(val, seen) {
	    let i, keys;
	    const isA = isArray(val);
	    if ((!isA && !isObject(val)) ||
	        Object.isFrozen(val) ||
	        val instanceof VNode) {
	        return;
	    }
	    if (val.__ob__) {
	        const depId = val.__ob__.dep.id;
	        if (seen.has(depId)) {
	            return;
	        }
	        seen.add(depId);
	    }
	    if (isA) {
	        i = val.length;
	        while (i--)
	            _traverse(val[i], seen);
	    }
	    else if (isRef(val)) {
	        _traverse(val.value, seen);
	    }
	    else {
	        keys = Object.keys(val);
	        i = keys.length;
	        while (i--)
	            _traverse(val[keys[i]], seen);
	    }
	}

	let uid$1 = 0;
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 * @internal
	 */
	class Watcher {
	    constructor(vm, expOrFn, cb, options, isRenderWatcher) {
	        recordEffectScope(this, 
	        // if the active effect scope is manually created (not a component scope),
	        // prioritize it
	        activeEffectScope && !activeEffectScope._vm
	            ? activeEffectScope
	            : vm
	                ? vm._scope
	                : undefined);
	        if ((this.vm = vm) && isRenderWatcher) {
	            vm._watcher = this;
	        }
	        // options
	        if (options) {
	            this.deep = !!options.deep;
	            this.user = !!options.user;
	            this.lazy = !!options.lazy;
	            this.sync = !!options.sync;
	            this.before = options.before;
	            {
	                this.onTrack = options.onTrack;
	                this.onTrigger = options.onTrigger;
	            }
	        }
	        else {
	            this.deep = this.user = this.lazy = this.sync = false;
	        }
	        this.cb = cb;
	        this.id = ++uid$1; // uid for batching
	        this.active = true;
	        this.post = false;
	        this.dirty = this.lazy; // for lazy watchers
	        this.deps = [];
	        this.newDeps = [];
	        this.depIds = new _Set();
	        this.newDepIds = new _Set();
	        this.expression = expOrFn.toString() ;
	        // parse expression for getter
	        if (isFunction(expOrFn)) {
	            this.getter = expOrFn;
	        }
	        else {
	            this.getter = parsePath(expOrFn);
	            if (!this.getter) {
	                this.getter = noop;
	                warn(`Failed watching path: "${expOrFn}" ` +
	                        'Watcher only accepts simple dot-delimited paths. ' +
	                        'For full control, use a function instead.', vm);
	            }
	        }
	        this.value = this.lazy ? undefined : this.get();
	    }
	    /**
	     * Evaluate the getter, and re-collect dependencies.
	     */
	    get() {
	        pushTarget(this);
	        let value;
	        const vm = this.vm;
	        try {
	            value = this.getter.call(vm, vm);
	        }
	        catch (e) {
	            if (this.user) {
	                handleError(e, vm, `getter for watcher "${this.expression}"`);
	            }
	            else {
	                throw e;
	            }
	        }
	        finally {
	            // "touch" every property so they are all tracked as
	            // dependencies for deep watching
	            if (this.deep) {
	                traverse(value);
	            }
	            popTarget();
	            this.cleanupDeps();
	        }
	        return value;
	    }
	    /**
	     * Add a dependency to this directive.
	     */
	    addDep(dep) {
	        const id = dep.id;
	        if (!this.newDepIds.has(id)) {
	            this.newDepIds.add(id);
	            this.newDeps.push(dep);
	            if (!this.depIds.has(id)) {
	                dep.addSub(this);
	            }
	        }
	    }
	    /**
	     * Clean up for dependency collection.
	     */
	    cleanupDeps() {
	        let i = this.deps.length;
	        while (i--) {
	            const dep = this.deps[i];
	            if (!this.newDepIds.has(dep.id)) {
	                dep.removeSub(this);
	            }
	        }
	        let tmp = this.depIds;
	        this.depIds = this.newDepIds;
	        this.newDepIds = tmp;
	        this.newDepIds.clear();
	        tmp = this.deps;
	        this.deps = this.newDeps;
	        this.newDeps = tmp;
	        this.newDeps.length = 0;
	    }
	    /**
	     * Subscriber interface.
	     * Will be called when a dependency changes.
	     */
	    update() {
	        /* istanbul ignore else */
	        if (this.lazy) {
	            this.dirty = true;
	        }
	        else if (this.sync) {
	            this.run();
	        }
	        else {
	            queueWatcher(this);
	        }
	    }
	    /**
	     * Scheduler job interface.
	     * Will be called by the scheduler.
	     */
	    run() {
	        if (this.active) {
	            const value = this.get();
	            if (value !== this.value ||
	                // Deep watchers and watchers on Object/Arrays should fire even
	                // when the value is the same, because the value may
	                // have mutated.
	                isObject(value) ||
	                this.deep) {
	                // set new value
	                const oldValue = this.value;
	                this.value = value;
	                if (this.user) {
	                    const info = `callback for watcher "${this.expression}"`;
	                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
	                }
	                else {
	                    this.cb.call(this.vm, value, oldValue);
	                }
	            }
	        }
	    }
	    /**
	     * Evaluate the value of the watcher.
	     * This only gets called for lazy watchers.
	     */
	    evaluate() {
	        this.value = this.get();
	        this.dirty = false;
	    }
	    /**
	     * Depend on all deps collected by this watcher.
	     */
	    depend() {
	        let i = this.deps.length;
	        while (i--) {
	            this.deps[i].depend();
	        }
	    }
	    /**
	     * Remove self from all dependencies' subscriber list.
	     */
	    teardown() {
	        if (this.vm && !this.vm._isBeingDestroyed) {
	            remove$2(this.vm._scope.effects, this);
	        }
	        if (this.active) {
	            let i = this.deps.length;
	            while (i--) {
	                this.deps[i].removeSub(this);
	            }
	            this.active = false;
	            if (this.onStop) {
	                this.onStop();
	            }
	        }
	    }
	}

	let mark;
	let measure;
	{
	    const perf = inBrowser && window.performance;
	    /* istanbul ignore if */
	    if (perf &&
	        // @ts-ignore
	        perf.mark &&
	        // @ts-ignore
	        perf.measure &&
	        // @ts-ignore
	        perf.clearMarks &&
	        // @ts-ignore
	        perf.clearMeasures) {
	        mark = tag => perf.mark(tag);
	        measure = (name, startTag, endTag) => {
	            perf.measure(name, startTag, endTag);
	            perf.clearMarks(startTag);
	            perf.clearMarks(endTag);
	            // perf.clearMeasures(name)
	        };
	    }
	}

	function initEvents(vm) {
	    vm._events = Object.create(null);
	    vm._hasHookEvent = false;
	    // init parent attached events
	    const listeners = vm.$options._parentListeners;
	    if (listeners) {
	        updateComponentListeners(vm, listeners);
	    }
	}
	let target$1;
	function add$1(event, fn) {
	    target$1.$on(event, fn);
	}
	function remove$1(event, fn) {
	    target$1.$off(event, fn);
	}
	function createOnceHandler$1(event, fn) {
	    const _target = target$1;
	    return function onceHandler() {
	        const res = fn.apply(null, arguments);
	        if (res !== null) {
	            _target.$off(event, onceHandler);
	        }
	    };
	}
	function updateComponentListeners(vm, listeners, oldListeners) {
	    target$1 = vm;
	    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
	    target$1 = undefined;
	}
	function eventsMixin(Vue) {
	    const hookRE = /^hook:/;
	    Vue.prototype.$on = function (event, fn) {
	        const vm = this;
	        if (isArray(event)) {
	            for (let i = 0, l = event.length; i < l; i++) {
	                vm.$on(event[i], fn);
	            }
	        }
	        else {
	            (vm._events[event] || (vm._events[event] = [])).push(fn);
	            // optimize hook:event cost by using a boolean flag marked at registration
	            // instead of a hash lookup
	            if (hookRE.test(event)) {
	                vm._hasHookEvent = true;
	            }
	        }
	        return vm;
	    };
	    Vue.prototype.$once = function (event, fn) {
	        const vm = this;
	        function on() {
	            vm.$off(event, on);
	            fn.apply(vm, arguments);
	        }
	        on.fn = fn;
	        vm.$on(event, on);
	        return vm;
	    };
	    Vue.prototype.$off = function (event, fn) {
	        const vm = this;
	        // all
	        if (!arguments.length) {
	            vm._events = Object.create(null);
	            return vm;
	        }
	        // array of events
	        if (isArray(event)) {
	            for (let i = 0, l = event.length; i < l; i++) {
	                vm.$off(event[i], fn);
	            }
	            return vm;
	        }
	        // specific event
	        const cbs = vm._events[event];
	        if (!cbs) {
	            return vm;
	        }
	        if (!fn) {
	            vm._events[event] = null;
	            return vm;
	        }
	        // specific handler
	        let cb;
	        let i = cbs.length;
	        while (i--) {
	            cb = cbs[i];
	            if (cb === fn || cb.fn === fn) {
	                cbs.splice(i, 1);
	                break;
	            }
	        }
	        return vm;
	    };
	    Vue.prototype.$emit = function (event) {
	        const vm = this;
	        {
	            const lowerCaseEvent = event.toLowerCase();
	            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
	                tip(`Event "${lowerCaseEvent}" is emitted in component ` +
	                    `${formatComponentName(vm)} but the handler is registered for "${event}". ` +
	                    `Note that HTML attributes are case-insensitive and you cannot use ` +
	                    `v-on to listen to camelCase events when using in-DOM templates. ` +
	                    `You should probably use "${hyphenate(event)}" instead of "${event}".`);
	            }
	        }
	        let cbs = vm._events[event];
	        if (cbs) {
	            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	            const args = toArray(arguments, 1);
	            const info = `event handler for "${event}"`;
	            for (let i = 0, l = cbs.length; i < l; i++) {
	                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
	            }
	        }
	        return vm;
	    };
	}

	let activeInstance = null;
	let isUpdatingChildComponent = false;
	function setActiveInstance(vm) {
	    const prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    return () => {
	        activeInstance = prevActiveInstance;
	    };
	}
	function initLifecycle(vm) {
	    const options = vm.$options;
	    // locate first non-abstract parent
	    let parent = options.parent;
	    if (parent && !options.abstract) {
	        while (parent.$options.abstract && parent.$parent) {
	            parent = parent.$parent;
	        }
	        parent.$children.push(vm);
	    }
	    vm.$parent = parent;
	    vm.$root = parent ? parent.$root : vm;
	    vm.$children = [];
	    vm.$refs = {};
	    vm._provided = parent ? parent._provided : Object.create(null);
	    vm._watcher = null;
	    vm._inactive = null;
	    vm._directInactive = false;
	    vm._isMounted = false;
	    vm._isDestroyed = false;
	    vm._isBeingDestroyed = false;
	}
	function lifecycleMixin(Vue) {
	    Vue.prototype._update = function (vnode, hydrating) {
	        const vm = this;
	        const prevEl = vm.$el;
	        const prevVnode = vm._vnode;
	        const restoreActiveInstance = setActiveInstance(vm);
	        vm._vnode = vnode;
	        // Vue.prototype.__patch__ is injected in entry points
	        // based on the rendering backend used.
	        if (!prevVnode) {
	            // initial render
	            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
	        }
	        else {
	            // updates
	            vm.$el = vm.__patch__(prevVnode, vnode);
	        }
	        restoreActiveInstance();
	        // update __vue__ reference
	        if (prevEl) {
	            prevEl.__vue__ = null;
	        }
	        if (vm.$el) {
	            vm.$el.__vue__ = vm;
	        }
	        // if parent is an HOC, update its $el as well
	        let wrapper = vm;
	        while (wrapper &&
	            wrapper.$vnode &&
	            wrapper.$parent &&
	            wrapper.$vnode === wrapper.$parent._vnode) {
	            wrapper.$parent.$el = wrapper.$el;
	            wrapper = wrapper.$parent;
	        }
	        // updated hook is called by the scheduler to ensure that children are
	        // updated in a parent's updated hook.
	    };
	    Vue.prototype.$forceUpdate = function () {
	        const vm = this;
	        if (vm._watcher) {
	            vm._watcher.update();
	        }
	    };
	    Vue.prototype.$destroy = function () {
	        const vm = this;
	        if (vm._isBeingDestroyed) {
	            return;
	        }
	        callHook$1(vm, 'beforeDestroy');
	        vm._isBeingDestroyed = true;
	        // remove self from parent
	        const parent = vm.$parent;
	        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	            remove$2(parent.$children, vm);
	        }
	        // teardown scope. this includes both the render watcher and other
	        // watchers created
	        vm._scope.stop();
	        // remove reference from data ob
	        // frozen object may not have observer.
	        if (vm._data.__ob__) {
	            vm._data.__ob__.vmCount--;
	        }
	        // call the last hook...
	        vm._isDestroyed = true;
	        // invoke destroy hooks on current rendered tree
	        vm.__patch__(vm._vnode, null);
	        // fire destroyed hook
	        callHook$1(vm, 'destroyed');
	        // turn off all instance listeners.
	        vm.$off();
	        // remove __vue__ reference
	        if (vm.$el) {
	            vm.$el.__vue__ = null;
	        }
	        // release circular reference (#6759)
	        if (vm.$vnode) {
	            vm.$vnode.parent = null;
	        }
	    };
	}
	function mountComponent(vm, el, hydrating) {
	    vm.$el = el;
	    if (!vm.$options.render) {
	        // @ts-expect-error invalid type
	        vm.$options.render = createEmptyVNode;
	        {
	            /* istanbul ignore if */
	            if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
	                vm.$options.el ||
	                el) {
	                warn('You are using the runtime-only build of Vue where the template ' +
	                    'compiler is not available. Either pre-compile the templates into ' +
	                    'render functions, or use the compiler-included build.', vm);
	            }
	            else {
	                warn('Failed to mount component: template or render function not defined.', vm);
	            }
	        }
	    }
	    callHook$1(vm, 'beforeMount');
	    let updateComponent;
	    /* istanbul ignore if */
	    if (config.performance && mark) {
	        updateComponent = () => {
	            const name = vm._name;
	            const id = vm._uid;
	            const startTag = `vue-perf-start:${id}`;
	            const endTag = `vue-perf-end:${id}`;
	            mark(startTag);
	            const vnode = vm._render();
	            mark(endTag);
	            measure(`vue ${name} render`, startTag, endTag);
	            mark(startTag);
	            vm._update(vnode, hydrating);
	            mark(endTag);
	            measure(`vue ${name} patch`, startTag, endTag);
	        };
	    }
	    else {
	        updateComponent = () => {
	            vm._update(vm._render(), hydrating);
	        };
	    }
	    const watcherOptions = {
	        before() {
	            if (vm._isMounted && !vm._isDestroyed) {
	                callHook$1(vm, 'beforeUpdate');
	            }
	        }
	    };
	    {
	        watcherOptions.onTrack = e => callHook$1(vm, 'renderTracked', [e]);
	        watcherOptions.onTrigger = e => callHook$1(vm, 'renderTriggered', [e]);
	    }
	    // we set this to vm._watcher inside the watcher's constructor
	    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
	    // component's mounted hook), which relies on vm._watcher being already defined
	    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
	    hydrating = false;
	    // flush buffer for flush: "pre" watchers queued in setup()
	    const preWatchers = vm._preWatchers;
	    if (preWatchers) {
	        for (let i = 0; i < preWatchers.length; i++) {
	            preWatchers[i].run();
	        }
	    }
	    // manually mounted instance, call mounted on self
	    // mounted is called for render-created child components in its inserted hook
	    if (vm.$vnode == null) {
	        vm._isMounted = true;
	        callHook$1(vm, 'mounted');
	    }
	    return vm;
	}
	function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
	    {
	        isUpdatingChildComponent = true;
	    }
	    // determine whether component has slot children
	    // we need to do this before overwriting $options._renderChildren.
	    // check if there are dynamic scopedSlots (hand-written or compiled but with
	    // dynamic slot names). Static scoped slots compiled from template has the
	    // "$stable" marker.
	    const newScopedSlots = parentVnode.data.scopedSlots;
	    const oldScopedSlots = vm.$scopedSlots;
	    const hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
	        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
	        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
	        (!newScopedSlots && vm.$scopedSlots.$key));
	    // Any static slot children from the parent may have changed during parent's
	    // update. Dynamic scoped slots may also have changed. In such cases, a forced
	    // update is necessary to ensure correctness.
	    let needsForceUpdate = !!(renderChildren || // has new static slots
	        vm.$options._renderChildren || // has old static slots
	        hasDynamicScopedSlot);
	    const prevVNode = vm.$vnode;
	    vm.$options._parentVnode = parentVnode;
	    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	    if (vm._vnode) {
	        // update child tree's parent
	        vm._vnode.parent = parentVnode;
	    }
	    vm.$options._renderChildren = renderChildren;
	    // update $attrs and $listeners hash
	    // these are also reactive so they may trigger child update if the child
	    // used them during render
	    const attrs = parentVnode.data.attrs || emptyObject;
	    if (vm._attrsProxy) {
	        // force update if attrs are accessed and has changed since it may be
	        // passed to a child component.
	        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
	            needsForceUpdate = true;
	        }
	    }
	    vm.$attrs = attrs;
	    // update listeners
	    listeners = listeners || emptyObject;
	    const prevListeners = vm.$options._parentListeners;
	    if (vm._listenersProxy) {
	        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
	    }
	    vm.$listeners = vm.$options._parentListeners = listeners;
	    updateComponentListeners(vm, listeners, prevListeners);
	    // update props
	    if (propsData && vm.$options.props) {
	        toggleObserving(false);
	        const props = vm._props;
	        const propKeys = vm.$options._propKeys || [];
	        for (let i = 0; i < propKeys.length; i++) {
	            const key = propKeys[i];
	            const propOptions = vm.$options.props; // wtf flow?
	            props[key] = validateProp(key, propOptions, propsData, vm);
	        }
	        toggleObserving(true);
	        // keep a copy of raw propsData
	        vm.$options.propsData = propsData;
	    }
	    // resolve slots + force update if has children
	    if (needsForceUpdate) {
	        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	        vm.$forceUpdate();
	    }
	    {
	        isUpdatingChildComponent = false;
	    }
	}
	function isInInactiveTree(vm) {
	    while (vm && (vm = vm.$parent)) {
	        if (vm._inactive)
	            return true;
	    }
	    return false;
	}
	function activateChildComponent(vm, direct) {
	    if (direct) {
	        vm._directInactive = false;
	        if (isInInactiveTree(vm)) {
	            return;
	        }
	    }
	    else if (vm._directInactive) {
	        return;
	    }
	    if (vm._inactive || vm._inactive === null) {
	        vm._inactive = false;
	        for (let i = 0; i < vm.$children.length; i++) {
	            activateChildComponent(vm.$children[i]);
	        }
	        callHook$1(vm, 'activated');
	    }
	}
	function deactivateChildComponent(vm, direct) {
	    if (direct) {
	        vm._directInactive = true;
	        if (isInInactiveTree(vm)) {
	            return;
	        }
	    }
	    if (!vm._inactive) {
	        vm._inactive = true;
	        for (let i = 0; i < vm.$children.length; i++) {
	            deactivateChildComponent(vm.$children[i]);
	        }
	        callHook$1(vm, 'deactivated');
	    }
	}
	function callHook$1(vm, hook, args, setContext = true) {
	    // #7573 disable dep collection when invoking lifecycle hooks
	    pushTarget();
	    const prev = currentInstance;
	    setContext && setCurrentInstance(vm);
	    const handlers = vm.$options[hook];
	    const info = `${hook} hook`;
	    if (handlers) {
	        for (let i = 0, j = handlers.length; i < j; i++) {
	            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
	        }
	    }
	    if (vm._hasHookEvent) {
	        vm.$emit('hook:' + hook);
	    }
	    setContext && setCurrentInstance(prev);
	    popTarget();
	}

	const MAX_UPDATE_COUNT = 100;
	const queue = [];
	const activatedChildren = [];
	let has = {};
	let circular = {};
	let waiting = false;
	let flushing = false;
	let index = 0;
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState() {
	    index = queue.length = activatedChildren.length = 0;
	    has = {};
	    {
	        circular = {};
	    }
	    waiting = flushing = false;
	}
	// Async edge case #6566 requires saving the timestamp when event listeners are
	// attached. However, calling performance.now() has a perf overhead especially
	// if the page has thousands of event listeners. Instead, we take a timestamp
	// every time the scheduler flushes and use that for all event listeners
	// attached during that flush.
	let currentFlushTimestamp = 0;
	// Async edge case fix requires storing an event listener's attach timestamp.
	let getNow = Date.now;
	// Determine what event timestamp the browser is using. Annoyingly, the
	// timestamp can either be hi-res (relative to page load) or low-res
	// (relative to UNIX epoch), so in order to compare time we have to use the
	// same timestamp type when saving the flush timestamp.
	// All IE versions use low-res event timestamps, and have problematic clock
	// implementations (#9632)
	if (inBrowser && !isIE) {
	    const performance = window.performance;
	    if (performance &&
	        typeof performance.now === 'function' &&
	        getNow() > document.createEvent('Event').timeStamp) {
	        // if the event timestamp, although evaluated AFTER the Date.now(), is
	        // smaller than it, it means the event is using a hi-res timestamp,
	        // and we need to use the hi-res version for event listener timestamps as
	        // well.
	        getNow = () => performance.now();
	    }
	}
	const sortCompareFn = (a, b) => {
	    if (a.post) {
	        if (!b.post)
	            return 1;
	    }
	    else if (b.post) {
	        return -1;
	    }
	    return a.id - b.id;
	};
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue() {
	    currentFlushTimestamp = getNow();
	    flushing = true;
	    let watcher, id;
	    // Sort queue before flush.
	    // This ensures that:
	    // 1. Components are updated from parent to child. (because parent is always
	    //    created before the child)
	    // 2. A component's user watchers are run before its render watcher (because
	    //    user watchers are created before the render watcher)
	    // 3. If a component is destroyed during a parent component's watcher run,
	    //    its watchers can be skipped.
	    queue.sort(sortCompareFn);
	    // do not cache length because more watchers might be pushed
	    // as we run existing watchers
	    for (index = 0; index < queue.length; index++) {
	        watcher = queue[index];
	        if (watcher.before) {
	            watcher.before();
	        }
	        id = watcher.id;
	        has[id] = null;
	        watcher.run();
	        // in dev build, check and stop circular updates.
	        if (has[id] != null) {
	            circular[id] = (circular[id] || 0) + 1;
	            if (circular[id] > MAX_UPDATE_COUNT) {
	                warn('You may have an infinite update loop ' +
	                    (watcher.user
	                        ? `in watcher with expression "${watcher.expression}"`
	                        : `in a component render function.`), watcher.vm);
	                break;
	            }
	        }
	    }
	    // keep copies of post queues before resetting state
	    const activatedQueue = activatedChildren.slice();
	    const updatedQueue = queue.slice();
	    resetSchedulerState();
	    // call component updated and activated hooks
	    callActivatedHooks(activatedQueue);
	    callUpdatedHooks(updatedQueue);
	    // devtool hook
	    /* istanbul ignore if */
	    if (devtools && config.devtools) {
	        devtools.emit('flush');
	    }
	}
	function callUpdatedHooks(queue) {
	    let i = queue.length;
	    while (i--) {
	        const watcher = queue[i];
	        const vm = watcher.vm;
	        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
	            callHook$1(vm, 'updated');
	        }
	    }
	}
	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent(vm) {
	    // setting _inactive to false here so that a render function can
	    // rely on checking whether it's in an inactive tree (e.g. router-view)
	    vm._inactive = false;
	    activatedChildren.push(vm);
	}
	function callActivatedHooks(queue) {
	    for (let i = 0; i < queue.length; i++) {
	        queue[i]._inactive = true;
	        activateChildComponent(queue[i], true /* true */);
	    }
	}
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher(watcher) {
	    const id = watcher.id;
	    if (has[id] != null) {
	        return;
	    }
	    if (watcher === Dep.target && watcher.noRecurse) {
	        return;
	    }
	    has[id] = true;
	    if (!flushing) {
	        queue.push(watcher);
	    }
	    else {
	        // if already flushing, splice the watcher based on its id
	        // if already past its id, it will be run next immediately.
	        let i = queue.length - 1;
	        while (i > index && queue[i].id > watcher.id) {
	            i--;
	        }
	        queue.splice(i + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	        waiting = true;
	        if (!config.async) {
	            flushSchedulerQueue();
	            return;
	        }
	        nextTick(flushSchedulerQueue);
	    }
	}

	function initProvide(vm) {
	    const provideOption = vm.$options.provide;
	    if (provideOption) {
	        const provided = isFunction(provideOption)
	            ? provideOption.call(vm)
	            : provideOption;
	        if (!isObject(provided)) {
	            return;
	        }
	        const source = resolveProvided(vm);
	        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
	        // iterate the keys ourselves.
	        const keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
	        for (let i = 0; i < keys.length; i++) {
	            const key = keys[i];
	            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
	        }
	    }
	}
	function initInjections(vm) {
	    const result = resolveInject(vm.$options.inject, vm);
	    if (result) {
	        toggleObserving(false);
	        Object.keys(result).forEach(key => {
	            /* istanbul ignore else */
	            {
	                defineReactive(vm, key, result[key], () => {
	                    warn(`Avoid mutating an injected value directly since the changes will be ` +
	                        `overwritten whenever the provided component re-renders. ` +
	                        `injection being mutated: "${key}"`, vm);
	                });
	            }
	        });
	        toggleObserving(true);
	    }
	}
	function resolveInject(inject, vm) {
	    if (inject) {
	        // inject is :any because flow is not smart enough to figure out cached
	        const result = Object.create(null);
	        const keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
	        for (let i = 0; i < keys.length; i++) {
	            const key = keys[i];
	            // #6574 in case the inject object is observed...
	            if (key === '__ob__')
	                continue;
	            const provideKey = inject[key].from;
	            if (provideKey in vm._provided) {
	                result[key] = vm._provided[provideKey];
	            }
	            else if ('default' in inject[key]) {
	                const provideDefault = inject[key].default;
	                result[key] = isFunction(provideDefault)
	                    ? provideDefault.call(vm)
	                    : provideDefault;
	            }
	            else {
	                warn(`Injection "${key}" not found`, vm);
	            }
	        }
	        return result;
	    }
	}

	function FunctionalRenderContext(data, props, children, parent, Ctor) {
	    const options = Ctor.options;
	    // ensure the createElement function in functional components
	    // gets a unique context - this is necessary for correct named slot check
	    let contextVm;
	    if (hasOwn(parent, '_uid')) {
	        contextVm = Object.create(parent);
	        contextVm._original = parent;
	    }
	    else {
	        // the context vm passed in is a functional context as well.
	        // in this case we want to make sure we are able to get a hold to the
	        // real context instance.
	        contextVm = parent;
	        // @ts-ignore
	        parent = parent._original;
	    }
	    const isCompiled = isTrue(options._compiled);
	    const needNormalization = !isCompiled;
	    this.data = data;
	    this.props = props;
	    this.children = children;
	    this.parent = parent;
	    this.listeners = data.on || emptyObject;
	    this.injections = resolveInject(options.inject, parent);
	    this.slots = () => {
	        if (!this.$slots) {
	            normalizeScopedSlots(parent, data.scopedSlots, (this.$slots = resolveSlots(children, parent)));
	        }
	        return this.$slots;
	    };
	    Object.defineProperty(this, 'scopedSlots', {
	        enumerable: true,
	        get() {
	            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
	        }
	    });
	    // support for compiled functional template
	    if (isCompiled) {
	        // exposing $options for renderStatic()
	        this.$options = options;
	        // pre-resolve slots for renderSlot()
	        this.$slots = this.slots();
	        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
	    }
	    if (options._scopeId) {
	        this._c = (a, b, c, d) => {
	            const vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
	            if (vnode && !isArray(vnode)) {
	                vnode.fnScopeId = options._scopeId;
	                vnode.fnContext = parent;
	            }
	            return vnode;
	        };
	    }
	    else {
	        this._c = (a, b, c, d) => createElement$1(contextVm, a, b, c, d, needNormalization);
	    }
	}
	installRenderHelpers(FunctionalRenderContext.prototype);
	function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
	    const options = Ctor.options;
	    const props = {};
	    const propOptions = options.props;
	    if (isDef(propOptions)) {
	        for (const key in propOptions) {
	            props[key] = validateProp(key, propOptions, propsData || emptyObject);
	        }
	    }
	    else {
	        if (isDef(data.attrs))
	            mergeProps(props, data.attrs);
	        if (isDef(data.props))
	            mergeProps(props, data.props);
	    }
	    const renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
	    const vnode = options.render.call(null, renderContext._c, renderContext);
	    if (vnode instanceof VNode) {
	        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
	    }
	    else if (isArray(vnode)) {
	        const vnodes = normalizeChildren(vnode) || [];
	        const res = new Array(vnodes.length);
	        for (let i = 0; i < vnodes.length; i++) {
	            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
	        }
	        return res;
	    }
	}
	function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
	    // #7817 clone node before setting fnContext, otherwise if the node is reused
	    // (e.g. it was from a cached normal slot) the fnContext causes named slots
	    // that should not be matched to match.
	    const clone = cloneVNode(vnode);
	    clone.fnContext = contextVm;
	    clone.fnOptions = options;
	    {
	        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
	            renderContext;
	    }
	    if (data.slot) {
	        (clone.data || (clone.data = {})).slot = data.slot;
	    }
	    return clone;
	}
	function mergeProps(to, from) {
	    for (const key in from) {
	        to[camelize(key)] = from[key];
	    }
	}

	function getComponentName(options) {
	    return options.name || options.__name || options._componentTag;
	}
	// inline hooks to be invoked on component VNodes during patch
	const componentVNodeHooks = {
	    init(vnode, hydrating) {
	        if (vnode.componentInstance &&
	            !vnode.componentInstance._isDestroyed &&
	            vnode.data.keepAlive) {
	            // kept-alive components, treat as a patch
	            const mountedNode = vnode; // work around flow
	            componentVNodeHooks.prepatch(mountedNode, mountedNode);
	        }
	        else {
	            const child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
	            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	        }
	    },
	    prepatch(oldVnode, vnode) {
	        const options = vnode.componentOptions;
	        const child = (vnode.componentInstance = oldVnode.componentInstance);
	        updateChildComponent(child, options.propsData, // updated props
	        options.listeners, // updated listeners
	        vnode, // new parent vnode
	        options.children // new children
	        );
	    },
	    insert(vnode) {
	        const { context, componentInstance } = vnode;
	        if (!componentInstance._isMounted) {
	            componentInstance._isMounted = true;
	            callHook$1(componentInstance, 'mounted');
	        }
	        if (vnode.data.keepAlive) {
	            if (context._isMounted) {
	                // vue-router#1212
	                // During updates, a kept-alive component's child components may
	                // change, so directly walking the tree here may call activated hooks
	                // on incorrect children. Instead we push them into a queue which will
	                // be processed after the whole patch process ended.
	                queueActivatedComponent(componentInstance);
	            }
	            else {
	                activateChildComponent(componentInstance, true /* direct */);
	            }
	        }
	    },
	    destroy(vnode) {
	        const { componentInstance } = vnode;
	        if (!componentInstance._isDestroyed) {
	            if (!vnode.data.keepAlive) {
	                componentInstance.$destroy();
	            }
	            else {
	                deactivateChildComponent(componentInstance, true /* direct */);
	            }
	        }
	    }
	};
	const hooksToMerge = Object.keys(componentVNodeHooks);
	function createComponent(Ctor, data, context, children, tag) {
	    if (isUndef(Ctor)) {
	        return;
	    }
	    const baseCtor = context.$options._base;
	    // plain options object: turn it into a constructor
	    if (isObject(Ctor)) {
	        Ctor = baseCtor.extend(Ctor);
	    }
	    // if at this stage it's not a constructor or an async component factory,
	    // reject.
	    if (typeof Ctor !== 'function') {
	        {
	            warn(`Invalid Component definition: ${String(Ctor)}`, context);
	        }
	        return;
	    }
	    // async component
	    let asyncFactory;
	    // @ts-expect-error
	    if (isUndef(Ctor.cid)) {
	        asyncFactory = Ctor;
	        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
	        if (Ctor === undefined) {
	            // return a placeholder node for async component, which is rendered
	            // as a comment node but preserves all the raw information for the node.
	            // the information will be used for async server-rendering and hydration.
	            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
	        }
	    }
	    data = data || {};
	    // resolve constructor options in case global mixins are applied after
	    // component constructor creation
	    resolveConstructorOptions(Ctor);
	    // transform component v-model data into props & events
	    if (isDef(data.model)) {
	        // @ts-expect-error
	        transformModel(Ctor.options, data);
	    }
	    // extract props
	    // @ts-expect-error
	    const propsData = extractPropsFromVNodeData(data, Ctor, tag);
	    // functional component
	    // @ts-expect-error
	    if (isTrue(Ctor.options.functional)) {
	        return createFunctionalComponent(Ctor, propsData, data, context, children);
	    }
	    // extract listeners, since these needs to be treated as
	    // child component listeners instead of DOM listeners
	    const listeners = data.on;
	    // replace with listeners with .native modifier
	    // so it gets processed during parent component patch.
	    data.on = data.nativeOn;
	    // @ts-expect-error
	    if (isTrue(Ctor.options.abstract)) {
	        // abstract components do not keep anything
	        // other than props & listeners & slot
	        // work around flow
	        const slot = data.slot;
	        data = {};
	        if (slot) {
	            data.slot = slot;
	        }
	    }
	    // install component management hooks onto the placeholder node
	    installComponentHooks(data);
	    // return a placeholder vnode
	    // @ts-expect-error
	    const name = getComponentName(Ctor.options) || tag;
	    const vnode = new VNode(
	    // @ts-expect-error
	    `vue-component-${Ctor.cid}${name ? `-${name}` : ''}`, data, undefined, undefined, undefined, context, 
	    // @ts-expect-error
	    { Ctor, propsData, listeners, tag, children }, asyncFactory);
	    return vnode;
	}
	function createComponentInstanceForVnode(
	// we know it's MountedComponentVNode but flow doesn't
	vnode, 
	// activeInstance in lifecycle state
	parent) {
	    const options = {
	        _isComponent: true,
	        _parentVnode: vnode,
	        parent
	    };
	    // check inline-template render functions
	    const inlineTemplate = vnode.data.inlineTemplate;
	    if (isDef(inlineTemplate)) {
	        options.render = inlineTemplate.render;
	        options.staticRenderFns = inlineTemplate.staticRenderFns;
	    }
	    return new vnode.componentOptions.Ctor(options);
	}
	function installComponentHooks(data) {
	    const hooks = data.hook || (data.hook = {});
	    for (let i = 0; i < hooksToMerge.length; i++) {
	        const key = hooksToMerge[i];
	        const existing = hooks[key];
	        const toMerge = componentVNodeHooks[key];
	        // @ts-expect-error
	        if (existing !== toMerge && !(existing && existing._merged)) {
	            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
	        }
	    }
	}
	function mergeHook(f1, f2) {
	    const merged = (a, b) => {
	        // flow complains about extra args which is why we use any
	        f1(a, b);
	        f2(a, b);
	    };
	    merged._merged = true;
	    return merged;
	}
	// transform component v-model info (value and callback) into
	// prop and event handler respectively.
	function transformModel(options, data) {
	    const prop = (options.model && options.model.prop) || 'value';
	    const event = (options.model && options.model.event) || 'input';
	    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
	    const on = data.on || (data.on = {});
	    const existing = on[event];
	    const callback = data.model.callback;
	    if (isDef(existing)) {
	        if (isArray(existing)
	            ? existing.indexOf(callback) === -1
	            : existing !== callback) {
	            on[event] = [callback].concat(existing);
	        }
	    }
	    else {
	        on[event] = callback;
	    }
	}

	let warn = noop;
	let tip = noop;
	let generateComponentTrace; // work around flow check
	let formatComponentName;
	{
	    const hasConsole = typeof console !== 'undefined';
	    const classifyRE = /(?:^|[-_])(\w)/g;
	    const classify = str => str.replace(classifyRE, c => c.toUpperCase()).replace(/[-_]/g, '');
	    warn = (msg, vm = currentInstance) => {
	        const trace = vm ? generateComponentTrace(vm) : '';
	        if (config.warnHandler) {
	            config.warnHandler.call(null, msg, vm, trace);
	        }
	        else if (hasConsole && !config.silent) {
	            console.error(`[Vue warn]: ${msg}${trace}`);
	        }
	    };
	    tip = (msg, vm) => {
	        if (hasConsole && !config.silent) {
	            console.warn(`[Vue tip]: ${msg}` + (vm ? generateComponentTrace(vm) : ''));
	        }
	    };
	    formatComponentName = (vm, includeFile) => {
	        if (vm.$root === vm) {
	            return '<Root>';
	        }
	        const options = isFunction(vm) && vm.cid != null
	            ? vm.options
	            : vm._isVue
	                ? vm.$options || vm.constructor.options
	                : vm;
	        let name = getComponentName(options);
	        const file = options.__file;
	        if (!name && file) {
	            const match = file.match(/([^/\\]+)\.vue$/);
	            name = match && match[1];
	        }
	        return ((name ? `<${classify(name)}>` : `<Anonymous>`) +
	            (file && includeFile !== false ? ` at ${file}` : ''));
	    };
	    const repeat = (str, n) => {
	        let res = '';
	        while (n) {
	            if (n % 2 === 1)
	                res += str;
	            if (n > 1)
	                str += str;
	            n >>= 1;
	        }
	        return res;
	    };
	    generateComponentTrace = (vm) => {
	        if (vm._isVue && vm.$parent) {
	            const tree = [];
	            let currentRecursiveSequence = 0;
	            while (vm) {
	                if (tree.length > 0) {
	                    const last = tree[tree.length - 1];
	                    if (last.constructor === vm.constructor) {
	                        currentRecursiveSequence++;
	                        vm = vm.$parent;
	                        continue;
	                    }
	                    else if (currentRecursiveSequence > 0) {
	                        tree[tree.length - 1] = [last, currentRecursiveSequence];
	                        currentRecursiveSequence = 0;
	                    }
	                }
	                tree.push(vm);
	                vm = vm.$parent;
	            }
	            return ('\n\nfound in\n\n' +
	                tree
	                    .map((vm, i) => `${i === 0 ? '---> ' : repeat(' ', 5 + i * 2)}${isArray(vm)
	                    ? `${formatComponentName(vm[0])}... (${vm[1]} recursive calls)`
	                    : formatComponentName(vm)}`)
	                    .join('\n'));
	        }
	        else {
	            return `\n\n(found in ${formatComponentName(vm)})`;
	        }
	    };
	}

	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	const strats = config.optionMergeStrategies;
	/**
	 * Options with restrictions
	 */
	{
	    strats.el = strats.propsData = function (parent, child, vm, key) {
	        if (!vm) {
	            warn(`option "${key}" can only be used during instance ` +
	                'creation with the `new` keyword.');
	        }
	        return defaultStrat(parent, child);
	    };
	}
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData(to, from) {
	    if (!from)
	        return to;
	    let key, toVal, fromVal;
	    const keys = hasSymbol
	        ? Reflect.ownKeys(from)
	        : Object.keys(from);
	    for (let i = 0; i < keys.length; i++) {
	        key = keys[i];
	        // in case the object is already observed...
	        if (key === '__ob__')
	            continue;
	        toVal = to[key];
	        fromVal = from[key];
	        if (!hasOwn(to, key)) {
	            set(to, key, fromVal);
	        }
	        else if (toVal !== fromVal &&
	            isPlainObject(toVal) &&
	            isPlainObject(fromVal)) {
	            mergeData(toVal, fromVal);
	        }
	    }
	    return to;
	}
	/**
	 * Data
	 */
	function mergeDataOrFn(parentVal, childVal, vm) {
	    if (!vm) {
	        // in a Vue.extend merge, both should be functions
	        if (!childVal) {
	            return parentVal;
	        }
	        if (!parentVal) {
	            return childVal;
	        }
	        // when parentVal & childVal are both present,
	        // we need to return a function that returns the
	        // merged result of both functions... no need to
	        // check if parentVal is a function here because
	        // it has to be a function to pass previous merges.
	        return function mergedDataFn() {
	            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
	        };
	    }
	    else {
	        return function mergedInstanceDataFn() {
	            // instance merge
	            const instanceData = isFunction(childVal)
	                ? childVal.call(vm, vm)
	                : childVal;
	            const defaultData = isFunction(parentVal)
	                ? parentVal.call(vm, vm)
	                : parentVal;
	            if (instanceData) {
	                return mergeData(instanceData, defaultData);
	            }
	            else {
	                return defaultData;
	            }
	        };
	    }
	}
	strats.data = function (parentVal, childVal, vm) {
	    if (!vm) {
	        if (childVal && typeof childVal !== 'function') {
	            warn('The "data" option should be a function ' +
	                    'that returns a per-instance value in component ' +
	                    'definitions.', vm);
	            return parentVal;
	        }
	        return mergeDataOrFn(parentVal, childVal);
	    }
	    return mergeDataOrFn(parentVal, childVal, vm);
	};
	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeLifecycleHook(parentVal, childVal) {
	    const res = childVal
	        ? parentVal
	            ? parentVal.concat(childVal)
	            : isArray(childVal)
	                ? childVal
	                : [childVal]
	        : parentVal;
	    return res ? dedupeHooks(res) : res;
	}
	function dedupeHooks(hooks) {
	    const res = [];
	    for (let i = 0; i < hooks.length; i++) {
	        if (res.indexOf(hooks[i]) === -1) {
	            res.push(hooks[i]);
	        }
	    }
	    return res;
	}
	LIFECYCLE_HOOKS.forEach(hook => {
	    strats[hook] = mergeLifecycleHook;
	});
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets(parentVal, childVal, vm, key) {
	    const res = Object.create(parentVal || null);
	    if (childVal) {
	        assertObjectType(key, childVal, vm);
	        return extend(res, childVal);
	    }
	    else {
	        return res;
	    }
	}
	ASSET_TYPES.forEach(function (type) {
	    strats[type + 's'] = mergeAssets;
	});
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (parentVal, childVal, vm, key) {
	    // work around Firefox's Object.prototype.watch...
	    //@ts-expect-error work around
	    if (parentVal === nativeWatch)
	        parentVal = undefined;
	    //@ts-expect-error work around
	    if (childVal === nativeWatch)
	        childVal = undefined;
	    /* istanbul ignore if */
	    if (!childVal)
	        return Object.create(parentVal || null);
	    {
	        assertObjectType(key, childVal, vm);
	    }
	    if (!parentVal)
	        return childVal;
	    const ret = {};
	    extend(ret, parentVal);
	    for (const key in childVal) {
	        let parent = ret[key];
	        const child = childVal[key];
	        if (parent && !isArray(parent)) {
	            parent = [parent];
	        }
	        ret[key] = parent ? parent.concat(child) : isArray(child) ? child : [child];
	    }
	    return ret;
	};
	/**
	 * Other object hashes.
	 */
	strats.props =
	    strats.methods =
	        strats.inject =
	            strats.computed =
	                function (parentVal, childVal, vm, key) {
	                    if (childVal && true) {
	                        assertObjectType(key, childVal, vm);
	                    }
	                    if (!parentVal)
	                        return childVal;
	                    const ret = Object.create(null);
	                    extend(ret, parentVal);
	                    if (childVal)
	                        extend(ret, childVal);
	                    return ret;
	                };
	strats.provide = mergeDataOrFn;
	/**
	 * Default strategy.
	 */
	const defaultStrat = function (parentVal, childVal) {
	    return childVal === undefined ? parentVal : childVal;
	};
	/**
	 * Validate component names
	 */
	function checkComponents(options) {
	    for (const key in options.components) {
	        validateComponentName(key);
	    }
	}
	function validateComponentName(name) {
	    if (!new RegExp(`^[a-zA-Z][\\-\\.0-9_${unicodeRegExp.source}]*$`).test(name)) {
	        warn('Invalid component name: "' +
	            name +
	            '". Component names ' +
	            'should conform to valid custom element name in html5 specification.');
	    }
	    if (isBuiltInTag(name) || config.isReservedTag(name)) {
	        warn('Do not use built-in or reserved HTML elements as component ' +
	            'id: ' +
	            name);
	    }
	}
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps(options, vm) {
	    const props = options.props;
	    if (!props)
	        return;
	    const res = {};
	    let i, val, name;
	    if (isArray(props)) {
	        i = props.length;
	        while (i--) {
	            val = props[i];
	            if (typeof val === 'string') {
	                name = camelize(val);
	                res[name] = { type: null };
	            }
	            else {
	                warn('props must be strings when using array syntax.');
	            }
	        }
	    }
	    else if (isPlainObject(props)) {
	        for (const key in props) {
	            val = props[key];
	            name = camelize(key);
	            res[name] = isPlainObject(val) ? val : { type: val };
	        }
	    }
	    else {
	        warn(`Invalid value for option "props": expected an Array or an Object, ` +
	            `but got ${toRawType(props)}.`, vm);
	    }
	    options.props = res;
	}
	/**
	 * Normalize all injections into Object-based format
	 */
	function normalizeInject(options, vm) {
	    const inject = options.inject;
	    if (!inject)
	        return;
	    const normalized = (options.inject = {});
	    if (isArray(inject)) {
	        for (let i = 0; i < inject.length; i++) {
	            normalized[inject[i]] = { from: inject[i] };
	        }
	    }
	    else if (isPlainObject(inject)) {
	        for (const key in inject) {
	            const val = inject[key];
	            normalized[key] = isPlainObject(val)
	                ? extend({ from: key }, val)
	                : { from: val };
	        }
	    }
	    else {
	        warn(`Invalid value for option "inject": expected an Array or an Object, ` +
	            `but got ${toRawType(inject)}.`, vm);
	    }
	}
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives$1(options) {
	    const dirs = options.directives;
	    if (dirs) {
	        for (const key in dirs) {
	            const def = dirs[key];
	            if (isFunction(def)) {
	                dirs[key] = { bind: def, update: def };
	            }
	        }
	    }
	}
	function assertObjectType(name, value, vm) {
	    if (!isPlainObject(value)) {
	        warn(`Invalid value for option "${name}": expected an Object, ` +
	            `but got ${toRawType(value)}.`, vm);
	    }
	}
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions(parent, child, vm) {
	    {
	        checkComponents(child);
	    }
	    if (isFunction(child)) {
	        // @ts-expect-error
	        child = child.options;
	    }
	    normalizeProps(child, vm);
	    normalizeInject(child, vm);
	    normalizeDirectives$1(child);
	    // Apply extends and mixins on the child options,
	    // but only if it is a raw options object that isn't
	    // the result of another mergeOptions call.
	    // Only merged options has the _base property.
	    if (!child._base) {
	        if (child.extends) {
	            parent = mergeOptions(parent, child.extends, vm);
	        }
	        if (child.mixins) {
	            for (let i = 0, l = child.mixins.length; i < l; i++) {
	                parent = mergeOptions(parent, child.mixins[i], vm);
	            }
	        }
	    }
	    const options = {};
	    let key;
	    for (key in parent) {
	        mergeField(key);
	    }
	    for (key in child) {
	        if (!hasOwn(parent, key)) {
	            mergeField(key);
	        }
	    }
	    function mergeField(key) {
	        const strat = strats[key] || defaultStrat;
	        options[key] = strat(parent[key], child[key], vm, key);
	    }
	    return options;
	}
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset(options, type, id, warnMissing) {
	    /* istanbul ignore if */
	    if (typeof id !== 'string') {
	        return;
	    }
	    const assets = options[type];
	    // check local registration variations first
	    if (hasOwn(assets, id))
	        return assets[id];
	    const camelizedId = camelize(id);
	    if (hasOwn(assets, camelizedId))
	        return assets[camelizedId];
	    const PascalCaseId = capitalize(camelizedId);
	    if (hasOwn(assets, PascalCaseId))
	        return assets[PascalCaseId];
	    // fallback to prototype chain
	    const res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	    if (warnMissing && !res) {
	        warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
	    }
	    return res;
	}

	function validateProp(key, propOptions, propsData, vm) {
	    const prop = propOptions[key];
	    const absent = !hasOwn(propsData, key);
	    let value = propsData[key];
	    // boolean casting
	    const booleanIndex = getTypeIndex(Boolean, prop.type);
	    if (booleanIndex > -1) {
	        if (absent && !hasOwn(prop, 'default')) {
	            value = false;
	        }
	        else if (value === '' || value === hyphenate(key)) {
	            // only cast empty string / same name to boolean if
	            // boolean has higher priority
	            const stringIndex = getTypeIndex(String, prop.type);
	            if (stringIndex < 0 || booleanIndex < stringIndex) {
	                value = true;
	            }
	        }
	    }
	    // check default value
	    if (value === undefined) {
	        value = getPropDefaultValue(vm, prop, key);
	        // since the default value is a fresh copy,
	        // make sure to observe it.
	        const prevShouldObserve = shouldObserve;
	        toggleObserving(true);
	        observe(value);
	        toggleObserving(prevShouldObserve);
	    }
	    {
	        assertProp(prop, key, value, vm, absent);
	    }
	    return value;
	}
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue(vm, prop, key) {
	    // no default, return undefined
	    if (!hasOwn(prop, 'default')) {
	        return undefined;
	    }
	    const def = prop.default;
	    // warn against non-factory defaults for Object & Array
	    if (isObject(def)) {
	        warn('Invalid default value for prop "' +
	            key +
	            '": ' +
	            'Props with type Object/Array must use a factory function ' +
	            'to return the default value.', vm);
	    }
	    // the raw prop value was also undefined from previous render,
	    // return previous default value to avoid unnecessary watcher trigger
	    if (vm &&
	        vm.$options.propsData &&
	        vm.$options.propsData[key] === undefined &&
	        vm._props[key] !== undefined) {
	        return vm._props[key];
	    }
	    // call factory function for non-Function types
	    // a value is Function if its prototype is function even across different execution context
	    return isFunction(def) && getType(prop.type) !== 'Function'
	        ? def.call(vm)
	        : def;
	}
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp(prop, name, value, vm, absent) {
	    if (prop.required && absent) {
	        warn('Missing required prop: "' + name + '"', vm);
	        return;
	    }
	    if (value == null && !prop.required) {
	        return;
	    }
	    let type = prop.type;
	    let valid = !type || type === true;
	    const expectedTypes = [];
	    if (type) {
	        if (!isArray(type)) {
	            type = [type];
	        }
	        for (let i = 0; i < type.length && !valid; i++) {
	            const assertedType = assertType(value, type[i], vm);
	            expectedTypes.push(assertedType.expectedType || '');
	            valid = assertedType.valid;
	        }
	    }
	    const haveExpectedTypes = expectedTypes.some(t => t);
	    if (!valid && haveExpectedTypes) {
	        warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
	        return;
	    }
	    const validator = prop.validator;
	    if (validator) {
	        if (!validator(value)) {
	            warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
	        }
	    }
	}
	const simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
	function assertType(value, type, vm) {
	    let valid;
	    const expectedType = getType(type);
	    if (simpleCheckRE.test(expectedType)) {
	        const t = typeof value;
	        valid = t === expectedType.toLowerCase();
	        // for primitive wrapper objects
	        if (!valid && t === 'object') {
	            valid = value instanceof type;
	        }
	    }
	    else if (expectedType === 'Object') {
	        valid = isPlainObject(value);
	    }
	    else if (expectedType === 'Array') {
	        valid = isArray(value);
	    }
	    else {
	        try {
	            valid = value instanceof type;
	        }
	        catch (e) {
	            warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
	            valid = false;
	        }
	    }
	    return {
	        valid,
	        expectedType
	    };
	}
	const functionTypeCheckRE = /^\s*function (\w+)/;
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType(fn) {
	    const match = fn && fn.toString().match(functionTypeCheckRE);
	    return match ? match[1] : '';
	}
	function isSameType(a, b) {
	    return getType(a) === getType(b);
	}
	function getTypeIndex(type, expectedTypes) {
	    if (!isArray(expectedTypes)) {
	        return isSameType(expectedTypes, type) ? 0 : -1;
	    }
	    for (let i = 0, len = expectedTypes.length; i < len; i++) {
	        if (isSameType(expectedTypes[i], type)) {
	            return i;
	        }
	    }
	    return -1;
	}
	function getInvalidTypeMessage(name, value, expectedTypes) {
	    let message = `Invalid prop: type check failed for prop "${name}".` +
	        ` Expected ${expectedTypes.map(capitalize).join(', ')}`;
	    const expectedType = expectedTypes[0];
	    const receivedType = toRawType(value);
	    // check if we need to specify expected value
	    if (expectedTypes.length === 1 &&
	        isExplicable(expectedType) &&
	        isExplicable(typeof value) &&
	        !isBoolean(expectedType, receivedType)) {
	        message += ` with value ${styleValue(value, expectedType)}`;
	    }
	    message += `, got ${receivedType} `;
	    // check if we need to specify received value
	    if (isExplicable(receivedType)) {
	        message += `with value ${styleValue(value, receivedType)}.`;
	    }
	    return message;
	}
	function styleValue(value, type) {
	    if (type === 'String') {
	        return `"${value}"`;
	    }
	    else if (type === 'Number') {
	        return `${Number(value)}`;
	    }
	    else {
	        return `${value}`;
	    }
	}
	const EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
	function isExplicable(value) {
	    return EXPLICABLE_TYPES.some(elem => value.toLowerCase() === elem);
	}
	function isBoolean(...args) {
	    return args.some(elem => elem.toLowerCase() === 'boolean');
	}

	/* not type checking this file because flow doesn't play well with Proxy */
	let initProxy;
	{
	    const allowedGlobals = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
	        'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	        'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
	        'require' // for Webpack/Browserify
	    );
	    const warnNonPresent = (target, key) => {
	        warn(`Property or method "${key}" is not defined on the instance but ` +
	            'referenced during render. Make sure that this property is reactive, ' +
	            'either in the data option, or for class-based components, by ' +
	            'initializing the property. ' +
	            'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
	    };
	    const warnReservedPrefix = (target, key) => {
	        warn(`Property "${key}" must be accessed with "$data.${key}" because ` +
	            'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
	            'prevent conflicts with Vue internals. ' +
	            'See: https://v2.vuejs.org/v2/api/#data', target);
	    };
	    const hasProxy = typeof Proxy !== 'undefined' && isNative(Proxy);
	    if (hasProxy) {
	        const isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
	        config.keyCodes = new Proxy(config.keyCodes, {
	            set(target, key, value) {
	                if (isBuiltInModifier(key)) {
	                    warn(`Avoid overwriting built-in modifier in config.keyCodes: .${key}`);
	                    return false;
	                }
	                else {
	                    target[key] = value;
	                    return true;
	                }
	            }
	        });
	    }
	    const hasHandler = {
	        has(target, key) {
	            const has = key in target;
	            const isAllowed = allowedGlobals(key) ||
	                (typeof key === 'string' &&
	                    key.charAt(0) === '_' &&
	                    !(key in target.$data));
	            if (!has && !isAllowed) {
	                if (key in target.$data)
	                    warnReservedPrefix(target, key);
	                else
	                    warnNonPresent(target, key);
	            }
	            return has || !isAllowed;
	        }
	    };
	    const getHandler = {
	        get(target, key) {
	            if (typeof key === 'string' && !(key in target)) {
	                if (key in target.$data)
	                    warnReservedPrefix(target, key);
	                else
	                    warnNonPresent(target, key);
	            }
	            return target[key];
	        }
	    };
	    initProxy = function initProxy(vm) {
	        if (hasProxy) {
	            // determine which proxy handler to use
	            const options = vm.$options;
	            const handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
	            vm._renderProxy = new Proxy(vm, handlers);
	        }
	        else {
	            vm._renderProxy = vm;
	        }
	    };
	}

	const sharedPropertyDefinition = {
	    enumerable: true,
	    configurable: true,
	    get: noop,
	    set: noop
	};
	function proxy(target, sourceKey, key) {
	    sharedPropertyDefinition.get = function proxyGetter() {
	        return this[sourceKey][key];
	    };
	    sharedPropertyDefinition.set = function proxySetter(val) {
	        this[sourceKey][key] = val;
	    };
	    Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	function initState(vm) {
	    const opts = vm.$options;
	    if (opts.props)
	        initProps$1(vm, opts.props);
	    // Composition API
	    initSetup(vm);
	    if (opts.methods)
	        initMethods(vm, opts.methods);
	    if (opts.data) {
	        initData(vm);
	    }
	    else {
	        const ob = observe((vm._data = {}));
	        ob && ob.vmCount++;
	    }
	    if (opts.computed)
	        initComputed$1(vm, opts.computed);
	    if (opts.watch && opts.watch !== nativeWatch) {
	        initWatch(vm, opts.watch);
	    }
	}
	function initProps$1(vm, propsOptions) {
	    const propsData = vm.$options.propsData || {};
	    const props = (vm._props = shallowReactive({}));
	    // cache prop keys so that future props updates can iterate using Array
	    // instead of dynamic object key enumeration.
	    const keys = (vm.$options._propKeys = []);
	    const isRoot = !vm.$parent;
	    // root instance props should be converted
	    if (!isRoot) {
	        toggleObserving(false);
	    }
	    for (const key in propsOptions) {
	        keys.push(key);
	        const value = validateProp(key, propsOptions, propsData, vm);
	        /* istanbul ignore else */
	        {
	            const hyphenatedKey = hyphenate(key);
	            if (isReservedAttribute(hyphenatedKey) ||
	                config.isReservedAttr(hyphenatedKey)) {
	                warn(`"${hyphenatedKey}" is a reserved attribute and cannot be used as component prop.`, vm);
	            }
	            defineReactive(props, key, value, () => {
	                if (!isRoot && !isUpdatingChildComponent) {
	                    warn(`Avoid mutating a prop directly since the value will be ` +
	                        `overwritten whenever the parent component re-renders. ` +
	                        `Instead, use a data or computed property based on the prop's ` +
	                        `value. Prop being mutated: "${key}"`, vm);
	                }
	            });
	        }
	        // static props are already proxied on the component's prototype
	        // during Vue.extend(). We only need to proxy props defined at
	        // instantiation here.
	        if (!(key in vm)) {
	            proxy(vm, `_props`, key);
	        }
	    }
	    toggleObserving(true);
	}
	function initData(vm) {
	    let data = vm.$options.data;
	    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
	    if (!isPlainObject(data)) {
	        data = {};
	        warn('data functions should return an object:\n' +
	                'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
	    }
	    // proxy data on instance
	    const keys = Object.keys(data);
	    const props = vm.$options.props;
	    const methods = vm.$options.methods;
	    let i = keys.length;
	    while (i--) {
	        const key = keys[i];
	        {
	            if (methods && hasOwn(methods, key)) {
	                warn(`Method "${key}" has already been defined as a data property.`, vm);
	            }
	        }
	        if (props && hasOwn(props, key)) {
	            warn(`The data property "${key}" is already declared as a prop. ` +
	                    `Use prop default value instead.`, vm);
	        }
	        else if (!isReserved(key)) {
	            proxy(vm, `_data`, key);
	        }
	    }
	    // observe data
	    const ob = observe(data);
	    ob && ob.vmCount++;
	}
	function getData(data, vm) {
	    // #7573 disable dep collection when invoking data getters
	    pushTarget();
	    try {
	        return data.call(vm, vm);
	    }
	    catch (e) {
	        handleError(e, vm, `data()`);
	        return {};
	    }
	    finally {
	        popTarget();
	    }
	}
	const computedWatcherOptions = { lazy: true };
	function initComputed$1(vm, computed) {
	    // $flow-disable-line
	    const watchers = (vm._computedWatchers = Object.create(null));
	    // computed properties are just getters during SSR
	    const isSSR = isServerRendering();
	    for (const key in computed) {
	        const userDef = computed[key];
	        const getter = isFunction(userDef) ? userDef : userDef.get;
	        if (getter == null) {
	            warn(`Getter is missing for computed property "${key}".`, vm);
	        }
	        if (!isSSR) {
	            // create internal watcher for the computed property.
	            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
	        }
	        // component-defined computed properties are already defined on the
	        // component prototype. We only need to define computed properties defined
	        // at instantiation here.
	        if (!(key in vm)) {
	            defineComputed(vm, key, userDef);
	        }
	        else {
	            if (key in vm.$data) {
	                warn(`The computed property "${key}" is already defined in data.`, vm);
	            }
	            else if (vm.$options.props && key in vm.$options.props) {
	                warn(`The computed property "${key}" is already defined as a prop.`, vm);
	            }
	            else if (vm.$options.methods && key in vm.$options.methods) {
	                warn(`The computed property "${key}" is already defined as a method.`, vm);
	            }
	        }
	    }
	}
	function defineComputed(target, key, userDef) {
	    const shouldCache = !isServerRendering();
	    if (isFunction(userDef)) {
	        sharedPropertyDefinition.get = shouldCache
	            ? createComputedGetter(key)
	            : createGetterInvoker(userDef);
	        sharedPropertyDefinition.set = noop;
	    }
	    else {
	        sharedPropertyDefinition.get = userDef.get
	            ? shouldCache && userDef.cache !== false
	                ? createComputedGetter(key)
	                : createGetterInvoker(userDef.get)
	            : noop;
	        sharedPropertyDefinition.set = userDef.set || noop;
	    }
	    if (sharedPropertyDefinition.set === noop) {
	        sharedPropertyDefinition.set = function () {
	            warn(`Computed property "${key}" was assigned to but it has no setter.`, this);
	        };
	    }
	    Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	function createComputedGetter(key) {
	    return function computedGetter() {
	        const watcher = this._computedWatchers && this._computedWatchers[key];
	        if (watcher) {
	            if (watcher.dirty) {
	                watcher.evaluate();
	            }
	            if (Dep.target) {
	                if (Dep.target.onTrack) {
	                    Dep.target.onTrack({
	                        effect: Dep.target,
	                        target: this,
	                        type: "get" /* TrackOpTypes.GET */,
	                        key
	                    });
	                }
	                watcher.depend();
	            }
	            return watcher.value;
	        }
	    };
	}
	function createGetterInvoker(fn) {
	    return function computedGetter() {
	        return fn.call(this, this);
	    };
	}
	function initMethods(vm, methods) {
	    const props = vm.$options.props;
	    for (const key in methods) {
	        {
	            if (typeof methods[key] !== 'function') {
	                warn(`Method "${key}" has type "${typeof methods[key]}" in the component definition. ` +
	                    `Did you reference the function correctly?`, vm);
	            }
	            if (props && hasOwn(props, key)) {
	                warn(`Method "${key}" has already been defined as a prop.`, vm);
	            }
	            if (key in vm && isReserved(key)) {
	                warn(`Method "${key}" conflicts with an existing Vue instance method. ` +
	                    `Avoid defining component methods that start with _ or $.`);
	            }
	        }
	        vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
	    }
	}
	function initWatch(vm, watch) {
	    for (const key in watch) {
	        const handler = watch[key];
	        if (isArray(handler)) {
	            for (let i = 0; i < handler.length; i++) {
	                createWatcher(vm, key, handler[i]);
	            }
	        }
	        else {
	            createWatcher(vm, key, handler);
	        }
	    }
	}
	function createWatcher(vm, expOrFn, handler, options) {
	    if (isPlainObject(handler)) {
	        options = handler;
	        handler = handler.handler;
	    }
	    if (typeof handler === 'string') {
	        handler = vm[handler];
	    }
	    return vm.$watch(expOrFn, handler, options);
	}
	function stateMixin(Vue) {
	    // flow somehow has problems with directly declared definition object
	    // when using Object.defineProperty, so we have to procedurally build up
	    // the object here.
	    const dataDef = {};
	    dataDef.get = function () {
	        return this._data;
	    };
	    const propsDef = {};
	    propsDef.get = function () {
	        return this._props;
	    };
	    {
	        dataDef.set = function () {
	            warn('Avoid replacing instance root $data. ' +
	                'Use nested data properties instead.', this);
	        };
	        propsDef.set = function () {
	            warn(`$props is readonly.`, this);
	        };
	    }
	    Object.defineProperty(Vue.prototype, '$data', dataDef);
	    Object.defineProperty(Vue.prototype, '$props', propsDef);
	    Vue.prototype.$set = set;
	    Vue.prototype.$delete = del;
	    Vue.prototype.$watch = function (expOrFn, cb, options) {
	        const vm = this;
	        if (isPlainObject(cb)) {
	            return createWatcher(vm, expOrFn, cb, options);
	        }
	        options = options || {};
	        options.user = true;
	        const watcher = new Watcher(vm, expOrFn, cb, options);
	        if (options.immediate) {
	            const info = `callback for immediate watcher "${watcher.expression}"`;
	            pushTarget();
	            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
	            popTarget();
	        }
	        return function unwatchFn() {
	            watcher.teardown();
	        };
	    };
	}

	let uid = 0;
	function initMixin$1(Vue) {
	    Vue.prototype._init = function (options) {
	        const vm = this;
	        // a uid
	        vm._uid = uid++;
	        let startTag, endTag;
	        /* istanbul ignore if */
	        if (config.performance && mark) {
	            startTag = `vue-perf-start:${vm._uid}`;
	            endTag = `vue-perf-end:${vm._uid}`;
	            mark(startTag);
	        }
	        // a flag to mark this as a Vue instance without having to do instanceof
	        // check
	        vm._isVue = true;
	        // avoid instances from being observed
	        vm.__v_skip = true;
	        // effect scope
	        vm._scope = new EffectScope(true /* detached */);
	        vm._scope._vm = true;
	        // merge options
	        if (options && options._isComponent) {
	            // optimize internal component instantiation
	            // since dynamic options merging is pretty slow, and none of the
	            // internal component options needs special treatment.
	            initInternalComponent(vm, options);
	        }
	        else {
	            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
	        }
	        /* istanbul ignore else */
	        {
	            initProxy(vm);
	        }
	        // expose real self
	        vm._self = vm;
	        initLifecycle(vm);
	        initEvents(vm);
	        initRender(vm);
	        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
	        initInjections(vm); // resolve injections before data/props
	        initState(vm);
	        initProvide(vm); // resolve provide after data/props
	        callHook$1(vm, 'created');
	        /* istanbul ignore if */
	        if (config.performance && mark) {
	            vm._name = formatComponentName(vm, false);
	            mark(endTag);
	            measure(`vue ${vm._name} init`, startTag, endTag);
	        }
	        if (vm.$options.el) {
	            vm.$mount(vm.$options.el);
	        }
	    };
	}
	function initInternalComponent(vm, options) {
	    const opts = (vm.$options = Object.create(vm.constructor.options));
	    // doing this because it's faster than dynamic enumeration.
	    const parentVnode = options._parentVnode;
	    opts.parent = options.parent;
	    opts._parentVnode = parentVnode;
	    const vnodeComponentOptions = parentVnode.componentOptions;
	    opts.propsData = vnodeComponentOptions.propsData;
	    opts._parentListeners = vnodeComponentOptions.listeners;
	    opts._renderChildren = vnodeComponentOptions.children;
	    opts._componentTag = vnodeComponentOptions.tag;
	    if (options.render) {
	        opts.render = options.render;
	        opts.staticRenderFns = options.staticRenderFns;
	    }
	}
	function resolveConstructorOptions(Ctor) {
	    let options = Ctor.options;
	    if (Ctor.super) {
	        const superOptions = resolveConstructorOptions(Ctor.super);
	        const cachedSuperOptions = Ctor.superOptions;
	        if (superOptions !== cachedSuperOptions) {
	            // super option changed,
	            // need to resolve new options.
	            Ctor.superOptions = superOptions;
	            // check if there are any late-modified/attached options (#4976)
	            const modifiedOptions = resolveModifiedOptions(Ctor);
	            // update base extend options
	            if (modifiedOptions) {
	                extend(Ctor.extendOptions, modifiedOptions);
	            }
	            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
	            if (options.name) {
	                options.components[options.name] = Ctor;
	            }
	        }
	    }
	    return options;
	}
	function resolveModifiedOptions(Ctor) {
	    let modified;
	    const latest = Ctor.options;
	    const sealed = Ctor.sealedOptions;
	    for (const key in latest) {
	        if (latest[key] !== sealed[key]) {
	            if (!modified)
	                modified = {};
	            modified[key] = latest[key];
	        }
	    }
	    return modified;
	}

	function Vue(options) {
	    if (!(this instanceof Vue)) {
	        warn('Vue is a constructor and should be called with the `new` keyword');
	    }
	    this._init(options);
	}
	//@ts-expect-error Vue has function type
	initMixin$1(Vue);
	//@ts-expect-error Vue has function type
	stateMixin(Vue);
	//@ts-expect-error Vue has function type
	eventsMixin(Vue);
	//@ts-expect-error Vue has function type
	lifecycleMixin(Vue);
	//@ts-expect-error Vue has function type
	renderMixin(Vue);

	function initUse(Vue) {
	    Vue.use = function (plugin) {
	        const installedPlugins = this._installedPlugins || (this._installedPlugins = []);
	        if (installedPlugins.indexOf(plugin) > -1) {
	            return this;
	        }
	        // additional parameters
	        const args = toArray(arguments, 1);
	        args.unshift(this);
	        if (isFunction(plugin.install)) {
	            plugin.install.apply(plugin, args);
	        }
	        else if (isFunction(plugin)) {
	            plugin.apply(null, args);
	        }
	        installedPlugins.push(plugin);
	        return this;
	    };
	}

	function initMixin(Vue) {
	    Vue.mixin = function (mixin) {
	        this.options = mergeOptions(this.options, mixin);
	        return this;
	    };
	}

	function initExtend(Vue) {
	    /**
	     * Each instance constructor, including Vue, has a unique
	     * cid. This enables us to create wrapped "child
	     * constructors" for prototypal inheritance and cache them.
	     */
	    Vue.cid = 0;
	    let cid = 1;
	    /**
	     * Class inheritance
	     */
	    Vue.extend = function (extendOptions) {
	        extendOptions = extendOptions || {};
	        const Super = this;
	        const SuperId = Super.cid;
	        const cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	        if (cachedCtors[SuperId]) {
	            return cachedCtors[SuperId];
	        }
	        const name = getComponentName(extendOptions) || getComponentName(Super.options);
	        if (name) {
	            validateComponentName(name);
	        }
	        const Sub = function VueComponent(options) {
	            this._init(options);
	        };
	        Sub.prototype = Object.create(Super.prototype);
	        Sub.prototype.constructor = Sub;
	        Sub.cid = cid++;
	        Sub.options = mergeOptions(Super.options, extendOptions);
	        Sub['super'] = Super;
	        // For props and computed properties, we define the proxy getters on
	        // the Vue instances at extension time, on the extended prototype. This
	        // avoids Object.defineProperty calls for each instance created.
	        if (Sub.options.props) {
	            initProps(Sub);
	        }
	        if (Sub.options.computed) {
	            initComputed(Sub);
	        }
	        // allow further extension/mixin/plugin usage
	        Sub.extend = Super.extend;
	        Sub.mixin = Super.mixin;
	        Sub.use = Super.use;
	        // create asset registers, so extended classes
	        // can have their private assets too.
	        ASSET_TYPES.forEach(function (type) {
	            Sub[type] = Super[type];
	        });
	        // enable recursive self-lookup
	        if (name) {
	            Sub.options.components[name] = Sub;
	        }
	        // keep a reference to the super options at extension time.
	        // later at instantiation we can check if Super's options have
	        // been updated.
	        Sub.superOptions = Super.options;
	        Sub.extendOptions = extendOptions;
	        Sub.sealedOptions = extend({}, Sub.options);
	        // cache constructor
	        cachedCtors[SuperId] = Sub;
	        return Sub;
	    };
	}
	function initProps(Comp) {
	    const props = Comp.options.props;
	    for (const key in props) {
	        proxy(Comp.prototype, `_props`, key);
	    }
	}
	function initComputed(Comp) {
	    const computed = Comp.options.computed;
	    for (const key in computed) {
	        defineComputed(Comp.prototype, key, computed[key]);
	    }
	}

	function initAssetRegisters(Vue) {
	    /**
	     * Create asset registration methods.
	     */
	    ASSET_TYPES.forEach(type => {
	        // @ts-expect-error function is not exact same type
	        Vue[type] = function (id, definition) {
	            if (!definition) {
	                return this.options[type + 's'][id];
	            }
	            else {
	                /* istanbul ignore if */
	                if (type === 'component') {
	                    validateComponentName(id);
	                }
	                if (type === 'component' && isPlainObject(definition)) {
	                    // @ts-expect-error
	                    definition.name = definition.name || id;
	                    definition = this.options._base.extend(definition);
	                }
	                if (type === 'directive' && isFunction(definition)) {
	                    definition = { bind: definition, update: definition };
	                }
	                this.options[type + 's'][id] = definition;
	                return definition;
	            }
	        };
	    });
	}

	function _getComponentName(opts) {
	    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
	}
	function matches(pattern, name) {
	    if (isArray(pattern)) {
	        return pattern.indexOf(name) > -1;
	    }
	    else if (typeof pattern === 'string') {
	        return pattern.split(',').indexOf(name) > -1;
	    }
	    else if (isRegExp(pattern)) {
	        return pattern.test(name);
	    }
	    /* istanbul ignore next */
	    return false;
	}
	function pruneCache(keepAliveInstance, filter) {
	    const { cache, keys, _vnode } = keepAliveInstance;
	    for (const key in cache) {
	        const entry = cache[key];
	        if (entry) {
	            const name = entry.name;
	            if (name && !filter(name)) {
	                pruneCacheEntry(cache, key, keys, _vnode);
	            }
	        }
	    }
	}
	function pruneCacheEntry(cache, key, keys, current) {
	    const entry = cache[key];
	    if (entry && (!current || entry.tag !== current.tag)) {
	        // @ts-expect-error can be undefined
	        entry.componentInstance.$destroy();
	    }
	    cache[key] = null;
	    remove$2(keys, key);
	}
	const patternTypes = [String, RegExp, Array];
	// TODO defineComponent
	var KeepAlive = {
	    name: 'keep-alive',
	    abstract: true,
	    props: {
	        include: patternTypes,
	        exclude: patternTypes,
	        max: [String, Number]
	    },
	    methods: {
	        cacheVNode() {
	            const { cache, keys, vnodeToCache, keyToCache } = this;
	            if (vnodeToCache) {
	                const { tag, componentInstance, componentOptions } = vnodeToCache;
	                cache[keyToCache] = {
	                    name: _getComponentName(componentOptions),
	                    tag,
	                    componentInstance
	                };
	                keys.push(keyToCache);
	                // prune oldest entry
	                if (this.max && keys.length > parseInt(this.max)) {
	                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
	                }
	                this.vnodeToCache = null;
	            }
	        }
	    },
	    created() {
	        this.cache = Object.create(null);
	        this.keys = [];
	    },
	    destroyed() {
	        for (const key in this.cache) {
	            pruneCacheEntry(this.cache, key, this.keys);
	        }
	    },
	    mounted() {
	        this.cacheVNode();
	        this.$watch('include', val => {
	            pruneCache(this, name => matches(val, name));
	        });
	        this.$watch('exclude', val => {
	            pruneCache(this, name => !matches(val, name));
	        });
	    },
	    updated() {
	        this.cacheVNode();
	    },
	    render() {
	        const slot = this.$slots.default;
	        const vnode = getFirstComponentChild(slot);
	        const componentOptions = vnode && vnode.componentOptions;
	        if (componentOptions) {
	            // check pattern
	            const name = _getComponentName(componentOptions);
	            const { include, exclude } = this;
	            if (
	            // not included
	            (include && (!name || !matches(include, name))) ||
	                // excluded
	                (exclude && name && matches(exclude, name))) {
	                return vnode;
	            }
	            const { cache, keys } = this;
	            const key = vnode.key == null
	                ? // same constructor may get registered as different local components
	                    // so cid alone is not enough (#3269)
	                    componentOptions.Ctor.cid +
	                        (componentOptions.tag ? `::${componentOptions.tag}` : '')
	                : vnode.key;
	            if (cache[key]) {
	                vnode.componentInstance = cache[key].componentInstance;
	                // make current key freshest
	                remove$2(keys, key);
	                keys.push(key);
	            }
	            else {
	                // delay setting the cache until update
	                this.vnodeToCache = vnode;
	                this.keyToCache = key;
	            }
	            // @ts-expect-error can vnode.data can be undefined
	            vnode.data.keepAlive = true;
	        }
	        return vnode || (slot && slot[0]);
	    }
	};

	var builtInComponents = {
	    KeepAlive
	};

	function initGlobalAPI(Vue) {
	    // config
	    const configDef = {};
	    configDef.get = () => config;
	    {
	        configDef.set = () => {
	            warn('Do not replace the Vue.config object, set individual fields instead.');
	        };
	    }
	    Object.defineProperty(Vue, 'config', configDef);
	    // exposed util methods.
	    // NOTE: these are not considered part of the public API - avoid relying on
	    // them unless you are aware of the risk.
	    Vue.util = {
	        warn,
	        extend,
	        mergeOptions,
	        defineReactive
	    };
	    Vue.set = set;
	    Vue.delete = del;
	    Vue.nextTick = nextTick;
	    // 2.6 explicit observable API
	    Vue.observable = (obj) => {
	        observe(obj);
	        return obj;
	    };
	    Vue.options = Object.create(null);
	    ASSET_TYPES.forEach(type => {
	        Vue.options[type + 's'] = Object.create(null);
	    });
	    // this is used to identify the "base" constructor to extend all plain-object
	    // components with in Weex's multi-instance scenarios.
	    Vue.options._base = Vue;
	    extend(Vue.options.components, builtInComponents);
	    initUse(Vue);
	    initMixin(Vue);
	    initExtend(Vue);
	    initAssetRegisters(Vue);
	}

	initGlobalAPI(Vue);
	Object.defineProperty(Vue.prototype, '$isServer', {
	    get: isServerRendering
	});
	Object.defineProperty(Vue.prototype, '$ssrContext', {
	    get() {
	        /* istanbul ignore next */
	        return this.$vnode && this.$vnode.ssrContext;
	    }
	});
	// expose FunctionalRenderContext for ssr runtime helper installation
	Object.defineProperty(Vue, 'FunctionalRenderContext', {
	    value: FunctionalRenderContext
	});
	Vue.version = version;

	// these are reserved for web because they are directly compiled away
	// during template compilation
	const isReservedAttr = makeMap('style,class');
	// attributes that should be using props for binding
	const acceptValue = makeMap('input,textarea,option,select,progress');
	const mustUseProp = (tag, type, attr) => {
	    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
	        (attr === 'selected' && tag === 'option') ||
	        (attr === 'checked' && tag === 'input') ||
	        (attr === 'muted' && tag === 'video'));
	};
	const isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	const isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
	const convertEnumeratedValue = (key, value) => {
	    return isFalsyAttrValue(value) || value === 'false'
	        ? 'false'
	        : // allow arbitrary string value for contenteditable
	            key === 'contenteditable' && isValidContentEditableValue(value)
	                ? value
	                : 'true';
	};
	const isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	    'required,reversed,scoped,seamless,selected,sortable,' +
	    'truespeed,typemustmatch,visible');
	const xlinkNS = 'http://www.w3.org/1999/xlink';
	const isXlink = (name) => {
	    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
	};
	const getXlinkProp = (name) => {
	    return isXlink(name) ? name.slice(6, name.length) : '';
	};
	const isFalsyAttrValue = (val) => {
	    return val == null || val === false;
	};

	function genClassForVnode(vnode) {
	    let data = vnode.data;
	    let parentNode = vnode;
	    let childNode = vnode;
	    while (isDef(childNode.componentInstance)) {
	        childNode = childNode.componentInstance._vnode;
	        if (childNode && childNode.data) {
	            data = mergeClassData(childNode.data, data);
	        }
	    }
	    // @ts-expect-error parentNode.parent not VNodeWithData
	    while (isDef((parentNode = parentNode.parent))) {
	        if (parentNode && parentNode.data) {
	            data = mergeClassData(data, parentNode.data);
	        }
	    }
	    return renderClass(data.staticClass, data.class);
	}
	function mergeClassData(child, parent) {
	    return {
	        staticClass: concat(child.staticClass, parent.staticClass),
	        class: isDef(child.class) ? [child.class, parent.class] : parent.class
	    };
	}
	function renderClass(staticClass, dynamicClass) {
	    if (isDef(staticClass) || isDef(dynamicClass)) {
	        return concat(staticClass, stringifyClass(dynamicClass));
	    }
	    /* istanbul ignore next */
	    return '';
	}
	function concat(a, b) {
	    return a ? (b ? a + ' ' + b : a) : b || '';
	}
	function stringifyClass(value) {
	    if (Array.isArray(value)) {
	        return stringifyArray(value);
	    }
	    if (isObject(value)) {
	        return stringifyObject(value);
	    }
	    if (typeof value === 'string') {
	        return value;
	    }
	    /* istanbul ignore next */
	    return '';
	}
	function stringifyArray(value) {
	    let res = '';
	    let stringified;
	    for (let i = 0, l = value.length; i < l; i++) {
	        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
	            if (res)
	                res += ' ';
	            res += stringified;
	        }
	    }
	    return res;
	}
	function stringifyObject(value) {
	    let res = '';
	    for (const key in value) {
	        if (value[key]) {
	            if (res)
	                res += ' ';
	            res += key;
	        }
	    }
	    return res;
	}

	const namespaceMap = {
	    svg: 'http://www.w3.org/2000/svg',
	    math: 'http://www.w3.org/1998/Math/MathML'
	};
	const isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
	    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
	    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	    'embed,object,param,source,canvas,script,noscript,del,ins,' +
	    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	    'output,progress,select,textarea,' +
	    'details,dialog,menu,menuitem,summary,' +
	    'content,element,shadow,template,blockquote,iframe,tfoot');
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	const isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
	    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
	const isReservedTag = (tag) => {
	    return isHTMLTag(tag) || isSVG(tag);
	};
	function getTagNamespace(tag) {
	    if (isSVG(tag)) {
	        return 'svg';
	    }
	    // basic support for MathML
	    // note it doesn't support other MathML elements being component roots
	    if (tag === 'math') {
	        return 'math';
	    }
	}
	const unknownElementCache = Object.create(null);
	function isUnknownElement(tag) {
	    /* istanbul ignore if */
	    if (!inBrowser) {
	        return true;
	    }
	    if (isReservedTag(tag)) {
	        return false;
	    }
	    tag = tag.toLowerCase();
	    /* istanbul ignore if */
	    if (unknownElementCache[tag] != null) {
	        return unknownElementCache[tag];
	    }
	    const el = document.createElement(tag);
	    if (tag.indexOf('-') > -1) {
	        // http://stackoverflow.com/a/28210364/1070244
	        return (unknownElementCache[tag] =
	            el.constructor === window.HTMLUnknownElement ||
	                el.constructor === window.HTMLElement);
	    }
	    else {
	        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
	    }
	}
	const isTextInputType = makeMap('text,number,password,search,email,tel,url');

	/**
	 * Query an element selector if it's not an element already.
	 */
	function query(el) {
	    if (typeof el === 'string') {
	        const selected = document.querySelector(el);
	        if (!selected) {
	            warn('Cannot find element: ' + el);
	            return document.createElement('div');
	        }
	        return selected;
	    }
	    else {
	        return el;
	    }
	}

	function createElement(tagName, vnode) {
	    const elm = document.createElement(tagName);
	    if (tagName !== 'select') {
	        return elm;
	    }
	    // false or null will remove the attribute but undefined will not
	    if (vnode.data &&
	        vnode.data.attrs &&
	        vnode.data.attrs.multiple !== undefined) {
	        elm.setAttribute('multiple', 'multiple');
	    }
	    return elm;
	}
	function createElementNS(namespace, tagName) {
	    return document.createElementNS(namespaceMap[namespace], tagName);
	}
	function createTextNode(text) {
	    return document.createTextNode(text);
	}
	function createComment(text) {
	    return document.createComment(text);
	}
	function insertBefore(parentNode, newNode, referenceNode) {
	    parentNode.insertBefore(newNode, referenceNode);
	}
	function removeChild(node, child) {
	    node.removeChild(child);
	}
	function appendChild(node, child) {
	    node.appendChild(child);
	}
	function parentNode(node) {
	    return node.parentNode;
	}
	function nextSibling(node) {
	    return node.nextSibling;
	}
	function tagName(node) {
	    return node.tagName;
	}
	function setTextContent(node, text) {
	    node.textContent = text;
	}
	function setStyleScope(node, scopeId) {
	    node.setAttribute(scopeId, '');
	}

	var nodeOps = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  createElement: createElement,
	  createElementNS: createElementNS,
	  createTextNode: createTextNode,
	  createComment: createComment,
	  insertBefore: insertBefore,
	  removeChild: removeChild,
	  appendChild: appendChild,
	  parentNode: parentNode,
	  nextSibling: nextSibling,
	  tagName: tagName,
	  setTextContent: setTextContent,
	  setStyleScope: setStyleScope
	});

	var ref = {
	    create(_, vnode) {
	        registerRef(vnode);
	    },
	    update(oldVnode, vnode) {
	        if (oldVnode.data.ref !== vnode.data.ref) {
	            registerRef(oldVnode, true);
	            registerRef(vnode);
	        }
	    },
	    destroy(vnode) {
	        registerRef(vnode, true);
	    }
	};
	function registerRef(vnode, isRemoval) {
	    const ref = vnode.data.ref;
	    if (!isDef(ref))
	        return;
	    const vm = vnode.context;
	    const refValue = vnode.componentInstance || vnode.elm;
	    const value = isRemoval ? null : refValue;
	    const $refsValue = isRemoval ? undefined : refValue;
	    if (isFunction(ref)) {
	        invokeWithErrorHandling(ref, vm, [value], vm, `template ref function`);
	        return;
	    }
	    const isFor = vnode.data.refInFor;
	    const _isString = typeof ref === 'string' || typeof ref === 'number';
	    const _isRef = isRef(ref);
	    const refs = vm.$refs;
	    if (_isString || _isRef) {
	        if (isFor) {
	            const existing = _isString ? refs[ref] : ref.value;
	            if (isRemoval) {
	                isArray(existing) && remove$2(existing, refValue);
	            }
	            else {
	                if (!isArray(existing)) {
	                    if (_isString) {
	                        refs[ref] = [refValue];
	                        setSetupRef(vm, ref, refs[ref]);
	                    }
	                    else {
	                        ref.value = [refValue];
	                    }
	                }
	                else if (!existing.includes(refValue)) {
	                    existing.push(refValue);
	                }
	            }
	        }
	        else if (_isString) {
	            if (isRemoval && refs[ref] !== refValue) {
	                return;
	            }
	            refs[ref] = $refsValue;
	            setSetupRef(vm, ref, value);
	        }
	        else if (_isRef) {
	            if (isRemoval && ref.value !== refValue) {
	                return;
	            }
	            ref.value = value;
	        }
	        else {
	            warn(`Invalid template ref type: ${typeof ref}`);
	        }
	    }
	}
	function setSetupRef({ _setupState }, key, val) {
	    if (_setupState && hasOwn(_setupState, key)) {
	        if (isRef(_setupState[key])) {
	            _setupState[key].value = val;
	        }
	        else {
	            _setupState[key] = val;
	        }
	    }
	}

	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	const emptyNode = new VNode('', {}, []);
	const hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
	function sameVnode(a, b) {
	    return (a.key === b.key &&
	        a.asyncFactory === b.asyncFactory &&
	        ((a.tag === b.tag &&
	            a.isComment === b.isComment &&
	            isDef(a.data) === isDef(b.data) &&
	            sameInputType(a, b)) ||
	            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
	}
	function sameInputType(a, b) {
	    if (a.tag !== 'input')
	        return true;
	    let i;
	    const typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
	    const typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
	    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
	}
	function createKeyToOldIdx(children, beginIdx, endIdx) {
	    let i, key;
	    const map = {};
	    for (i = beginIdx; i <= endIdx; ++i) {
	        key = children[i].key;
	        if (isDef(key))
	            map[key] = i;
	    }
	    return map;
	}
	function createPatchFunction(backend) {
	    let i, j;
	    const cbs = {};
	    const { modules, nodeOps } = backend;
	    for (i = 0; i < hooks.length; ++i) {
	        cbs[hooks[i]] = [];
	        for (j = 0; j < modules.length; ++j) {
	            if (isDef(modules[j][hooks[i]])) {
	                cbs[hooks[i]].push(modules[j][hooks[i]]);
	            }
	        }
	    }
	    function emptyNodeAt(elm) {
	        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
	    }
	    function createRmCb(childElm, listeners) {
	        function remove() {
	            if (--remove.listeners === 0) {
	                removeNode(childElm);
	            }
	        }
	        remove.listeners = listeners;
	        return remove;
	    }
	    function removeNode(el) {
	        const parent = nodeOps.parentNode(el);
	        // element may have already been removed due to v-html / v-text
	        if (isDef(parent)) {
	            nodeOps.removeChild(parent, el);
	        }
	    }
	    function isUnknownElement(vnode, inVPre) {
	        return (!inVPre &&
	            !vnode.ns &&
	            !(config.ignoredElements.length &&
	                config.ignoredElements.some(ignore => {
	                    return isRegExp(ignore)
	                        ? ignore.test(vnode.tag)
	                        : ignore === vnode.tag;
	                })) &&
	            config.isUnknownElement(vnode.tag));
	    }
	    let creatingElmInVPre = 0;
	    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
	        if (isDef(vnode.elm) && isDef(ownerArray)) {
	            // This vnode was used in a previous render!
	            // now it's used as a new node, overwriting its elm would cause
	            // potential patch errors down the road when it's used as an insertion
	            // reference node. Instead, we clone the node on-demand before creating
	            // associated DOM element for it.
	            vnode = ownerArray[index] = cloneVNode(vnode);
	        }
	        vnode.isRootInsert = !nested; // for transition enter check
	        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	            return;
	        }
	        const data = vnode.data;
	        const children = vnode.children;
	        const tag = vnode.tag;
	        if (isDef(tag)) {
	            {
	                if (data && data.pre) {
	                    creatingElmInVPre++;
	                }
	                if (isUnknownElement(vnode, creatingElmInVPre)) {
	                    warn('Unknown custom element: <' +
	                        tag +
	                        '> - did you ' +
	                        'register the component correctly? For recursive components, ' +
	                        'make sure to provide the "name" option.', vnode.context);
	                }
	            }
	            vnode.elm = vnode.ns
	                ? nodeOps.createElementNS(vnode.ns, tag)
	                : nodeOps.createElement(tag, vnode);
	            setScope(vnode);
	            createChildren(vnode, children, insertedVnodeQueue);
	            if (isDef(data)) {
	                invokeCreateHooks(vnode, insertedVnodeQueue);
	            }
	            insert(parentElm, vnode.elm, refElm);
	            if (data && data.pre) {
	                creatingElmInVPre--;
	            }
	        }
	        else if (isTrue(vnode.isComment)) {
	            vnode.elm = nodeOps.createComment(vnode.text);
	            insert(parentElm, vnode.elm, refElm);
	        }
	        else {
	            vnode.elm = nodeOps.createTextNode(vnode.text);
	            insert(parentElm, vnode.elm, refElm);
	        }
	    }
	    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
	        let i = vnode.data;
	        if (isDef(i)) {
	            const isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	            if (isDef((i = i.hook)) && isDef((i = i.init))) {
	                i(vnode, false /* hydrating */);
	            }
	            // after calling the init hook, if the vnode is a child component
	            // it should've created a child instance and mounted it. the child
	            // component also has set the placeholder vnode's elm.
	            // in that case we can just return the element and be done.
	            if (isDef(vnode.componentInstance)) {
	                initComponent(vnode, insertedVnodeQueue);
	                insert(parentElm, vnode.elm, refElm);
	                if (isTrue(isReactivated)) {
	                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	                }
	                return true;
	            }
	        }
	    }
	    function initComponent(vnode, insertedVnodeQueue) {
	        if (isDef(vnode.data.pendingInsert)) {
	            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	            vnode.data.pendingInsert = null;
	        }
	        vnode.elm = vnode.componentInstance.$el;
	        if (isPatchable(vnode)) {
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            setScope(vnode);
	        }
	        else {
	            // empty component root.
	            // skip all element-related modules except for ref (#3455)
	            registerRef(vnode);
	            // make sure to invoke the insert hook
	            insertedVnodeQueue.push(vnode);
	        }
	    }
	    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
	        let i;
	        // hack for #4339: a reactivated component with inner transition
	        // does not trigger because the inner node's created hooks are not called
	        // again. It's not ideal to involve module-specific logic in here but
	        // there doesn't seem to be a better way to do it.
	        let innerNode = vnode;
	        while (innerNode.componentInstance) {
	            innerNode = innerNode.componentInstance._vnode;
	            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
	                for (i = 0; i < cbs.activate.length; ++i) {
	                    cbs.activate[i](emptyNode, innerNode);
	                }
	                insertedVnodeQueue.push(innerNode);
	                break;
	            }
	        }
	        // unlike a newly created component,
	        // a reactivated keep-alive component doesn't insert itself
	        insert(parentElm, vnode.elm, refElm);
	    }
	    function insert(parent, elm, ref) {
	        if (isDef(parent)) {
	            if (isDef(ref)) {
	                if (nodeOps.parentNode(ref) === parent) {
	                    nodeOps.insertBefore(parent, elm, ref);
	                }
	            }
	            else {
	                nodeOps.appendChild(parent, elm);
	            }
	        }
	    }
	    function createChildren(vnode, children, insertedVnodeQueue) {
	        if (isArray(children)) {
	            {
	                checkDuplicateKeys(children);
	            }
	            for (let i = 0; i < children.length; ++i) {
	                createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
	            }
	        }
	        else if (isPrimitive(vnode.text)) {
	            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
	        }
	    }
	    function isPatchable(vnode) {
	        while (vnode.componentInstance) {
	            vnode = vnode.componentInstance._vnode;
	        }
	        return isDef(vnode.tag);
	    }
	    function invokeCreateHooks(vnode, insertedVnodeQueue) {
	        for (let i = 0; i < cbs.create.length; ++i) {
	            cbs.create[i](emptyNode, vnode);
	        }
	        i = vnode.data.hook; // Reuse variable
	        if (isDef(i)) {
	            if (isDef(i.create))
	                i.create(emptyNode, vnode);
	            if (isDef(i.insert))
	                insertedVnodeQueue.push(vnode);
	        }
	    }
	    // set scope id attribute for scoped CSS.
	    // this is implemented as a special case to avoid the overhead
	    // of going through the normal attribute patching process.
	    function setScope(vnode) {
	        let i;
	        if (isDef((i = vnode.fnScopeId))) {
	            nodeOps.setStyleScope(vnode.elm, i);
	        }
	        else {
	            let ancestor = vnode;
	            while (ancestor) {
	                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
	                    nodeOps.setStyleScope(vnode.elm, i);
	                }
	                ancestor = ancestor.parent;
	            }
	        }
	        // for slot content they should also get the scopeId from the host instance.
	        if (isDef((i = activeInstance)) &&
	            i !== vnode.context &&
	            i !== vnode.fnContext &&
	            isDef((i = i.$options._scopeId))) {
	            nodeOps.setStyleScope(vnode.elm, i);
	        }
	    }
	    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	        for (; startIdx <= endIdx; ++startIdx) {
	            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
	        }
	    }
	    function invokeDestroyHook(vnode) {
	        let i, j;
	        const data = vnode.data;
	        if (isDef(data)) {
	            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
	                i(vnode);
	            for (i = 0; i < cbs.destroy.length; ++i)
	                cbs.destroy[i](vnode);
	        }
	        if (isDef((i = vnode.children))) {
	            for (j = 0; j < vnode.children.length; ++j) {
	                invokeDestroyHook(vnode.children[j]);
	            }
	        }
	    }
	    function removeVnodes(vnodes, startIdx, endIdx) {
	        for (; startIdx <= endIdx; ++startIdx) {
	            const ch = vnodes[startIdx];
	            if (isDef(ch)) {
	                if (isDef(ch.tag)) {
	                    removeAndInvokeRemoveHook(ch);
	                    invokeDestroyHook(ch);
	                }
	                else {
	                    // Text node
	                    removeNode(ch.elm);
	                }
	            }
	        }
	    }
	    function removeAndInvokeRemoveHook(vnode, rm) {
	        if (isDef(rm) || isDef(vnode.data)) {
	            let i;
	            const listeners = cbs.remove.length + 1;
	            if (isDef(rm)) {
	                // we have a recursively passed down rm callback
	                // increase the listeners count
	                rm.listeners += listeners;
	            }
	            else {
	                // directly removing
	                rm = createRmCb(vnode.elm, listeners);
	            }
	            // recursively invoke hooks on child component root node
	            if (isDef((i = vnode.componentInstance)) &&
	                isDef((i = i._vnode)) &&
	                isDef(i.data)) {
	                removeAndInvokeRemoveHook(i, rm);
	            }
	            for (i = 0; i < cbs.remove.length; ++i) {
	                cbs.remove[i](vnode, rm);
	            }
	            if (isDef((i = vnode.data.hook)) && isDef((i = i.remove))) {
	                i(vnode, rm);
	            }
	            else {
	                rm();
	            }
	        }
	        else {
	            removeNode(vnode.elm);
	        }
	    }
	    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	        let oldStartIdx = 0;
	        let newStartIdx = 0;
	        let oldEndIdx = oldCh.length - 1;
	        let oldStartVnode = oldCh[0];
	        let oldEndVnode = oldCh[oldEndIdx];
	        let newEndIdx = newCh.length - 1;
	        let newStartVnode = newCh[0];
	        let newEndVnode = newCh[newEndIdx];
	        let oldKeyToIdx, idxInOld, vnodeToMove, refElm;
	        // removeOnly is a special flag used only by <transition-group>
	        // to ensure removed elements stay in correct relative positions
	        // during leaving transitions
	        const canMove = !removeOnly;
	        {
	            checkDuplicateKeys(newCh);
	        }
	        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	            if (isUndef(oldStartVnode)) {
	                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	            }
	            else if (isUndef(oldEndVnode)) {
	                oldEndVnode = oldCh[--oldEndIdx];
	            }
	            else if (sameVnode(oldStartVnode, newStartVnode)) {
	                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
	                oldStartVnode = oldCh[++oldStartIdx];
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else if (sameVnode(oldEndVnode, newEndVnode)) {
	                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
	                oldEndVnode = oldCh[--oldEndIdx];
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldStartVnode, newEndVnode)) {
	                // Vnode moved right
	                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
	                canMove &&
	                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	                oldStartVnode = oldCh[++oldStartIdx];
	                newEndVnode = newCh[--newEndIdx];
	            }
	            else if (sameVnode(oldEndVnode, newStartVnode)) {
	                // Vnode moved left
	                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
	                canMove &&
	                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	                oldEndVnode = oldCh[--oldEndIdx];
	                newStartVnode = newCh[++newStartIdx];
	            }
	            else {
	                if (isUndef(oldKeyToIdx))
	                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
	                idxInOld = isDef(newStartVnode.key)
	                    ? oldKeyToIdx[newStartVnode.key]
	                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
	                if (isUndef(idxInOld)) {
	                    // New element
	                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	                }
	                else {
	                    vnodeToMove = oldCh[idxInOld];
	                    if (sameVnode(vnodeToMove, newStartVnode)) {
	                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
	                        oldCh[idxInOld] = undefined;
	                        canMove &&
	                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
	                    }
	                    else {
	                        // same key but different element. treat as new element
	                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	                    }
	                }
	                newStartVnode = newCh[++newStartIdx];
	            }
	        }
	        if (oldStartIdx > oldEndIdx) {
	            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	        }
	        else if (newStartIdx > newEndIdx) {
	            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
	        }
	    }
	    function checkDuplicateKeys(children) {
	        const seenKeys = {};
	        for (let i = 0; i < children.length; i++) {
	            const vnode = children[i];
	            const key = vnode.key;
	            if (isDef(key)) {
	                if (seenKeys[key]) {
	                    warn(`Duplicate keys detected: '${key}'. This may cause an update error.`, vnode.context);
	                }
	                else {
	                    seenKeys[key] = true;
	                }
	            }
	        }
	    }
	    function findIdxInOld(node, oldCh, start, end) {
	        for (let i = start; i < end; i++) {
	            const c = oldCh[i];
	            if (isDef(c) && sameVnode(node, c))
	                return i;
	        }
	    }
	    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
	        if (oldVnode === vnode) {
	            return;
	        }
	        if (isDef(vnode.elm) && isDef(ownerArray)) {
	            // clone reused vnode
	            vnode = ownerArray[index] = cloneVNode(vnode);
	        }
	        const elm = (vnode.elm = oldVnode.elm);
	        if (isTrue(oldVnode.isAsyncPlaceholder)) {
	            if (isDef(vnode.asyncFactory.resolved)) {
	                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
	            }
	            else {
	                vnode.isAsyncPlaceholder = true;
	            }
	            return;
	        }
	        // reuse element for static trees.
	        // note we only do this if the vnode is cloned -
	        // if the new node is not cloned it means the render functions have been
	        // reset by the hot-reload-api and we need to do a proper re-render.
	        if (isTrue(vnode.isStatic) &&
	            isTrue(oldVnode.isStatic) &&
	            vnode.key === oldVnode.key &&
	            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
	            vnode.componentInstance = oldVnode.componentInstance;
	            return;
	        }
	        let i;
	        const data = vnode.data;
	        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
	            i(oldVnode, vnode);
	        }
	        const oldCh = oldVnode.children;
	        const ch = vnode.children;
	        if (isDef(data) && isPatchable(vnode)) {
	            for (i = 0; i < cbs.update.length; ++i)
	                cbs.update[i](oldVnode, vnode);
	            if (isDef((i = data.hook)) && isDef((i = i.update)))
	                i(oldVnode, vnode);
	        }
	        if (isUndef(vnode.text)) {
	            if (isDef(oldCh) && isDef(ch)) {
	                if (oldCh !== ch)
	                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
	            }
	            else if (isDef(ch)) {
	                {
	                    checkDuplicateKeys(ch);
	                }
	                if (isDef(oldVnode.text))
	                    nodeOps.setTextContent(elm, '');
	                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	            }
	            else if (isDef(oldCh)) {
	                removeVnodes(oldCh, 0, oldCh.length - 1);
	            }
	            else if (isDef(oldVnode.text)) {
	                nodeOps.setTextContent(elm, '');
	            }
	        }
	        else if (oldVnode.text !== vnode.text) {
	            nodeOps.setTextContent(elm, vnode.text);
	        }
	        if (isDef(data)) {
	            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
	                i(oldVnode, vnode);
	        }
	    }
	    function invokeInsertHook(vnode, queue, initial) {
	        // delay insert hooks for component root nodes, invoke them after the
	        // element is really inserted
	        if (isTrue(initial) && isDef(vnode.parent)) {
	            vnode.parent.data.pendingInsert = queue;
	        }
	        else {
	            for (let i = 0; i < queue.length; ++i) {
	                queue[i].data.hook.insert(queue[i]);
	            }
	        }
	    }
	    let hydrationBailed = false;
	    // list of modules that can skip create hook during hydration because they
	    // are already rendered on the client or has no need for initialization
	    // Note: style is excluded because it relies on initial clone for future
	    // deep updates (#7063).
	    const isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
	    // Note: this is a browser-only function so we can assume elms are DOM nodes.
	    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
	        let i;
	        const { tag, data, children } = vnode;
	        inVPre = inVPre || (data && data.pre);
	        vnode.elm = elm;
	        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
	            vnode.isAsyncPlaceholder = true;
	            return true;
	        }
	        // assert node match
	        {
	            if (!assertNodeMatch(elm, vnode, inVPre)) {
	                return false;
	            }
	        }
	        if (isDef(data)) {
	            if (isDef((i = data.hook)) && isDef((i = i.init)))
	                i(vnode, true /* hydrating */);
	            if (isDef((i = vnode.componentInstance))) {
	                // child component. it should have hydrated its own tree.
	                initComponent(vnode, insertedVnodeQueue);
	                return true;
	            }
	        }
	        if (isDef(tag)) {
	            if (isDef(children)) {
	                // empty element, allow client to pick up and populate children
	                if (!elm.hasChildNodes()) {
	                    createChildren(vnode, children, insertedVnodeQueue);
	                }
	                else {
	                    // v-html and domProps: innerHTML
	                    if (isDef((i = data)) &&
	                        isDef((i = i.domProps)) &&
	                        isDef((i = i.innerHTML))) {
	                        if (i !== elm.innerHTML) {
	                            /* istanbul ignore if */
	                            if (typeof console !== 'undefined' &&
	                                !hydrationBailed) {
	                                hydrationBailed = true;
	                                console.warn('Parent: ', elm);
	                                console.warn('server innerHTML: ', i);
	                                console.warn('client innerHTML: ', elm.innerHTML);
	                            }
	                            return false;
	                        }
	                    }
	                    else {
	                        // iterate and compare children lists
	                        let childrenMatch = true;
	                        let childNode = elm.firstChild;
	                        for (let i = 0; i < children.length; i++) {
	                            if (!childNode ||
	                                !hydrate(childNode, children[i], insertedVnodeQueue, inVPre)) {
	                                childrenMatch = false;
	                                break;
	                            }
	                            childNode = childNode.nextSibling;
	                        }
	                        // if childNode is not null, it means the actual childNodes list is
	                        // longer than the virtual children list.
	                        if (!childrenMatch || childNode) {
	                            /* istanbul ignore if */
	                            if (typeof console !== 'undefined' &&
	                                !hydrationBailed) {
	                                hydrationBailed = true;
	                                console.warn('Parent: ', elm);
	                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	                            }
	                            return false;
	                        }
	                    }
	                }
	            }
	            if (isDef(data)) {
	                let fullInvoke = false;
	                for (const key in data) {
	                    if (!isRenderedModule(key)) {
	                        fullInvoke = true;
	                        invokeCreateHooks(vnode, insertedVnodeQueue);
	                        break;
	                    }
	                }
	                if (!fullInvoke && data['class']) {
	                    // ensure collecting deps for deep class bindings for future updates
	                    traverse(data['class']);
	                }
	            }
	        }
	        else if (elm.data !== vnode.text) {
	            elm.data = vnode.text;
	        }
	        return true;
	    }
	    function assertNodeMatch(node, vnode, inVPre) {
	        if (isDef(vnode.tag)) {
	            return (vnode.tag.indexOf('vue-component') === 0 ||
	                (!isUnknownElement(vnode, inVPre) &&
	                    vnode.tag.toLowerCase() ===
	                        (node.tagName && node.tagName.toLowerCase())));
	        }
	        else {
	            return node.nodeType === (vnode.isComment ? 8 : 3);
	        }
	    }
	    return function patch(oldVnode, vnode, hydrating, removeOnly) {
	        if (isUndef(vnode)) {
	            if (isDef(oldVnode))
	                invokeDestroyHook(oldVnode);
	            return;
	        }
	        let isInitialPatch = false;
	        const insertedVnodeQueue = [];
	        if (isUndef(oldVnode)) {
	            // empty mount (likely as component), create new root element
	            isInitialPatch = true;
	            createElm(vnode, insertedVnodeQueue);
	        }
	        else {
	            const isRealElement = isDef(oldVnode.nodeType);
	            if (!isRealElement && sameVnode(oldVnode, vnode)) {
	                // patch existing root node
	                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
	            }
	            else {
	                if (isRealElement) {
	                    // mounting to a real element
	                    // check if this is server-rendered content and if we can perform
	                    // a successful hydration.
	                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
	                        oldVnode.removeAttribute(SSR_ATTR);
	                        hydrating = true;
	                    }
	                    if (isTrue(hydrating)) {
	                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	                            invokeInsertHook(vnode, insertedVnodeQueue, true);
	                            return oldVnode;
	                        }
	                        else {
	                            warn('The client-side rendered virtual DOM tree is not matching ' +
	                                'server-rendered content. This is likely caused by incorrect ' +
	                                'HTML markup, for example nesting block-level elements inside ' +
	                                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                                'full client-side render.');
	                        }
	                    }
	                    // either not server-rendered, or hydration failed.
	                    // create an empty node and replace it
	                    oldVnode = emptyNodeAt(oldVnode);
	                }
	                // replacing existing element
	                const oldElm = oldVnode.elm;
	                const parentElm = nodeOps.parentNode(oldElm);
	                // create new node
	                createElm(vnode, insertedVnodeQueue, 
	                // extremely rare edge case: do not insert if old element is in a
	                // leaving transition. Only happens when combining transition +
	                // keep-alive + HOCs. (#4590)
	                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
	                // update parent placeholder node element, recursively
	                if (isDef(vnode.parent)) {
	                    let ancestor = vnode.parent;
	                    const patchable = isPatchable(vnode);
	                    while (ancestor) {
	                        for (let i = 0; i < cbs.destroy.length; ++i) {
	                            cbs.destroy[i](ancestor);
	                        }
	                        ancestor.elm = vnode.elm;
	                        if (patchable) {
	                            for (let i = 0; i < cbs.create.length; ++i) {
	                                cbs.create[i](emptyNode, ancestor);
	                            }
	                            // #6513
	                            // invoke insert hooks that may have been merged by create hooks.
	                            // e.g. for directives that uses the "inserted" hook.
	                            const insert = ancestor.data.hook.insert;
	                            if (insert.merged) {
	                                // start at index 1 to avoid re-invoking component mounted hook
	                                for (let i = 1; i < insert.fns.length; i++) {
	                                    insert.fns[i]();
	                                }
	                            }
	                        }
	                        else {
	                            registerRef(ancestor);
	                        }
	                        ancestor = ancestor.parent;
	                    }
	                }
	                // destroy old node
	                if (isDef(parentElm)) {
	                    removeVnodes([oldVnode], 0, 0);
	                }
	                else if (isDef(oldVnode.tag)) {
	                    invokeDestroyHook(oldVnode);
	                }
	            }
	        }
	        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	        return vnode.elm;
	    };
	}

	var directives = {
	    create: updateDirectives,
	    update: updateDirectives,
	    destroy: function unbindDirectives(vnode) {
	        // @ts-expect-error emptyNode is not VNodeWithData
	        updateDirectives(vnode, emptyNode);
	    }
	};
	function updateDirectives(oldVnode, vnode) {
	    if (oldVnode.data.directives || vnode.data.directives) {
	        _update(oldVnode, vnode);
	    }
	}
	function _update(oldVnode, vnode) {
	    const isCreate = oldVnode === emptyNode;
	    const isDestroy = vnode === emptyNode;
	    const oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
	    const newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
	    const dirsWithInsert = [];
	    const dirsWithPostpatch = [];
	    let key, oldDir, dir;
	    for (key in newDirs) {
	        oldDir = oldDirs[key];
	        dir = newDirs[key];
	        if (!oldDir) {
	            // new directive, bind
	            callHook(dir, 'bind', vnode, oldVnode);
	            if (dir.def && dir.def.inserted) {
	                dirsWithInsert.push(dir);
	            }
	        }
	        else {
	            // existing directive, update
	            dir.oldValue = oldDir.value;
	            dir.oldArg = oldDir.arg;
	            callHook(dir, 'update', vnode, oldVnode);
	            if (dir.def && dir.def.componentUpdated) {
	                dirsWithPostpatch.push(dir);
	            }
	        }
	    }
	    if (dirsWithInsert.length) {
	        const callInsert = () => {
	            for (let i = 0; i < dirsWithInsert.length; i++) {
	                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	            }
	        };
	        if (isCreate) {
	            mergeVNodeHook(vnode, 'insert', callInsert);
	        }
	        else {
	            callInsert();
	        }
	    }
	    if (dirsWithPostpatch.length) {
	        mergeVNodeHook(vnode, 'postpatch', () => {
	            for (let i = 0; i < dirsWithPostpatch.length; i++) {
	                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	            }
	        });
	    }
	    if (!isCreate) {
	        for (key in oldDirs) {
	            if (!newDirs[key]) {
	                // no longer present, unbind
	                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	            }
	        }
	    }
	}
	const emptyModifiers = Object.create(null);
	function normalizeDirectives(dirs, vm) {
	    const res = Object.create(null);
	    if (!dirs) {
	        // $flow-disable-line
	        return res;
	    }
	    let i, dir;
	    for (i = 0; i < dirs.length; i++) {
	        dir = dirs[i];
	        if (!dir.modifiers) {
	            // $flow-disable-line
	            dir.modifiers = emptyModifiers;
	        }
	        res[getRawDirName(dir)] = dir;
	        if (vm._setupState && vm._setupState.__sfc) {
	            const setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
	            if (typeof setupDef === 'function') {
	                dir.def = {
	                    bind: setupDef,
	                    update: setupDef,
	                };
	            }
	            else {
	                dir.def = setupDef;
	            }
	        }
	        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
	    }
	    // $flow-disable-line
	    return res;
	}
	function getRawDirName(dir) {
	    return (dir.rawName || `${dir.name}.${Object.keys(dir.modifiers || {}).join('.')}`);
	}
	function callHook(dir, hook, vnode, oldVnode, isDestroy) {
	    const fn = dir.def && dir.def[hook];
	    if (fn) {
	        try {
	            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	        }
	        catch (e) {
	            handleError(e, vnode.context, `directive ${dir.name} ${hook} hook`);
	        }
	    }
	}

	var baseModules = [ref, directives];

	function updateAttrs(oldVnode, vnode) {
	    const opts = vnode.componentOptions;
	    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
	        return;
	    }
	    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
	        return;
	    }
	    let key, cur, old;
	    const elm = vnode.elm;
	    const oldAttrs = oldVnode.data.attrs || {};
	    let attrs = vnode.data.attrs || {};
	    // clone observed objects, as the user probably wants to mutate it
	    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
	        attrs = vnode.data.attrs = extend({}, attrs);
	    }
	    for (key in attrs) {
	        cur = attrs[key];
	        old = oldAttrs[key];
	        if (old !== cur) {
	            setAttr(elm, key, cur, vnode.data.pre);
	        }
	    }
	    // #4391: in IE9, setting type can reset value for input[type=radio]
	    // #6666: IE/Edge forces progress value down to 1 before setting a max
	    /* istanbul ignore if */
	    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
	        setAttr(elm, 'value', attrs.value);
	    }
	    for (key in oldAttrs) {
	        if (isUndef(attrs[key])) {
	            if (isXlink(key)) {
	                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	            }
	            else if (!isEnumeratedAttr(key)) {
	                elm.removeAttribute(key);
	            }
	        }
	    }
	}
	function setAttr(el, key, value, isInPre) {
	    if (isInPre || el.tagName.indexOf('-') > -1) {
	        baseSetAttr(el, key, value);
	    }
	    else if (isBooleanAttr(key)) {
	        // set attribute for blank value
	        // e.g. <option disabled>Select one</option>
	        if (isFalsyAttrValue(value)) {
	            el.removeAttribute(key);
	        }
	        else {
	            // technically allowfullscreen is a boolean attribute for <iframe>,
	            // but Flash expects a value of "true" when used on <embed> tag
	            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
	            el.setAttribute(key, value);
	        }
	    }
	    else if (isEnumeratedAttr(key)) {
	        el.setAttribute(key, convertEnumeratedValue(key, value));
	    }
	    else if (isXlink(key)) {
	        if (isFalsyAttrValue(value)) {
	            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	        }
	        else {
	            el.setAttributeNS(xlinkNS, key, value);
	        }
	    }
	    else {
	        baseSetAttr(el, key, value);
	    }
	}
	function baseSetAttr(el, key, value) {
	    if (isFalsyAttrValue(value)) {
	        el.removeAttribute(key);
	    }
	    else {
	        // #7138: IE10 & 11 fires input event when setting placeholder on
	        // <textarea>... block the first input event and remove the blocker
	        // immediately.
	        /* istanbul ignore if */
	        if (isIE &&
	            !isIE9 &&
	            el.tagName === 'TEXTAREA' &&
	            key === 'placeholder' &&
	            value !== '' &&
	            !el.__ieph) {
	            const blocker = e => {
	                e.stopImmediatePropagation();
	                el.removeEventListener('input', blocker);
	            };
	            el.addEventListener('input', blocker);
	            // $flow-disable-line
	            el.__ieph = true; /* IE placeholder patched */
	        }
	        el.setAttribute(key, value);
	    }
	}
	var attrs = {
	    create: updateAttrs,
	    update: updateAttrs
	};

	function updateClass(oldVnode, vnode) {
	    const el = vnode.elm;
	    const data = vnode.data;
	    const oldData = oldVnode.data;
	    if (isUndef(data.staticClass) &&
	        isUndef(data.class) &&
	        (isUndef(oldData) ||
	            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
	        return;
	    }
	    let cls = genClassForVnode(vnode);
	    // handle transition classes
	    const transitionClass = el._transitionClasses;
	    if (isDef(transitionClass)) {
	        cls = concat(cls, stringifyClass(transitionClass));
	    }
	    // set the class
	    if (cls !== el._prevClass) {
	        el.setAttribute('class', cls);
	        el._prevClass = cls;
	    }
	}
	var klass = {
	    create: updateClass,
	    update: updateClass
	};

	// in some cases, the event used has to be determined at runtime
	// so we used some reserved tokens during compile.
	const RANGE_TOKEN = '__r';
	const CHECKBOX_RADIO_TOKEN = '__c';

	// normalize v-model event tokens that can only be determined at runtime.
	// it's important to place the event as the first in the array because
	// the whole point is ensuring the v-model callback gets called before
	// user-attached handlers.
	function normalizeEvents(on) {
	    /* istanbul ignore if */
	    if (isDef(on[RANGE_TOKEN])) {
	        // IE input[type=range] only supports `change` event
	        const event = isIE ? 'change' : 'input';
	        on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
	        delete on[RANGE_TOKEN];
	    }
	    // This was originally intended to fix #4521 but no longer necessary
	    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
	    /* istanbul ignore if */
	    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
	        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
	        delete on[CHECKBOX_RADIO_TOKEN];
	    }
	}
	let target;
	function createOnceHandler(event, handler, capture) {
	    const _target = target; // save current target element in closure
	    return function onceHandler() {
	        const res = handler.apply(null, arguments);
	        if (res !== null) {
	            remove(event, onceHandler, capture, _target);
	        }
	    };
	}
	// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
	// implementation and does not fire microtasks in between event propagation, so
	// safe to exclude.
	const useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
	function add(name, handler, capture, passive) {
	    // async edge case #6566: inner click event triggers patch, event handler
	    // attached to outer element during patch, and triggered again. This
	    // happens because browsers fire microtask ticks between event propagation.
	    // the solution is simple: we save the timestamp when a handler is attached,
	    // and the handler would only fire if the event passed to it was fired
	    // AFTER it was attached.
	    if (useMicrotaskFix) {
	        const attachedTimestamp = currentFlushTimestamp;
	        const original = handler;
	        //@ts-expect-error
	        handler = original._wrapper = function (e) {
	            if (
	            // no bubbling, should always fire.
	            // this is just a safety net in case event.timeStamp is unreliable in
	            // certain weird environments...
	            e.target === e.currentTarget ||
	                // event is fired after handler attachment
	                e.timeStamp >= attachedTimestamp ||
	                // bail for environments that have buggy event.timeStamp implementations
	                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
	                // #9681 QtWebEngine event.timeStamp is negative value
	                e.timeStamp <= 0 ||
	                // #9448 bail if event is fired in another document in a multi-page
	                // electron/nw.js app, since event.timeStamp will be using a different
	                // starting reference
	                e.target.ownerDocument !== document) {
	                return original.apply(this, arguments);
	            }
	        };
	    }
	    target.addEventListener(name, handler, supportsPassive ? { capture, passive } : capture);
	}
	function remove(name, handler, capture, _target) {
	    (_target || target).removeEventListener(name, 
	    //@ts-expect-error
	    handler._wrapper || handler, capture);
	}
	function updateDOMListeners(oldVnode, vnode) {
	    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
	        return;
	    }
	    const on = vnode.data.on || {};
	    const oldOn = oldVnode.data.on || {};
	    // vnode is empty when removing all listeners,
	    // and use old vnode dom element
	    target = vnode.elm || oldVnode.elm;
	    normalizeEvents(on);
	    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
	    target = undefined;
	}
	var events = {
	    create: updateDOMListeners,
	    update: updateDOMListeners,
	    // @ts-expect-error emptyNode has actually data
	    destroy: (vnode) => updateDOMListeners(vnode, emptyNode)
	};

	let svgContainer;
	function updateDOMProps(oldVnode, vnode) {
	    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
	        return;
	    }
	    let key, cur;
	    const elm = vnode.elm;
	    const oldProps = oldVnode.data.domProps || {};
	    let props = vnode.data.domProps || {};
	    // clone observed objects, as the user probably wants to mutate it
	    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
	        props = vnode.data.domProps = extend({}, props);
	    }
	    for (key in oldProps) {
	        if (!(key in props)) {
	            elm[key] = '';
	        }
	    }
	    for (key in props) {
	        cur = props[key];
	        // ignore children if the node has textContent or innerHTML,
	        // as these will throw away existing DOM nodes and cause removal errors
	        // on subsequent patches (#3360)
	        if (key === 'textContent' || key === 'innerHTML') {
	            if (vnode.children)
	                vnode.children.length = 0;
	            if (cur === oldProps[key])
	                continue;
	            // #6601 work around Chrome version <= 55 bug where single textNode
	            // replaced by innerHTML/textContent retains its parentNode property
	            if (elm.childNodes.length === 1) {
	                elm.removeChild(elm.childNodes[0]);
	            }
	        }
	        if (key === 'value' && elm.tagName !== 'PROGRESS') {
	            // store value as _value as well since
	            // non-string values will be stringified
	            elm._value = cur;
	            // avoid resetting cursor position when value is the same
	            const strCur = isUndef(cur) ? '' : String(cur);
	            if (shouldUpdateValue(elm, strCur)) {
	                elm.value = strCur;
	            }
	        }
	        else if (key === 'innerHTML' &&
	            isSVG(elm.tagName) &&
	            isUndef(elm.innerHTML)) {
	            // IE doesn't support innerHTML for SVG elements
	            svgContainer = svgContainer || document.createElement('div');
	            svgContainer.innerHTML = `<svg>${cur}</svg>`;
	            const svg = svgContainer.firstChild;
	            while (elm.firstChild) {
	                elm.removeChild(elm.firstChild);
	            }
	            while (svg.firstChild) {
	                elm.appendChild(svg.firstChild);
	            }
	        }
	        else if (
	        // skip the update if old and new VDOM state is the same.
	        // `value` is handled separately because the DOM value may be temporarily
	        // out of sync with VDOM state due to focus, composition and modifiers.
	        // This  #4521 by skipping the unnecessary `checked` update.
	        cur !== oldProps[key]) {
	            // some property updates can throw
	            // e.g. `value` on <progress> w/ non-finite value
	            try {
	                elm[key] = cur;
	            }
	            catch (e) { }
	        }
	    }
	}
	function shouldUpdateValue(elm, checkVal) {
	    return (
	    //@ts-expect-error
	    !elm.composing &&
	        (elm.tagName === 'OPTION' ||
	            isNotInFocusAndDirty(elm, checkVal) ||
	            isDirtyWithModifiers(elm, checkVal)));
	}
	function isNotInFocusAndDirty(elm, checkVal) {
	    // return true when textbox (.number and .trim) loses focus and its value is
	    // not equal to the updated value
	    let notInFocus = true;
	    // #6157
	    // work around IE bug when accessing document.activeElement in an iframe
	    try {
	        notInFocus = document.activeElement !== elm;
	    }
	    catch (e) { }
	    return notInFocus && elm.value !== checkVal;
	}
	function isDirtyWithModifiers(elm, newVal) {
	    const value = elm.value;
	    const modifiers = elm._vModifiers; // injected by v-model runtime
	    if (isDef(modifiers)) {
	        if (modifiers.number) {
	            return toNumber(value) !== toNumber(newVal);
	        }
	        if (modifiers.trim) {
	            return value.trim() !== newVal.trim();
	        }
	    }
	    return value !== newVal;
	}
	var domProps = {
	    create: updateDOMProps,
	    update: updateDOMProps
	};

	const parseStyleText = cached(function (cssText) {
	    const res = {};
	    const listDelimiter = /;(?![^(]*\))/g;
	    const propertyDelimiter = /:(.+)/;
	    cssText.split(listDelimiter).forEach(function (item) {
	        if (item) {
	            const tmp = item.split(propertyDelimiter);
	            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	        }
	    });
	    return res;
	});
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData(data) {
	    const style = normalizeStyleBinding(data.style);
	    // static style is pre-processed into an object during compilation
	    // and is always a fresh object, so it's safe to merge into it
	    return data.staticStyle ? extend(data.staticStyle, style) : style;
	}
	// normalize possible array / string values into Object
	function normalizeStyleBinding(bindingStyle) {
	    if (Array.isArray(bindingStyle)) {
	        return toObject(bindingStyle);
	    }
	    if (typeof bindingStyle === 'string') {
	        return parseStyleText(bindingStyle);
	    }
	    return bindingStyle;
	}
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle(vnode, checkChild) {
	    const res = {};
	    let styleData;
	    if (checkChild) {
	        let childNode = vnode;
	        while (childNode.componentInstance) {
	            childNode = childNode.componentInstance._vnode;
	            if (childNode &&
	                childNode.data &&
	                (styleData = normalizeStyleData(childNode.data))) {
	                extend(res, styleData);
	            }
	        }
	    }
	    if ((styleData = normalizeStyleData(vnode.data))) {
	        extend(res, styleData);
	    }
	    let parentNode = vnode;
	    // @ts-expect-error parentNode.parent not VNodeWithData
	    while ((parentNode = parentNode.parent)) {
	        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	            extend(res, styleData);
	        }
	    }
	    return res;
	}

	const cssVarRE = /^--/;
	const importantRE = /\s*!important$/;
	const setProp = (el, name, val) => {
	    /* istanbul ignore if */
	    if (cssVarRE.test(name)) {
	        el.style.setProperty(name, val);
	    }
	    else if (importantRE.test(val)) {
	        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
	    }
	    else {
	        const normalizedName = normalize(name);
	        if (Array.isArray(val)) {
	            // Support values array created by autoprefixer, e.g.
	            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
	            // Set them one by one, and the browser will only set those it can recognize
	            for (let i = 0, len = val.length; i < len; i++) {
	                el.style[normalizedName] = val[i];
	            }
	        }
	        else {
	            el.style[normalizedName] = val;
	        }
	    }
	};
	const vendorNames = ['Webkit', 'Moz', 'ms'];
	let emptyStyle;
	const normalize = cached(function (prop) {
	    emptyStyle = emptyStyle || document.createElement('div').style;
	    prop = camelize(prop);
	    if (prop !== 'filter' && prop in emptyStyle) {
	        return prop;
	    }
	    const capName = prop.charAt(0).toUpperCase() + prop.slice(1);
	    for (let i = 0; i < vendorNames.length; i++) {
	        const name = vendorNames[i] + capName;
	        if (name in emptyStyle) {
	            return name;
	        }
	    }
	});
	function updateStyle(oldVnode, vnode) {
	    const data = vnode.data;
	    const oldData = oldVnode.data;
	    if (isUndef(data.staticStyle) &&
	        isUndef(data.style) &&
	        isUndef(oldData.staticStyle) &&
	        isUndef(oldData.style)) {
	        return;
	    }
	    let cur, name;
	    const el = vnode.elm;
	    const oldStaticStyle = oldData.staticStyle;
	    const oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
	    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	    const oldStyle = oldStaticStyle || oldStyleBinding;
	    const style = normalizeStyleBinding(vnode.data.style) || {};
	    // store normalized style under a different key for next diff
	    // make sure to clone it if it's reactive, since the user likely wants
	    // to mutate it.
	    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
	    const newStyle = getStyle(vnode, true);
	    for (name in oldStyle) {
	        if (isUndef(newStyle[name])) {
	            setProp(el, name, '');
	        }
	    }
	    for (name in newStyle) {
	        cur = newStyle[name];
	        if (cur !== oldStyle[name]) {
	            // ie9 setting to null has no effect, must use empty string
	            setProp(el, name, cur == null ? '' : cur);
	        }
	    }
	}
	var style = {
	    create: updateStyle,
	    update: updateStyle
	};

	const whitespaceRE = /\s+/;
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass(el, cls) {
	    /* istanbul ignore if */
	    if (!cls || !(cls = cls.trim())) {
	        return;
	    }
	    /* istanbul ignore else */
	    if (el.classList) {
	        if (cls.indexOf(' ') > -1) {
	            cls.split(whitespaceRE).forEach(c => el.classList.add(c));
	        }
	        else {
	            el.classList.add(cls);
	        }
	    }
	    else {
	        const cur = ` ${el.getAttribute('class') || ''} `;
	        if (cur.indexOf(' ' + cls + ' ') < 0) {
	            el.setAttribute('class', (cur + cls).trim());
	        }
	    }
	}
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass(el, cls) {
	    /* istanbul ignore if */
	    if (!cls || !(cls = cls.trim())) {
	        return;
	    }
	    /* istanbul ignore else */
	    if (el.classList) {
	        if (cls.indexOf(' ') > -1) {
	            cls.split(whitespaceRE).forEach(c => el.classList.remove(c));
	        }
	        else {
	            el.classList.remove(cls);
	        }
	        if (!el.classList.length) {
	            el.removeAttribute('class');
	        }
	    }
	    else {
	        let cur = ` ${el.getAttribute('class') || ''} `;
	        const tar = ' ' + cls + ' ';
	        while (cur.indexOf(tar) >= 0) {
	            cur = cur.replace(tar, ' ');
	        }
	        cur = cur.trim();
	        if (cur) {
	            el.setAttribute('class', cur);
	        }
	        else {
	            el.removeAttribute('class');
	        }
	    }
	}

	function resolveTransition(def) {
	    if (!def) {
	        return;
	    }
	    /* istanbul ignore else */
	    if (typeof def === 'object') {
	        const res = {};
	        if (def.css !== false) {
	            extend(res, autoCssTransition(def.name || 'v'));
	        }
	        extend(res, def);
	        return res;
	    }
	    else if (typeof def === 'string') {
	        return autoCssTransition(def);
	    }
	}
	const autoCssTransition = cached(name => {
	    return {
	        enterClass: `${name}-enter`,
	        enterToClass: `${name}-enter-to`,
	        enterActiveClass: `${name}-enter-active`,
	        leaveClass: `${name}-leave`,
	        leaveToClass: `${name}-leave-to`,
	        leaveActiveClass: `${name}-leave-active`
	    };
	});
	const hasTransition = inBrowser && !isIE9;
	const TRANSITION = 'transition';
	const ANIMATION = 'animation';
	// Transition property/event sniffing
	let transitionProp = 'transition';
	let transitionEndEvent = 'transitionend';
	let animationProp = 'animation';
	let animationEndEvent = 'animationend';
	if (hasTransition) {
	    /* istanbul ignore if */
	    if (window.ontransitionend === undefined &&
	        window.onwebkittransitionend !== undefined) {
	        transitionProp = 'WebkitTransition';
	        transitionEndEvent = 'webkitTransitionEnd';
	    }
	    if (window.onanimationend === undefined &&
	        window.onwebkitanimationend !== undefined) {
	        animationProp = 'WebkitAnimation';
	        animationEndEvent = 'webkitAnimationEnd';
	    }
	}
	// binding to window is necessary to make hot reload work in IE in strict mode
	const raf = inBrowser
	    ? window.requestAnimationFrame
	        ? window.requestAnimationFrame.bind(window)
	        : setTimeout
	    : /* istanbul ignore next */ /* istanbul ignore next */ fn => fn();
	function nextFrame(fn) {
	    raf(() => {
	        // @ts-expect-error
	        raf(fn);
	    });
	}
	function addTransitionClass(el, cls) {
	    const transitionClasses = el._transitionClasses || (el._transitionClasses = []);
	    if (transitionClasses.indexOf(cls) < 0) {
	        transitionClasses.push(cls);
	        addClass(el, cls);
	    }
	}
	function removeTransitionClass(el, cls) {
	    if (el._transitionClasses) {
	        remove$2(el._transitionClasses, cls);
	    }
	    removeClass(el, cls);
	}
	function whenTransitionEnds(el, expectedType, cb) {
	    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
	    if (!type)
	        return cb();
	    const event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	    let ended = 0;
	    const end = () => {
	        el.removeEventListener(event, onEnd);
	        cb();
	    };
	    const onEnd = e => {
	        if (e.target === el) {
	            if (++ended >= propCount) {
	                end();
	            }
	        }
	    };
	    setTimeout(() => {
	        if (ended < propCount) {
	            end();
	        }
	    }, timeout + 1);
	    el.addEventListener(event, onEnd);
	}
	const transformRE = /\b(transform|all)(,|$)/;
	function getTransitionInfo(el, expectedType) {
	    const styles = window.getComputedStyle(el);
	    // JSDOM may return undefined for transition properties
	    const transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
	    const transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
	    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	    const animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
	    const animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
	    const animationTimeout = getTimeout(animationDelays, animationDurations);
	    let type;
	    let timeout = 0;
	    let propCount = 0;
	    /* istanbul ignore if */
	    if (expectedType === TRANSITION) {
	        if (transitionTimeout > 0) {
	            type = TRANSITION;
	            timeout = transitionTimeout;
	            propCount = transitionDurations.length;
	        }
	    }
	    else if (expectedType === ANIMATION) {
	        if (animationTimeout > 0) {
	            type = ANIMATION;
	            timeout = animationTimeout;
	            propCount = animationDurations.length;
	        }
	    }
	    else {
	        timeout = Math.max(transitionTimeout, animationTimeout);
	        type =
	            timeout > 0
	                ? transitionTimeout > animationTimeout
	                    ? TRANSITION
	                    : ANIMATION
	                : null;
	        propCount = type
	            ? type === TRANSITION
	                ? transitionDurations.length
	                : animationDurations.length
	            : 0;
	    }
	    const hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
	    return {
	        type,
	        timeout,
	        propCount,
	        hasTransform
	    };
	}
	function getTimeout(delays, durations) {
	    /* istanbul ignore next */
	    while (delays.length < durations.length) {
	        delays = delays.concat(delays);
	    }
	    return Math.max.apply(null, durations.map((d, i) => {
	        return toMs(d) + toMs(delays[i]);
	    }));
	}
	// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
	// in a locale-dependent way, using a comma instead of a dot.
	// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
	// as a floor function) causing unexpected behaviors
	function toMs(s) {
	    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
	}

	function enter(vnode, toggleDisplay) {
	    const el = vnode.elm;
	    // call leave callback now
	    if (isDef(el._leaveCb)) {
	        el._leaveCb.cancelled = true;
	        el._leaveCb();
	    }
	    const data = resolveTransition(vnode.data.transition);
	    if (isUndef(data)) {
	        return;
	    }
	    /* istanbul ignore if */
	    if (isDef(el._enterCb) || el.nodeType !== 1) {
	        return;
	    }
	    const { css, type, enterClass, enterToClass, enterActiveClass, appearClass, appearToClass, appearActiveClass, beforeEnter, enter, afterEnter, enterCancelled, beforeAppear, appear, afterAppear, appearCancelled, duration } = data;
	    // activeInstance will always be the <transition> component managing this
	    // transition. One edge case to check is when the <transition> is placed
	    // as the root node of a child component. In that case we need to check
	    // <transition>'s parent for appear check.
	    let context = activeInstance;
	    let transitionNode = activeInstance.$vnode;
	    while (transitionNode && transitionNode.parent) {
	        context = transitionNode.context;
	        transitionNode = transitionNode.parent;
	    }
	    const isAppear = !context._isMounted || !vnode.isRootInsert;
	    if (isAppear && !appear && appear !== '') {
	        return;
	    }
	    const startClass = isAppear && appearClass ? appearClass : enterClass;
	    const activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
	    const toClass = isAppear && appearToClass ? appearToClass : enterToClass;
	    const beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
	    const enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
	    const afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
	    const enterCancelledHook = isAppear
	        ? appearCancelled || enterCancelled
	        : enterCancelled;
	    const explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
	    if (explicitEnterDuration != null) {
	        checkDuration(explicitEnterDuration, 'enter', vnode);
	    }
	    const expectsCSS = css !== false && !isIE9;
	    const userWantsControl = getHookArgumentsLength(enterHook);
	    const cb = (el._enterCb = once(() => {
	        if (expectsCSS) {
	            removeTransitionClass(el, toClass);
	            removeTransitionClass(el, activeClass);
	        }
	        // @ts-expect-error
	        if (cb.cancelled) {
	            if (expectsCSS) {
	                removeTransitionClass(el, startClass);
	            }
	            enterCancelledHook && enterCancelledHook(el);
	        }
	        else {
	            afterEnterHook && afterEnterHook(el);
	        }
	        el._enterCb = null;
	    }));
	    if (!vnode.data.show) {
	        // remove pending leave element on enter by injecting an insert hook
	        mergeVNodeHook(vnode, 'insert', () => {
	            const parent = el.parentNode;
	            const pendingNode = parent && parent._pending && parent._pending[vnode.key];
	            if (pendingNode &&
	                pendingNode.tag === vnode.tag &&
	                pendingNode.elm._leaveCb) {
	                pendingNode.elm._leaveCb();
	            }
	            enterHook && enterHook(el, cb);
	        });
	    }
	    // start enter transition
	    beforeEnterHook && beforeEnterHook(el);
	    if (expectsCSS) {
	        addTransitionClass(el, startClass);
	        addTransitionClass(el, activeClass);
	        nextFrame(() => {
	            removeTransitionClass(el, startClass);
	            // @ts-expect-error
	            if (!cb.cancelled) {
	                addTransitionClass(el, toClass);
	                if (!userWantsControl) {
	                    if (isValidDuration(explicitEnterDuration)) {
	                        setTimeout(cb, explicitEnterDuration);
	                    }
	                    else {
	                        whenTransitionEnds(el, type, cb);
	                    }
	                }
	            }
	        });
	    }
	    if (vnode.data.show) {
	        toggleDisplay && toggleDisplay();
	        enterHook && enterHook(el, cb);
	    }
	    if (!expectsCSS && !userWantsControl) {
	        cb();
	    }
	}
	function leave(vnode, rm) {
	    const el = vnode.elm;
	    // call enter callback now
	    if (isDef(el._enterCb)) {
	        el._enterCb.cancelled = true;
	        el._enterCb();
	    }
	    const data = resolveTransition(vnode.data.transition);
	    if (isUndef(data) || el.nodeType !== 1) {
	        return rm();
	    }
	    /* istanbul ignore if */
	    if (isDef(el._leaveCb)) {
	        return;
	    }
	    const { css, type, leaveClass, leaveToClass, leaveActiveClass, beforeLeave, leave, afterLeave, leaveCancelled, delayLeave, duration } = data;
	    const expectsCSS = css !== false && !isIE9;
	    const userWantsControl = getHookArgumentsLength(leave);
	    const explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
	    if (isDef(explicitLeaveDuration)) {
	        checkDuration(explicitLeaveDuration, 'leave', vnode);
	    }
	    const cb = (el._leaveCb = once(() => {
	        if (el.parentNode && el.parentNode._pending) {
	            el.parentNode._pending[vnode.key] = null;
	        }
	        if (expectsCSS) {
	            removeTransitionClass(el, leaveToClass);
	            removeTransitionClass(el, leaveActiveClass);
	        }
	        // @ts-expect-error
	        if (cb.cancelled) {
	            if (expectsCSS) {
	                removeTransitionClass(el, leaveClass);
	            }
	            leaveCancelled && leaveCancelled(el);
	        }
	        else {
	            rm();
	            afterLeave && afterLeave(el);
	        }
	        el._leaveCb = null;
	    }));
	    if (delayLeave) {
	        delayLeave(performLeave);
	    }
	    else {
	        performLeave();
	    }
	    function performLeave() {
	        // the delayed leave may have already been cancelled
	        // @ts-expect-error
	        if (cb.cancelled) {
	            return;
	        }
	        // record leaving element
	        if (!vnode.data.show && el.parentNode) {
	            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
	                vnode;
	        }
	        beforeLeave && beforeLeave(el);
	        if (expectsCSS) {
	            addTransitionClass(el, leaveClass);
	            addTransitionClass(el, leaveActiveClass);
	            nextFrame(() => {
	                removeTransitionClass(el, leaveClass);
	                // @ts-expect-error
	                if (!cb.cancelled) {
	                    addTransitionClass(el, leaveToClass);
	                    if (!userWantsControl) {
	                        if (isValidDuration(explicitLeaveDuration)) {
	                            setTimeout(cb, explicitLeaveDuration);
	                        }
	                        else {
	                            whenTransitionEnds(el, type, cb);
	                        }
	                    }
	                }
	            });
	        }
	        leave && leave(el, cb);
	        if (!expectsCSS && !userWantsControl) {
	            cb();
	        }
	    }
	}
	// only used in dev mode
	function checkDuration(val, name, vnode) {
	    if (typeof val !== 'number') {
	        warn(`<transition> explicit ${name} duration is not a valid number - ` +
	            `got ${JSON.stringify(val)}.`, vnode.context);
	    }
	    else if (isNaN(val)) {
	        warn(`<transition> explicit ${name} duration is NaN - ` +
	            'the duration expression might be incorrect.', vnode.context);
	    }
	}
	function isValidDuration(val) {
	    return typeof val === 'number' && !isNaN(val);
	}
	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength(fn) {
	    if (isUndef(fn)) {
	        return false;
	    }
	    // @ts-expect-error
	    const invokerFns = fn.fns;
	    if (isDef(invokerFns)) {
	        // invoker
	        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
	    }
	    else {
	        // @ts-expect-error
	        return (fn._length || fn.length) > 1;
	    }
	}
	function _enter(_, vnode) {
	    if (vnode.data.show !== true) {
	        enter(vnode);
	    }
	}
	var transition = inBrowser
	    ? {
	        create: _enter,
	        activate: _enter,
	        remove(vnode, rm) {
	            /* istanbul ignore else */
	            if (vnode.data.show !== true) {
	                // @ts-expect-error
	                leave(vnode, rm);
	            }
	            else {
	                rm();
	            }
	        }
	    }
	    : {};

	var platformModules = [attrs, klass, events, domProps, style, transition];

	// the directive module should be applied last, after all
	// built-in modules have been applied.
	const modules = platformModules.concat(baseModules);
	const patch = createPatchFunction({ nodeOps, modules });

	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	/* istanbul ignore if */
	if (isIE9) {
	    // http://www.matts411.com/post/internet-explorer-9-oninput/
	    document.addEventListener('selectionchange', () => {
	        const el = document.activeElement;
	        // @ts-expect-error
	        if (el && el.vmodel) {
	            trigger(el, 'input');
	        }
	    });
	}
	const directive = {
	    inserted(el, binding, vnode, oldVnode) {
	        if (vnode.tag === 'select') {
	            // #6903
	            if (oldVnode.elm && !oldVnode.elm._vOptions) {
	                mergeVNodeHook(vnode, 'postpatch', () => {
	                    directive.componentUpdated(el, binding, vnode);
	                });
	            }
	            else {
	                setSelected(el, binding, vnode.context);
	            }
	            el._vOptions = [].map.call(el.options, getValue);
	        }
	        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
	            el._vModifiers = binding.modifiers;
	            if (!binding.modifiers.lazy) {
	                el.addEventListener('compositionstart', onCompositionStart);
	                el.addEventListener('compositionend', onCompositionEnd);
	                // Safari < 10.2 & UIWebView doesn't fire compositionend when
	                // switching focus before confirming composition choice
	                // this also fixes the issue where some browsers e.g. iOS Chrome
	                // fires "change" instead of "input" on autocomplete.
	                el.addEventListener('change', onCompositionEnd);
	                /* istanbul ignore if */
	                if (isIE9) {
	                    el.vmodel = true;
	                }
	            }
	        }
	    },
	    componentUpdated(el, binding, vnode) {
	        if (vnode.tag === 'select') {
	            setSelected(el, binding, vnode.context);
	            // in case the options rendered by v-for have changed,
	            // it's possible that the value is out-of-sync with the rendered options.
	            // detect such cases and filter out values that no longer has a matching
	            // option in the DOM.
	            const prevOptions = el._vOptions;
	            const curOptions = (el._vOptions = [].map.call(el.options, getValue));
	            if (curOptions.some((o, i) => !looseEqual(o, prevOptions[i]))) {
	                // trigger change event if
	                // no matching option found for at least one value
	                const needReset = el.multiple
	                    ? binding.value.some(v => hasNoMatchingOption(v, curOptions))
	                    : binding.value !== binding.oldValue &&
	                        hasNoMatchingOption(binding.value, curOptions);
	                if (needReset) {
	                    trigger(el, 'change');
	                }
	            }
	        }
	    }
	};
	function setSelected(el, binding, vm) {
	    actuallySetSelected(el, binding, vm);
	    /* istanbul ignore if */
	    if (isIE || isEdge) {
	        setTimeout(() => {
	            actuallySetSelected(el, binding, vm);
	        }, 0);
	    }
	}
	function actuallySetSelected(el, binding, vm) {
	    const value = binding.value;
	    const isMultiple = el.multiple;
	    if (isMultiple && !Array.isArray(value)) {
	        warn(`<select multiple v-model="${binding.expression}"> ` +
	                `expects an Array value for its binding, but got ${Object.prototype.toString
	                    .call(value)
	                    .slice(8, -1)}`, vm);
	        return;
	    }
	    let selected, option;
	    for (let i = 0, l = el.options.length; i < l; i++) {
	        option = el.options[i];
	        if (isMultiple) {
	            selected = looseIndexOf(value, getValue(option)) > -1;
	            if (option.selected !== selected) {
	                option.selected = selected;
	            }
	        }
	        else {
	            if (looseEqual(getValue(option), value)) {
	                if (el.selectedIndex !== i) {
	                    el.selectedIndex = i;
	                }
	                return;
	            }
	        }
	    }
	    if (!isMultiple) {
	        el.selectedIndex = -1;
	    }
	}
	function hasNoMatchingOption(value, options) {
	    return options.every(o => !looseEqual(o, value));
	}
	function getValue(option) {
	    return '_value' in option ? option._value : option.value;
	}
	function onCompositionStart(e) {
	    e.target.composing = true;
	}
	function onCompositionEnd(e) {
	    // prevent triggering an input event for no reason
	    if (!e.target.composing)
	        return;
	    e.target.composing = false;
	    trigger(e.target, 'input');
	}
	function trigger(el, type) {
	    const e = document.createEvent('HTMLEvents');
	    e.initEvent(type, true, true);
	    el.dispatchEvent(e);
	}

	// recursively search for possible transition defined inside the component root
	function locateNode(vnode) {
	    // @ts-expect-error
	    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	        ? locateNode(vnode.componentInstance._vnode)
	        : vnode;
	}
	var show = {
	    bind(el, { value }, vnode) {
	        vnode = locateNode(vnode);
	        const transition = vnode.data && vnode.data.transition;
	        const originalDisplay = (el.__vOriginalDisplay =
	            el.style.display === 'none' ? '' : el.style.display);
	        if (value && transition) {
	            vnode.data.show = true;
	            enter(vnode, () => {
	                el.style.display = originalDisplay;
	            });
	        }
	        else {
	            el.style.display = value ? originalDisplay : 'none';
	        }
	    },
	    update(el, { value, oldValue }, vnode) {
	        /* istanbul ignore if */
	        if (!value === !oldValue)
	            return;
	        vnode = locateNode(vnode);
	        const transition = vnode.data && vnode.data.transition;
	        if (transition) {
	            vnode.data.show = true;
	            if (value) {
	                enter(vnode, () => {
	                    el.style.display = el.__vOriginalDisplay;
	                });
	            }
	            else {
	                leave(vnode, () => {
	                    el.style.display = 'none';
	                });
	            }
	        }
	        else {
	            el.style.display = value ? el.__vOriginalDisplay : 'none';
	        }
	    },
	    unbind(el, binding, vnode, oldVnode, isDestroy) {
	        if (!isDestroy) {
	            el.style.display = el.__vOriginalDisplay;
	        }
	    }
	};

	var platformDirectives = {
	    model: directive,
	    show
	};

	// Provides transition support for a single element/component.
	const transitionProps = {
	    name: String,
	    appear: Boolean,
	    css: Boolean,
	    mode: String,
	    type: String,
	    enterClass: String,
	    leaveClass: String,
	    enterToClass: String,
	    leaveToClass: String,
	    enterActiveClass: String,
	    leaveActiveClass: String,
	    appearClass: String,
	    appearActiveClass: String,
	    appearToClass: String,
	    duration: [Number, String, Object]
	};
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild(vnode) {
	    const compOptions = vnode && vnode.componentOptions;
	    if (compOptions && compOptions.Ctor.options.abstract) {
	        return getRealChild(getFirstComponentChild(compOptions.children));
	    }
	    else {
	        return vnode;
	    }
	}
	function extractTransitionData(comp) {
	    const data = {};
	    const options = comp.$options;
	    // props
	    for (const key in options.propsData) {
	        data[key] = comp[key];
	    }
	    // events.
	    // extract listeners and pass them directly to the transition methods
	    const listeners = options._parentListeners;
	    for (const key in listeners) {
	        data[camelize(key)] = listeners[key];
	    }
	    return data;
	}
	function placeholder(h, rawChild) {
	    // @ts-expect-error
	    if (/\d-keep-alive$/.test(rawChild.tag)) {
	        return h('keep-alive', {
	            props: rawChild.componentOptions.propsData
	        });
	    }
	}
	function hasParentTransition(vnode) {
	    while ((vnode = vnode.parent)) {
	        if (vnode.data.transition) {
	            return true;
	        }
	    }
	}
	function isSameChild(child, oldChild) {
	    return oldChild.key === child.key && oldChild.tag === child.tag;
	}
	const isNotTextNode = (c) => c.tag || isAsyncPlaceholder(c);
	const isVShowDirective = d => d.name === 'show';
	var Transition = {
	    name: 'transition',
	    props: transitionProps,
	    abstract: true,
	    render(h) {
	        let children = this.$slots.default;
	        if (!children) {
	            return;
	        }
	        // filter out text nodes (possible whitespaces)
	        children = children.filter(isNotTextNode);
	        /* istanbul ignore if */
	        if (!children.length) {
	            return;
	        }
	        // warn multiple elements
	        if (children.length > 1) {
	            warn('<transition> can only be used on a single element. Use ' +
	                '<transition-group> for lists.', this.$parent);
	        }
	        const mode = this.mode;
	        // warn invalid mode
	        if (mode && mode !== 'in-out' && mode !== 'out-in') {
	            warn('invalid <transition> mode: ' + mode, this.$parent);
	        }
	        const rawChild = children[0];
	        // if this is a component root node and the component's
	        // parent container node also has transition, skip.
	        if (hasParentTransition(this.$vnode)) {
	            return rawChild;
	        }
	        // apply transition data to child
	        // use getRealChild() to ignore abstract components e.g. keep-alive
	        const child = getRealChild(rawChild);
	        /* istanbul ignore if */
	        if (!child) {
	            return rawChild;
	        }
	        if (this._leaving) {
	            return placeholder(h, rawChild);
	        }
	        // ensure a key that is unique to the vnode type and to this transition
	        // component instance. This key will be used to remove pending leaving nodes
	        // during entering.
	        const id = `__transition-${this._uid}-`;
	        child.key =
	            child.key == null
	                ? child.isComment
	                    ? id + 'comment'
	                    : id + child.tag
	                : isPrimitive(child.key)
	                    ? String(child.key).indexOf(id) === 0
	                        ? child.key
	                        : id + child.key
	                    : child.key;
	        const data = ((child.data || (child.data = {})).transition =
	            extractTransitionData(this));
	        const oldRawChild = this._vnode;
	        const oldChild = getRealChild(oldRawChild);
	        // mark v-show
	        // so that the transition module can hand over the control to the directive
	        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
	            child.data.show = true;
	        }
	        if (oldChild &&
	            oldChild.data &&
	            !isSameChild(child, oldChild) &&
	            !isAsyncPlaceholder(oldChild) &&
	            // #6687 component root is a comment node
	            !(oldChild.componentInstance &&
	                oldChild.componentInstance._vnode.isComment)) {
	            // replace old child transition data with fresh one
	            // important for dynamic transitions!
	            const oldData = (oldChild.data.transition = extend({}, data));
	            // handle transition mode
	            if (mode === 'out-in') {
	                // return placeholder node and queue update when leave finishes
	                this._leaving = true;
	                mergeVNodeHook(oldData, 'afterLeave', () => {
	                    this._leaving = false;
	                    this.$forceUpdate();
	                });
	                return placeholder(h, rawChild);
	            }
	            else if (mode === 'in-out') {
	                if (isAsyncPlaceholder(child)) {
	                    return oldRawChild;
	                }
	                let delayedLeave;
	                const performLeave = () => {
	                    delayedLeave();
	                };
	                mergeVNodeHook(data, 'afterEnter', performLeave);
	                mergeVNodeHook(data, 'enterCancelled', performLeave);
	                mergeVNodeHook(oldData, 'delayLeave', leave => {
	                    delayedLeave = leave;
	                });
	            }
	        }
	        return rawChild;
	    }
	};

	// Provides transition support for list items.
	const props = extend({
	    tag: String,
	    moveClass: String
	}, transitionProps);
	delete props.mode;
	var TransitionGroup = {
	    props,
	    beforeMount() {
	        const update = this._update;
	        this._update = (vnode, hydrating) => {
	            const restoreActiveInstance = setActiveInstance(this);
	            // force removing pass
	            this.__patch__(this._vnode, this.kept, false, // hydrating
	            true // removeOnly (!important, avoids unnecessary moves)
	            );
	            this._vnode = this.kept;
	            restoreActiveInstance();
	            update.call(this, vnode, hydrating);
	        };
	    },
	    render(h) {
	        const tag = this.tag || this.$vnode.data.tag || 'span';
	        const map = Object.create(null);
	        const prevChildren = (this.prevChildren = this.children);
	        const rawChildren = this.$slots.default || [];
	        const children = (this.children = []);
	        const transitionData = extractTransitionData(this);
	        for (let i = 0; i < rawChildren.length; i++) {
	            const c = rawChildren[i];
	            if (c.tag) {
	                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	                    children.push(c);
	                    map[c.key] = c;
	                    (c.data || (c.data = {})).transition = transitionData;
	                }
	                else {
	                    const opts = c.componentOptions;
	                    const name = opts
	                        ? getComponentName(opts.Ctor.options) || opts.tag || ''
	                        : c.tag;
	                    warn(`<transition-group> children must be keyed: <${name}>`);
	                }
	            }
	        }
	        if (prevChildren) {
	            const kept = [];
	            const removed = [];
	            for (let i = 0; i < prevChildren.length; i++) {
	                const c = prevChildren[i];
	                c.data.transition = transitionData;
	                // @ts-expect-error .getBoundingClientRect is not typed in Node
	                c.data.pos = c.elm.getBoundingClientRect();
	                if (map[c.key]) {
	                    kept.push(c);
	                }
	                else {
	                    removed.push(c);
	                }
	            }
	            this.kept = h(tag, null, kept);
	            this.removed = removed;
	        }
	        return h(tag, null, children);
	    },
	    updated() {
	        const children = this.prevChildren;
	        const moveClass = this.moveClass || (this.name || 'v') + '-move';
	        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	            return;
	        }
	        // we divide the work into three loops to avoid mixing DOM reads and writes
	        // in each iteration - which helps prevent layout thrashing.
	        children.forEach(callPendingCbs);
	        children.forEach(recordPosition);
	        children.forEach(applyTranslation);
	        // force reflow to put everything in position
	        // assign to this to avoid being removed in tree-shaking
	        // $flow-disable-line
	        this._reflow = document.body.offsetHeight;
	        children.forEach((c) => {
	            if (c.data.moved) {
	                const el = c.elm;
	                const s = el.style;
	                addTransitionClass(el, moveClass);
	                s.transform = s.WebkitTransform = s.transitionDuration = '';
	                el.addEventListener(transitionEndEvent, (el._moveCb = function cb(e) {
	                    if (e && e.target !== el) {
	                        return;
	                    }
	                    if (!e || /transform$/.test(e.propertyName)) {
	                        el.removeEventListener(transitionEndEvent, cb);
	                        el._moveCb = null;
	                        removeTransitionClass(el, moveClass);
	                    }
	                }));
	            }
	        });
	    },
	    methods: {
	        hasMove(el, moveClass) {
	            /* istanbul ignore if */
	            if (!hasTransition) {
	                return false;
	            }
	            /* istanbul ignore if */
	            if (this._hasMove) {
	                return this._hasMove;
	            }
	            // Detect whether an element with the move class applied has
	            // CSS transitions. Since the element may be inside an entering
	            // transition at this very moment, we make a clone of it and remove
	            // all other transition classes applied to ensure only the move class
	            // is applied.
	            const clone = el.cloneNode();
	            if (el._transitionClasses) {
	                el._transitionClasses.forEach((cls) => {
	                    removeClass(clone, cls);
	                });
	            }
	            addClass(clone, moveClass);
	            clone.style.display = 'none';
	            this.$el.appendChild(clone);
	            const info = getTransitionInfo(clone);
	            this.$el.removeChild(clone);
	            return (this._hasMove = info.hasTransform);
	        }
	    }
	};
	function callPendingCbs(c) {
	    /* istanbul ignore if */
	    if (c.elm._moveCb) {
	        c.elm._moveCb();
	    }
	    /* istanbul ignore if */
	    if (c.elm._enterCb) {
	        c.elm._enterCb();
	    }
	}
	function recordPosition(c) {
	    c.data.newPos = c.elm.getBoundingClientRect();
	}
	function applyTranslation(c) {
	    const oldPos = c.data.pos;
	    const newPos = c.data.newPos;
	    const dx = oldPos.left - newPos.left;
	    const dy = oldPos.top - newPos.top;
	    if (dx || dy) {
	        c.data.moved = true;
	        const s = c.elm.style;
	        s.transform = s.WebkitTransform = `translate(${dx}px,${dy}px)`;
	        s.transitionDuration = '0s';
	    }
	}

	var platformComponents = {
	    Transition,
	    TransitionGroup
	};

	// install platform specific utils
	Vue.config.mustUseProp = mustUseProp;
	Vue.config.isReservedTag = isReservedTag;
	Vue.config.isReservedAttr = isReservedAttr;
	Vue.config.getTagNamespace = getTagNamespace;
	Vue.config.isUnknownElement = isUnknownElement;
	// install platform runtime directives & components
	extend(Vue.options.directives, platformDirectives);
	extend(Vue.options.components, platformComponents);
	// install platform patch function
	Vue.prototype.__patch__ = inBrowser ? patch : noop;
	// public mount method
	Vue.prototype.$mount = function (el, hydrating) {
	    el = el && inBrowser ? query(el) : undefined;
	    return mountComponent(this, el, hydrating);
	};
	// devtools global hook
	/* istanbul ignore next */
	if (inBrowser) {
	    setTimeout(() => {
	        if (config.devtools) {
	            if (devtools) {
	                devtools.emit('init', Vue);
	            }
	            else {
	                // @ts-expect-error
	                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
	                    'https://github.com/vuejs/vue-devtools');
	            }
	        }
	        if (config.productionTip !== false &&
	            typeof console !== 'undefined') {
	            // @ts-expect-error
	            console[console.info ? 'info' : 'log'](`You are running Vue in development mode.\n` +
	                `Make sure to turn on production mode when deploying for production.\n` +
	                `See more tips at https://vuejs.org/guide/deployment.html`);
	        }
	    }, 0);
	}

	extend(Vue, vca);

	vue_runtime_common_dev = Vue;
	return vue_runtime_common_dev;
}

var hasRequiredVue_runtime_common;

function requireVue_runtime_common () {
	if (hasRequiredVue_runtime_common) return vue_runtime_common.exports;
	hasRequiredVue_runtime_common = 1;
	(function (module) {
		{
		  module.exports = requireVue_runtime_common_dev();
		}
} (vue_runtime_common));
	return vue_runtime_common.exports;
}

(function (module, exports) {
	!function(t,n){module.exports=n();}(self,(function(){return function(){var t={723:function(t,n,e){var o=e(2734),i=e.n(o);n.Z={before:function(){this.$slots.default&&""!==this.text.trim()||(i().util.warn("".concat(this.$options.name," cannot be empty and requires a meaningful text content"),this),this.$destroy(),this.$el.remove());},beforeUpdate:function(){this.text=this.getText();},data:function(){return {text:this.getText()}},computed:{isLongText:function(){return this.text&&this.text.trim().length>20}},methods:{getText:function(){return this.$slots.default?this.$slots.default[0].text.trim():""}}};},1139:function(t,n,e){e.d(n,{Z:function(){return i}});var o=e(723),i={mixins:[o.Z],props:{icon:{type:String,default:""},title:{type:String,default:""},closeAfterClick:{type:Boolean,default:!1},ariaLabel:{type:String,default:""}},emits:["click"],computed:{isIconUrl:function(){try{return new URL(this.icon)}catch(t){return !1}}},methods:{onClick:function(t){if(this.$emit("click",t),this.closeAfterClick){var n=function(t,n){for(var e=t.$parent;e;){if(e.$options.name===n)return e;e=e.$parent;}}(this,"NcActions");n&&n.closeMenu&&n.closeMenu(!1);}}}};},5698:function(t,n,e){var o=e(7537),i=e.n(o),r=e(3645),a=e.n(r)()(i());a.push([t.id,".material-design-icon[data-v-45a871d0]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}li.active[data-v-45a871d0]{background-color:var(--color-background-hover);border-radius:6px;padding:0}.action--disabled[data-v-45a871d0]{pointer-events:none;opacity:.5}.action--disabled[data-v-45a871d0]:hover,.action--disabled[data-v-45a871d0]:focus{cursor:default;opacity:.5}.action--disabled *[data-v-45a871d0]{opacity:1 !important}.action-button[data-v-45a871d0]{display:flex;align-items:flex-start;width:100%;height:auto;margin:0;padding:0;padding-right:14px;box-sizing:border-box;cursor:pointer;white-space:nowrap;opacity:.7;color:var(--color-main-text);border:0;border-radius:0;background-color:rgba(0,0,0,0);box-shadow:none;font-weight:normal;font-size:var(--default-font-size);line-height:44px}.action-button[data-v-45a871d0]:hover,.action-button[data-v-45a871d0]:focus{opacity:1}.action-button>span[data-v-45a871d0]{cursor:pointer;white-space:nowrap}.action-button__icon[data-v-45a871d0]{width:44px;height:44px;opacity:1;background-position:14px center;background-size:16px;background-repeat:no-repeat}.action-button[data-v-45a871d0] .material-design-icon{width:44px;height:44px;opacity:1}.action-button[data-v-45a871d0] .material-design-icon .material-design-icon__svg{vertical-align:middle}.action-button p[data-v-45a871d0]{max-width:220px;line-height:1.6em;padding:10.8px 0;cursor:pointer;text-align:left;overflow:hidden;text-overflow:ellipsis}.action-button__longtext[data-v-45a871d0]{cursor:pointer;white-space:pre-wrap}.action-button__title[data-v-45a871d0]{font-weight:bold;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:100%;display:inline-block}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/assets/action.scss","webpack://./src/assets/variables.scss"],names:[],mappings:"AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCiBC,2BACC,8CAAA,CACA,iBAAA,CACA,SAAA,CAMF,mCACC,mBAAA,CACA,UCMiB,CDLjB,kFACC,cAAA,CACA,UCGgB,CDDjB,qCACC,oBAAA,CAOF,gCACC,YAAA,CACA,sBAAA,CAEA,UAAA,CACA,WAAA,CACA,QAAA,CACA,SAAA,CACA,kBCxBY,CDyBZ,qBAAA,CAEA,cAAA,CACA,kBAAA,CAEA,UCpBe,CDqBf,4BAAA,CACA,QAAA,CACA,eAAA,CACA,8BAAA,CACA,eAAA,CAEA,kBAAA,CACA,kCAAA,CACA,gBC/Ce,CDiDf,4EAEC,SChCY,CDmCb,qCACC,cAAA,CACA,kBAAA,CAGD,sCACC,UC5Dc,CD6Dd,WC7Dc,CD8Dd,SC3CY,CD4CZ,+BAAA,CACA,oBC5DS,CD6DT,2BAAA,CAGD,sDACC,UCrEc,CDsEd,WCtEc,CDuEd,SCpDY,CDsDZ,iFACC,qBAAA,CAKF,kCACC,eAAA,CACA,iBAAA,CAGA,gBAAA,CAEA,cAAA,CACA,eAAA,CAGA,eAAA,CACA,sBAAA,CAGD,0CACC,cAAA,CAEA,oBAAA,CAGD,uCACC,gBAAA,CACA,sBAAA,CACA,eAAA,CACA,kBAAA,CACA,cAAA,CACA,oBAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n * @author Marco Ambrosini <marcoambrosini@icloud.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n\n@mixin action-active {\n\tli {\n\t\t&.active {\n\t\t\tbackground-color: var(--color-background-hover);\n\t\t\tborder-radius: 6px;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n}\n\n@mixin action--disabled {\n\t.action--disabled {\n\t\tpointer-events: none;\n\t\topacity: $opacity_disabled;\n\t\t&:hover, &:focus {\n\t\t\tcursor: default;\n\t\t\topacity: $opacity_disabled;\n\t\t}\n\t\t& * {\n\t\t\topacity: 1 !important;\n\t\t}\n\t}\n}\n\n\n@mixin action-item($name) {\n\t.action-#{$name} {\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\n\t\twidth: 100%;\n\t\theight: auto;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tpadding-right: $icon-margin;\n\t\tbox-sizing: border-box; // otherwise router-link overflows in Firefox\n\n\t\tcursor: pointer;\n\t\twhite-space: nowrap;\n\n\t\topacity: $opacity_normal;\n\t\tcolor: var(--color-main-text);\n\t\tborder: 0;\n\t\tborder-radius: 0; // otherwise Safari will cut the border-radius area\n\t\tbackground-color: transparent;\n\t\tbox-shadow: none;\n\n\t\tfont-weight: normal;\n\t\tfont-size: var(--default-font-size);\n\t\tline-height: $clickable-area;\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\topacity: $opacity_full;\n\t\t}\n\n\t\t& > span {\n\t\t\tcursor: pointer;\n\t\t\twhite-space: nowrap;\n\t\t}\n\n\t\t&__icon {\n\t\t\twidth: $clickable-area;\n\t\t\theight: $clickable-area;\n\t\t\topacity: $opacity_full;\n\t\t\tbackground-position: $icon-margin center;\n\t\t\tbackground-size: $icon-size;\n\t\t\tbackground-repeat: no-repeat;\n\t\t}\n\n\t\t&::v-deep .material-design-icon {\n\t\t\twidth: $clickable-area;\n\t\t\theight: $clickable-area;\n\t\t\topacity: $opacity_full;\n\n\t\t\t.material-design-icon__svg {\n\t\t\t\tvertical-align: middle;\n\t\t\t}\n\t\t}\n\n\t\t// long text area\n\t\tp {\n\t\t\tmax-width: 220px;\n\t\t\tline-height: 1.6em;\n\n\t\t\t// 14px are currently 1em line-height. Mixing units as '44px - 1.6em' does not work.\n\t\t\tpadding: #{math.div($clickable-area - 1.6 * 14px, 2)} 0;\n\n\t\t\tcursor: pointer;\n\t\t\ttext-align: left;\n\n\t\t\t// in case there are no spaces like long email addresses\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t&__longtext {\n\t\t\tcursor: pointer;\n\t\t\t// allow the use of `\\n`\n\t\t\twhite-space: pre-wrap;\n\t\t}\n\n\t\t&__title {\n\t\t\tfont-weight: bold;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\twhite-space: nowrap;\n\t\t\tmax-width: 100%;\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n}\n","/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n\n// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556\n// recommended is 48px\n// 44px is what we choose and have very good visual-to-usability ratio\n$clickable-area: 44px;\n\n// background icon size\n// also used for the scss icon font\n$icon-size: 16px;\n\n// icon padding for a $clickable-area width and a $icon-size icon\n// ( 44px - 16px ) / 2\n$icon-margin: math.div($clickable-area - $icon-size, 2);\n\n// transparency background for icons\n$icon-focus-bg: rgba(127, 127, 127, .25);\n\n// popovermenu arrow width from the triangle center\n$arrow-width: 9px;\n\n// opacities\n$opacity_disabled: .5;\n$opacity_normal: .7;\n$opacity_full: 1;\n\n// menu round background hover feedback\n// good looking on dark AND white bg\n$action-background-hover: rgba(127, 127, 127, .25);\n\n// various structure data used in the \n// `AppNavigation` component\n$header-height: 50px;\n$navigation-width: 300px;\n\n// mobile breakpoint\n$breakpoint-mobile: 1024px;\n\n// top-bar spacing\n$topbar-margin: 4px;\n"],sourceRoot:""}]),n.Z=a;},3645:function(t){t.exports=function(t){var n=[];return n.toString=function(){return this.map((function(n){var e="",o=void 0!==n[5];return n[4]&&(e+="@supports (".concat(n[4],") {")),n[2]&&(e+="@media ".concat(n[2]," {")),o&&(e+="@layer".concat(n[5].length>0?" ".concat(n[5]):""," {")),e+=t(n),o&&(e+="}"),n[2]&&(e+="}"),n[4]&&(e+="}"),e})).join("")},n.i=function(t,e,o,i,r){"string"==typeof t&&(t=[[null,t,void 0]]);var a={};if(o)for(var s=0;s<this.length;s++){var c=this[s][0];null!=c&&(a[c]=!0);}for(var l=0;l<t.length;l++){var u=[].concat(t[l]);o&&a[u[0]]||(void 0!==r&&(void 0===u[5]||(u[1]="@layer".concat(u[5].length>0?" ".concat(u[5]):""," {").concat(u[1],"}")),u[5]=r),e&&(u[2]?(u[1]="@media ".concat(u[2]," {").concat(u[1],"}"),u[2]=e):u[2]=e),i&&(u[4]?(u[1]="@supports (".concat(u[4],") {").concat(u[1],"}"),u[4]=i):u[4]="".concat(i)),n.push(u));}},n};},7537:function(t){t.exports=function(t){var n=t[1],e=t[3];if(!e)return n;if("function"==typeof btoa){var o=btoa(unescape(encodeURIComponent(JSON.stringify(e)))),i="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(o),r="/*# ".concat(i," */"),a=e.sources.map((function(t){return "/*# sourceURL=".concat(e.sourceRoot||"").concat(t," */")}));return [n].concat(a).concat([r]).join("\n")}return [n].join("\n")};},3379:function(t){var n=[];function e(t){for(var e=-1,o=0;o<n.length;o++)if(n[o].identifier===t){e=o;break}return e}function o(t,o){for(var r={},a=[],s=0;s<t.length;s++){var c=t[s],l=o.base?c[0]+o.base:c[0],u=r[l]||0,d="".concat(l," ").concat(u);r[l]=u+1;var p=e(d),A={css:c[1],media:c[2],sourceMap:c[3],supports:c[4],layer:c[5]};if(-1!==p)n[p].references++,n[p].updater(A);else {var f=i(A,o);o.byIndex=s,n.splice(s,0,{identifier:d,updater:f,references:1});}a.push(d);}return a}function i(t,n){var e=n.domAPI(n);return e.update(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap&&n.supports===t.supports&&n.layer===t.layer)return;e.update(t=n);}else e.remove();}}t.exports=function(t,i){var r=o(t=t||[],i=i||{});return function(t){t=t||[];for(var a=0;a<r.length;a++){var s=e(r[a]);n[s].references--;}for(var c=o(t,i),l=0;l<r.length;l++){var u=e(r[l]);0===n[u].references&&(n[u].updater(),n.splice(u,1));}r=c;}};},569:function(t){var n={};t.exports=function(t,e){var o=function(t){if(void 0===n[t]){var e=document.querySelector(t);if(window.HTMLIFrameElement&&e instanceof window.HTMLIFrameElement)try{e=e.contentDocument.head;}catch(t){e=null;}n[t]=e;}return n[t]}(t);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");o.appendChild(e);};},9216:function(t){t.exports=function(t){var n=document.createElement("style");return t.setAttributes(n,t.attributes),t.insert(n,t.options),n};},3565:function(t,n,e){t.exports=function(t){var n=e.nc;n&&t.setAttribute("nonce",n);};},7795:function(t){t.exports=function(t){var n=t.insertStyleElement(t);return {update:function(e){!function(t,n,e){var o="";e.supports&&(o+="@supports (".concat(e.supports,") {")),e.media&&(o+="@media ".concat(e.media," {"));var i=void 0!==e.layer;i&&(o+="@layer".concat(e.layer.length>0?" ".concat(e.layer):""," {")),o+=e.css,i&&(o+="}"),e.media&&(o+="}"),e.supports&&(o+="}");var r=e.sourceMap;r&&"undefined"!=typeof btoa&&(o+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r))))," */")),n.styleTagTransform(o,t,n.options);}(n,t,e);},remove:function(){!function(t){if(null===t.parentNode)return !1;t.parentNode.removeChild(t);}(n);}}};},4589:function(t){t.exports=function(t,n){if(n.styleSheet)n.styleSheet.cssText=t;else {for(;n.firstChild;)n.removeChild(n.firstChild);n.appendChild(document.createTextNode(t));}};},4216:function(){},1900:function(t,n,e){function o(t,n,e,o,i,r,a,s){var c,l="function"==typeof t?t.options:t;if(n&&(l.render=n,l.staticRenderFns=e,l._compiled=!0),o&&(l.functional=!0),r&&(l._scopeId="data-v-"+r),a?(c=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(a);},l._ssrRegister=c):i&&(c=s?function(){i.call(this,(l.functional?this.parent:this).$root.$options.shadowRoot);}:i),c)if(l.functional){l._injectStyles=c;var u=l.render;l.render=function(t,n){return c.call(n),u(t,n)};}else {var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,c):[c];}return {exports:t,options:l}}e.d(n,{Z:function(){return o}});},2734:function(t){t.exports=requireVue_runtime_common();}},n={};function e(o){var i=n[o];if(void 0!==i)return i.exports;var r=n[o]={id:o,exports:{}};return t[o](r,r.exports,e),r.exports}e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,{a:n}),n},e.d=function(t,n){for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]});},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},e.nc=void 0;var o={};return function(){e.r(o),e.d(o,{default:function(){return x}});var t={name:"NcActionButton",mixins:[e(1139).Z],props:{disabled:{type:Boolean,default:!1}},computed:{isFocusable:function(){return !this.disabled}}},n=e(3379),i=e.n(n),r=e(7795),a=e.n(r),s=e(569),c=e.n(s),l=e(3565),u=e.n(l),d=e(9216),p=e.n(d),A=e(4589),f=e.n(A),h=e(5698),C={};C.styleTagTransform=f(),C.setAttributes=u(),C.insert=c().bind(null,"head"),C.domAPI=a(),C.insertStyleElement=p(),i()(h.Z,C),h.Z&&h.Z.locals&&h.Z.locals;var v=e(1900),b=e(4216),m=e.n(b),g=(0, v.Z)(t,(function(){var t=this,n=t._self._c;return n("li",{staticClass:"action",class:{"action--disabled":t.disabled},attrs:{role:"presentation"}},[n("button",{staticClass:"action-button",class:{focusable:t.isFocusable},attrs:{"aria-label":t.ariaLabel,role:"menuitem",type:"button"},on:{click:t.onClick}},[t._t("icon",(function(){return [n("span",{staticClass:"action-button__icon",class:[t.isIconUrl?"action-button__icon--url":t.icon],style:{backgroundImage:t.isIconUrl?"url(".concat(t.icon,")"):null}})]})),t._v(" "),t.title?n("p",[n("strong",{staticClass:"action-button__title"},[t._v("\n\t\t\t\t"+t._s(t.title)+"\n\t\t\t")]),t._v(" "),n("br"),t._v(" "),n("span",{staticClass:"action-button__longtext",domProps:{textContent:t._s(t.text)}})]):t.isLongText?n("p",{staticClass:"action-button__longtext",domProps:{textContent:t._s(t.text)}}):n("span",{staticClass:"action-button__text"},[t._v(t._s(t.text))]),t._v(" "),t._e()],2)])}),[],!1,null,"45a871d0",null);"function"==typeof m()&&m()(g);var x=g.exports;}(),o}()}));
	
} (NcActionButton$1));

var NcActionButton = /*@__PURE__*/getDefaultExportFromCjs(NcActionButton$1.exports);

var NcActions$1 = {exports: {}};

var gettext$1 = {};

var es_regexp_exec = {};

var global$1;
var hasRequiredGlobal;

function requireGlobal () {
	if (hasRequiredGlobal) return global$1;
	hasRequiredGlobal = 1;
	var check = function (it) {
	  return it && it.Math == Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	global$1 =
	  // eslint-disable-next-line es-x/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	return global$1;
}

var objectGetOwnPropertyDescriptor = {};

var fails;
var hasRequiredFails;

function requireFails () {
	if (hasRequiredFails) return fails;
	hasRequiredFails = 1;
	fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};
	return fails;
}

var descriptors;
var hasRequiredDescriptors;

function requireDescriptors () {
	if (hasRequiredDescriptors) return descriptors;
	hasRequiredDescriptors = 1;
	var fails = requireFails();

	// Detect IE8's incomplete defineProperty implementation
	descriptors = !fails(function () {
	  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
	});
	return descriptors;
}

var functionBindNative;
var hasRequiredFunctionBindNative;

function requireFunctionBindNative () {
	if (hasRequiredFunctionBindNative) return functionBindNative;
	hasRequiredFunctionBindNative = 1;
	var fails = requireFails();

	functionBindNative = !fails(function () {
	  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});
	return functionBindNative;
}

var functionCall;
var hasRequiredFunctionCall;

function requireFunctionCall () {
	if (hasRequiredFunctionCall) return functionCall;
	hasRequiredFunctionCall = 1;
	var NATIVE_BIND = requireFunctionBindNative();

	var call = Function.prototype.call;

	functionCall = NATIVE_BIND ? call.bind(call) : function () {
	  return call.apply(call, arguments);
	};
	return functionCall;
}

var objectPropertyIsEnumerable = {};

var hasRequiredObjectPropertyIsEnumerable;

function requireObjectPropertyIsEnumerable () {
	if (hasRequiredObjectPropertyIsEnumerable) return objectPropertyIsEnumerable;
	hasRequiredObjectPropertyIsEnumerable = 1;
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;
	return objectPropertyIsEnumerable;
}

var createPropertyDescriptor;
var hasRequiredCreatePropertyDescriptor;

function requireCreatePropertyDescriptor () {
	if (hasRequiredCreatePropertyDescriptor) return createPropertyDescriptor;
	hasRequiredCreatePropertyDescriptor = 1;
	createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	return createPropertyDescriptor;
}

var functionUncurryThis;
var hasRequiredFunctionUncurryThis;

function requireFunctionUncurryThis () {
	if (hasRequiredFunctionUncurryThis) return functionUncurryThis;
	hasRequiredFunctionUncurryThis = 1;
	var NATIVE_BIND = requireFunctionBindNative();

	var FunctionPrototype = Function.prototype;
	var bind = FunctionPrototype.bind;
	var call = FunctionPrototype.call;
	var uncurryThis = NATIVE_BIND && bind.bind(call, call);

	functionUncurryThis = NATIVE_BIND ? function (fn) {
	  return fn && uncurryThis(fn);
	} : function (fn) {
	  return fn && function () {
	    return call.apply(fn, arguments);
	  };
	};
	return functionUncurryThis;
}

var classofRaw;
var hasRequiredClassofRaw;

function requireClassofRaw () {
	if (hasRequiredClassofRaw) return classofRaw;
	hasRequiredClassofRaw = 1;
	var uncurryThis = requireFunctionUncurryThis();

	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);

	classofRaw = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};
	return classofRaw;
}

var indexedObject;
var hasRequiredIndexedObject;

function requireIndexedObject () {
	if (hasRequiredIndexedObject) return indexedObject;
	hasRequiredIndexedObject = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var fails = requireFails();
	var classof = requireClassofRaw();

	var $Object = Object;
	var split = uncurryThis(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) == 'String' ? split(it, '') : $Object(it);
	} : $Object;
	return indexedObject;
}

var isNullOrUndefined;
var hasRequiredIsNullOrUndefined;

function requireIsNullOrUndefined () {
	if (hasRequiredIsNullOrUndefined) return isNullOrUndefined;
	hasRequiredIsNullOrUndefined = 1;
	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	isNullOrUndefined = function (it) {
	  return it === null || it === undefined;
	};
	return isNullOrUndefined;
}

var requireObjectCoercible;
var hasRequiredRequireObjectCoercible;

function requireRequireObjectCoercible () {
	if (hasRequiredRequireObjectCoercible) return requireObjectCoercible;
	hasRequiredRequireObjectCoercible = 1;
	var isNullOrUndefined = requireIsNullOrUndefined();

	var $TypeError = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	requireObjectCoercible = function (it) {
	  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
	  return it;
	};
	return requireObjectCoercible;
}

var toIndexedObject;
var hasRequiredToIndexedObject;

function requireToIndexedObject () {
	if (hasRequiredToIndexedObject) return toIndexedObject;
	hasRequiredToIndexedObject = 1;
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = requireIndexedObject();
	var requireObjectCoercible = requireRequireObjectCoercible();

	toIndexedObject = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};
	return toIndexedObject;
}

var isCallable;
var hasRequiredIsCallable;

function requireIsCallable () {
	if (hasRequiredIsCallable) return isCallable;
	hasRequiredIsCallable = 1;
	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	isCallable = function (argument) {
	  return typeof argument == 'function';
	};
	return isCallable;
}

var isObject$1;
var hasRequiredIsObject;

function requireIsObject () {
	if (hasRequiredIsObject) return isObject$1;
	hasRequiredIsObject = 1;
	var isCallable = requireIsCallable();

	var documentAll = typeof document == 'object' && document.all;

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var SPECIAL_DOCUMENT_ALL = typeof documentAll == 'undefined' && documentAll !== undefined;

	isObject$1 = SPECIAL_DOCUMENT_ALL ? function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
	} : function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};
	return isObject$1;
}

var getBuiltIn;
var hasRequiredGetBuiltIn;

function requireGetBuiltIn () {
	if (hasRequiredGetBuiltIn) return getBuiltIn;
	hasRequiredGetBuiltIn = 1;
	var global = requireGlobal();
	var isCallable = requireIsCallable();

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};

	getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
	};
	return getBuiltIn;
}

var objectIsPrototypeOf;
var hasRequiredObjectIsPrototypeOf;

function requireObjectIsPrototypeOf () {
	if (hasRequiredObjectIsPrototypeOf) return objectIsPrototypeOf;
	hasRequiredObjectIsPrototypeOf = 1;
	var uncurryThis = requireFunctionUncurryThis();

	objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);
	return objectIsPrototypeOf;
}

var engineUserAgent;
var hasRequiredEngineUserAgent;

function requireEngineUserAgent () {
	if (hasRequiredEngineUserAgent) return engineUserAgent;
	hasRequiredEngineUserAgent = 1;
	var getBuiltIn = requireGetBuiltIn();

	engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';
	return engineUserAgent;
}

var engineV8Version;
var hasRequiredEngineV8Version;

function requireEngineV8Version () {
	if (hasRequiredEngineV8Version) return engineV8Version;
	hasRequiredEngineV8Version = 1;
	var global = requireGlobal();
	var userAgent = requireEngineUserAgent();

	var process = global.process;
	var Deno = global.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;

	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}

	engineV8Version = version;
	return engineV8Version;
}

var symbolConstructorDetection;
var hasRequiredSymbolConstructorDetection;

function requireSymbolConstructorDetection () {
	if (hasRequiredSymbolConstructorDetection) return symbolConstructorDetection;
	hasRequiredSymbolConstructorDetection = 1;
	var V8_VERSION = requireEngineV8Version();
	var fails = requireFails();

	// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
	symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol();
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});
	return symbolConstructorDetection;
}

var useSymbolAsUid;
var hasRequiredUseSymbolAsUid;

function requireUseSymbolAsUid () {
	if (hasRequiredUseSymbolAsUid) return useSymbolAsUid;
	hasRequiredUseSymbolAsUid = 1;
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();

	useSymbolAsUid = NATIVE_SYMBOL
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';
	return useSymbolAsUid;
}

var isSymbol;
var hasRequiredIsSymbol;

function requireIsSymbol () {
	if (hasRequiredIsSymbol) return isSymbol;
	hasRequiredIsSymbol = 1;
	var getBuiltIn = requireGetBuiltIn();
	var isCallable = requireIsCallable();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();

	var $Object = Object;

	isSymbol = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
	};
	return isSymbol;
}

var tryToString;
var hasRequiredTryToString;

function requireTryToString () {
	if (hasRequiredTryToString) return tryToString;
	hasRequiredTryToString = 1;
	var $String = String;

	tryToString = function (argument) {
	  try {
	    return $String(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};
	return tryToString;
}

var aCallable;
var hasRequiredACallable;

function requireACallable () {
	if (hasRequiredACallable) return aCallable;
	hasRequiredACallable = 1;
	var isCallable = requireIsCallable();
	var tryToString = requireTryToString();

	var $TypeError = TypeError;

	// `Assert: IsCallable(argument) is true`
	aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw $TypeError(tryToString(argument) + ' is not a function');
	};
	return aCallable;
}

var getMethod;
var hasRequiredGetMethod;

function requireGetMethod () {
	if (hasRequiredGetMethod) return getMethod;
	hasRequiredGetMethod = 1;
	var aCallable = requireACallable();
	var isNullOrUndefined = requireIsNullOrUndefined();

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};
	return getMethod;
}

var ordinaryToPrimitive;
var hasRequiredOrdinaryToPrimitive;

function requireOrdinaryToPrimitive () {
	if (hasRequiredOrdinaryToPrimitive) return ordinaryToPrimitive;
	hasRequiredOrdinaryToPrimitive = 1;
	var call = requireFunctionCall();
	var isCallable = requireIsCallable();
	var isObject = requireIsObject();

	var $TypeError = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  throw $TypeError("Can't convert object to primitive value");
	};
	return ordinaryToPrimitive;
}

var shared = {exports: {}};

var isPure;
var hasRequiredIsPure;

function requireIsPure () {
	if (hasRequiredIsPure) return isPure;
	hasRequiredIsPure = 1;
	isPure = false;
	return isPure;
}

var defineGlobalProperty;
var hasRequiredDefineGlobalProperty;

function requireDefineGlobalProperty () {
	if (hasRequiredDefineGlobalProperty) return defineGlobalProperty;
	hasRequiredDefineGlobalProperty = 1;
	var global = requireGlobal();

	// eslint-disable-next-line es-x/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;

	defineGlobalProperty = function (key, value) {
	  try {
	    defineProperty(global, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global[key] = value;
	  } return value;
	};
	return defineGlobalProperty;
}

var sharedStore;
var hasRequiredSharedStore;

function requireSharedStore () {
	if (hasRequiredSharedStore) return sharedStore;
	hasRequiredSharedStore = 1;
	var global = requireGlobal();
	var defineGlobalProperty = requireDefineGlobalProperty();

	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || defineGlobalProperty(SHARED, {});

	sharedStore = store;
	return sharedStore;
}

var hasRequiredShared;

function requireShared () {
	if (hasRequiredShared) return shared.exports;
	hasRequiredShared = 1;
	var IS_PURE = requireIsPure();
	var store = requireSharedStore();

	(shared.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: '3.25.1',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.25.1/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});
	return shared.exports;
}

var toObject$1;
var hasRequiredToObject;

function requireToObject () {
	if (hasRequiredToObject) return toObject$1;
	hasRequiredToObject = 1;
	var requireObjectCoercible = requireRequireObjectCoercible();

	var $Object = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	toObject$1 = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};
	return toObject$1;
}

var hasOwnProperty_1;
var hasRequiredHasOwnProperty;

function requireHasOwnProperty () {
	if (hasRequiredHasOwnProperty) return hasOwnProperty_1;
	hasRequiredHasOwnProperty = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var toObject = requireToObject();

	var hasOwnProperty = uncurryThis({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es-x/no-object-hasown -- safe
	hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};
	return hasOwnProperty_1;
}

var uid$3;
var hasRequiredUid;

function requireUid () {
	if (hasRequiredUid) return uid$3;
	hasRequiredUid = 1;
	var uncurryThis = requireFunctionUncurryThis();

	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis(1.0.toString);

	uid$3 = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};
	return uid$3;
}

var wellKnownSymbol;
var hasRequiredWellKnownSymbol;

function requireWellKnownSymbol () {
	if (hasRequiredWellKnownSymbol) return wellKnownSymbol;
	hasRequiredWellKnownSymbol = 1;
	var global = requireGlobal();
	var shared = requireShared();
	var hasOwn = requireHasOwnProperty();
	var uid = requireUid();
	var NATIVE_SYMBOL = requireSymbolConstructorDetection();
	var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();

	var WellKnownSymbolsStore = shared('wks');
	var Symbol = global.Symbol;
	var symbolFor = Symbol && Symbol['for'];
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

	wellKnownSymbol = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
	    var description = 'Symbol.' + name;
	    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
	      WellKnownSymbolsStore[name] = Symbol[name];
	    } else if (USE_SYMBOL_AS_UID && symbolFor) {
	      WellKnownSymbolsStore[name] = symbolFor(description);
	    } else {
	      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
	    }
	  } return WellKnownSymbolsStore[name];
	};
	return wellKnownSymbol;
}

var toPrimitive;
var hasRequiredToPrimitive;

function requireToPrimitive () {
	if (hasRequiredToPrimitive) return toPrimitive;
	hasRequiredToPrimitive = 1;
	var call = requireFunctionCall();
	var isObject = requireIsObject();
	var isSymbol = requireIsSymbol();
	var getMethod = requireGetMethod();
	var ordinaryToPrimitive = requireOrdinaryToPrimitive();
	var wellKnownSymbol = requireWellKnownSymbol();

	var $TypeError = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	toPrimitive = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw $TypeError("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};
	return toPrimitive;
}

var toPropertyKey;
var hasRequiredToPropertyKey;

function requireToPropertyKey () {
	if (hasRequiredToPropertyKey) return toPropertyKey;
	hasRequiredToPropertyKey = 1;
	var toPrimitive = requireToPrimitive();
	var isSymbol = requireIsSymbol();

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};
	return toPropertyKey;
}

var documentCreateElement;
var hasRequiredDocumentCreateElement;

function requireDocumentCreateElement () {
	if (hasRequiredDocumentCreateElement) return documentCreateElement;
	hasRequiredDocumentCreateElement = 1;
	var global = requireGlobal();
	var isObject = requireIsObject();

	var document = global.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);

	documentCreateElement = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};
	return documentCreateElement;
}

var ie8DomDefine;
var hasRequiredIe8DomDefine;

function requireIe8DomDefine () {
	if (hasRequiredIe8DomDefine) return ie8DomDefine;
	hasRequiredIe8DomDefine = 1;
	var DESCRIPTORS = requireDescriptors();
	var fails = requireFails();
	var createElement = requireDocumentCreateElement();

	// Thanks to IE8 for its funny defineProperty
	ie8DomDefine = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a != 7;
	});
	return ie8DomDefine;
}

var hasRequiredObjectGetOwnPropertyDescriptor;

function requireObjectGetOwnPropertyDescriptor () {
	if (hasRequiredObjectGetOwnPropertyDescriptor) return objectGetOwnPropertyDescriptor;
	hasRequiredObjectGetOwnPropertyDescriptor = 1;
	var DESCRIPTORS = requireDescriptors();
	var call = requireFunctionCall();
	var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();
	var toIndexedObject = requireToIndexedObject();
	var toPropertyKey = requireToPropertyKey();
	var hasOwn = requireHasOwnProperty();
	var IE8_DOM_DEFINE = requireIe8DomDefine();

	// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	objectGetOwnPropertyDescriptor.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};
	return objectGetOwnPropertyDescriptor;
}

var objectDefineProperty = {};

var v8PrototypeDefineBug;
var hasRequiredV8PrototypeDefineBug;

function requireV8PrototypeDefineBug () {
	if (hasRequiredV8PrototypeDefineBug) return v8PrototypeDefineBug;
	hasRequiredV8PrototypeDefineBug = 1;
	var DESCRIPTORS = requireDescriptors();
	var fails = requireFails();

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	v8PrototypeDefineBug = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype != 42;
	});
	return v8PrototypeDefineBug;
}

var anObject;
var hasRequiredAnObject;

function requireAnObject () {
	if (hasRequiredAnObject) return anObject;
	hasRequiredAnObject = 1;
	var isObject = requireIsObject();

	var $String = String;
	var $TypeError = TypeError;

	// `Assert: Type(argument) is Object`
	anObject = function (argument) {
	  if (isObject(argument)) return argument;
	  throw $TypeError($String(argument) + ' is not an object');
	};
	return anObject;
}

var hasRequiredObjectDefineProperty;

function requireObjectDefineProperty () {
	if (hasRequiredObjectDefineProperty) return objectDefineProperty;
	hasRequiredObjectDefineProperty = 1;
	var DESCRIPTORS = requireDescriptors();
	var IE8_DOM_DEFINE = requireIe8DomDefine();
	var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
	var anObject = requireAnObject();
	var toPropertyKey = requireToPropertyKey();

	var $TypeError = TypeError;
	// eslint-disable-next-line es-x/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE = 'configurable';
	var WRITABLE = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	objectDefineProperty.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	return objectDefineProperty;
}

var createNonEnumerableProperty;
var hasRequiredCreateNonEnumerableProperty;

function requireCreateNonEnumerableProperty () {
	if (hasRequiredCreateNonEnumerableProperty) return createNonEnumerableProperty;
	hasRequiredCreateNonEnumerableProperty = 1;
	var DESCRIPTORS = requireDescriptors();
	var definePropertyModule = requireObjectDefineProperty();
	var createPropertyDescriptor = requireCreatePropertyDescriptor();

	createNonEnumerableProperty = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	return createNonEnumerableProperty;
}

var makeBuiltIn = {exports: {}};

var functionName;
var hasRequiredFunctionName;

function requireFunctionName () {
	if (hasRequiredFunctionName) return functionName;
	hasRequiredFunctionName = 1;
	var DESCRIPTORS = requireDescriptors();
	var hasOwn = requireHasOwnProperty();

	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

	var EXISTS = hasOwn(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

	functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};
	return functionName;
}

var inspectSource;
var hasRequiredInspectSource;

function requireInspectSource () {
	if (hasRequiredInspectSource) return inspectSource;
	hasRequiredInspectSource = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var isCallable = requireIsCallable();
	var store = requireSharedStore();

	var functionToString = uncurryThis(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(store.inspectSource)) {
	  store.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}

	inspectSource = store.inspectSource;
	return inspectSource;
}

var weakMapBasicDetection;
var hasRequiredWeakMapBasicDetection;

function requireWeakMapBasicDetection () {
	if (hasRequiredWeakMapBasicDetection) return weakMapBasicDetection;
	hasRequiredWeakMapBasicDetection = 1;
	var global = requireGlobal();
	var isCallable = requireIsCallable();

	var WeakMap = global.WeakMap;

	weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));
	return weakMapBasicDetection;
}

var sharedKey;
var hasRequiredSharedKey;

function requireSharedKey () {
	if (hasRequiredSharedKey) return sharedKey;
	hasRequiredSharedKey = 1;
	var shared = requireShared();
	var uid = requireUid();

	var keys = shared('keys');

	sharedKey = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};
	return sharedKey;
}

var hiddenKeys;
var hasRequiredHiddenKeys;

function requireHiddenKeys () {
	if (hasRequiredHiddenKeys) return hiddenKeys;
	hasRequiredHiddenKeys = 1;
	hiddenKeys = {};
	return hiddenKeys;
}

var internalState;
var hasRequiredInternalState;

function requireInternalState () {
	if (hasRequiredInternalState) return internalState;
	hasRequiredInternalState = 1;
	var NATIVE_WEAK_MAP = requireWeakMapBasicDetection();
	var global = requireGlobal();
	var uncurryThis = requireFunctionUncurryThis();
	var isObject = requireIsObject();
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
	var hasOwn = requireHasOwnProperty();
	var shared = requireSharedStore();
	var sharedKey = requireSharedKey();
	var hiddenKeys = requireHiddenKeys();

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError = global.TypeError;
	var WeakMap = global.WeakMap;
	var set, get, has;

	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};

	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};

	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  var wmget = uncurryThis(store.get);
	  var wmhas = uncurryThis(store.has);
	  var wmset = uncurryThis(store.set);
	  set = function (it, metadata) {
	    if (wmhas(store, it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    wmset(store, it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return wmget(store, it) || {};
	  };
	  has = function (it) {
	    return wmhas(store, it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn(it, STATE);
	  };
	}

	internalState = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};
	return internalState;
}

var hasRequiredMakeBuiltIn;

function requireMakeBuiltIn () {
	if (hasRequiredMakeBuiltIn) return makeBuiltIn.exports;
	hasRequiredMakeBuiltIn = 1;
	var fails = requireFails();
	var isCallable = requireIsCallable();
	var hasOwn = requireHasOwnProperty();
	var DESCRIPTORS = requireDescriptors();
	var CONFIGURABLE_FUNCTION_NAME = requireFunctionName().CONFIGURABLE;
	var inspectSource = requireInspectSource();
	var InternalStateModule = requireInternalState();

	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	// eslint-disable-next-line es-x/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;

	var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
	  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});

	var TEMPLATE = String(String).split('String');

	var makeBuiltIn$1 = makeBuiltIn.exports = function (value, name, options) {
	  if (String(name).slice(0, 7) === 'Symbol(') {
	    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn(state, 'source')) {
	    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
	  } return value;
	};

	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn$1(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');
	return makeBuiltIn.exports;
}

var defineBuiltIn;
var hasRequiredDefineBuiltIn;

function requireDefineBuiltIn () {
	if (hasRequiredDefineBuiltIn) return defineBuiltIn;
	hasRequiredDefineBuiltIn = 1;
	var isCallable = requireIsCallable();
	var definePropertyModule = requireObjectDefineProperty();
	var makeBuiltIn = requireMakeBuiltIn();
	var defineGlobalProperty = requireDefineGlobalProperty();

	defineBuiltIn = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};
	return defineBuiltIn;
}

var objectGetOwnPropertyNames = {};

var mathTrunc;
var hasRequiredMathTrunc;

function requireMathTrunc () {
	if (hasRequiredMathTrunc) return mathTrunc;
	hasRequiredMathTrunc = 1;
	var ceil = Math.ceil;
	var floor = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es-x/no-math-trunc -- safe
	mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};
	return mathTrunc;
}

var toIntegerOrInfinity;
var hasRequiredToIntegerOrInfinity;

function requireToIntegerOrInfinity () {
	if (hasRequiredToIntegerOrInfinity) return toIntegerOrInfinity;
	hasRequiredToIntegerOrInfinity = 1;
	var trunc = requireMathTrunc();

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	toIntegerOrInfinity = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};
	return toIntegerOrInfinity;
}

var toAbsoluteIndex;
var hasRequiredToAbsoluteIndex;

function requireToAbsoluteIndex () {
	if (hasRequiredToAbsoluteIndex) return toAbsoluteIndex;
	hasRequiredToAbsoluteIndex = 1;
	var toIntegerOrInfinity = requireToIntegerOrInfinity();

	var max = Math.max;
	var min = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};
	return toAbsoluteIndex;
}

var toLength;
var hasRequiredToLength;

function requireToLength () {
	if (hasRequiredToLength) return toLength;
	hasRequiredToLength = 1;
	var toIntegerOrInfinity = requireToIntegerOrInfinity();

	var min = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	toLength = function (argument) {
	  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};
	return toLength;
}

var lengthOfArrayLike;
var hasRequiredLengthOfArrayLike;

function requireLengthOfArrayLike () {
	if (hasRequiredLengthOfArrayLike) return lengthOfArrayLike;
	hasRequiredLengthOfArrayLike = 1;
	var toLength = requireToLength();

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};
	return lengthOfArrayLike;
}

var arrayIncludes;
var hasRequiredArrayIncludes;

function requireArrayIncludes () {
	if (hasRequiredArrayIncludes) return arrayIncludes;
	hasRequiredArrayIncludes = 1;
	var toIndexedObject = requireToIndexedObject();
	var toAbsoluteIndex = requireToAbsoluteIndex();
	var lengthOfArrayLike = requireLengthOfArrayLike();

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};
	return arrayIncludes;
}

var objectKeysInternal;
var hasRequiredObjectKeysInternal;

function requireObjectKeysInternal () {
	if (hasRequiredObjectKeysInternal) return objectKeysInternal;
	hasRequiredObjectKeysInternal = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var hasOwn = requireHasOwnProperty();
	var toIndexedObject = requireToIndexedObject();
	var indexOf = requireArrayIncludes().indexOf;
	var hiddenKeys = requireHiddenKeys();

	var push = uncurryThis([].push);

	objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }
	  return result;
	};
	return objectKeysInternal;
}

var enumBugKeys;
var hasRequiredEnumBugKeys;

function requireEnumBugKeys () {
	if (hasRequiredEnumBugKeys) return enumBugKeys;
	hasRequiredEnumBugKeys = 1;
	// IE8- don't enum bug keys
	enumBugKeys = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];
	return enumBugKeys;
}

var hasRequiredObjectGetOwnPropertyNames;

function requireObjectGetOwnPropertyNames () {
	if (hasRequiredObjectGetOwnPropertyNames) return objectGetOwnPropertyNames;
	hasRequiredObjectGetOwnPropertyNames = 1;
	var internalObjectKeys = requireObjectKeysInternal();
	var enumBugKeys = requireEnumBugKeys();

	var hiddenKeys = enumBugKeys.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
	objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};
	return objectGetOwnPropertyNames;
}

var objectGetOwnPropertySymbols = {};

var hasRequiredObjectGetOwnPropertySymbols;

function requireObjectGetOwnPropertySymbols () {
	if (hasRequiredObjectGetOwnPropertySymbols) return objectGetOwnPropertySymbols;
	hasRequiredObjectGetOwnPropertySymbols = 1;
	// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
	objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
	return objectGetOwnPropertySymbols;
}

var ownKeys$1;
var hasRequiredOwnKeys;

function requireOwnKeys () {
	if (hasRequiredOwnKeys) return ownKeys$1;
	hasRequiredOwnKeys = 1;
	var getBuiltIn = requireGetBuiltIn();
	var uncurryThis = requireFunctionUncurryThis();
	var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
	var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
	var anObject = requireAnObject();

	var concat = uncurryThis([].concat);

	// all object keys, includes non-enumerable and symbols
	ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};
	return ownKeys$1;
}

var copyConstructorProperties;
var hasRequiredCopyConstructorProperties;

function requireCopyConstructorProperties () {
	if (hasRequiredCopyConstructorProperties) return copyConstructorProperties;
	hasRequiredCopyConstructorProperties = 1;
	var hasOwn = requireHasOwnProperty();
	var ownKeys = requireOwnKeys();
	var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
	var definePropertyModule = requireObjectDefineProperty();

	copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	return copyConstructorProperties;
}

var isForced_1;
var hasRequiredIsForced;

function requireIsForced () {
	if (hasRequiredIsForced) return isForced_1;
	hasRequiredIsForced = 1;
	var fails = requireFails();
	var isCallable = requireIsCallable();

	var replacement = /#|\.prototype\./;

	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value == POLYFILL ? true
	    : value == NATIVE ? false
	    : isCallable(detection) ? fails(detection)
	    : !!detection;
	};

	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};

	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';

	isForced_1 = isForced;
	return isForced_1;
}

var _export;
var hasRequired_export;

function require_export () {
	if (hasRequired_export) return _export;
	hasRequired_export = 1;
	var global = requireGlobal();
	var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
	var defineBuiltIn = requireDefineBuiltIn();
	var defineGlobalProperty = requireDefineGlobalProperty();
	var copyConstructorProperties = requireCopyConstructorProperties();
	var isForced = requireIsForced();

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	_export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global;
	  } else if (STATIC) {
	    target = global[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = (global[TARGET] || {}).prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};
	return _export;
}

var toStringTagSupport;
var hasRequiredToStringTagSupport;

function requireToStringTagSupport () {
	if (hasRequiredToStringTagSupport) return toStringTagSupport;
	hasRequiredToStringTagSupport = 1;
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};

	test[TO_STRING_TAG] = 'z';

	toStringTagSupport = String(test) === '[object z]';
	return toStringTagSupport;
}

var classof;
var hasRequiredClassof;

function requireClassof () {
	if (hasRequiredClassof) return classof;
	hasRequiredClassof = 1;
	var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
	var isCallable = requireIsCallable();
	var classofRaw = requireClassofRaw();
	var wellKnownSymbol = requireWellKnownSymbol();

	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Object = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};

	// getting tag from ES6+ `Object.prototype.toString`
	classof = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};
	return classof;
}

var toString$1;
var hasRequiredToString;

function requireToString () {
	if (hasRequiredToString) return toString$1;
	hasRequiredToString = 1;
	var classof = requireClassof();

	var $String = String;

	toString$1 = function (argument) {
	  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};
	return toString$1;
}

var regexpFlags;
var hasRequiredRegexpFlags;

function requireRegexpFlags () {
	if (hasRequiredRegexpFlags) return regexpFlags;
	hasRequiredRegexpFlags = 1;
	var anObject = requireAnObject();

	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	regexpFlags = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.hasIndices) result += 'd';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.unicodeSets) result += 'v';
	  if (that.sticky) result += 'y';
	  return result;
	};
	return regexpFlags;
}

var regexpStickyHelpers;
var hasRequiredRegexpStickyHelpers;

function requireRegexpStickyHelpers () {
	if (hasRequiredRegexpStickyHelpers) return regexpStickyHelpers;
	hasRequiredRegexpStickyHelpers = 1;
	var fails = requireFails();
	var global = requireGlobal();

	// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	var $RegExp = global.RegExp;

	var UNSUPPORTED_Y = fails(function () {
	  var re = $RegExp('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') != null;
	});

	// UC Browser bug
	// https://github.com/zloirock/core-js/issues/1008
	var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
	  return !$RegExp('a', 'y').sticky;
	});

	var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = $RegExp('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') != null;
	});

	regexpStickyHelpers = {
	  BROKEN_CARET: BROKEN_CARET,
	  MISSED_STICKY: MISSED_STICKY,
	  UNSUPPORTED_Y: UNSUPPORTED_Y
	};
	return regexpStickyHelpers;
}

var objectDefineProperties = {};

var objectKeys;
var hasRequiredObjectKeys;

function requireObjectKeys () {
	if (hasRequiredObjectKeys) return objectKeys;
	hasRequiredObjectKeys = 1;
	var internalObjectKeys = requireObjectKeysInternal();
	var enumBugKeys = requireEnumBugKeys();

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es-x/no-object-keys -- safe
	objectKeys = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};
	return objectKeys;
}

var hasRequiredObjectDefineProperties;

function requireObjectDefineProperties () {
	if (hasRequiredObjectDefineProperties) return objectDefineProperties;
	hasRequiredObjectDefineProperties = 1;
	var DESCRIPTORS = requireDescriptors();
	var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
	var definePropertyModule = requireObjectDefineProperty();
	var anObject = requireAnObject();
	var toIndexedObject = requireToIndexedObject();
	var objectKeys = requireObjectKeys();

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es-x/no-object-defineproperties -- safe
	objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};
	return objectDefineProperties;
}

var html;
var hasRequiredHtml;

function requireHtml () {
	if (hasRequiredHtml) return html;
	hasRequiredHtml = 1;
	var getBuiltIn = requireGetBuiltIn();

	html = getBuiltIn('document', 'documentElement');
	return html;
}

var objectCreate;
var hasRequiredObjectCreate;

function requireObjectCreate () {
	if (hasRequiredObjectCreate) return objectCreate;
	hasRequiredObjectCreate = 1;
	var anObject = requireAnObject();
	var definePropertiesModule = requireObjectDefineProperties();
	var enumBugKeys = requireEnumBugKeys();
	var hiddenKeys = requireHiddenKeys();
	var html = requireHtml();
	var documentCreateElement = requireDocumentCreateElement();
	var sharedKey = requireSharedKey();

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');

	var EmptyConstructor = function () { /* empty */ };

	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};

	hiddenKeys[IE_PROTO] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es-x/no-object-create -- safe
	objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};
	return objectCreate;
}

var regexpUnsupportedDotAll;
var hasRequiredRegexpUnsupportedDotAll;

function requireRegexpUnsupportedDotAll () {
	if (hasRequiredRegexpUnsupportedDotAll) return regexpUnsupportedDotAll;
	hasRequiredRegexpUnsupportedDotAll = 1;
	var fails = requireFails();
	var global = requireGlobal();

	// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
	var $RegExp = global.RegExp;

	regexpUnsupportedDotAll = fails(function () {
	  var re = $RegExp('.', 's');
	  return !(re.dotAll && re.exec('\n') && re.flags === 's');
	});
	return regexpUnsupportedDotAll;
}

var regexpUnsupportedNcg;
var hasRequiredRegexpUnsupportedNcg;

function requireRegexpUnsupportedNcg () {
	if (hasRequiredRegexpUnsupportedNcg) return regexpUnsupportedNcg;
	hasRequiredRegexpUnsupportedNcg = 1;
	var fails = requireFails();
	var global = requireGlobal();

	// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
	var $RegExp = global.RegExp;

	regexpUnsupportedNcg = fails(function () {
	  var re = $RegExp('(?<a>b)', 'g');
	  return re.exec('b').groups.a !== 'b' ||
	    'b'.replace(re, '$<a>c') !== 'bc';
	});
	return regexpUnsupportedNcg;
}

var regexpExec;
var hasRequiredRegexpExec;

function requireRegexpExec () {
	if (hasRequiredRegexpExec) return regexpExec;
	hasRequiredRegexpExec = 1;
	/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
	/* eslint-disable regexp/no-useless-quantifier -- testing */
	var call = requireFunctionCall();
	var uncurryThis = requireFunctionUncurryThis();
	var toString = requireToString();
	var regexpFlags = requireRegexpFlags();
	var stickyHelpers = requireRegexpStickyHelpers();
	var shared = requireShared();
	var create = requireObjectCreate();
	var getInternalState = requireInternalState().get;
	var UNSUPPORTED_DOT_ALL = requireRegexpUnsupportedDotAll();
	var UNSUPPORTED_NCG = requireRegexpUnsupportedNcg();

	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var nativeExec = RegExp.prototype.exec;
	var patchedExec = nativeExec;
	var charAt = uncurryThis(''.charAt);
	var indexOf = uncurryThis(''.indexOf);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);

	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  call(nativeExec, re1, 'a');
	  call(nativeExec, re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	})();

	var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

	if (PATCH) {
	  patchedExec = function exec(string) {
	    var re = this;
	    var state = getInternalState(re);
	    var str = toString(string);
	    var raw = state.raw;
	    var result, reCopy, lastIndex, match, i, object, group;

	    if (raw) {
	      raw.lastIndex = re.lastIndex;
	      result = call(patchedExec, raw, str);
	      re.lastIndex = raw.lastIndex;
	      return result;
	    }

	    var groups = state.groups;
	    var sticky = UNSUPPORTED_Y && re.sticky;
	    var flags = call(regexpFlags, re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;

	    if (sticky) {
	      flags = replace(flags, 'y', '');
	      if (indexOf(flags, 'g') === -1) {
	        flags += 'g';
	      }

	      strCopy = stringSlice(str, re.lastIndex);
	      // Support anchored sticky behavior.
	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      }
	      // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.
	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

	    match = call(nativeExec, sticky ? reCopy : re, strCopy);

	    if (sticky) {
	      if (match) {
	        match.input = stringSlice(match.input, charsAdded);
	        match[0] = stringSlice(match[0], charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
	      call(nativeReplace, match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    if (match && groups) {
	      match.groups = object = create(null);
	      for (i = 0; i < groups.length; i++) {
	        group = groups[i];
	        object[group[0]] = match[group[1]];
	      }
	    }

	    return match;
	  };
	}

	regexpExec = patchedExec;
	return regexpExec;
}

var hasRequiredEs_regexp_exec;

function requireEs_regexp_exec () {
	if (hasRequiredEs_regexp_exec) return es_regexp_exec;
	hasRequiredEs_regexp_exec = 1;
	var $ = require_export();
	var exec = requireRegexpExec();

	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
	  exec: exec
	});
	return es_regexp_exec;
}

var es_string_replace = {};

var functionApply;
var hasRequiredFunctionApply;

function requireFunctionApply () {
	if (hasRequiredFunctionApply) return functionApply;
	hasRequiredFunctionApply = 1;
	var NATIVE_BIND = requireFunctionBindNative();

	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;

	// eslint-disable-next-line es-x/no-reflect -- safe
	functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});
	return functionApply;
}

var fixRegexpWellKnownSymbolLogic;
var hasRequiredFixRegexpWellKnownSymbolLogic;

function requireFixRegexpWellKnownSymbolLogic () {
	if (hasRequiredFixRegexpWellKnownSymbolLogic) return fixRegexpWellKnownSymbolLogic;
	hasRequiredFixRegexpWellKnownSymbolLogic = 1;
	// TODO: Remove from `core-js@4` since it's moved to entry points
	requireEs_regexp_exec();
	var uncurryThis = requireFunctionUncurryThis();
	var defineBuiltIn = requireDefineBuiltIn();
	var regexpExec = requireRegexpExec();
	var fails = requireFails();
	var wellKnownSymbol = requireWellKnownSymbol();
	var createNonEnumerableProperty = requireCreateNonEnumerableProperty();

	var SPECIES = wellKnownSymbol('species');
	var RegExpPrototype = RegExp.prototype;

	fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
	  var SYMBOL = wellKnownSymbol(KEY);

	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });

	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;

	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {};
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }

	    re.exec = function () { execCalled = true; return null; };

	    re[SYMBOL]('');
	    return !execCalled;
	  });

	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    FORCED
	  ) {
	    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var uncurriedNativeMethod = uncurryThis(nativeMethod);
	      var $exec = regexp.exec;
	      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
	        }
	        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
	      }
	      return { done: false };
	    });

	    defineBuiltIn(String.prototype, KEY, methods[0]);
	    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
	  }

	  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};
	return fixRegexpWellKnownSymbolLogic;
}

var stringMultibyte;
var hasRequiredStringMultibyte;

function requireStringMultibyte () {
	if (hasRequiredStringMultibyte) return stringMultibyte;
	hasRequiredStringMultibyte = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var toIntegerOrInfinity = requireToIntegerOrInfinity();
	var toString = requireToString();
	var requireObjectCoercible = requireRequireObjectCoercible();

	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var stringSlice = uncurryThis(''.slice);

	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};

	stringMultibyte = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};
	return stringMultibyte;
}

var advanceStringIndex;
var hasRequiredAdvanceStringIndex;

function requireAdvanceStringIndex () {
	if (hasRequiredAdvanceStringIndex) return advanceStringIndex;
	hasRequiredAdvanceStringIndex = 1;
	var charAt = requireStringMultibyte().charAt;

	// `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex
	advanceStringIndex = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};
	return advanceStringIndex;
}

var getSubstitution;
var hasRequiredGetSubstitution;

function requireGetSubstitution () {
	if (hasRequiredGetSubstitution) return getSubstitution;
	hasRequiredGetSubstitution = 1;
	var uncurryThis = requireFunctionUncurryThis();
	var toObject = requireToObject();

	var floor = Math.floor;
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

	// `GetSubstitution` abstract operation
	// https://tc39.es/ecma262/#sec-getsubstitution
	getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }
	  return replace(replacement, symbols, function (match, ch) {
	    var capture;
	    switch (charAt(ch, 0)) {
	      case '$': return '$';
	      case '&': return matched;
	      case '`': return stringSlice(str, 0, position);
	      case "'": return stringSlice(str, tailPos);
	      case '<':
	        capture = namedCaptures[stringSlice(ch, 1, -1)];
	        break;
	      default: // \d\d?
	        var n = +ch;
	        if (n === 0) return match;
	        if (n > m) {
	          var f = floor(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
	          return match;
	        }
	        capture = captures[n - 1];
	    }
	    return capture === undefined ? '' : capture;
	  });
	};
	return getSubstitution;
}

var regexpExecAbstract;
var hasRequiredRegexpExecAbstract;

function requireRegexpExecAbstract () {
	if (hasRequiredRegexpExecAbstract) return regexpExecAbstract;
	hasRequiredRegexpExecAbstract = 1;
	var call = requireFunctionCall();
	var anObject = requireAnObject();
	var isCallable = requireIsCallable();
	var classof = requireClassofRaw();
	var regexpExec = requireRegexpExec();

	var $TypeError = TypeError;

	// `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec
	regexpExecAbstract = function (R, S) {
	  var exec = R.exec;
	  if (isCallable(exec)) {
	    var result = call(exec, R, S);
	    if (result !== null) anObject(result);
	    return result;
	  }
	  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
	  throw $TypeError('RegExp#exec called on incompatible receiver');
	};
	return regexpExecAbstract;
}

var hasRequiredEs_string_replace;

function requireEs_string_replace () {
	if (hasRequiredEs_string_replace) return es_string_replace;
	hasRequiredEs_string_replace = 1;
	var apply = requireFunctionApply();
	var call = requireFunctionCall();
	var uncurryThis = requireFunctionUncurryThis();
	var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
	var fails = requireFails();
	var anObject = requireAnObject();
	var isCallable = requireIsCallable();
	var isNullOrUndefined = requireIsNullOrUndefined();
	var toIntegerOrInfinity = requireToIntegerOrInfinity();
	var toLength = requireToLength();
	var toString = requireToString();
	var requireObjectCoercible = requireRequireObjectCoercible();
	var advanceStringIndex = requireAdvanceStringIndex();
	var getMethod = requireGetMethod();
	var getSubstitution = requireGetSubstitution();
	var regExpExec = requireRegexpExecAbstract();
	var wellKnownSymbol = requireWellKnownSymbol();

	var REPLACE = wellKnownSymbol('replace');
	var max = Math.max;
	var min = Math.min;
	var concat = uncurryThis([].concat);
	var push = uncurryThis([].push);
	var stringIndexOf = uncurryThis(''.indexOf);
	var stringSlice = uncurryThis(''.slice);

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};

	// IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
	var REPLACE_KEEPS_$0 = (function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	})();

	// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }
	  return false;
	})();

	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
	  return ''.replace(re, '$<a>') !== '7';
	});

	// @@replace logic
	fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

	  return [
	    // `String.prototype.replace` method
	    // https://tc39.es/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = requireObjectCoercible(this);
	      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
	      return replacer
	        ? call(replacer, searchValue, O, replaceValue)
	        : call(nativeReplace, toString(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	    function (string, replaceValue) {
	      var rx = anObject(this);
	      var S = toString(string);

	      if (
	        typeof replaceValue == 'string' &&
	        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
	        stringIndexOf(replaceValue, '$<') === -1
	      ) {
	        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
	        if (res.done) return res.value;
	      }

	      var functionalReplace = isCallable(replaceValue);
	      if (!functionalReplace) replaceValue = toString(replaceValue);

	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;

	        push(results, result);
	        if (!global) break;

	        var matchStr = toString(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }

	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];

	        var matched = toString(result[0]);
	        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = concat([matched], captures, position, S);
	          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
	          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + stringSlice(S, nextSourcePosition);
	    }
	  ];
	}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
	return es_string_replace;
}

var es_object_defineProperty = {};

var hasRequiredEs_object_defineProperty;

function requireEs_object_defineProperty () {
	if (hasRequiredEs_object_defineProperty) return es_object_defineProperty;
	hasRequiredEs_object_defineProperty = 1;
	var $ = require_export();
	var DESCRIPTORS = requireDescriptors();
	var defineProperty = requireObjectDefineProperty().f;

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	// eslint-disable-next-line es-x/no-object-defineproperty -- safe
	$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
	  defineProperty: defineProperty
	});
	return es_object_defineProperty;
}

var es_object_toString = {};

var objectToString;
var hasRequiredObjectToString;

function requireObjectToString () {
	if (hasRequiredObjectToString) return objectToString;
	hasRequiredObjectToString = 1;
	var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
	var classof = requireClassof();

	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	objectToString = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};
	return objectToString;
}

var hasRequiredEs_object_toString;

function requireEs_object_toString () {
	if (hasRequiredEs_object_toString) return es_object_toString;
	hasRequiredEs_object_toString = 1;
	var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
	var defineBuiltIn = requireDefineBuiltIn();
	var toString = requireObjectToString();

	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
	}
	return es_object_toString;
}

var es_regexp_toString = {};

var regexpGetFlags;
var hasRequiredRegexpGetFlags;

function requireRegexpGetFlags () {
	if (hasRequiredRegexpGetFlags) return regexpGetFlags;
	hasRequiredRegexpGetFlags = 1;
	var call = requireFunctionCall();
	var hasOwn = requireHasOwnProperty();
	var isPrototypeOf = requireObjectIsPrototypeOf();
	var regExpFlags = requireRegexpFlags();

	var RegExpPrototype = RegExp.prototype;

	regexpGetFlags = function (R) {
	  var flags = R.flags;
	  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
	    ? call(regExpFlags, R) : flags;
	};
	return regexpGetFlags;
}

var hasRequiredEs_regexp_toString;

function requireEs_regexp_toString () {
	if (hasRequiredEs_regexp_toString) return es_regexp_toString;
	hasRequiredEs_regexp_toString = 1;
	var PROPER_FUNCTION_NAME = requireFunctionName().PROPER;
	var defineBuiltIn = requireDefineBuiltIn();
	var anObject = requireAnObject();
	var $toString = requireToString();
	var fails = requireFails();
	var getRegExpFlags = requireRegexpGetFlags();

	var TO_STRING = 'toString';
	var RegExpPrototype = RegExp.prototype;
	var nativeToString = RegExpPrototype[TO_STRING];

	var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
	// FF44- RegExp#toString has a wrong name
	var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

	// `RegExp.prototype.toString` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
	if (NOT_GENERIC || INCORRECT_NAME) {
	  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
	    var R = anObject(this);
	    var pattern = $toString(R.source);
	    var flags = $toString(getRegExpFlags(R));
	    return '/' + pattern + '/' + flags;
	  }, { unsafe: true });
	}
	return es_regexp_toString;
}

var lodash_get;
var hasRequiredLodash_get;

function requireLodash_get () {
	if (hasRequiredLodash_get) return lodash_get;
	hasRequiredLodash_get = 1;
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';

	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;

	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);

	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}

	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	lodash_get = get;
	return lodash_get;
}

var plurals;
var hasRequiredPlurals;

function requirePlurals () {
	if (hasRequiredPlurals) return plurals;
	hasRequiredPlurals = 1;

	plurals = {
	    ach: {
	        name: 'Acholi',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    af: {
	        name: 'Afrikaans',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ak: {
	        name: 'Akan',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    am: {
	        name: 'Amharic',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    an: {
	        name: 'Aragonese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ar: {
	        name: 'Arabic',
	        examples: [{
	            plural: 0,
	            sample: 0
	        }, {
	            plural: 1,
	            sample: 1
	        }, {
	            plural: 2,
	            sample: 2
	        }, {
	            plural: 3,
	            sample: 3
	        }, {
	            plural: 4,
	            sample: 11
	        }, {
	            plural: 5,
	            sample: 100
	        }],
	        nplurals: 6,
	        pluralsText: 'nplurals = 6; plural = (n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5)',
	        pluralsFunc: function(n) {
	            return (n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	        }
	    },
	    arn: {
	        name: 'Mapudungun',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    ast: {
	        name: 'Asturian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ay: {
	        name: 'Aymará',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    az: {
	        name: 'Azerbaijani',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    be: {
	        name: 'Belarusian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    bg: {
	        name: 'Bulgarian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    bn: {
	        name: 'Bengali',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    bo: {
	        name: 'Tibetan',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    br: {
	        name: 'Breton',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    brx: {
	        name: 'Bodo',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    bs: {
	        name: 'Bosnian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    ca: {
	        name: 'Catalan',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    cgg: {
	        name: 'Chiga',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    cs: {
	        name: 'Czech',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2);
	        }
	    },
	    csb: {
	        name: 'Kashubian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    cy: {
	        name: 'Welsh',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 3
	        }, {
	            plural: 3,
	            sample: 8
	        }],
	        nplurals: 4,
	        pluralsText: 'nplurals = 4; plural = (n === 1 ? 0 : n === 2 ? 1 : (n !== 8 && n !== 11) ? 2 : 3)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : n === 2 ? 1 : (n !== 8 && n !== 11) ? 2 : 3);
	        }
	    },
	    da: {
	        name: 'Danish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    de: {
	        name: 'German',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    doi: {
	        name: 'Dogri',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    dz: {
	        name: 'Dzongkha',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    el: {
	        name: 'Greek',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    en: {
	        name: 'English',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    eo: {
	        name: 'Esperanto',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    es: {
	        name: 'Spanish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    et: {
	        name: 'Estonian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    eu: {
	        name: 'Basque',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    fa: {
	        name: 'Persian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    ff: {
	        name: 'Fulah',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    fi: {
	        name: 'Finnish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    fil: {
	        name: 'Filipino',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    fo: {
	        name: 'Faroese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    fr: {
	        name: 'French',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    fur: {
	        name: 'Friulian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    fy: {
	        name: 'Frisian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ga: {
	        name: 'Irish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 3
	        }, {
	            plural: 3,
	            sample: 7
	        }, {
	            plural: 4,
	            sample: 11
	        }],
	        nplurals: 5,
	        pluralsText: 'nplurals = 5; plural = (n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	        }
	    },
	    gd: {
	        name: 'Scottish Gaelic',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 3
	        }, {
	            plural: 3,
	            sample: 20
	        }],
	        nplurals: 4,
	        pluralsText: 'nplurals = 4; plural = ((n === 1 || n === 11) ? 0 : (n === 2 || n === 12) ? 1 : (n > 2 && n < 20) ? 2 : 3)',
	        pluralsFunc: function(n) {
	            return ((n === 1 || n === 11) ? 0 : (n === 2 || n === 12) ? 1 : (n > 2 && n < 20) ? 2 : 3);
	        }
	    },
	    gl: {
	        name: 'Galician',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    gu: {
	        name: 'Gujarati',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    gun: {
	        name: 'Gun',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    ha: {
	        name: 'Hausa',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    he: {
	        name: 'Hebrew',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    hi: {
	        name: 'Hindi',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    hne: {
	        name: 'Chhattisgarhi',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    hr: {
	        name: 'Croatian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    hu: {
	        name: 'Hungarian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    hy: {
	        name: 'Armenian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    id: {
	        name: 'Indonesian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    is: {
	        name: 'Icelandic',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n % 10 !== 1 || n % 100 === 11)',
	        pluralsFunc: function(n) {
	            return (n % 10 !== 1 || n % 100 === 11);
	        }
	    },
	    it: {
	        name: 'Italian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ja: {
	        name: 'Japanese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    jbo: {
	        name: 'Lojban',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    jv: {
	        name: 'Javanese',
	        examples: [{
	            plural: 0,
	            sample: 0
	        }, {
	            plural: 1,
	            sample: 1
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 0)',
	        pluralsFunc: function(n) {
	            return (n !== 0);
	        }
	    },
	    ka: {
	        name: 'Georgian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    kk: {
	        name: 'Kazakh',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    km: {
	        name: 'Khmer',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    kn: {
	        name: 'Kannada',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ko: {
	        name: 'Korean',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    ku: {
	        name: 'Kurdish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    kw: {
	        name: 'Cornish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 3
	        }, {
	            plural: 3,
	            sample: 4
	        }],
	        nplurals: 4,
	        pluralsText: 'nplurals = 4; plural = (n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3);
	        }
	    },
	    ky: {
	        name: 'Kyrgyz',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    lb: {
	        name: 'Letzeburgesch',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ln: {
	        name: 'Lingala',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    lo: {
	        name: 'Lao',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    lt: {
	        name: 'Lithuanian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 10
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    lv: {
	        name: 'Latvian',
	        examples: [{
	            plural: 2,
	            sample: 0
	        }, {
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2);
	        }
	    },
	    mai: {
	        name: 'Maithili',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    mfe: {
	        name: 'Mauritian Creole',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    mg: {
	        name: 'Malagasy',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    mi: {
	        name: 'Maori',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    mk: {
	        name: 'Macedonian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n === 1 || n % 10 === 1 ? 0 : 1)',
	        pluralsFunc: function(n) {
	            return (n === 1 || n % 10 === 1 ? 0 : 1);
	        }
	    },
	    ml: {
	        name: 'Malayalam',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    mn: {
	        name: 'Mongolian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    mni: {
	        name: 'Manipuri',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    mnk: {
	        name: 'Mandinka',
	        examples: [{
	            plural: 0,
	            sample: 0
	        }, {
	            plural: 1,
	            sample: 1
	        }, {
	            plural: 2,
	            sample: 2
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n === 0 ? 0 : n === 1 ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n === 0 ? 0 : n === 1 ? 1 : 2);
	        }
	    },
	    mr: {
	        name: 'Marathi',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ms: {
	        name: 'Malay',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    mt: {
	        name: 'Maltese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 11
	        }, {
	            plural: 3,
	            sample: 20
	        }],
	        nplurals: 4,
	        pluralsText: 'nplurals = 4; plural = (n === 1 ? 0 : n === 0 || ( n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20 ) ? 2 : 3)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : n === 0 || (n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20) ? 2 : 3);
	        }
	    },
	    my: {
	        name: 'Burmese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    nah: {
	        name: 'Nahuatl',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    nap: {
	        name: 'Neapolitan',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    nb: {
	        name: 'Norwegian Bokmal',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ne: {
	        name: 'Nepali',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    nl: {
	        name: 'Dutch',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    nn: {
	        name: 'Norwegian Nynorsk',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    no: {
	        name: 'Norwegian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    nso: {
	        name: 'Northern Sotho',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    oc: {
	        name: 'Occitan',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    or: {
	        name: 'Oriya',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    pa: {
	        name: 'Punjabi',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    pap: {
	        name: 'Papiamento',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    pl: {
	        name: 'Polish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    pms: {
	        name: 'Piemontese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ps: {
	        name: 'Pashto',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    pt: {
	        name: 'Portuguese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    rm: {
	        name: 'Romansh',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ro: {
	        name: 'Romanian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 20
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : (n === 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : (n === 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2);
	        }
	    },
	    ru: {
	        name: 'Russian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    rw: {
	        name: 'Kinyarwanda',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sah: {
	        name: 'Yakut',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    sat: {
	        name: 'Santali',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sco: {
	        name: 'Scots',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sd: {
	        name: 'Sindhi',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    se: {
	        name: 'Northern Sami',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    si: {
	        name: 'Sinhala',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sk: {
	        name: 'Slovak',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n === 1 ? 0 : (n >= 2 && n <= 4) ? 1 : 2);
	        }
	    },
	    sl: {
	        name: 'Slovenian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 3
	        }, {
	            plural: 3,
	            sample: 5
	        }],
	        nplurals: 4,
	        pluralsText: 'nplurals = 4; plural = (n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3)',
	        pluralsFunc: function(n) {
	            return (n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3);
	        }
	    },
	    so: {
	        name: 'Somali',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    son: {
	        name: 'Songhay',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sq: {
	        name: 'Albanian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sr: {
	        name: 'Serbian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    su: {
	        name: 'Sundanese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    sv: {
	        name: 'Swedish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    sw: {
	        name: 'Swahili',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    ta: {
	        name: 'Tamil',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    te: {
	        name: 'Telugu',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    tg: {
	        name: 'Tajik',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    th: {
	        name: 'Thai',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    ti: {
	        name: 'Tigrinya',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    tk: {
	        name: 'Turkmen',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    tr: {
	        name: 'Turkish',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    tt: {
	        name: 'Tatar',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    ug: {
	        name: 'Uyghur',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    uk: {
	        name: 'Ukrainian',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }, {
	            plural: 2,
	            sample: 5
	        }],
	        nplurals: 3,
	        pluralsText: 'nplurals = 3; plural = (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2)',
	        pluralsFunc: function(n) {
	            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	        }
	    },
	    ur: {
	        name: 'Urdu',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    uz: {
	        name: 'Uzbek',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    vi: {
	        name: 'Vietnamese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    wa: {
	        name: 'Walloon',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n > 1)',
	        pluralsFunc: function(n) {
	            return (n > 1);
	        }
	    },
	    wo: {
	        name: 'Wolof',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    },
	    yo: {
	        name: 'Yoruba',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }, {
	            plural: 1,
	            sample: 2
	        }],
	        nplurals: 2,
	        pluralsText: 'nplurals = 2; plural = (n !== 1)',
	        pluralsFunc: function(n) {
	            return (n !== 1);
	        }
	    },
	    zh: {
	        name: 'Chinese',
	        examples: [{
	            plural: 0,
	            sample: 1
	        }],
	        nplurals: 1,
	        pluralsText: 'nplurals = 1; plural = 0',
	        pluralsFunc: function() {
	            return 0;
	        }
	    }
	};
	return plurals;
}

var gettext;
var hasRequiredGettext$1;

function requireGettext$1 () {
	if (hasRequiredGettext$1) return gettext;
	hasRequiredGettext$1 = 1;

	var get = requireLodash_get();
	var plurals = requirePlurals();

	gettext = Gettext;

	/**
	 * Creates and returns a new Gettext instance.
	 *
	 * @constructor
	 * @param  {Object}  [options]             A set of options
	 * @param  {String}  options.sourceLocale  The locale that the source code and its
	 *                                         texts are written in. Translations for
	 *                                         this locale is not necessary.
	 * @param  {Boolean} options.debug         Whether to output debug info into the
	 *                                         console.
	 * @return {Object}  A Gettext instance
	 */
	function Gettext(options) {
	    options = options || {};

	    this.catalogs = {};
	    this.locale = '';
	    this.domain = 'messages';

	    this.listeners = [];

	    // Set source locale
	    this.sourceLocale = '';
	    if (options.sourceLocale) {
	        if (typeof options.sourceLocale === 'string') {
	            this.sourceLocale = options.sourceLocale;
	        }
	        else {
	            this.warn('The `sourceLocale` option should be a string');
	        }
	    }

	    // Set debug flag
	    this.debug = 'debug' in options && options.debug === true;
	}

	/**
	 * Adds an event listener.
	 *
	 * @param  {String}   eventName  An event name
	 * @param  {Function} callback   An event handler function
	 */
	Gettext.prototype.on = function(eventName, callback) {
	    this.listeners.push({
	        eventName: eventName,
	        callback: callback
	    });
	};

	/**
	 * Removes an event listener.
	 *
	 * @param  {String}   eventName  An event name
	 * @param  {Function} callback   A previously registered event handler function
	 */
	Gettext.prototype.off = function(eventName, callback) {
	    this.listeners = this.listeners.filter(function(listener) {
	        return (
	            listener.eventName === eventName &&
	            listener.callback === callback
	        ) === false;
	    });
	};

	/**
	 * Emits an event to all registered event listener.
	 *
	 * @private
	 * @param  {String} eventName  An event name
	 * @param  {any}    eventData  Data to pass to event listeners
	 */
	Gettext.prototype.emit = function(eventName, eventData) {
	    for (var i = 0; i < this.listeners.length; i++) {
	        var listener = this.listeners[i];
	        if (listener.eventName === eventName) {
	            listener.callback(eventData);
	        }
	    }
	};

	/**
	 * Logs a warning to the console if debug mode is enabled.
	 *
	 * @ignore
	 * @param  {String} message  A warning message
	 */
	Gettext.prototype.warn = function(message) {
	    if (this.debug) {
	        console.warn(message);
	    }

	    this.emit('error', new Error(message));
	};

	/**
	 * Stores a set of translations in the set of gettext
	 * catalogs.
	 *
	 * @example
	 *     gt.addTranslations('sv-SE', 'messages', translationsObject)
	 *
	 * @param {String} locale        A locale string
	 * @param {String} domain        A domain name
	 * @param {Object} translations  An object of gettext-parser JSON shape
	 */
	Gettext.prototype.addTranslations = function(locale, domain, translations) {
	    if (!this.catalogs[locale]) {
	        this.catalogs[locale] = {};
	    }

	    this.catalogs[locale][domain] = translations;
	};

	/**
	 * Sets the locale to get translated messages for.
	 *
	 * @example
	 *     gt.setLocale('sv-SE')
	 *
	 * @param {String} locale  A locale
	 */
	Gettext.prototype.setLocale = function(locale) {
	    if (typeof locale !== 'string') {
	        this.warn(
	            'You called setLocale() with an argument of type ' + (typeof locale) + '. ' +
	            'The locale must be a string.'
	        );
	        return;
	    }

	    if (locale.trim() === '') {
	        this.warn('You called setLocale() with an empty value, which makes little sense.');
	    }

	    if (locale !== this.sourceLocale && !this.catalogs[locale]) {
	        this.warn('You called setLocale() with "' + locale + '", but no translations for that locale has been added.');
	    }

	    this.locale = locale;
	};

	/**
	 * Sets the default gettext domain.
	 *
	 * @example
	 *     gt.setTextDomain('domainname')
	 *
	 * @param {String} domain  A gettext domain name
	 */
	Gettext.prototype.setTextDomain = function(domain) {
	    if (typeof domain !== 'string') {
	        this.warn(
	            'You called setTextDomain() with an argument of type ' + (typeof domain) + '. ' +
	            'The domain must be a string.'
	        );
	        return;
	    }

	    if (domain.trim() === '') {
	        this.warn('You called setTextDomain() with an empty `domain` value.');
	    }

	    this.domain = domain;
	};

	/**
	 * Translates a string using the default textdomain
	 *
	 * @example
	 *     gt.gettext('Some text')
	 *
	 * @param  {String} msgid  String to be translated
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.gettext = function(msgid) {
	    return this.dnpgettext(this.domain, '', msgid);
	};

	/**
	 * Translates a string using a specific domain
	 *
	 * @example
	 *     gt.dgettext('domainname', 'Some text')
	 *
	 * @param  {String} domain  A gettext domain name
	 * @param  {String} msgid   String to be translated
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.dgettext = function(domain, msgid) {
	    return this.dnpgettext(domain, '', msgid);
	};

	/**
	 * Translates a plural string using the default textdomain
	 *
	 * @example
	 *     gt.ngettext('One thing', 'Many things', numberOfThings)
	 *
	 * @param  {String} msgid        String to be translated when count is not plural
	 * @param  {String} msgidPlural  String to be translated when count is plural
	 * @param  {Number} count        Number count for the plural
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.ngettext = function(msgid, msgidPlural, count) {
	    return this.dnpgettext(this.domain, '', msgid, msgidPlural, count);
	};

	/**
	 * Translates a plural string using a specific textdomain
	 *
	 * @example
	 *     gt.dngettext('domainname', 'One thing', 'Many things', numberOfThings)
	 *
	 * @param  {String} domain       A gettext domain name
	 * @param  {String} msgid        String to be translated when count is not plural
	 * @param  {String} msgidPlural  String to be translated when count is plural
	 * @param  {Number} count        Number count for the plural
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.dngettext = function(domain, msgid, msgidPlural, count) {
	    return this.dnpgettext(domain, '', msgid, msgidPlural, count);
	};

	/**
	 * Translates a string from a specific context using the default textdomain
	 *
	 * @example
	 *    gt.pgettext('sports', 'Back')
	 *
	 * @param  {String} msgctxt  Translation context
	 * @param  {String} msgid    String to be translated
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.pgettext = function(msgctxt, msgid) {
	    return this.dnpgettext(this.domain, msgctxt, msgid);
	};

	/**
	 * Translates a string from a specific context using s specific textdomain
	 *
	 * @example
	 *     gt.dpgettext('domainname', 'sports', 'Back')
	 *
	 * @param  {String} domain   A gettext domain name
	 * @param  {String} msgctxt  Translation context
	 * @param  {String} msgid    String to be translated
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.dpgettext = function(domain, msgctxt, msgid) {
	    return this.dnpgettext(domain, msgctxt, msgid);
	};

	/**
	 * Translates a plural string from a specific context using the default textdomain
	 *
	 * @example
	 *     gt.npgettext('sports', 'Back', '%d backs', numberOfBacks)
	 *
	 * @param  {String} msgctxt      Translation context
	 * @param  {String} msgid        String to be translated when count is not plural
	 * @param  {String} msgidPlural  String to be translated when count is plural
	 * @param  {Number} count        Number count for the plural
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.npgettext = function(msgctxt, msgid, msgidPlural, count) {
	    return this.dnpgettext(this.domain, msgctxt, msgid, msgidPlural, count);
	};

	/**
	 * Translates a plural string from a specifi context using a specific textdomain
	 *
	 * @example
	 *     gt.dnpgettext('domainname', 'sports', 'Back', '%d backs', numberOfBacks)
	 *
	 * @param  {String} domain       A gettext domain name
	 * @param  {String} msgctxt      Translation context
	 * @param  {String} msgid        String to be translated
	 * @param  {String} msgidPlural  If no translation was found, return this on count!=1
	 * @param  {Number} count        Number count for the plural
	 * @return {String} Translation or the original string if no translation was found
	 */
	Gettext.prototype.dnpgettext = function(domain, msgctxt, msgid, msgidPlural, count) {
	    var defaultTranslation = msgid;
	    var translation;
	    var index;

	    msgctxt = msgctxt || '';

	    if (!isNaN(count) && count !== 1) {
	        defaultTranslation = msgidPlural || msgid;
	    }

	    translation = this._getTranslation(domain, msgctxt, msgid);

	    if (translation) {
	        if (typeof count === 'number') {
	            var pluralsFunc = plurals[Gettext.getLanguageCode(this.locale)].pluralsFunc;
	            index = pluralsFunc(count);
	            if (typeof index === 'boolean') {
	                index = index ? 1 : 0;
	            }
	        } else {
	            index = 0;
	        }

	        return translation.msgstr[index] || defaultTranslation;
	    }
	    else if (!this.sourceLocale || this.locale !== this.sourceLocale) {
	        this.warn('No translation was found for msgid "' + msgid + '" in msgctxt "' + msgctxt + '" and domain "' + domain + '"');
	    }

	    return defaultTranslation;
	};

	/**
	 * Retrieves comments object for a translation. The comments object
	 * has the shape `{ translator, extracted, reference, flag, previous }`.
	 *
	 * @example
	 *     const comment = gt.getComment('domainname', 'sports', 'Backs')
	 *
	 * @private
	 * @param  {String} domain   A gettext domain name
	 * @param  {String} msgctxt  Translation context
	 * @param  {String} msgid    String to be translated
	 * @return {Object} Comments object or false if not found
	 */
	Gettext.prototype.getComment = function(domain, msgctxt, msgid) {
	    var translation;

	    translation = this._getTranslation(domain, msgctxt, msgid);
	    if (translation) {
	        return translation.comments || {};
	    }

	    return {};
	};

	/**
	 * Retrieves translation object from the domain and context
	 *
	 * @private
	 * @param  {String} domain   A gettext domain name
	 * @param  {String} msgctxt  Translation context
	 * @param  {String} msgid    String to be translated
	 * @return {Object} Translation object or false if not found
	 */
	Gettext.prototype._getTranslation = function(domain, msgctxt, msgid) {
	    msgctxt = msgctxt || '';

	    return get(this.catalogs, [this.locale, domain, 'translations', msgctxt, msgid]);
	};

	/**
	 * Returns the language code part of a locale
	 *
	 * @example
	 *     Gettext.getLanguageCode('sv-SE')
	 *     // -> "sv"
	 *
	 * @private
	 * @param   {String} locale  A case-insensitive locale string
	 * @returns {String} A language code
	 */
	Gettext.getLanguageCode = function(locale) {
	    return locale.split(/[\-_]/)[0].toLowerCase();
	};

	/* C-style aliases */

	/**
	 * C-style alias for [setTextDomain](#gettextsettextdomaindomain)
	 *
	 * @see Gettext#setTextDomain
	 */
	Gettext.prototype.textdomain = function(domain) {
	    if (this.debug) {
	        console.warn('textdomain(domain) was used to set locales in node-gettext v1. ' +
	            'Make sure you are using it for domains, and switch to setLocale(locale) if you are not.\n\n ' +
	            'To read more about the migration from node-gettext v1 to v2, ' +
	            'see https://github.com/alexanderwallin/node-gettext/#migrating-from-1x-to-2x\n\n' +
	            'This warning will be removed in the final 2.0.0');
	    }

	    this.setTextDomain(domain);
	};

	/**
	 * C-style alias for [setLocale](#gettextsetlocalelocale)
	 *
	 * @see Gettext#setLocale
	 */
	Gettext.prototype.setlocale = function(locale) {
	    this.setLocale(locale);
	};

	/* Deprecated functions */

	/**
	 * This function will be removed in the final 2.0.0 release.
	 *
	 * @deprecated
	 */
	Gettext.prototype.addTextdomain = function() {
	    console.error('addTextdomain() is deprecated.\n\n' +
	        '* To add translations, use addTranslations()\n' +
	        '* To set the default domain, use setTextDomain() (or its alias textdomain())\n' +
	        '\n' +
	        'To read more about the migration from node-gettext v1 to v2, ' +
	        'see https://github.com/alexanderwallin/node-gettext/#migrating-from-1x-to-2x');
	};
	return gettext;
}

var dist = {};

var hasRequiredDist;

function requireDist () {
	if (hasRequiredDist) return dist;
	hasRequiredDist = 1;

	requireEs_object_defineProperty();

	Object.defineProperty(dist, "__esModule", {
	  value: true
	});
	dist.getCanonicalLocale = getCanonicalLocale;
	dist.getDayNames = getDayNames;
	dist.getDayNamesMin = getDayNamesMin;
	dist.getDayNamesShort = getDayNamesShort;
	dist.getFirstDay = getFirstDay;
	dist.getLanguage = getLanguage;
	dist.getLocale = getLocale;
	dist.getMonthNames = getMonthNames;
	dist.getMonthNamesShort = getMonthNamesShort;
	dist.translate = translate;
	dist.translatePlural = translatePlural;

	requireEs_regexp_exec();

	requireEs_string_replace();

	/// <reference types="@nextcloud/typings" />

	/**
	 * Returns the user's locale
	 */
	function getLocale() {
	  return document.documentElement.dataset.locale || 'en';
	}

	function getCanonicalLocale() {
	  return getLocale().replace(/_/g, '-');
	}
	/**
	 * Returns the user's language
	 */


	function getLanguage() {
	  return document.documentElement.lang || 'en';
	}

	/**
	 * Translate a string
	 *
	 * @param {string} app the id of the app for which to translate the string
	 * @param {string} text the string to translate
	 * @param {object} vars map of placeholder key to value
	 * @param {number} number to replace %n with
	 * @param {object} [options] options object
	 * @return {string}
	 */
	function translate(app, text, vars, count, options) {
	  if (typeof OC === 'undefined') {
	    console.warn('No OC found');
	    return text;
	  }

	  return OC.L10N.translate(app, text, vars, count, options);
	}
	/**
	 * Translate a plural string
	 *
	 * @param {string} app the id of the app for which to translate the string
	 * @param {string} textSingular the string to translate for exactly one object
	 * @param {string} textPlural the string to translate for n objects
	 * @param {number} count number to determine whether to use singular or plural
	 * @param {Object} vars of placeholder key to value
	 * @param {object} options options object
	 * @return {string}
	 */


	function translatePlural(app, textSingular, textPlural, count, vars, options) {
	  if (typeof OC === 'undefined') {
	    console.warn('No OC found');
	    return textSingular;
	  }

	  return OC.L10N.translatePlural(app, textSingular, textPlural, count, vars, options);
	}
	/**
	 * Get the first day of the week
	 *
	 * @return {number}
	 */


	function getFirstDay() {
	  if (typeof window.firstDay === 'undefined') {
	    console.warn('No firstDay found');
	    return 1;
	  }

	  return window.firstDay;
	}
	/**
	 * Get a list of day names (full names)
	 *
	 * @return {string[]}
	 */


	function getDayNames() {
	  if (typeof window.dayNames === 'undefined') {
	    console.warn('No dayNames found');
	    return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	  }

	  return window.dayNames;
	}
	/**
	 * Get a list of day names (short names)
	 *
	 * @return {string[]}
	 */


	function getDayNamesShort() {
	  if (typeof window.dayNamesShort === 'undefined') {
	    console.warn('No dayNamesShort found');
	    return ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'];
	  }

	  return window.dayNamesShort;
	}
	/**
	 * Get a list of day names (minified names)
	 *
	 * @return {string[]}
	 */


	function getDayNamesMin() {
	  if (typeof window.dayNamesMin === 'undefined') {
	    console.warn('No dayNamesMin found');
	    return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
	  }

	  return window.dayNamesMin;
	}
	/**
	 * Get a list of month names (full names)
	 *
	 * @return {string[]}
	 */


	function getMonthNames() {
	  if (typeof window.monthNames === 'undefined') {
	    console.warn('No monthNames found');
	    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  }

	  return window.monthNames;
	}
	/**
	 * Get a list of month names (short names)
	 *
	 * @return {string[]}
	 */


	function getMonthNamesShort() {
	  if (typeof window.monthNamesShort === 'undefined') {
	    console.warn('No monthNamesShort found');
	    return ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
	  }

	  return window.monthNamesShort;
	}
	
	return dist;
}

var hasRequiredGettext;

function requireGettext () {
	if (hasRequiredGettext) return gettext$1;
	hasRequiredGettext = 1;

	Object.defineProperty(gettext$1, "__esModule", {
	  value: true
	});
	gettext$1.getGettextBuilder = getGettextBuilder;

	requireEs_regexp_exec();

	requireEs_string_replace();

	requireEs_object_defineProperty();

	requireEs_object_toString();

	requireEs_regexp_toString();

	var _nodeGettext = _interopRequireDefault(requireGettext$1());

	var _ = requireDist();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

	var GettextBuilder = /*#__PURE__*/function () {
	  function GettextBuilder() {
	    _classCallCheck(this, GettextBuilder);

	    this.translations = {};
	    this.debug = false;
	  }

	  _createClass(GettextBuilder, [{
	    key: "setLanguage",
	    value: function setLanguage(language) {
	      this.locale = language;
	      return this;
	    }
	  }, {
	    key: "detectLocale",
	    value: function detectLocale() {
	      return this.setLanguage((0, _.getLanguage)().replace('-', '_'));
	    }
	  }, {
	    key: "addTranslation",
	    value: function addTranslation(language, data) {
	      this.translations[language] = data;
	      return this;
	    }
	  }, {
	    key: "enableDebugMode",
	    value: function enableDebugMode() {
	      this.debug = true;
	      return this;
	    }
	  }, {
	    key: "build",
	    value: function build() {
	      return new GettextWrapper(this.locale || 'en', this.translations, this.debug);
	    }
	  }]);

	  return GettextBuilder;
	}();

	var GettextWrapper = /*#__PURE__*/function () {
	  function GettextWrapper(locale, data, debug) {
	    _classCallCheck(this, GettextWrapper);

	    this.gt = new _nodeGettext.default({
	      debug: debug,
	      sourceLocale: 'en'
	    });

	    for (var key in data) {
	      this.gt.addTranslations(key, 'messages', data[key]);
	    }

	    this.gt.setLocale(locale);
	  }

	  _createClass(GettextWrapper, [{
	    key: "subtitudePlaceholders",
	    value: function subtitudePlaceholders(translated, vars) {
	      return translated.replace(/{([^{}]*)}/g, function (a, b) {
	        var r = vars[b];

	        if (typeof r === 'string' || typeof r === 'number') {
	          return r.toString();
	        } else {
	          return a;
	        }
	      });
	    }
	  }, {
	    key: "gettext",
	    value: function gettext(original) {
	      var placeholders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      return this.subtitudePlaceholders(this.gt.gettext(original), placeholders);
	    }
	  }, {
	    key: "ngettext",
	    value: function ngettext(singular, plural, count) {
	      var placeholders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	      return this.subtitudePlaceholders(this.gt.ngettext(singular, plural, count).replace(/%n/g, count.toString()), placeholders);
	    }
	  }]);

	  return GettextWrapper;
	}();

	function getGettextBuilder() {
	  return new GettextBuilder();
	}
	
	return gettext$1;
}

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getAlignment(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].includes(getBasePlacement(placement)) ? 'x' : 'y';
}

function getLengthFromAxis(axis) {
  return axis === 'y' ? 'height' : 'width';
}

function computeCoordsFromPlacement(_ref) {
  let {
    reference,
    floating,
    placement
  } = _ref;
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  let coords;

  switch (getBasePlacement(placement)) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;

    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;

    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }

  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);

  switch (getAlignment(placement)) {
    case 'start':
      coords[mainAxis] = coords[mainAxis] - (reference[length] / 2 - floating[length] / 2);
      break;

    case 'end':
      coords[mainAxis] = coords[mainAxis] + (reference[length] / 2 - floating[length] / 2);
      break;
  }

  return coords;
}

const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;

  if (process.env.NODE_ENV !== "production") {
    if (platform == null) {
      console.error(['Floating UI: `platform` property was not passed to config. If you', 'want to use Floating UI on the web, install @floating-ui/dom', 'instead of the /core package. Otherwise, you can create your own', '`platform`: https://floating-ui.com/docs/platform'].join(' '));
    }

    if (middleware.filter(_ref => {
      let {
        name
      } = _ref;
      return name === 'autoPlacement' || name === 'flip';
    }).length > 1) {
      throw new Error(['Floating UI: duplicate `flip` and/or `autoPlacement`', 'middleware detected. This will lead to an infinite loop. Ensure only', 'one of either has been passed to the `middleware` array.'].join(' '));
    }
  }

  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement({ ...rects,
    placement
  });
  let statefulPlacement = placement;
  let middlewareData = {};
  let _debug_loop_count_ = 0;

  for (let i = 0; i < middleware.length; i++) {
    if (process.env.NODE_ENV !== "production") {
      _debug_loop_count_++;

      if (_debug_loop_count_ > 100) {
        throw new Error(['Floating UI: The middleware lifecycle appears to be', 'running in an infinite loop. This is usually caused by a `reset`', 'continually being returned without a break condition.'].join(' '));
      }
    }

    const {
      name,
      fn
    } = middleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = { ...middlewareData,
      [name]: data != null ? data : {}
    };

    if (reset) {
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }

        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }

        ({
          x,
          y
        } = computeCoordsFromPlacement({ ...rects,
          placement: statefulPlacement
        }));
      }

      i = -1;
      continue;
    }
  }

  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}

function getSideObjectFromPadding(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}

function rectToClientRect(rect) {
  return { ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}

async function detectOverflow(middlewareArguments, options) {
  if (options === void 0) {
    options = {};
  }

  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = middlewareArguments;
  const {
    boundary = 'clippingParents',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = options;
  const paddingObject = getSideObjectFromPadding(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = await platform.getClippingClientRect({
    element: (await platform.isElement(element)) ? element : element.contextElement || (await platform.getDocumentElement({
      element: elements.floating
    })),
    boundary,
    rootBoundary
  });
  const elementClientRect = rectToClientRect(await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: elementContext === 'floating' ? { ...rects.floating,
      x,
      y
    } : rects.reference,
    offsetParent: await platform.getOffsetParent({
      element: elements.floating
    }),
    strategy
  })); // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  return {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
}

const min$1 = Math.min;
const max$1 = Math.max;

function within(min$1$1, value, max$1$1) {
  return max$1(min$1$1, min$1(value, max$1$1));
}

const arrow = options => ({
  name: 'arrow',
  options,

  async fn(middlewareArguments) {
    // Since `element` is required, we don't Partial<> the type
    const {
      element,
      padding = 0
    } = options != null ? options : {};
    const {
      x,
      y,
      placement,
      rects,
      platform
    } = middlewareArguments;

    if (element == null) {
      if (process.env.NODE_ENV !== "production") {
        console.warn('Floating UI: No `element` was passed to the `arrow` middleware.');
      }

      return {};
    }

    const paddingObject = getSideObjectFromPadding(padding);
    const coords = {
      x,
      y
    };
    const basePlacement = getBasePlacement(placement);
    const axis = getMainAxisFromPlacement(basePlacement);
    const length = getLengthFromAxis(axis);
    const arrowDimensions = await platform.getDimensions({
      element
    });
    const minProp = axis === 'y' ? 'top' : 'left';
    const maxProp = axis === 'y' ? 'bottom' : 'right';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await platform.getOffsetParent({
      element
    });
    const clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    const centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside of the floating element's bounds

    const min = paddingObject[minProp];
    const max = clientSize - arrowDimensions[length] - paddingObject[maxProp];
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = within(min, center, max);
    return {
      data: {
        [axis]: offset,
        centerOffset: center - offset
      }
    };
  }

});

const hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, matched => hash$1[matched]);
}

function getAlignmentSides(placement, rects) {
  const isStart = getAlignment(placement) === 'start';
  const mainAxis = getMainAxisFromPlacement(placement);
  const length = getLengthFromAxis(mainAxis);
  let mainAlignmentSide = mainAxis === 'x' ? isStart ? 'right' : 'left' : isStart ? 'bottom' : 'top';

  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }

  return {
    main: mainAlignmentSide,
    cross: getOppositePlacement(mainAlignmentSide)
  };
}

const hash = {
  start: 'end',
  end: 'start'
};
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, matched => hash[matched]);
}

const basePlacements = ['top', 'right', 'bottom', 'left'];
const allPlacements = /*#__PURE__*/basePlacements.reduce((acc, basePlacement) => acc.concat(basePlacement, basePlacement + "-start", basePlacement + "-end"), []);

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getBasePlacement(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }

    return true;
  });
}
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'autoPlacement',
    options,

    async fn(middlewareArguments) {
      var _middlewareData$autoP, _middlewareData$autoP2, _middlewareData$autoP3, _middlewareData$autoP4, _middlewareData$autoP5, _placementsSortedByLe;

      const {
        x,
        y,
        rects,
        middlewareData,
        placement
      } = middlewareArguments;
      const {
        alignment = null,
        allowedPlacements = allPlacements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = options;

      if ((_middlewareData$autoP = middlewareData.autoPlacement) != null && _middlewareData$autoP.skip) {
        return {};
      }

      const placements = getPlacementList(alignment, autoAlignment, allowedPlacements);
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const currentIndex = (_middlewareData$autoP2 = (_middlewareData$autoP3 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP3.index) != null ? _middlewareData$autoP2 : 0;
      const currentPlacement = placements[currentIndex];
      const {
        main,
        cross
      } = getAlignmentSides(currentPlacement, rects); // Make `computeCoords` start from the right place

      if (placement !== currentPlacement) {
        return {
          x,
          y,
          reset: {
            placement: placements[0]
          }
        };
      }

      const currentOverflows = [overflow[getBasePlacement(currentPlacement)], overflow[main], overflow[cross]];
      const allOverflows = [...((_middlewareData$autoP4 = (_middlewareData$autoP5 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP5.overflows) != null ? _middlewareData$autoP4 : []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements[currentIndex + 1]; // There are more placements to check

      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }

      const placementsSortedByLeastOverflow = allOverflows.slice().sort((a, b) => a.overflows[0] - b.overflows[0]);
      const placementThatFitsOnAllSides = (_placementsSortedByLe = placementsSortedByLeastOverflow.find(_ref => {
        let {
          overflows
        } = _ref;
        return overflows.every(overflow => overflow <= 0);
      })) == null ? void 0 : _placementsSortedByLe.placement;
      return {
        data: {
          skip: true
        },
        reset: {
          placement: placementThatFitsOnAllSides != null ? placementThatFitsOnAllSides : placementsSortedByLeastOverflow[0].placement
        }
      };
    }

  };
};

function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}

const flip = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'flip',
    options,

    async fn(middlewareArguments) {
      var _middlewareData$flip, _middlewareData$flip2;

      const {
        placement,
        middlewareData,
        rects,
        initialPlacement
      } = middlewareArguments;

      if ((_middlewareData$flip = middlewareData.flip) != null && _middlewareData$flip.skip) {
        return {};
      }

      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        flipAlignment = true,
        ...detectOverflowOptions
      } = options;
      const basePlacement = getBasePlacement(placement);
      const isBasePlacement = basePlacement === initialPlacement;
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.overflows) || [];

      if (checkMainAxis) {
        overflows.push(overflow[basePlacement]);
      }

      if (checkCrossAxis) {
        const {
          main,
          cross
        } = getAlignmentSides(placement, rects);
        overflows.push(overflow[main], overflow[cross]);
      }

      overflowsData = [...overflowsData, {
        placement,
        overflows
      }]; // One or more sides is overflowing

      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip$, _middlewareData$flip3;

        const nextIndex = ((_middlewareData$flip$ = (_middlewareData$flip3 = middlewareData.flip) == null ? void 0 : _middlewareData$flip3.index) != null ? _middlewareData$flip$ : 0) + 1;
        const nextPlacement = placements[nextIndex];

        if (nextPlacement) {
          // Try next placement and re-run the lifecycle
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        let resetPlacement = 'bottom';

        switch (fallbackStrategy) {
          case 'bestFit':
            {
              var _overflowsData$slice$;

              const placement = (_overflowsData$slice$ = overflowsData.slice().sort((a, b) => a.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0) - b.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0))[0]) == null ? void 0 : _overflowsData$slice$.placement;

              if (placement) {
                resetPlacement = placement;
              }

              break;
            }

          case 'initialPlacement':
            resetPlacement = initialPlacement;
            break;
        }

        return {
          data: {
            skip: true
          },
          reset: {
            placement: resetPlacement
          }
        };
      }

      return {};
    }

  };
};

function convertValueToCoords(_ref) {
  let {
    placement,
    rects,
    value
  } = _ref;
  const basePlacement = getBasePlacement(placement);
  const multiplier = ['left', 'top'].includes(basePlacement) ? -1 : 1;
  const rawValue = typeof value === 'function' ? value({ ...rects,
    placement
  }) : value;
  const {
    mainAxis,
    crossAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0
  } : {
    mainAxis: 0,
    crossAxis: 0,
    ...rawValue
  };
  return getMainAxisFromPlacement(basePlacement) === 'x' ? {
    x: crossAxis,
    y: mainAxis * multiplier
  } : {
    x: mainAxis * multiplier,
    y: crossAxis
  };
}
const offset = function (value) {
  if (value === void 0) {
    value = 0;
  }

  return {
    name: 'offset',
    options: value,

    fn(middlewareArguments) {
      const {
        x,
        y,
        placement,
        rects
      } = middlewareArguments;
      const diffCoords = convertValueToCoords({
        placement,
        rects,
        value
      });
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }

  };
};

function getCrossAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

const shift = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'shift',
    options,

    async fn(middlewareArguments) {
      const {
        x,
        y,
        placement
      } = middlewareArguments;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = options;
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const mainAxis = getMainAxisFromPlacement(getBasePlacement(placement));
      const crossAxis = getCrossAxis(mainAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];

      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = within(min, mainAxisCoord, max);
      }

      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = within(min, crossAxisCoord, max);
      }

      const limitedCoords = limiter.fn({ ...middlewareArguments,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return { ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }

  };
};

const size = function (options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'size',
    options,

    async fn(middlewareArguments) {
      var _middlewareData$size;

      const {
        placement,
        rects,
        middlewareData
      } = middlewareArguments;
      const {
        apply,
        ...detectOverflowOptions
      } = options;

      if ((_middlewareData$size = middlewareData.size) != null && _middlewareData$size.skip) {
        return {};
      }

      const overflow = await detectOverflow(middlewareArguments, detectOverflowOptions);
      const basePlacement = getBasePlacement(placement);
      const isEnd = getAlignment(placement) === 'end';
      let heightSide;
      let widthSide;

      if (basePlacement === 'top' || basePlacement === 'bottom') {
        heightSide = basePlacement;
        widthSide = isEnd ? 'left' : 'right';
      } else {
        widthSide = basePlacement;
        heightSide = isEnd ? 'top' : 'bottom';
      }

      const xMin = max$1(overflow.left, 0);
      const xMax = max$1(overflow.right, 0);
      const yMin = max$1(overflow.top, 0);
      const yMax = max$1(overflow.bottom, 0);
      const dimensions = {
        height: rects.floating.height - (['left', 'right'].includes(placement) ? 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max$1(overflow.top, overflow.bottom)) : overflow[heightSide]),
        width: rects.floating.width - (['top', 'bottom'].includes(placement) ? 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right)) : overflow[widthSide])
      };
      apply == null ? void 0 : apply({ ...dimensions,
        ...rects
      });
      return {
        data: {
          skip: true
        },
        reset: {
          rects: true
        }
      };
    }

  };
};

function isWindow(value) {
  return (value == null ? void 0 : value.toString()) === '[object Window]';
}
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (!isWindow(node)) {
    const ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function getNodeName(node) {
  return isWindow(node) ? '' : node ? (node.nodeName || '').toLowerCase() : '';
}

function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function isShadowRoot(node) {
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  const {
    overflow,
    overflowX,
    overflowY
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  // TODO: Try and use feature detection here instead
  const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
  const css = getComputedStyle$1(element); // This is non-exhaustive but covers the most common CSS properties that
  // create a containing block.
  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

  return css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].includes(css.willChange) || isFirefox && css.willChange === 'filter' || isFirefox && (css.filter ? css.filter !== 'none' : false);
}

const min = Math.min;
const max = Math.max;
const round = Math.round;

function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  const clientRect = element.getBoundingClientRect();
  let scaleX = 1;
  let scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  return {
    width: clientRect.width / scaleX,
    height: clientRect.height / scaleY,
    top: clientRect.top / scaleY,
    right: clientRect.right / scaleX,
    bottom: clientRect.bottom / scaleY,
    left: clientRect.left / scaleX,
    x: clientRect.left / scaleX,
    y: clientRect.top / scaleY
  };
}

function getDocumentElement(node) {
  return ((isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}

function getNodeScroll(element) {
  if (isWindow(element)) {
    return {
      scrollLeft: element.pageXOffset,
      scrollTop: element.pageYOffset
    };
  }

  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

function isScaled(element) {
  const rect = getBoundingClientRect(element);
  return round(rect.width) !== element.offsetWidth || round(rect.height) !== element.offsetHeight;
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const rect = getBoundingClientRect(element, isOffsetParentAnElement && isScaled(offsetParent));
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // @ts-ignore
    node.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    node.parentNode || ( // DOM Element detected
    isShadowRoot(node) ? node.host : null) || // ShadowRoot detected
    getDocumentElement(node) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
}

function getContainingBlock(element) {
  let currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && !['html', 'body'].includes(getNodeName(currentNode))) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  const window = getWindow(element);
  let offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getDimensions(element) {
  return {
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);

  if (offsetParent === documentElement) {
    return rect;
  }

  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } // This doesn't appear to be need to be negated.
    // else if (documentElement) {
    //   offsets.x = getWindowScrollBarX(documentElement);
    // }

  }

  return { ...rect,
    x: rect.x - scroll.scrollLeft + offsets.x,
    y: rect.y - scroll.scrollTop + offsets.y
  };
}

function getViewportRect(element) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed

    if (Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) < 0.01) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width,
    height,
    x,
    y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  const width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  const height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width,
    height,
    x,
    y
  };
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].includes(getNodeName(node))) {
    // @ts-ignore assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

function getScrollParents(node, list) {
  var _node$ownerDocument;

  if (list === void 0) {
    list = [];
  }

  const scrollParent = getScrollParent(node);
  const isBody = scrollParent === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollParent);
  const target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  const updatedList = list.concat(target);
  return isBody ? updatedList : // @ts-ignore: isBody tells us target will be an HTMLElement here
  updatedList.concat(getScrollParents(getParentNode(target)));
}

function contains(parent, child) {
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    let next = child;

    do {
      // use `===` replace node.isSameNode()
      if (next && parent === next) {
        return true;
      } // @ts-ignore: need a better way to handle this...


      next = next.parentNode || next.host;
    } while (next);
  }

  return false;
}

function getInnerBoundingClientRect(element) {
  const clientRect = getBoundingClientRect(element);
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  return {
    top,
    left,
    x: left,
    y: top,
    right: left + element.clientWidth,
    bottom: top + element.clientHeight,
    width: element.clientWidth,
    height: element.clientHeight
  };
}

function getClientRectFromClippingParent(element, clippingParent) {
  if (clippingParent === 'viewport') {
    return rectToClientRect(getViewportRect(element));
  }

  if (isElement(clippingParent)) {
    return getInnerBoundingClientRect(clippingParent);
  }

  return rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  const clippingParents = getScrollParents(getParentNode(element));
  const canEscapeClipping = ['absolute', 'fixed'].includes(getComputedStyle$1(element).position);
  const clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // @ts-ignore isElement check ensures we return Array<Element>


  return clippingParents.filter(clippingParent => isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body');
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingClientRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary
  } = _ref;
  const mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  const clippingParents = [...mainClippingParents, rootBoundary];
  const firstClippingParent = clippingParents[0];
  const clippingRect = clippingParents.reduce((accRect, clippingParent) => {
    const rect = getClientRectFromClippingParent(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingParent(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

const platform = {
  getElementRects: _ref => {
    let {
      reference,
      floating,
      strategy
    } = _ref;
    return {
      reference: getRectRelativeToOffsetParent(reference, getOffsetParent(floating), strategy),
      floating: { ...getDimensions(floating),
        x: 0,
        y: 0
      }
    };
  },
  convertOffsetParentRelativeRectToViewportRelativeRect: args => convertOffsetParentRelativeRectToViewportRelativeRect(args),
  getOffsetParent: _ref2 => {
    let {
      element
    } = _ref2;
    return getOffsetParent(element);
  },
  isElement: value => isElement(value),
  getDocumentElement: _ref3 => {
    let {
      element
    } = _ref3;
    return getDocumentElement(element);
  },
  getClippingClientRect: args => getClippingClientRect(args),
  getDimensions: _ref4 => {
    let {
      element
    } = _ref4;
    return getDimensions(element);
  },
  getClientRects: _ref5 => {
    let {
      element
    } = _ref5;
    return element.getClientRects();
  }
};

const computePosition = (reference, floating, options) => computePosition$1(reference, floating, {
  platform,
  ...options
});

/*!
 * Vue.js v2.7.10
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return (isDef(val) &&
        typeof val.then === 'function' &&
        typeof val.catch === 'function');
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null
        ? ''
        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
            ? JSON.stringify(val, null, 2)
            : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    if (arr.length) {
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l
            ? l > 1
                ? fn.apply(ctx, arguments)
                : fn.call(ctx, a)
            : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) { }
/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function (_) { return _; };
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b)
        return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (a.length === b.length &&
                    a.every(function (e, i) {
                        return looseEqual(e, b[i]);
                    }));
            }
            else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            }
            else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return (keysA.length === keysB.length &&
                    keysA.every(function (key) {
                        return looseEqual(a[key], b[key]);
                    }));
            }
            else {
                /* istanbul ignore next */
                return false;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            return false;
        }
    }
    else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    }
    else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val))
            return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    }
    else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];

var config$1 = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: process.env.NODE_ENV !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: process.env.NODE_ENV !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj)
                return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE$1 = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS$1 = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive$1 = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                /* istanbul ignore next */
                supportsPassive$1 = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer =
                global['process'] && global['process'].env.VUE_ENV === 'server';
        }
        else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
}
else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */ (function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }());
}

var currentInstance = null;
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) { vm = null; }
    if (!vm)
        currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */ (function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function () {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}());
var createEmptyVNode = function (text) {
    if (text === void 0) { text = ''; }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var uid$2 = 0;
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */ (function () {
    function Dep() {
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        remove$2(this.subs, sub);
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (process.env.NODE_ENV !== 'production' && info && Dep.target.onTrack) {
                Dep.target.onTrack(__assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.slice();
        if (process.env.NODE_ENV !== 'production' && !config$1.async) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) { return a.id - b.id; });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            if (process.env.NODE_ENV !== 'production' && info) {
                var sub = subs[i];
                sub.onTrigger &&
                    sub.onTrigger(__assign({ effect: subs[i] }, info));
            }
            subs[i].update();
        }
    };
    return Dep;
}());
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted)
            ob.observeArray(inserted);
        // notify change
        if (process.env.NODE_ENV !== 'production') {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                target: this,
                key: method
            });
        }
        else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */ (function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                }
                else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        }
        else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}());
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (!isObject(value) || isRef(value) || value instanceof VNode) {
        return;
    }
    var ob;
    if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        ob = value.__ob__;
    }
    else if (shouldObserve &&
        (ssrMockReactivity || !isServerRendering()) &&
        (isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value.__v_skip /* ReactiveFlags.SKIP */) {
        ob = new Observer(value, shallow, ssrMockReactivity);
    }
    return ob;
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) &&
        (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = !shallow && observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (process.env.NODE_ENV !== 'production') {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (process.env.NODE_ENV !== 'production' && customSetter) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            }
            else if (getter) {
                // #7981: for accessor properties without setter
                return;
            }
            else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            }
            else {
                val = newVal;
            }
            childOb = !shallow && observe(newVal, false, mock);
            if (process.env.NODE_ENV !== 'production') {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */,
                    target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            }
            else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (process.env.NODE_ENV !== 'production' && (isUndef(target) || isPrimitive(target))) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        process.env.NODE_ENV !== 'production' && warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        process.env.NODE_ENV !== 'production' &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (process.env.NODE_ENV !== 'production') {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */,
            target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    }
    else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (process.env.NODE_ENV !== 'production' && (isUndef(target) || isPrimitive(target))) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        process.env.NODE_ENV !== 'production' &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        process.env.NODE_ENV !== 'production' &&
            warn("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (process.env.NODE_ENV !== 'production') {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */,
            target: target,
            key: key
        });
    }
    else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (process.env.NODE_ENV !== 'production') {
            if (isArray(target)) {
                warn("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (process.env.NODE_ENV !== 'production' && !ob) {
            if (target == null || isPrimitive(target)) {
                warn("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
}
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            }
            else {
                var ob = val && val.__ob__;
                if (ob)
                    ob.dep.depend();
                return val;
            }
        },
        set: function (value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            }
            else {
                source[key] = value;
            }
        }
    });
}

var activeEffectScope;
var EffectScope = /** @class */ (function () {
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        if (!detached && activeEffectScope) {
            this.parent = activeEffectScope;
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = currentEffectScope;
            }
        }
        else if (process.env.NODE_ENV !== 'production') {
            warn("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.active = false;
        }
    };
    return EffectScope;
}());
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) { scope = activeEffectScope; }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return (vm._provided = Object.create(parentProvides));
    }
    else {
        return existing;
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        }
        else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            process.env.NODE_ENV !== 'production' &&
                warn("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        }
        else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        }
        else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    }
    else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        }
        else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs, props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (process.env.NODE_ENV !== 'production') {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") +
                        "".concat(formatComponentName(
                        // @ts-expect-error tag is string
                        tag || Ctor), ", but the declared prop name is") +
                        " \"".concat(key, "\". ") +
                        "Note that HTML attributes are case-insensitive and camelCased " +
                        "props need to use their kebab-case equivalents when using in-DOM " +
                        "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) ||
                checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        }
        else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children)
        ? [createTextVNode(children)]
        : isArray(children)
            ? normalizeArrayChildren(children)
            : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean')
            continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        }
        else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            }
            else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        }
        else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            }
            else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null, i, l, keys, key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    }
    else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    }
    else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        }
        else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (process.env.NODE_ENV !== 'production' && !isObject(bindObject)) {
                warn('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes =
            scopedSlotFn(props) ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    else {
        nodes =
            this.$slots[name] ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    }
    else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    }
    else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config$1.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config$1.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    }
    else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    }
    else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            process.env.NODE_ENV !== 'production' &&
                warn('v-bind without argument expects an Object or Array value', this);
        }
        else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function (key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                }
                else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                        asProp || config$1.mustUseProp(tag, type, key)
                            ? data.domProps || (data.domProps = {})
                            : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    }
    else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            process.env.NODE_ENV !== 'production' && warn('v-on without argument expects an Object value', this);
        }
        else {
            var on = (data.on = data.on ? extend({}, data.on) : {});
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res, 
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        }
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        }
        else if (process.env.NODE_ENV !== 'production' && key !== '' && key !== null) {
            // null is a special value for explicitly removing a binding
            warn("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) &&
            data &&
            data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    }
    else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    }
    else if (isStable &&
        prevScopedSlots &&
        prevScopedSlots !== emptyObject &&
        key === prevScopedSlots.$key &&
        !hasNormalSlots &&
        !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    }
    else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function () {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
            res && typeof res === 'object' && !isArray(res)
                ? [res] // single vnode
                : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res &&
            (!vnode ||
                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
            ? undefined
            : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = (vm._setupContext = createSetupContext(vm));
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        }
        else if (isObject(setupResult)) {
            // bindings
            if (process.env.NODE_ENV !== 'production' && setupResult instanceof VNode) {
                warn("setup() should not return VNodes directly - " +
                    "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    }
                    else if (process.env.NODE_ENV !== 'production') {
                        warn("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            }
            else {
                // exposed for compiled render fn
                var proxy = (vm._setupProxy = {});
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        }
        else if (process.env.NODE_ENV !== 'production' && setupResult !== undefined) {
            warn("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = (vm._attrsProxy = {});
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = (vm._listenersProxy = {});
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind$1(vm.$emit, vm),
        expose: function (exposed) {
            if (process.env.NODE_ENV !== 'production') {
                if (exposeCalled) {
                    warn("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        }
        else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode
        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
        : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== 'production') {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, function () {
            !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
        }, true);
    }
    else {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        }
        catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (process.env.NODE_ENV !== 'production' && vm.$options.renderError) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                }
                catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            }
            else {
                vnode = vm._vnode;
            }
        }
        finally {
            currentRenderingInstance = null;
            setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (process.env.NODE_ENV !== 'production' && isArray(vnode)) {
                warn('Multiple root nodes returned from render function. Render function ' +
                    'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = (factory.owners = [owner]);
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
        var forceRender_1 = function (renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            }
            else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            process.env.NODE_ENV !== 'production' &&
                warn("Failed to resolve async component: ".concat(String(factory)) +
                    (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            }
            else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    }
                    else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1(process.env.NODE_ENV !== 'production' ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        process.env.NODE_ENV !== 'production' &&
            warn("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (process.env.NODE_ENV !== 'production' && isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
        warn('Avoid using non-primitive value as key, ' +
            'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    }
    else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = (context.$vnode && context.$vnode.ns) || config$1.getTagNamespace(tag);
        if (config$1.isReservedTag(tag)) {
            // platform built-in elements
            if (process.env.NODE_ENV !== 'production' &&
                isDef(data) &&
                isDef(data.nativeOn) &&
                data.tag !== 'component') {
                warn("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config$1.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        }
        else if ((!data || !data.pre) &&
            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        }
        else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    }
    else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    }
    else if (isDef(vnode)) {
        if (isDef(ns))
            applyNS(vnode, ns);
        if (isDef(data))
            registerDeepBindings(data);
        return vnode;
    }
    else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) &&
                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while ((cur = cur.$parent)) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture)
                                return;
                        }
                        catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    }
    finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
            res._handled = true;
        }
    }
    catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config$1.errorHandler) {
        try {
            return config$1.errorHandler.call(null, err, vm, info);
        }
        catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (process.env.NODE_ENV !== 'production') {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS$1)
            setTimeout(noop);
    };
    isUsingMicroTask = true;
}
else if (!isIE$1 &&
    typeof MutationObserver !== 'undefined' &&
    (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
}
else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
        setImmediate(flushCallbacks);
    };
}
else {
    // Fallback to setTimeout.
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            }
            catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        }
        else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.10';

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if ((!isA && !isObject(val)) ||
        Object.isFrozen(val) ||
        val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--)
            _traverse(val[i], seen);
    }
    else if (isRef(val)) {
        _traverse(val.value, seen);
    }
    else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--)
            _traverse(val[keys[i]], seen);
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */ (function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this, 
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm
            ? activeEffectScope
            : vm
                ? vm._scope
                : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (process.env.NODE_ENV !== 'production') {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        }
        else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression = process.env.NODE_ENV !== 'production' ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        }
        else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                process.env.NODE_ENV !== 'production' &&
                    warn("Failed watching path: \"".concat(expOrFn, "\" ") +
                        'Watcher only accepts simple dot-delimited paths. ' +
                        'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        }
        catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            }
            else {
                throw e;
            }
        }
        finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        }
        else if (this.sync) {
            this.run();
        }
        else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
                // Deep watchers and watchers on Object/Arrays should fire even
                // when the value is the same, because the value may
                // have mutated.
                isObject(value) ||
                this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                }
                else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}());

var mark;
var measure;
if (process.env.NODE_ENV !== 'production') {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
        // @ts-ignore
        perf_1.mark &&
        // @ts-ignore
        perf_1.measure &&
        // @ts-ignore
        perf_1.clearMarks &&
        // @ts-ignore
        perf_1.clearMeasures) {
        mark = function (tag) { return perf_1.mark(tag); };
        measure = function (name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        }
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (process.env.NODE_ENV !== 'production') {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") +
                    "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") +
                    "Note that HTML attributes are case-insensitive and you cannot use " +
                    "v-on to listen to camelCase events when using in-DOM templates. " +
                    "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        }
        else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper &&
            wrapper.$vnode &&
            wrapper.$parent &&
            wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (process.env.NODE_ENV !== 'production') {
            /* istanbul ignore if */
            if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
                vm.$options.el ||
                el) {
                warn('You are using the runtime-only build of Vue where the template ' +
                    'compiler is not available. Either pre-compile the templates into ' +
                    'render functions, or use the compiler-included build.', vm);
            }
            else {
                warn('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (process.env.NODE_ENV !== 'production' && config$1.performance && mark) {
        updateComponent = function () {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    }
    else {
        updateComponent = function () {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function () {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (process.env.NODE_ENV !== 'production') {
        watcherOptions.onTrack = function (e) { return callHook$1(vm, 'renderTracked', [e]); };
        watcherOptions.onTrigger = function (e) { return callHook$1(vm, 'renderTriggered', [e]); };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (process.env.NODE_ENV !== 'production') {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key));
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (process.env.NODE_ENV !== 'production') {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive)
            return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) { setContext = true; }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prev = currentInstance;
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    setContext && setCurrentInstance(prev);
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index = queue.length = activatedChildren.length = 0;
    has = {};
    if (process.env.NODE_ENV !== 'production') {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE$1) {
    var performance_1 = window.performance;
    if (performance_1 &&
        typeof performance_1.now === 'function' &&
        getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () { return performance_1.now(); };
    }
}
var sortCompareFn = function (a, b) {
    if (a.post) {
        if (!b.post)
            return 1;
    }
    else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index = 0; index < queue.length; index++) {
        watcher = queue[index];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (process.env.NODE_ENV !== 'production' && has[id] != null) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn('You may have an infinite update loop ' +
                    (watcher.user
                        ? "in watcher with expression \"".concat(watcher.expression, "\"")
                        : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config$1.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    }
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (process.env.NODE_ENV !== 'production' && !config$1.async) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption)
            ? provideOption.call(vm)
            : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (process.env.NODE_ENV !== 'production') {
                defineReactive(vm, key, result[key], function () {
                    warn("Avoid mutating an injected value directly since the changes will be " +
                        "overwritten whenever the provided component re-renders. " +
                        "injection being mutated: \"".concat(key, "\""), vm);
                });
            }
            else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__')
                continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            }
            else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
            }
            else if (process.env.NODE_ENV !== 'production') {
                warn("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    }
    else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function () {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    }
    else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    }
    else {
        if (isDef(data.attrs))
            mergeProps(props, data.attrs);
        if (isDef(data.props))
            mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    }
    else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (process.env.NODE_ENV !== 'production') {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
            renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function (vnode, hydrating) {
        if (vnode.componentInstance &&
            !vnode.componentInstance._isDestroyed &&
            vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        }
        else {
            var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function (oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function (vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            }
            else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function (vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            }
            else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (process.env.NODE_ENV !== 'production') {
            warn("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode, 
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    }
    else {
        on[event] = callback;
    }
}

var warn = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (process.env.NODE_ENV !== 'production') {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function (str) {
        return str.replace(classifyRE_1, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, '');
    };
    warn = function (msg, vm) {
        if (vm === void 0) { vm = currentInstance; }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config$1.warnHandler) {
            config$1.warnHandler.call(null, msg, vm, trace);
        }
        else if (hasConsole_1 && !config$1.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function (msg, vm) {
        if (hasConsole_1 && !config$1.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function (vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null
            ? vm.options
            : vm._isVue
                ? vm.$options || vm.constructor.options
                : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return ((name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
            (file && includeFile !== false ? " at ".concat(file) : ''));
    };
    var repeat_1 = function (str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1)
                res += str;
            if (n > 1)
                str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function (vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    }
                    else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return ('\n\nfound in\n\n' +
                tree
                    .map(function (vm, i) {
                    return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm)
                        ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)")
                        : formatComponentName(vm));
                })
                    .join('\n'));
        }
        else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config$1.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (process.env.NODE_ENV !== 'production') {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn("option \"".concat(key, "\" can only be used during instance ") +
                'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from) {
    if (!from)
        return to;
    var key, toVal, fromVal;
    var keys = hasSymbol
        ? Reflect.ownKeys(from)
        : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            set(to, key, fromVal);
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    }
    else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal)
                ? childVal.call(vm, vm)
                : childVal;
            var defaultData = isFunction(parentVal)
                ? parentVal.call(vm, vm)
                : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            }
            else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            process.env.NODE_ENV !== 'production' &&
                warn('The "data" option should be a function ' +
                    'that returns a per-instance value in component ' +
                    'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal
        ? parentVal
            ? parentVal.concat(childVal)
            : isArray(childVal)
                ? childVal
                : [childVal]
        : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        process.env.NODE_ENV !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    }
    else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch)
        parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch)
        childVal = undefined;
    /* istanbul ignore if */
    if (!childVal)
        return Object.create(parentVal || null);
    if (process.env.NODE_ENV !== 'production') {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal)
        return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props =
    strats.methods =
        strats.inject =
            strats.computed =
                function (parentVal, childVal, vm, key) {
                    if (childVal && process.env.NODE_ENV !== 'production') {
                        assertObjectType(key, childVal, vm);
                    }
                    if (!parentVal)
                        return childVal;
                    var ret = Object.create(null);
                    extend(ret, parentVal);
                    if (childVal)
                        extend(ret, childVal);
                    return ret;
                };
strats.provide = mergeDataOrFn;
/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn('Invalid component name: "' +
            name +
            '". Component names ' +
            'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config$1.isReservedTag(name)) {
        warn('Do not use built-in or reserved HTML elements as component ' +
            'id: ' +
            name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props)
        return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            }
            else if (process.env.NODE_ENV !== 'production') {
                warn('props must be strings when using array syntax.');
            }
        }
    }
    else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    }
    else if (process.env.NODE_ENV !== 'production') {
        warn("Invalid value for option \"props\": expected an Array or an Object, " +
            "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject)
        return;
    var normalized = (options.inject = {});
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    }
    else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val)
                ? extend({ from: key }, val)
                : { from: val };
        }
    }
    else if (process.env.NODE_ENV !== 'production') {
        warn("Invalid value for option \"inject\": expected an Array or an Object, " +
            "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn("Invalid value for option \"".concat(name, "\": expected an Object, ") +
            "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (process.env.NODE_ENV !== 'production') {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id))
        return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId))
        return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId))
        return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (process.env.NODE_ENV !== 'production' && warnMissing && !res) {
        warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        }
        else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (process.env.NODE_ENV !== 'production') {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (process.env.NODE_ENV !== 'production' && isObject(def)) {
        warn('Invalid default value for prop "' +
            key +
            '": ' +
            'Props with type Object/Array must use a factory function ' +
            'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function'
        ? def.call(vm)
        : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
    if (!valid && haveExpectedTypes) {
        warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        try {
            valid = value instanceof type;
        }
        catch (e) {
            warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
        " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    }
    else if (type === 'Number') {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (process.env.NODE_ENV !== 'production') {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
        'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
        'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
        'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function (target, key) {
        warn("Property or method \"".concat(key, "\" is not defined on the instance but ") +
            'referenced during render. Make sure that this property is reactive, ' +
            'either in the data option, or for class-based components, by ' +
            'initializing the property. ' +
            'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function (target, key) {
        warn("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") +
            'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
            'prevent conflicts with Vue internals. ' +
            'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config$1.keyCodes = new Proxy(config$1.keyCodes, {
            set: function (target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                }
                else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function (target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) ||
                (typeof key === 'string' &&
                    key.charAt(0) === '_' &&
                    !(key in target.$data));
            if (!has && !isAllowed) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function (target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        }
        else {
            vm._renderProxy = vm;
        }
    };
}

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props)
        initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods)
        initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    }
    else {
        var ob = observe((vm._data = {}));
        ob && ob.vmCount++;
    }
    if (opts.computed)
        initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = (vm._props = shallowReactive({}));
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = (vm.$options._propKeys = []);
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (process.env.NODE_ENV !== 'production') {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) ||
                config$1.isReservedAttr(hyphenatedKey)) {
                warn("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn("Avoid mutating a prop directly since the value will be " +
                        "overwritten whenever the parent component re-renders. " +
                        "Instead, use a data or computed property based on the prop's " +
                        "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            });
        }
        else {
            defineReactive(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        process.env.NODE_ENV !== 'production' &&
            warn('data functions should return an object:\n' +
                'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (process.env.NODE_ENV !== 'production') {
            if (methods && hasOwn(methods, key)) {
                warn("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            process.env.NODE_ENV !== 'production' &&
                warn("The data property \"".concat(key, "\" is already declared as a prop. ") +
                    "Use prop default value instead.", vm);
        }
        else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    }
    catch (e) {
        handleError(e, vm, "data()");
        return {};
    }
    finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = (vm._computedWatchers = Object.create(null));
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (process.env.NODE_ENV !== 'production' && getter == null) {
            warn("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        }
        else if (process.env.NODE_ENV !== 'production') {
            if (key in vm.$data) {
                warn("The computed property \"".concat(key, "\" is already defined in data."), vm);
            }
            else if (vm.$options.props && key in vm.$options.props) {
                warn("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            }
            else if (vm.$options.methods && key in vm.$options.methods) {
                warn("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache
            ? createComputedGetter(key)
            : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    }
    else {
        sharedPropertyDefinition.get = userDef.get
            ? shouldCache && userDef.cache !== false
                ? createComputedGetter(key)
                : createGetterInvoker(userDef.get)
            : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (process.env.NODE_ENV !== 'production' && sharedPropertyDefinition.set === noop) {
        sharedPropertyDefinition.set = function () {
            warn("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (process.env.NODE_ENV !== 'production' && Dep.target.onTrack) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (process.env.NODE_ENV !== 'production') {
            if (typeof methods[key] !== 'function') {
                warn("Method \"".concat(key, "\" has type \"").concat(typeof methods[key], "\" in the component definition. ") +
                    "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") +
                    "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        }
        else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (process.env.NODE_ENV !== 'production') {
        dataDef.set = function () {
            warn('Avoid replacing instance root $data. ' +
                'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production' && config$1.performance && mark) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        }
        else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (process.env.NODE_ENV !== 'production') {
            initProxy(vm);
        }
        else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production' && config$1.performance && mark) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = (vm.$options = Object.create(vm.constructor.options));
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified)
                modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function Vue(options) {
    if (process.env.NODE_ENV !== 'production' && !(this instanceof Vue)) {
        warn('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        }
        else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (process.env.NODE_ENV !== 'production' && name) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            }
            else {
                /* istanbul ignore if */
                if (process.env.NODE_ENV !== 'production' && type === 'component') {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches$1(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    }
    else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function () {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function () {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function () {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) { return matches$1(val, name); });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) { return !matches$1(val, name); });
        });
    },
    updated: function () {
        this.cacheVNode();
    },
    render: function () {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (
            // not included
            (include && (!name_2 || !matches$1(include, name_2))) ||
                // excluded
                (exclude && name_2 && matches$1(exclude, name_2))) {
                return vnode;
            }
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null
                ? // same constructor may get registered as different local components
                    // so cid alone is not enough (#3269)
                    componentOptions.Ctor.cid +
                        (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            }
            else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config$1; };
    if (process.env.NODE_ENV !== 'production') {
        configDef.set = function () {
            warn('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function () {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
        (attr === 'selected' && tag === 'option') ||
        (attr === 'checked' && tag === 'input') ||
        (attr === 'muted' && tag === 'video'));
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
        ? 'false'
        : // allow arbitrary string value for contenteditable
            key === 'contenteditable' && isValidContentEditableValue(value)
                ? value
                : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,' +
    'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function (val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? (b ? a + ' ' + b : a) : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
            el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
    }
    else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            process.env.NODE_ENV !== 'production' && warn('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    }
    else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createElement: createElement,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

var ref = {
    create: function (_, vnode) {
        registerRef(vnode);
    },
    update: function (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function (vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref))
        return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            }
            else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    }
                    else {
                        ref.value = [refValue];
                    }
                }
                else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        }
        else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        }
        else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        }
        else if (process.env.NODE_ENV !== 'production') {
            warn("Invalid template ref type: ".concat(typeof ref));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        }
        else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return (a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
            a.isComment === b.isComment &&
            isDef(a.data) === isDef(b.data) &&
            sameInputType(a, b)) ||
            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
}
function sameInputType(a, b) {
    if (a.tag !== 'input')
        return true;
    var i;
    var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
    var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key))
            map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return (!inVPre &&
            !vnode.ns &&
            !(config$1.ignoredElements.length &&
                config$1.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                        ? ignore.test(vnode.tag)
                        : ignore === vnode.tag;
                })) &&
            config$1.isUnknownElement(vnode.tag));
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (process.env.NODE_ENV !== 'production') {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn('Unknown custom element: <' +
                        tag +
                        '> - did you ' +
                        'register the component correctly? For recursive components, ' +
                        'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns
                ? nodeOps.createElementNS(vnode.ns, tag)
                : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (process.env.NODE_ENV !== 'production' && data && data.pre) {
                creatingElmInVPre--;
            }
        }
        else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
        else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef((i = i.hook)) && isDef((i = i.init))) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        }
        else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            }
            else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (process.env.NODE_ENV !== 'production') {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        }
        else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create))
                i.create(emptyNode, vnode);
            if (isDef(i.insert))
                insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
        else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef((i = activeInstance)) &&
            i !== vnode.context &&
            i !== vnode.fnContext &&
            isDef((i = i.$options._scopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
        }
        if (isDef((i = vnode.children))) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                }
                else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            }
            else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef((i_3 = vnode.componentInstance)) &&
                isDef((i_3 = i_3._vnode)) &&
                isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                i_3(vnode, rm);
            }
            else {
                rm();
            }
        }
        else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (process.env.NODE_ENV !== 'production') {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            }
            else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove &&
                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    }
                    else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                }
                else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c))
                return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = (vnode.elm = oldVnode.elm);
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            }
            else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) &&
            isTrue(oldVnode.isStatic) &&
            vnode.key === oldVnode.key &&
            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            if (isDef((i = data.hook)) && isDef((i = i.update)))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
            else if (isDef(ch)) {
                if (process.env.NODE_ENV !== 'production') {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text))
                    nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        }
        else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (process.env.NODE_ENV !== 'production') {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.init)))
                i(vnode, true /* hydrating */);
            if (isDef((i = vnode.componentInstance))) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                }
                else {
                    // v-html and domProps: innerHTML
                    if (isDef((i = data)) &&
                        isDef((i = i.domProps)) &&
                        isDef((i = i.innerHTML))) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (process.env.NODE_ENV !== 'production' &&
                                typeof console !== 'undefined' &&
                                !hydrationBailed) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    }
                    else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode ||
                                !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (process.env.NODE_ENV !== 'production' &&
                                typeof console !== 'undefined' &&
                                !hydrationBailed) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        }
        else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return (vnode.tag.indexOf('vue-component') === 0 ||
                (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                        (node.tagName && node.tagName.toLowerCase())));
        }
        else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode))
                invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        }
        else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            }
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                        else if (process.env.NODE_ENV !== 'production') {
                            warn('The client-side rendered virtual DOM tree is not matching ' +
                                'server-rendered content. This is likely caused by incorrect ' +
                                'HTML markup, for example nesting block-level elements inside ' +
                                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                                'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, 
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                for (var i_10 = 1; i_10 < insert_1.fns.length; i_10++) {
                                    insert_1.fns[i_10]();
                                }
                            }
                        }
                        else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                }
                else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        }
        else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function () {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        }
        else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef,
                };
            }
            else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        }
        catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE$1 || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            }
            else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    }
    else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        }
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    }
    else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    }
    else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    }
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE$1 &&
            !isIE9 &&
            el.tagName === 'TEXTAREA' &&
            key === 'placeholder' &&
            value !== '' &&
            !el.__ieph) {
            var blocker_1 = function (e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass = {
    create: updateClass,
    update: updateClass
};

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE$1 ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
                // event is fired after handler attachment
                e.timeStamp >= attachedTimestamp_1 ||
                // bail for environments that have buggy event.timeStamp implementations
                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                // #9681 QtWebEngine event.timeStamp is negative value
                e.timeStamp <= 0 ||
                // #9448 bail if event is fired in another document in a multi-page
                // electron/nw.js app, since event.timeStamp will be using a different
                // starting reference
                e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive$1 ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name, 
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children)
                vnode.children.length = 0;
            if (cur === oldProps[key])
                continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        }
        else if (key === 'innerHTML' &&
            isSVG(elm.tagName) &&
            isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        }
        else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            }
            catch (e) { }
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
    //@ts-expect-error
    !elm.composing &&
        (elm.tagName === 'OPTION' ||
            isNotInFocusAndDirty(elm, checkVal) ||
            isDirtyWithModifiers(elm, checkVal)));
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    }
    catch (e) { }
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode &&
                childNode.data &&
                (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while ((parentNode = parentNode.parent)) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    }
    else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    }
    else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        }
        else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
        }
    }
}
var style = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
        }
        else {
            el.classList.add(cls);
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
        }
        else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        }
        else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if (typeof def === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    }
    else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
    ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
    : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
function nextFrame$1(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type)
        return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function (e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (process.env.NODE_ENV !== 'production' && explicitEnterDuration != null) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        }
        else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    }));
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode &&
                pendingNode.tag === vnode.tag &&
                pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame$1(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    }
                    else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (process.env.NODE_ENV !== 'production' && isDef(explicitLeaveDuration)) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        }
        else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    }));
    if (delayLeave) {
        delayLeave(performLeave);
    }
    else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame$1(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        }
                        else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn("<transition> explicit ".concat(name, " duration is not a valid number - ") +
            "got ".concat(JSON.stringify(val), "."), vnode.context);
    }
    else if (isNaN(val)) {
        warn("<transition> explicit ".concat(name, " duration is NaN - ") +
            'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    }
    else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser
    ? {
        create: _enter,
        activate: _enter,
        remove: function (vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
                // @ts-expect-error
                leave(vnode, rm);
            }
            else {
                rm();
            }
        }
    }
    : {};

var platformModules = [attrs, klass, events, domProps, style, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            }
            else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        }
        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function (el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
            if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple
                    ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                    : binding.value !== binding.oldValue &&
                        hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE$1 || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        process.env.NODE_ENV !== 'production' &&
            warn("<select multiple v-model=\"".concat(binding.expression, "\"> ") +
                "expects an Array value for its binding, but got ".concat(Object.prototype.toString
                    .call(value)
                    .slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        }
        else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) { return !looseEqual(o, value); });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing)
        return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
}
var show = {
    bind: function (el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
            el.style.display === 'none' ? '' : el.style.display);
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        }
        else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue)
            return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            }
            else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        }
        else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    }
    else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
var isVShowDirective = function (d) { return d.name === 'show'; };
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function (h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (process.env.NODE_ENV !== 'production' && children.length > 1) {
            warn('<transition> can only be used on a single element. Use ' +
                '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (process.env.NODE_ENV !== 'production' && mode && mode !== 'in-out' && mode !== 'out-in') {
            warn('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key =
            child.key == null
                ? child.isComment
                    ? id + 'comment'
                    : id + child.tag
                : isPrimitive(child.key)
                    ? String(child.key).indexOf(id) === 0
                        ? child.key
                        : id + child.key
                    : child.key;
        var data = ((child.data || (child.data = {})).transition =
            extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild &&
            oldChild.data &&
            !isSameChild(child, oldChild) &&
            !isAsyncPlaceholder(oldChild) &&
            // #6687 component root is a comment node
            !(oldChild.componentInstance &&
                oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = (oldChild.data.transition = extend({}, data));
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            }
            else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function () {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function () {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function (h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                }
                else if (process.env.NODE_ENV !== 'production') {
                    var opts = c.componentOptions;
                    var name_1 = opts
                        ? getComponentName(opts.Ctor.options) || opts.tag || ''
                        : c.tag;
                    warn("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                }
                else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function () {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                }));
            }
        });
    },
    methods: {
        hasMove: function (el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return (this._hasMove = info.hasTransform);
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config$1.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            }
            else if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
                    'https://github.com/vuejs/vue-devtools');
            }
        }
        if (process.env.NODE_ENV !== 'production' &&
            process.env.NODE_ENV !== 'test' &&
            config$1.productionTip !== false &&
            typeof console !== 'undefined') {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" +
                "Make sure to turn on production mode when deploying for production.\n" +
                "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function assign(to, from) {
  for (const key in from) {
    if (Object.prototype.hasOwnProperty.call(from, key)) {
      if (typeof from[key] === "object" && to[key]) {
        assign(to[key], from[key]);
      } else {
        to[key] = from[key];
      }
    }
  }
}
const config = {
  disabled: false,
  distance: 5,
  skidding: 0,
  container: "body",
  boundary: void 0,
  instantMove: false,
  disposeTimeout: 5e3,
  popperTriggers: [],
  strategy: "absolute",
  preventOverflow: true,
  flip: true,
  shift: true,
  overflowPadding: 0,
  arrowPadding: 0,
  arrowOverflow: true,
  themes: {
    tooltip: {
      placement: "top",
      triggers: ["hover", "focus", "touch"],
      hideTriggers: (events) => [...events, "click"],
      delay: {
        show: 200,
        hide: 0
      },
      handleResize: false,
      html: false,
      loadingContent: "..."
    },
    dropdown: {
      placement: "bottom",
      triggers: ["click"],
      delay: 0,
      handleResize: true,
      autoHide: true
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover", "focus"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function getDefaultConfig(theme, key) {
  let themeConfig = config.themes[theme] || {};
  let value;
  do {
    value = themeConfig[key];
    if (typeof value === "undefined") {
      if (themeConfig.$extend) {
        themeConfig = config.themes[themeConfig.$extend] || {};
      } else {
        themeConfig = null;
        value = config[key];
      }
    } else {
      themeConfig = null;
    }
  } while (themeConfig);
  return value;
}
function getThemeClasses(theme) {
  const result = [theme];
  let themeConfig = config.themes[theme] || {};
  do {
    if (themeConfig.$extend && !themeConfig.$resetCss) {
      result.push(themeConfig.$extend);
      themeConfig = config.themes[themeConfig.$extend] || {};
    } else {
      themeConfig = null;
    }
  } while (themeConfig);
  return result.map((c) => `v-popper--theme-${c}`);
}
function getAllParentThemes(theme) {
  const result = [theme];
  let themeConfig = config.themes[theme] || {};
  do {
    if (themeConfig.$extend) {
      result.push(themeConfig.$extend);
      themeConfig = config.themes[themeConfig.$extend] || {};
    } else {
      themeConfig = null;
    }
  } while (themeConfig);
  return result;
}
let supportsPassive = false;
if (typeof window !== "undefined") {
  supportsPassive = false;
  try {
    const opts = Object.defineProperty({}, "passive", {
      get() {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {
  }
}
let isIOS = false;
if (typeof window !== "undefined" && typeof navigator !== "undefined") {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}
const placements = ["auto", "top", "bottom", "left", "right"].reduce((acc, base) => acc.concat([
  base,
  `${base}-start`,
  `${base}-end`
]), []);
const SHOW_EVENT_MAP = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart"
};
const HIDE_EVENT_MAP = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend"
};
function removeFromArray(array, item) {
  const index = array.indexOf(item);
  if (index !== -1) {
    array.splice(index, 1);
  }
}
function nextFrame() {
  return new Promise((resolve) => requestAnimationFrame(() => {
    requestAnimationFrame(resolve);
  }));
}
const shownPoppers = [];
let hidingPopper = null;
const shownPoppersByTheme = {};
function getShownPoppersByTheme(theme) {
  let list = shownPoppersByTheme[theme];
  if (!list) {
    list = shownPoppersByTheme[theme] = [];
  }
  return list;
}
let Element$1 = function() {
};
if (typeof window !== "undefined") {
  Element$1 = window.Element;
}
function defaultPropFactory(prop) {
  return function() {
    const props = this.$props;
    return getDefaultConfig(props.theme, prop);
  };
}
const PROVIDE_KEY = "__floating-vue__popper";
var PrivatePopper = () => ({
  name: "VPopper",
  props: {
    theme: {
      type: String,
      required: true
    },
    targetNodes: {
      type: Function,
      required: true
    },
    referenceNode: {
      type: Function,
      required: true
    },
    popperNode: {
      type: Function,
      required: true
    },
    shown: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: String,
      default: null
    },
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: defaultPropFactory("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: defaultPropFactory("positioningDisabled")
    },
    placement: {
      type: String,
      default: defaultPropFactory("placement"),
      validator: (value) => placements.includes(value)
    },
    delay: {
      type: [String, Number, Object],
      default: defaultPropFactory("delay")
    },
    distance: {
      type: [Number, String],
      default: defaultPropFactory("distance")
    },
    skidding: {
      type: [Number, String],
      default: defaultPropFactory("skidding")
    },
    triggers: {
      type: Array,
      default: defaultPropFactory("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: defaultPropFactory("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: defaultPropFactory("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: defaultPropFactory("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: defaultPropFactory("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: defaultPropFactory("popperHideTriggers")
    },
    container: {
      type: [String, Object, Element$1, Boolean],
      default: defaultPropFactory("container")
    },
    boundary: {
      type: [String, Element$1],
      default: defaultPropFactory("boundary")
    },
    strategy: {
      type: String,
      validator: (value) => ["absolute", "fixed"].includes(value),
      default: defaultPropFactory("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: defaultPropFactory("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: defaultPropFactory("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: defaultPropFactory("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: defaultPropFactory("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: defaultPropFactory("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: defaultPropFactory("computeTransformOrigin")
    },
    autoMinSize: {
      type: Boolean,
      default: defaultPropFactory("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: defaultPropFactory("autoSize")
    },
    autoMaxSize: {
      type: Boolean,
      default: defaultPropFactory("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: defaultPropFactory("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: defaultPropFactory("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: defaultPropFactory("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: defaultPropFactory("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: defaultPropFactory("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: defaultPropFactory("flip")
    },
    shift: {
      type: Boolean,
      default: defaultPropFactory("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: defaultPropFactory("shiftCrossAxis")
    }
  },
  provide() {
    return {
      [PROVIDE_KEY]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [PROVIDE_KEY]: { default: null }
  },
  data() {
    return {
      isShown: false,
      isMounted: false,
      skipTransition: false,
      classes: {
        showFrom: false,
        showTo: false,
        hideFrom: false,
        hideTo: true
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: true
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide === "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: __spreadProps(__spreadValues({}, this.classes), {
          popperClass: this.popperClass
        }),
        result: this.positioningDisabled ? null : this.result
      };
    },
    parentPopper() {
      var _a;
      return (_a = this[PROVIDE_KEY]) == null ? void 0 : _a.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var _a, _b;
      return ((_a = this.popperTriggers) == null ? void 0 : _a.includes("hover")) || ((_b = this.popperShowTriggers) == null ? void 0 : _b.includes("hover"));
    }
  },
  watch: __spreadValues(__spreadValues({
    shown: "$_autoShowHide",
    disabled(value) {
      if (value) {
        this.dispose();
      } else {
        this.init();
      }
    },
    async container() {
      if (this.isShown) {
        this.$_ensureTeleport();
        await this.$_computePosition();
      }
    }
  }, [
    "triggers",
    "positioningDisabled"
  ].reduce((acc, prop) => {
    acc[prop] = "$_refreshListeners";
    return acc;
  }, {})), [
    "placement",
    "distance",
    "skidding",
    "boundary",
    "strategy",
    "overflowPadding",
    "arrowPadding",
    "preventOverflow",
    "shift",
    "shiftCrossAxis",
    "flip"
  ].reduce((acc, prop) => {
    acc[prop] = "$_computePosition";
    return acc;
  }, {})),
  created() {
    this.$_isDisposed = true;
    this.randomId = `popper_${[Math.random(), Date.now()].map((n) => n.toString(36).substring(2, 10)).join("_")}`;
    if (this.autoMinSize) {
      console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.');
    }
    if (this.autoMaxSize) {
      console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
    }
  },
  mounted() {
    this.init();
    this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeDestroy() {
    this.dispose();
  },
  methods: {
    show({ event = null, skipDelay = false, force = false } = {}) {
      var _a, _b;
      if (((_a = this.parentPopper) == null ? void 0 : _a.lockedChild) && this.parentPopper.lockedChild !== this)
        return;
      this.$_pendingHide = false;
      if (force || !this.disabled) {
        if (((_b = this.parentPopper) == null ? void 0 : _b.lockedChild) === this) {
          this.parentPopper.lockedChild = null;
        }
        this.$_scheduleShow(event, skipDelay);
        this.$emit("show");
        this.$_showFrameLocked = true;
        requestAnimationFrame(() => {
          this.$_showFrameLocked = false;
        });
      }
      this.$emit("update:shown", true);
    },
    hide({ event = null, skipDelay = false, skipAiming = false } = {}) {
      var _a;
      if (this.$_hideInProgress)
        return;
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = true;
        return;
      }
      if (!skipAiming && this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
        if (this.parentPopper) {
          this.parentPopper.lockedChild = this;
          clearTimeout(this.parentPopper.lockedChildTimer);
          this.parentPopper.lockedChildTimer = setTimeout(() => {
            if (this.parentPopper.lockedChild === this) {
              this.parentPopper.lockedChild.hide({ skipDelay });
              this.parentPopper.lockedChild = null;
            }
          }, 1e3);
        }
        return;
      }
      if (((_a = this.parentPopper) == null ? void 0 : _a.lockedChild) === this) {
        this.parentPopper.lockedChild = null;
      }
      this.$_pendingHide = false;
      this.$_scheduleHide(event, skipDelay);
      this.$emit("hide");
      this.$emit("update:shown", false);
    },
    init() {
      if (!this.$_isDisposed)
        return;
      this.$_isDisposed = false;
      this.isMounted = false;
      this.$_events = [];
      this.$_preventShow = false;
      this.$_referenceNode = this.referenceNode();
      this.$_targetNodes = this.targetNodes().filter((e) => e.nodeType === e.ELEMENT_NODE);
      this.$_popperNode = this.popperNode();
      this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner");
      this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container");
      this.$_swapTargetAttrs("title", "data-original-title");
      this.$_detachPopperNode();
      if (this.triggers.length) {
        this.$_addEventListeners();
      }
      if (this.shown) {
        this.show();
      }
    },
    dispose() {
      if (this.$_isDisposed)
        return;
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({ skipDelay: true });
      this.$_detachPopperNode();
      this.isMounted = false;
      this.isShown = false;
      this.$_updateParentShownChildren(false);
      this.$_swapTargetAttrs("data-original-title", "title");
      this.$emit("dispose");
    },
    async onResize() {
      if (this.isShown) {
        await this.$_computePosition();
        this.$emit("resize");
      }
    },
    async $_computePosition() {
      var _a;
      if (this.$_isDisposed || this.positioningDisabled)
        return;
      const options2 = {
        strategy: this.strategy,
        middleware: []
      };
      if (this.distance || this.skidding) {
        options2.middleware.push(offset({
          mainAxis: this.distance,
          crossAxis: this.skidding
        }));
      }
      const isPlacementAuto = this.placement.startsWith("auto");
      if (isPlacementAuto) {
        options2.middleware.push(autoPlacement({
          alignment: (_a = this.placement.split("-")[1]) != null ? _a : ""
        }));
      } else {
        options2.placement = this.placement;
      }
      if (this.preventOverflow) {
        if (this.shift) {
          options2.middleware.push(shift({
            padding: this.overflowPadding,
            boundary: this.boundary,
            crossAxis: this.shiftCrossAxis
          }));
        }
        if (!isPlacementAuto && this.flip) {
          options2.middleware.push(flip({
            padding: this.overflowPadding,
            boundary: this.boundary
          }));
        }
      }
      options2.middleware.push(arrow({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      }));
      if (this.arrowOverflow) {
        options2.middleware.push({
          name: "arrowOverflow",
          fn: ({ placement, rects, middlewareData }) => {
            let overflow;
            const { centerOffset } = middlewareData.arrow;
            if (placement.startsWith("top") || placement.startsWith("bottom")) {
              overflow = Math.abs(centerOffset) > rects.reference.width / 2;
            } else {
              overflow = Math.abs(centerOffset) > rects.reference.height / 2;
            }
            return {
              data: {
                overflow
              }
            };
          }
        });
      }
      if (this.autoMinSize || this.autoSize) {
        const autoSize = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        options2.middleware.push({
          name: "autoSize",
          fn: ({ rects, placement, middlewareData }) => {
            var _a2;
            if ((_a2 = middlewareData.autoSize) == null ? void 0 : _a2.skip) {
              return {};
            }
            let width;
            let height;
            if (placement.startsWith("top") || placement.startsWith("bottom")) {
              width = rects.reference.width;
            } else {
              height = rects.reference.height;
            }
            this.$_innerNode.style[autoSize === "min" ? "minWidth" : autoSize === "max" ? "maxWidth" : "width"] = width != null ? `${width}px` : null;
            this.$_innerNode.style[autoSize === "min" ? "minHeight" : autoSize === "max" ? "maxHeight" : "height"] = height != null ? `${height}px` : null;
            return {
              data: {
                skip: true
              },
              reset: {
                rects: true
              }
            };
          }
        });
      }
      if (this.autoMaxSize || this.autoBoundaryMaxSize) {
        this.$_innerNode.style.maxWidth = null;
        this.$_innerNode.style.maxHeight = null;
        options2.middleware.push(size({
          boundary: this.boundary,
          padding: this.overflowPadding,
          apply: ({ width, height }) => {
            this.$_innerNode.style.maxWidth = width != null ? `${width}px` : null;
            this.$_innerNode.style.maxHeight = height != null ? `${height}px` : null;
          }
        }));
      }
      const data = await computePosition(this.$_referenceNode, this.$_popperNode, options2);
      Object.assign(this.result, {
        x: data.x,
        y: data.y,
        placement: data.placement,
        strategy: data.strategy,
        arrow: __spreadValues(__spreadValues({}, data.middlewareData.arrow), data.middlewareData.arrowOverflow)
      });
    },
    $_scheduleShow(event = null, skipDelay = false) {
      this.$_updateParentShownChildren(true);
      this.$_hideInProgress = false;
      clearTimeout(this.$_scheduleTimer);
      if (hidingPopper && this.instantMove && hidingPopper.instantMove && hidingPopper !== this.parentPopper) {
        hidingPopper.$_applyHide(true);
        this.$_applyShow(true);
        return;
      }
      if (skipDelay) {
        this.$_applyShow();
      } else {
        this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
      }
    },
    $_scheduleHide(event = null, skipDelay = false) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = true;
        return;
      }
      this.$_updateParentShownChildren(false);
      this.$_hideInProgress = true;
      clearTimeout(this.$_scheduleTimer);
      if (this.isShown) {
        hidingPopper = this;
      }
      if (skipDelay) {
        this.$_applyHide();
      } else {
        this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
      }
    },
    $_computeDelay(type) {
      const delay = this.delay;
      return parseInt(delay && delay[type] || delay || 0);
    },
    async $_applyShow(skipTransition = false) {
      clearTimeout(this.$_disposeTimer);
      clearTimeout(this.$_scheduleTimer);
      this.skipTransition = skipTransition;
      if (this.isShown) {
        return;
      }
      this.$_ensureTeleport();
      await nextFrame();
      await this.$_computePosition();
      await this.$_applyShowEffect();
      if (!this.positioningDisabled) {
        this.$_registerEventListeners([
          ...getScrollParents(this.$_referenceNode),
          ...getScrollParents(this.$_popperNode)
        ], "scroll", () => {
          this.$_computePosition();
        });
      }
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const bounds = this.$_referenceNode.getBoundingClientRect();
        const popperWrapper = this.$_popperNode.querySelector(".v-popper__wrapper");
        const parentBounds = popperWrapper.parentNode.getBoundingClientRect();
        const x = bounds.x + bounds.width / 2 - (parentBounds.left + popperWrapper.offsetLeft);
        const y = bounds.y + bounds.height / 2 - (parentBounds.top + popperWrapper.offsetTop);
        this.result.transformOrigin = `${x}px ${y}px`;
      }
      this.isShown = true;
      this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const showGroup = this.showGroup;
      if (showGroup) {
        let popover;
        for (let i = 0; i < shownPoppers.length; i++) {
          popover = shownPoppers[i];
          if (popover.showGroup !== showGroup) {
            popover.hide();
            popover.$emit("close-group");
          }
        }
      }
      shownPoppers.push(this);
      document.body.classList.add("v-popper--some-open");
      for (const theme of getAllParentThemes(this.theme)) {
        getShownPoppersByTheme(theme).push(this);
        document.body.classList.add(`v-popper--some-open--${theme}`);
      }
      this.$emit("apply-show");
      this.classes.showFrom = true;
      this.classes.showTo = false;
      this.classes.hideFrom = false;
      this.classes.hideTo = false;
      await nextFrame();
      this.classes.showFrom = false;
      this.classes.showTo = true;
      this.$_popperNode.focus();
    },
    async $_applyHide(skipTransition = false) {
      if (this.shownChildren.size > 0) {
        this.$_pendingHide = true;
        this.$_hideInProgress = false;
        return;
      }
      clearTimeout(this.$_scheduleTimer);
      if (!this.isShown) {
        return;
      }
      this.skipTransition = skipTransition;
      removeFromArray(shownPoppers, this);
      if (shownPoppers.length === 0) {
        document.body.classList.remove("v-popper--some-open");
      }
      for (const theme of getAllParentThemes(this.theme)) {
        const list = getShownPoppersByTheme(theme);
        removeFromArray(list, this);
        if (list.length === 0) {
          document.body.classList.remove(`v-popper--some-open--${theme}`);
        }
      }
      if (hidingPopper === this) {
        hidingPopper = null;
      }
      this.isShown = false;
      this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      });
      clearTimeout(this.$_disposeTimer);
      const disposeTime = getDefaultConfig(this.theme, "disposeTimeout");
      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(() => {
          if (this.$_popperNode) {
            this.$_detachPopperNode();
            this.isMounted = false;
          }
        }, disposeTime);
      }
      this.$_removeEventListeners("scroll");
      this.$emit("apply-hide");
      this.classes.showFrom = false;
      this.classes.showTo = false;
      this.classes.hideFrom = true;
      this.classes.hideTo = false;
      await nextFrame();
      this.classes.hideFrom = false;
      this.classes.hideTo = true;
    },
    $_autoShowHide() {
      if (this.shown) {
        this.show();
      } else {
        this.hide();
      }
    },
    $_ensureTeleport() {
      if (this.$_isDisposed)
        return;
      let container = this.container;
      if (typeof container === "string") {
        container = window.document.querySelector(container);
      } else if (container === false) {
        container = this.$_targetNodes[0].parentNode;
      }
      if (!container) {
        throw new Error("No container for popover: " + this.container);
      }
      container.appendChild(this.$_popperNode);
      this.isMounted = true;
    },
    $_addEventListeners() {
      const handleShow = (event) => {
        if (this.isShown && !this.$_hideInProgress) {
          return;
        }
        event.usedByTooltip = true;
        !this.$_preventShow && this.show({ event });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, SHOW_EVENT_MAP, this.triggers, this.showTriggers, handleShow);
      this.$_registerTriggerListeners([this.$_popperNode], SHOW_EVENT_MAP, this.popperTriggers, this.popperShowTriggers, handleShow);
      const handleHide = (skipAiming) => (event) => {
        if (event.usedByTooltip) {
          return;
        }
        this.hide({ event, skipAiming });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, HIDE_EVENT_MAP, this.triggers, this.hideTriggers, handleHide(false));
      this.$_registerTriggerListeners([this.$_popperNode], HIDE_EVENT_MAP, this.popperTriggers, this.popperHideTriggers, handleHide(true));
    },
    $_registerEventListeners(targetNodes, eventType, handler) {
      this.$_events.push({ targetNodes, eventType, handler });
      targetNodes.forEach((node) => node.addEventListener(eventType, handler, supportsPassive ? {
        passive: true
      } : void 0));
    },
    $_registerTriggerListeners(targetNodes, eventMap, commonTriggers, customTrigger, handler) {
      let triggers = commonTriggers;
      if (customTrigger != null) {
        triggers = typeof customTrigger === "function" ? customTrigger(triggers) : customTrigger;
      }
      triggers.forEach((trigger) => {
        const eventType = eventMap[trigger];
        if (eventType) {
          this.$_registerEventListeners(targetNodes, eventType, handler);
        }
      });
    },
    $_removeEventListeners(filterEventType) {
      const newList = [];
      this.$_events.forEach((listener) => {
        const { targetNodes, eventType, handler } = listener;
        if (!filterEventType || filterEventType === eventType) {
          targetNodes.forEach((node) => node.removeEventListener(eventType, handler));
        } else {
          newList.push(listener);
        }
      });
      this.$_events = newList;
    },
    $_refreshListeners() {
      if (!this.$_isDisposed) {
        this.$_removeEventListeners();
        this.$_addEventListeners();
      }
    },
    $_handleGlobalClose(event, touch = false) {
      if (this.$_showFrameLocked)
        return;
      this.hide({ event });
      if (event.closePopover) {
        this.$emit("close-directive");
      } else {
        this.$emit("auto-hide");
      }
      if (touch) {
        this.$_preventShow = true;
        setTimeout(() => {
          this.$_preventShow = false;
        }, 300);
      }
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(attrFrom, attrTo) {
      for (const el of this.$_targetNodes) {
        const value = el.getAttribute(attrFrom);
        if (value) {
          el.removeAttribute(attrFrom);
          el.setAttribute(attrTo, value);
        }
      }
    },
    $_applyAttrsToTarget(attrs) {
      for (const el of this.$_targetNodes) {
        for (const n in attrs) {
          const value = attrs[n];
          if (value == null) {
            el.removeAttribute(n);
          } else {
            el.setAttribute(n, value);
          }
        }
      }
    },
    $_updateParentShownChildren(value) {
      let parent = this.parentPopper;
      while (parent) {
        if (value) {
          parent.shownChildren.add(this.randomId);
        } else {
          parent.shownChildren.delete(this.randomId);
          if (parent.$_pendingHide) {
            parent.hide();
          }
        }
        parent = parent.parentPopper;
      }
    },
    $_isAimingPopper() {
      const referenceBounds = this.$el.getBoundingClientRect();
      if (mouseX >= referenceBounds.left && mouseX <= referenceBounds.right && mouseY >= referenceBounds.top && mouseY <= referenceBounds.bottom) {
        const popperBounds = this.$_popperNode.getBoundingClientRect();
        const vectorX = mouseX - mousePreviousX;
        const vectorY = mouseY - mousePreviousY;
        const distance = popperBounds.left + popperBounds.width / 2 - mousePreviousX + (popperBounds.top + popperBounds.height / 2) - mousePreviousY;
        const newVectorLength = distance + popperBounds.width + popperBounds.height;
        const edgeX = mousePreviousX + vectorX * newVectorLength;
        const edgeY = mousePreviousY + vectorY * newVectorLength;
        return lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.left, popperBounds.top, popperBounds.left, popperBounds.bottom) || lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.left, popperBounds.top, popperBounds.right, popperBounds.top) || lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.right, popperBounds.top, popperBounds.right, popperBounds.bottom) || lineIntersectsLine(mousePreviousX, mousePreviousY, edgeX, edgeY, popperBounds.left, popperBounds.bottom, popperBounds.right, popperBounds.bottom);
      }
      return false;
    }
  },
  render() {
    return this.$scopedSlots.default(this.slotData)[0];
  }
});
if (typeof document !== "undefined" && typeof window !== "undefined") {
  if (isIOS) {
    document.addEventListener("touchstart", handleGlobalMousedown, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
    document.addEventListener("touchend", handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener("mousedown", handleGlobalMousedown, true);
    window.addEventListener("click", handleGlobalClick, true);
  }
  window.addEventListener("resize", computePositionAllShownPoppers);
}
function handleGlobalMousedown(event) {
  for (let i = 0; i < shownPoppers.length; i++) {
    const popper = shownPoppers[i];
    try {
      const popperContent = popper.popperNode();
      popper.$_mouseDownContains = popperContent.contains(event.target);
    } catch (e) {
    }
  }
}
function handleGlobalClick(event) {
  handleGlobalClose(event);
}
function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}
function handleGlobalClose(event, touch = false) {
  const preventClose = {};
  for (let i = shownPoppers.length - 1; i >= 0; i--) {
    const popper = shownPoppers[i];
    try {
      const contains = popper.$_containsGlobalTarget = isContainingEventTarget(popper, event);
      popper.$_pendingHide = false;
      requestAnimationFrame(() => {
        popper.$_pendingHide = false;
        if (preventClose[popper.randomId])
          return;
        if (shouldAutoHide(popper, contains, event)) {
          popper.$_handleGlobalClose(event, touch);
          if (!event.closeAllPopover && event.closePopover && contains) {
            let parent2 = popper.parentPopper;
            while (parent2) {
              preventClose[parent2.randomId] = true;
              parent2 = parent2.parentPopper;
            }
            return;
          }
          let parent = popper.parentPopper;
          while (parent) {
            if (shouldAutoHide(parent, parent.$_containsGlobalTarget, event)) {
              parent.$_handleGlobalClose(event, touch);
            } else {
              break;
            }
            parent = parent.parentPopper;
          }
        }
      });
    } catch (e) {
    }
  }
}
function isContainingEventTarget(popper, event) {
  const popperContent = popper.popperNode();
  return popper.$_mouseDownContains || popperContent.contains(event.target);
}
function shouldAutoHide(popper, contains, event) {
  return event.closeAllPopover || event.closePopover && contains || getAutoHideResult(popper, event) && !contains;
}
function getAutoHideResult(popper, event) {
  if (typeof popper.autoHide === "function") {
    const result = popper.autoHide(event);
    popper.lastAutoHide = result;
    return result;
  }
  return popper.autoHide;
}
function computePositionAllShownPoppers(event) {
  for (let i = 0; i < shownPoppers.length; i++) {
    const popper = shownPoppers[i];
    popper.$_computePosition(event);
  }
}
function hideAllPoppers() {
  for (let i = 0; i < shownPoppers.length; i++) {
    const popper = shownPoppers[i];
    popper.hide();
  }
}
let mousePreviousX = 0;
let mousePreviousY = 0;
let mouseX = 0;
let mouseY = 0;
if (typeof window !== "undefined") {
  window.addEventListener("mousemove", (event) => {
    mousePreviousX = mouseX;
    mousePreviousY = mouseY;
    mouseX = event.clientX;
    mouseY = event.clientY;
  }, supportsPassive ? {
    passive: true
  } : void 0);
}
function lineIntersectsLine(x1, y1, x2, y2, x3, y3, x4, y4) {
  const uA = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  const uB = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));
  return uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1;
}
function getInternetExplorerVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }
  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    var rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }
  var edge = ua.indexOf("Edge/");
  if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }
  return -1;
}
var isIE;
function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
    isIE = getInternetExplorerVersion() !== -1;
  }
}
var script = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;
    initCompat();
    this.$nextTick(function() {
      _this._w = _this.$el.offsetWidth;
      _this._h = _this.$el.offsetHeight;
      if (_this.emitOnMount) {
        _this.emitSize();
      }
    });
    var object = document.createElement("object");
    this._resizeObject = object;
    object.setAttribute("aria-hidden", "true");
    object.setAttribute("tabindex", -1);
    object.onload = this.addResizeHandlers;
    object.type = "text/html";
    if (isIE) {
      this.$el.appendChild(object);
    }
    object.data = "about:blank";
    if (!isIE) {
      this.$el.appendChild(object);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify: function compareAndNotify() {
      if (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.emitSize();
      }
    },
    emitSize: function emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers: function addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify);
      this.compareAndNotify();
    },
    removeResizeHandlers: function removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify);
        }
        this.$el.removeChild(this._resizeObject);
        this._resizeObject.onload = null;
        this._resizeObject = null;
      }
    }
  }
};
function normalizeComponent$1(template, style, script2, scopeId, isFunctionalTemplate, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== "boolean") {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  var options2 = typeof script2 === "function" ? script2.options : script2;
  if (template && template.render) {
    options2.render = template.render;
    options2.staticRenderFns = template.staticRenderFns;
    options2._compiled = true;
    if (isFunctionalTemplate) {
      options2.functional = true;
    }
  }
  if (scopeId) {
    options2._scopeId = scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options2._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function(context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function(context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options2.functional) {
      var originalRender = options2.render;
      options2.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options2.beforeCreate;
      options2.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script2;
}
var __vue_script__ = script;
var __vue_render__ = function __vue_render__2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "resize-observer",
    attrs: {
      tabindex: "-1"
    }
  });
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
var __vue_inject_styles__ = void 0;
var __vue_scope_id__ = "data-v-8859cc6c";
var __vue_module_identifier__ = void 0;
var __vue_is_functional_template__ = false;
var __vue_component__ = /* @__PURE__ */ normalizeComponent$1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, void 0, void 0, void 0);
function install$1(Vue2) {
  Vue2.component("resize-observer", __vue_component__);
  Vue2.component("ResizeObserver", __vue_component__);
}
var plugin$1 = {
  version: "1.0.1",
  install: install$1
};
var GlobalVue$1 = null;
if (typeof window !== "undefined") {
  GlobalVue$1 = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue$1 = global.Vue;
}
if (GlobalVue$1) {
  GlobalVue$1.use(plugin$1);
}
var PrivateThemeClass = {
  computed: {
    themeClass() {
      return getThemeClasses(this.theme);
    }
  }
};
var __vue2_script$5 = {
  name: "VPopperContent",
  components: {
    ResizeObserver: __vue_component__
  },
  mixins: [
    PrivateThemeClass
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  methods: {
    toPx(value) {
      if (value != null && !isNaN(value)) {
        return `${value}px`;
      }
      return null;
    }
  }
};
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popover", staticClass: "v-popper__popper", class: [
    _vm.themeClass,
    _vm.classes.popperClass,
    {
      "v-popper__popper--shown": _vm.shown,
      "v-popper__popper--hidden": !_vm.shown,
      "v-popper__popper--show-from": _vm.classes.showFrom,
      "v-popper__popper--show-to": _vm.classes.showTo,
      "v-popper__popper--hide-from": _vm.classes.hideFrom,
      "v-popper__popper--hide-to": _vm.classes.hideTo,
      "v-popper__popper--skip-transition": _vm.skipTransition,
      "v-popper__popper--arrow-overflow": _vm.result && _vm.result.arrow.overflow,
      "v-popper__popper--no-positioning": !_vm.result
    }
  ], style: _vm.result ? {
    position: _vm.result.strategy,
    transform: "translate3d(" + Math.round(_vm.result.x) + "px," + Math.round(_vm.result.y) + "px,0)"
  } : void 0, attrs: { "id": _vm.popperId, "aria-hidden": _vm.shown ? "false" : "true", "tabindex": _vm.autoHide ? 0 : void 0, "data-popper-placement": _vm.result ? _vm.result.placement : void 0 }, on: { "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
      return null;
    }
    _vm.autoHide && _vm.$emit("hide");
  } } }, [_c("div", { staticClass: "v-popper__backdrop", on: { "click": function($event) {
    _vm.autoHide && _vm.$emit("hide");
  } } }), _c("div", { staticClass: "v-popper__wrapper", style: _vm.result ? {
    transformOrigin: _vm.result.transformOrigin
  } : void 0 }, [_c("div", { ref: "inner", staticClass: "v-popper__inner" }, [_vm.mounted ? [_c("div", [_vm._t("default")], 2), _vm.handleResize ? _c("ResizeObserver", { on: { "notify": function($event) {
    return _vm.$emit("resize", $event);
  } } }) : _vm._e()] : _vm._e()], 2), _c("div", { ref: "arrow", staticClass: "v-popper__arrow-container", style: _vm.result ? {
    left: _vm.toPx(_vm.result.arrow.x),
    top: _vm.toPx(_vm.result.arrow.y)
  } : void 0 }, [_c("div", { staticClass: "v-popper__arrow-outer" }), _c("div", { staticClass: "v-popper__arrow-inner" })])])]);
};
var staticRenderFns$2 = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options2 = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options2.render = render2;
    options2.staticRenderFns = staticRenderFns2;
    options2._compiled = true;
  }
  if (functionalTemplate) {
    options2.functional = true;
  }
  if (scopeId) {
    options2._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options2._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options2.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options2.functional) {
      options2._injectStyles = hook;
      var originalRender = options2.render;
      options2.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options2.beforeCreate;
      options2.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options: options2
  };
}
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(__vue2_script$5, render$2, staticRenderFns$2, false, __vue2_injectStyles$5, null, null, null);
function __vue2_injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var PrivatePopperContent = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var PrivatePopperMethods = {
  methods: {
    show(...args) {
      return this.$refs.popper.show(...args);
    },
    hide(...args) {
      return this.$refs.popper.hide(...args);
    },
    dispose(...args) {
      return this.$refs.popper.dispose(...args);
    },
    onResize(...args) {
      return this.$refs.popper.onResize(...args);
    }
  }
};
var __vue2_script$4 = {
  name: "VPopperWrapper",
  components: {
    Popper: PrivatePopper(),
    PopperContent: PrivatePopperContent
  },
  mixins: [
    PrivatePopperMethods,
    PrivateThemeClass
  ],
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default() {
        return this.$options.vPopperTheme;
      }
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$refs.reference.children).filter((node) => node !== this.$refs.popperContent.$el);
    }
  }
};
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("Popper", _vm._g(_vm._b({ ref: "popper", attrs: { "theme": _vm.theme, "target-nodes": _vm.getTargetNodes, "reference-node": function() {
    return _vm.$refs.reference;
  }, "popper-node": function() {
    return _vm.$refs.popperContent.$el;
  } }, scopedSlots: _vm._u([{ key: "default", fn: function(ref) {
    var popperId = ref.popperId;
    var isShown = ref.isShown;
    var shouldMountContent = ref.shouldMountContent;
    var skipTransition = ref.skipTransition;
    var autoHide = ref.autoHide;
    var show = ref.show;
    var hide = ref.hide;
    var handleResize = ref.handleResize;
    var onResize = ref.onResize;
    var classes = ref.classes;
    var result = ref.result;
    return [_c("div", { ref: "reference", staticClass: "v-popper", class: [
      _vm.themeClass,
      {
        "v-popper--shown": isShown
      }
    ] }, [_vm._t("default", null, { "shown": isShown, "show": show, "hide": hide }), _c("PopperContent", { ref: "popperContent", attrs: { "popper-id": popperId, "theme": _vm.theme, "shown": isShown, "mounted": shouldMountContent, "skip-transition": skipTransition, "auto-hide": autoHide, "handle-resize": handleResize, "classes": classes, "result": result }, on: { "hide": hide, "resize": onResize } }, [_vm._t("popper", null, { "shown": isShown, "hide": hide })], 2)], 2)];
  } }], null, true) }, "Popper", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns$1 = [];
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(__vue2_script$4, render$1, staticRenderFns$1, false, __vue2_injectStyles$4, null, null, null);
function __vue2_injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var PrivatePopperWrapper = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var __vue2_script$3 = __spreadProps(__spreadValues({}, PrivatePopperWrapper), {
  name: "VDropdown",
  vPopperTheme: "dropdown"
});
let __vue2_render$2, __vue2_staticRenderFns$2;
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(__vue2_script$3, __vue2_render$2, __vue2_staticRenderFns$2, false, __vue2_injectStyles$3, null, null, null);
function __vue2_injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var PrivateDropdown = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var __vue2_script$2 = __spreadProps(__spreadValues({}, PrivatePopperWrapper), {
  name: "VMenu",
  vPopperTheme: "menu"
});
let __vue2_render$1, __vue2_staticRenderFns$1;
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(__vue2_script$2, __vue2_render$1, __vue2_staticRenderFns$1, false, __vue2_injectStyles$2, null, null, null);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var PrivateMenu = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var __vue2_script$1 = __spreadProps(__spreadValues({}, PrivatePopperWrapper), {
  name: "VTooltip",
  vPopperTheme: "tooltip"
});
let __vue2_render, __vue2_staticRenderFns;
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(__vue2_script$1, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles$1, null, null, null);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var PrivateTooltip = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var __vue2_script = {
  name: "VTooltipDirective",
  components: {
    Popper: PrivatePopper(),
    PopperContent: PrivatePopperContent
  },
  mixins: [
    PrivatePopperMethods
  ],
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default() {
        return getDefaultConfig(this.theme, "html");
      }
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default() {
        return getDefaultConfig(this.theme, "loadingContent");
      }
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content === "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      if (this.isContentAsync) {
        return this.loading ? this.loadingContent : this.asyncContent;
      }
      return this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(true);
      },
      immediate: true
    },
    async finalContent(value) {
      await this.$nextTick();
      this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(force) {
      if (typeof this.content === "function" && this.$_isShown && (force || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null;
        this.$_loading = true;
        const fetchId = ++this.$_fetchId;
        const result = this.content(this);
        if (result.then) {
          result.then((res) => this.onResult(fetchId, res));
        } else {
          this.onResult(fetchId, result);
        }
      }
    },
    onResult(fetchId, result) {
      if (fetchId !== this.$_fetchId)
        return;
      this.$_loading = false;
      this.asyncContent = result;
    },
    onShow() {
      this.$_isShown = true;
      this.fetchContent();
    },
    onHide() {
      this.$_isShown = false;
    }
  }
};
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("Popper", _vm._g(_vm._b({ ref: "popper", attrs: { "theme": _vm.theme, "popper-node": function() {
    return _vm.$refs.popperContent.$el;
  } }, on: { "apply-show": _vm.onShow, "apply-hide": _vm.onHide }, scopedSlots: _vm._u([{ key: "default", fn: function(ref) {
    var popperId = ref.popperId;
    var isShown = ref.isShown;
    var shouldMountContent = ref.shouldMountContent;
    var skipTransition = ref.skipTransition;
    var autoHide = ref.autoHide;
    var hide = ref.hide;
    var handleResize = ref.handleResize;
    var onResize = ref.onResize;
    var classes = ref.classes;
    var result = ref.result;
    return [_c("PopperContent", { ref: "popperContent", class: {
      "v-popper--tooltip-loading": _vm.loading
    }, attrs: { "popper-id": popperId, "theme": _vm.theme, "shown": isShown, "mounted": shouldMountContent, "skip-transition": skipTransition, "auto-hide": autoHide, "handle-resize": handleResize, "classes": classes, "result": result }, on: { "hide": hide, "resize": onResize } }, [_vm.html ? _c("div", { domProps: { "innerHTML": _vm._s(_vm.finalContent) } }) : _c("div", { domProps: { "textContent": _vm._s(_vm.finalContent) } })])];
  } }]) }, "Popper", _vm.$attrs, false), _vm.$listeners));
};
var staticRenderFns = [];
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var PrivateTooltipDirective = /* @__PURE__ */ function() {
  return __component__.exports;
}();
const TARGET_CLASS = "v-popper--has-tooltip";
function getPlacement(options2, modifiers) {
  let result = options2.placement;
  if (!result && modifiers) {
    for (const pos of placements) {
      if (modifiers[pos]) {
        result = pos;
      }
    }
  }
  if (!result) {
    result = getDefaultConfig(options2.theme || "tooltip", "placement");
  }
  return result;
}
function getOptions(el, value, modifiers) {
  let options2;
  const type = typeof value;
  if (type === "string") {
    options2 = { content: value };
  } else if (value && type === "object") {
    options2 = value;
  } else {
    options2 = { content: false };
  }
  options2.placement = getPlacement(options2, modifiers);
  options2.targetNodes = () => [el];
  options2.referenceNode = () => el;
  return options2;
}
function createTooltip(el, value, modifiers) {
  const options2 = getOptions(el, value, modifiers);
  const tooltipApp = el.$_popper = new Vue({
    mixins: [
      PrivatePopperMethods
    ],
    data() {
      return {
        options: options2
      };
    },
    render(h) {
      const _a = this.options, {
        theme,
        html,
        content,
        loadingContent
      } = _a, otherOptions = __objRest(_a, [
        "theme",
        "html",
        "content",
        "loadingContent"
      ]);
      return h(PrivateTooltipDirective, {
        props: {
          theme,
          html,
          content,
          loadingContent
        },
        attrs: otherOptions,
        ref: "popper"
      });
    },
    devtools: {
      hide: true
    }
  });
  const mountTarget = document.createElement("div");
  document.body.appendChild(mountTarget);
  tooltipApp.$mount(mountTarget);
  if (el.classList) {
    el.classList.add(TARGET_CLASS);
  }
  return tooltipApp;
}
function destroyTooltip(el) {
  if (el.$_popper) {
    el.$_popper.$destroy();
    delete el.$_popper;
    delete el.$_popperOldShown;
  }
  if (el.classList) {
    el.classList.remove(TARGET_CLASS);
  }
}
function bind(el, { value, oldValue, modifiers }) {
  const options2 = getOptions(el, value, modifiers);
  if (!options2.content || getDefaultConfig(options2.theme || "tooltip", "disabled")) {
    destroyTooltip(el);
  } else {
    let tooltipApp;
    if (el.$_popper) {
      tooltipApp = el.$_popper;
      tooltipApp.options = options2;
    } else {
      tooltipApp = createTooltip(el, value, modifiers);
    }
    if (typeof value.shown !== "undefined" && value.shown !== el.$_popperOldShown) {
      el.$_popperOldShown = value.shown;
      value.shown ? tooltipApp.show() : tooltipApp.hide();
    }
  }
}
var PrivateVTooltip = {
  bind,
  update: bind,
  unbind(el) {
    destroyTooltip(el);
  }
};
function addListeners(el) {
  el.addEventListener("click", onClick);
  el.addEventListener("touchstart", onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}
function removeListeners(el) {
  el.removeEventListener("click", onClick);
  el.removeEventListener("touchstart", onTouchStart);
  el.removeEventListener("touchend", onTouchEnd);
  el.removeEventListener("touchcancel", onTouchCancel);
}
function onClick(event) {
  const el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}
function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    const el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    const touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener("touchend", onTouchEnd);
    el.addEventListener("touchcancel", onTouchCancel);
  }
}
function onTouchEnd(event) {
  const el = event.currentTarget;
  el.$_vclosepopover_touch = false;
  if (event.changedTouches.length === 1) {
    const touch = event.changedTouches[0];
    const firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}
function onTouchCancel(event) {
  const el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}
var PrivateVClosePopper = {
  bind(el, { value, modifiers }) {
    el.$_closePopoverModifiers = modifiers;
    if (typeof value === "undefined" || value) {
      addListeners(el);
    }
  },
  update(el, { value, oldValue, modifiers }) {
    el.$_closePopoverModifiers = modifiers;
    if (value !== oldValue) {
      if (typeof value === "undefined" || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind(el) {
    removeListeners(el);
  }
};
const options = config;
const VTooltip = PrivateVTooltip;
const VClosePopper = PrivateVClosePopper;
const Dropdown = PrivateDropdown;
const Menu = PrivateMenu;
const Popper = PrivatePopper;
const PopperContent = PrivatePopperContent;
const PopperMethods = PrivatePopperMethods;
const PopperWrapper = PrivatePopperWrapper;
const ThemeClass = PrivateThemeClass;
const Tooltip = PrivateTooltip;
const TooltipDirective = PrivateTooltipDirective;
function install(app, options2 = {}) {
  if (app.$_vTooltipInstalled)
    return;
  app.$_vTooltipInstalled = true;
  assign(config, options2);
  app.directive("tooltip", PrivateVTooltip);
  app.directive("close-popper", PrivateVClosePopper);
  app.component("v-tooltip", PrivateTooltip);
  app.component("VTooltip", PrivateTooltip);
  app.component("v-dropdown", PrivateDropdown);
  app.component("VDropdown", PrivateDropdown);
  app.component("v-menu", PrivateMenu);
  app.component("VMenu", PrivateMenu);
}
const plugin = {
  version: "1.0.0-beta.18",
  install,
  options: config
};
let GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

var floatingVue_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Dropdown: Dropdown,
    HIDE_EVENT_MAP: HIDE_EVENT_MAP,
    Menu: Menu,
    Popper: Popper,
    PopperContent: PopperContent,
    PopperMethods: PopperMethods,
    PopperWrapper: PopperWrapper,
    SHOW_EVENT_MAP: SHOW_EVENT_MAP,
    ThemeClass: ThemeClass,
    Tooltip: Tooltip,
    TooltipDirective: TooltipDirective,
    VClosePopper: VClosePopper,
    VTooltip: VTooltip,
    createTooltip: createTooltip,
    'default': plugin,
    destroyTooltip: destroyTooltip,
    hideAllPoppers: hideAllPoppers,
    install: install,
    options: options,
    placements: placements
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(floatingVue_es);

/*!
* tabbable 6.0.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  return element.getRootNode();
} : function (element) {
  return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */


var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);

  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();

    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);

      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);

      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      } // iterate over shadow content if possible


      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);

      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }

  return candidates;
};

var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || getRootNode(node);

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}; // determines if a node is ultimately attached to the window's document


var isNodeAttached = function isNodeAttached(node) {
  var _nodeRootHost;

  // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // To further complicate things, we have to look all the way up until we find a shadow HOST
  //  that is attached (or find none) because the node might be in nested shadows...
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.
  var nodeRootHost = getRootNode(node).host;
  var attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && _nodeRootHost.ownerDocument.contains(nodeRootHost) || node.ownerDocument.contains(node));

  while (!attached && nodeRootHost) {
    var _nodeRootHost2;

    // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
    //  which means we need to get the host's host and check if that parent host is contained
    //  in (i.e. attached to) the document
    nodeRootHost = getRootNode(nodeRootHost).host;
    attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && _nodeRootHost2.ownerDocument.contains(nodeRootHost));
  }

  return attached;
};

var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;

  return width === 0 && height === 0;
};

var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;

  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  }

  if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;

      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);

        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }

      node = originalNode;
    } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled
    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.


    if (isNodeAttached(node)) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    } // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    //
    // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
    //  nodes as visible with the 'none' fallback.__


    if (displayCheck !== 'legacy-full') {
      return true; // hidden
    } // else, fallback to 'none' mode and consider the node visible

  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  } // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
  //  it's visible


  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i); // when the first <legend> (in document order) is found

          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        } // the disabled <fieldset> containing `node` has no <legend>


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }

  return true;
};

var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  } // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.


  return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */


var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;

    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }

  return sortByOrder(candidates);
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }

  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */


  var findContainerIndex = function findContainerIndex(element) {
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes

      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,

        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });

          if (nodeIdx < 0) {
            return undefined;
          }

          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }

          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    get active() {
      return state.active;
    },

    get paused() {
      return state.paused;
    },

    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');

      if (onDeactivate) {
        onDeactivate();
      }

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};

var focusTrap_esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    createFocusTrap: createFocusTrap
});

var require$$2 = /*@__PURE__*/getAugmentedNamespace(focusTrap_esm);

var DotsHorizontal = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"material-design-icon dots-horizontal-icon",attrs:{"aria-hidden":!_vm.title,"aria-label":_vm.title,"role":"img"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'span',_vm.$attrs,false),[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])])])},
staticRenderFns: [],
  name: "DotsHorizontalIcon",
  emits: ['click'],
  props: {
    title: {
      type: String,
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};

var DotsHorizontal$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': DotsHorizontal
});

var require$$4 = /*@__PURE__*/getAugmentedNamespace(DotsHorizontal$1);

(function (module, exports) {
	!function(e,t){module.exports=t();}(self,(function(){return function(){var e={8399:function(e,t,a){function o(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,o);}return a}function i(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?o(Object(a),!0).forEach((function(t){n(e,t,a[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):o(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t));}));}return e}function n(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}a.d(t,{default:function(){return j}});var r={name:"NcButton",props:{disabled:{type:Boolean,default:!1},type:{type:String,validator:function(e){return -1!==["primary","secondary","tertiary","tertiary-no-background","tertiary-on-primary","error","warning","success"].indexOf(e)},default:"secondary"},nativeType:{type:String,validator:function(e){return -1!==["submit","reset","button"].indexOf(e)},default:"button"},wide:{type:Boolean,default:!1},ariaLabel:{type:String,default:null},href:{type:String,default:null},to:{type:[String,Object],default:null},exact:{type:Boolean,default:!1}},data:function(){return {slots:this.$slots}},computed:{rootElement:function(){return this.to?i({is:"router-link",tag:"button",to:this.to,exact:this.exact},this.$attrs):this.href?i({is:"a",href:this.href},this.$attrs):i({is:"button"},this.$attrs)},hasText:function(){var e,t,a;return void 0!==(null===(e=this.slots)||void 0===e?void 0:e.default)&&(null===(t=this.slots)||void 0===t||null===(a=t.default[0])||void 0===a?void 0:a.text)},hasIcon:function(){return void 0!==this.slots.icon},iconOnly:function(){return this.hasIcon&&!this.hasText},textOnly:function(){return !this.hasIcon&&this.hasText},iconAndText:function(){return this.hasIcon&&this.hasText},text:function(){return this.hasText?this.slots.default[0].text.trim():null},buttonClassObject:function(){var e;return n(e={"button-vue--icon-only":this.iconOnly,"button-vue--text-only":this.textOnly,"button-vue--icon-and-text":this.iconAndText},"button-vue--vue-".concat(this.type),this.type),n(e,"button-vue--wide",this.wide),e}},beforeUpdate:function(){this.slots=this.$slots;},mounted:function(){this.text||this.ariaLabel||console.warn("You need to fill either the text or the ariaLabel props in the button component.",{text:this.text,ariaLabel:this.ariaLabel},this);}},s=a(3379),l=a.n(s),c=a(7795),u=a.n(c),d=a(569),m=a.n(d),p=a(3565),g=a.n(p),A=a(9216),v=a.n(A),h=a(4589),b=a.n(h),f=a(7190),C={};C.styleTagTransform=b(),C.setAttributes=g(),C.insert=m().bind(null,"head"),C.domAPI=u(),C.insertStyleElement=v(),l()(f.Z,C),f.Z&&f.Z.locals&&f.Z.locals;var y=a(1900),k=a(2102),S=a.n(k),w=(0, y.Z)(r,(function(){var e=this,t=e._self._c;return t("root-element",e._g(e._b({staticClass:"button-vue",class:e.buttonClassObject,attrs:{"aria-label":e.ariaLabel,type:e.nativeType,disabled:e.disabled}},"root-element",e.rootElement,!1),e.$listeners),[t("span",{staticClass:"button-vue__wrapper"},[e.hasIcon?t("span",{staticClass:"button-vue__icon"},[e._t("icon")],2):e._e(),e._v(" "),e.hasText?t("span",{staticClass:"button-vue__text"},[e._t("default")],2):e._e()])])}),[],!1,null,"7a8f3349",null);"function"==typeof S()&&S()(w);var j=w.exports;},1481:function(e,t,a){a.d(t,{default:function(){return P}});var o=a(9454),i=a(4505);function n(e,t,a,o,i,n,r){try{var s=e[n](r),l=s.value;}catch(e){return void a(e)}s.done?t(l):Promise.resolve(l).then(o,i);}var r={name:"NcPopover",components:{Dropdown:o.Dropdown},props:{popoverBaseClass:{type:String,default:""},focusTrap:{type:Boolean,default:!0}},emits:["after-show","after-hide"],beforeDestroy:function(){this.clearFocusTrap();},methods:{useFocusTrap:function(){var e,t=this;return (e=regeneratorRuntime.mark((function e(){var a,o,n;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,t.$nextTick();case 2:if(t.focusTrap){e.next=4;break}return e.abrupt("return");case 4:if(n=null===(a=t.$refs.popover)||void 0===a||null===(o=a.$refs.popperContent)||void 0===o?void 0:o.$el){e.next=7;break}return e.abrupt("return");case 7:t.$focusTrap=(0, i.createFocusTrap)(n,{escapeDeactivates:!1,allowOutsideClick:!0}),t.$focusTrap.activate();case 9:case"end":return e.stop()}}),e)})),function(){var t=this,a=arguments;return new Promise((function(o,i){var r=e.apply(t,a);function s(e){n(r,o,i,s,l,"next",e);}function l(e){n(r,o,i,s,l,"throw",e);}s(void 0);}))})()},clearFocusTrap:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};try{var t;null===(t=this.$focusTrap)||void 0===t||t.deactivate(e),this.$focusTrap=null;}catch(e){console.warn(e);}},afterShow:function(){this.$emit("after-show"),this.useFocusTrap();},afterHide:function(){this.$emit("after-hide"),this.clearFocusTrap();}}},s=r,l=a(3379),c=a.n(l),u=a(7795),d=a.n(u),m=a(569),p=a.n(m),g=a(3565),A=a.n(g),v=a(9216),h=a.n(v),b=a(4589),f=a.n(b),C=a(8985),y={};y.styleTagTransform=f(),y.setAttributes=A(),y.insert=p().bind(null,"head"),y.domAPI=d(),y.insertStyleElement=h(),c()(C.Z,y),C.Z&&C.Z.locals&&C.Z.locals;var k=a(1900),S=a(2405),w=a.n(S),j=(0, k.Z)(s,(function(){var e=this;return (0, e._self._c)("Dropdown",e._g(e._b({ref:"popover",attrs:{distance:10,"arrow-padding":10,"popper-class":e.popoverBaseClass},on:{"apply-show":e.afterShow,"apply-hide":e.afterHide},scopedSlots:e._u([{key:"popper",fn:function(){return [e._t("default")]},proxy:!0}],null,!0)},"Dropdown",e.$attrs,!1),e.$listeners),[e._t("trigger")],2)}),[],!1,null,null,null);"function"==typeof w()&&w()(j);var P=j.exports;},336:function(e,t,a){a.d(t,{default:function(){return b}});var o=a(9454),i=a(3379),n=a.n(i),r=a(7795),s=a.n(r),l=a(569),c=a.n(l),u=a(3565),d=a.n(u),m=a(9216),p=a.n(m),g=a(4589),A=a.n(g),v=a(8384),h={};h.styleTagTransform=A(),h.setAttributes=d(),h.insert=c().bind(null,"head"),h.domAPI=s(),h.insertStyleElement=p(),n()(v.Z,h),v.Z&&v.Z.locals&&v.Z.locals,o.options.themes.tooltip.html=!1,o.options.themes.tooltip.delay={show:500,hide:200},o.options.themes.tooltip.distance=10,o.options.themes.tooltip["arrow-padding"]=3;var b=o.VTooltip;},932:function(e,t,a){a.d(t,{t:function(){return n}});var o=(0, a(754).getGettextBuilder)().detectLocale();[{locale:"ar",translations:{"{tag} (invisible)":"{tag} (غير مرئي)","{tag} (restricted)":"{tag} (مقيد)",Actions:"الإجراءات",Activities:"النشاطات","Animals & Nature":"الحيوانات والطبيعة","Avatar of {displayName}":"صورة {displayName} الرمزية","Avatar of {displayName}, {status}":"صورة {displayName} الرمزية، {status}","Cancel changes":"إلغاء التغييرات",Choose:"إختيار",Close:"أغلق","Close navigation":"إغلاق المتصفح","Confirm changes":"تأكيد التغييرات",Custom:"مخصص","Edit item":"تعديل عنصر","External documentation for {title}":"الوثائق الخارجية لـ{title}",Flags:"الأعلام","Food & Drink":"الطعام والشراب","Frequently used":"كثيرا ما تستخدم",Global:"عالمي","Go back to the list":"العودة إلى القائمة","Message limit of {count} characters reached":"تم الوصول إلى الحد الأقصى لعدد الأحرف في الرسالة: {count} حرف",Next:"التالي","No emoji found":"لم يتم العثور على أي رمز تعبيري","No results":"ليس هناك أية نتيجة",Objects:"الأشياء","Open navigation":"فتح المتصفح","Pause slideshow":"إيقاف العرض مؤقتًا","People & Body":"الناس والجسم","Pick an emoji":"اختر رمزًا تعبيريًا","Please select a time zone:":"الرجاء تحديد المنطقة الزمنية:",Previous:"السابق",Search:"بحث","Search results":"نتائج البحث","Select a tag":"اختر علامة",Settings:"الإعدادات","Settings navigation":"إعدادات المتصفح","Smileys & Emotion":"الوجوه و الرموز التعبيرية","Start slideshow":"بدء العرض",Submit:"إرسال",Symbols:"الرموز","Travel & Places":"السفر والأماكن","Type to search time zone":"اكتب للبحث عن منطقة زمنية","Unable to search the group":"تعذر البحث في المجموعة","Undo changes":"التراجع عن التغييرات","Write message, @ to mention someone, : for emoji autocompletion …":"اكتب رسالة، @ للإشارة إلى شخص ما، : للإكمال التلقائي للرموز التعبيرية ..."}},{locale:"br",translations:{"{tag} (invisible)":"{tag} (diwelus)","{tag} (restricted)":"{tag} (bevennet)",Actions:"Oberioù",Activities:"Oberiantizoù","Animals & Nature":"Loened & Natur",Choose:"Dibab",Close:"Serriñ",Custom:"Personelañ",Flags:"Bannieloù","Food & Drink":"Boued & Evajoù","Frequently used":"Implijet alies",Next:"Da heul","No emoji found":"Emoji ebet kavet","No results":"Disoc'h ebet",Objects:"Traoù","Pause slideshow":"Arsav an diaporama","People & Body":"Tud & Korf","Pick an emoji":"Choaz un emoji",Previous:"A-raok",Search:"Klask","Search results":"Disoc'hoù an enklask","Select a tag":"Choaz ur c'hlav",Settings:"Arventennoù","Smileys & Emotion":"Smileyioù & Fromoù","Start slideshow":"Kregiñ an diaporama",Symbols:"Arouezioù","Travel & Places":"Beaj & Lec'hioù","Unable to search the group":"Dibosupl eo klask ar strollad"}},{locale:"ca",translations:{"{tag} (invisible)":"{tag} (invisible)","{tag} (restricted)":"{tag} (restringit)",Actions:"Accions",Activities:"Activitats","Animals & Nature":"Animals i natura","Avatar of {displayName}":"Avatar de {displayName}","Avatar of {displayName}, {status}":"Avatar de {displayName}, {status}","Cancel changes":"Cancel·la els canvis","Change title":"Canviar títol",Choose:"Tria","Clear text":"Netejar text",Close:"Tanca","Close modal":"Tancar el mode","Close navigation":"Tanca la navegació","Close sidebar":"Tancar la barra lateral","Confirm changes":"Confirmeu els canvis",Custom:"Personalitzat","Edit item":"Edita l'element","Error getting related resources":"Error obtenint els recursos relacionats","External documentation for {title}":"Documentació externa per a {title}",Favorite:"Preferit",Flags:"Marques","Food & Drink":"Menjar i begudes","Frequently used":"Utilitzats recentment",Global:"Global","Go back to the list":"Torna a la llista","Hide password":"Amagar contrasenya",items:"elements","Message limit of {count} characters reached":"S'ha arribat al límit de {count} caràcters per missatge","More {dashboardItemType} …":"Més {dashboardItemType} …",Next:"Següent","No emoji found":"No s'ha trobat cap emoji","No results":"Sense resultats",Objects:"Objectes",Open:"Obrir",'Open link to "{resourceTitle}"':'Obrir enllaç a "{resourceTitle}"',"Open navigation":"Obre la navegació","Password is secure":"Contrasenya segura<br>","Pause slideshow":"Atura la presentació","People & Body":"Persones i cos","Pick a date":"Seleccioni un dia ","Pick a date and a time":"Seleccioni un dia i hora","Pick a month":"Seleccioni un mes","Pick a time":"Seleccioni una hora","Pick a week":"Seleccioni una setmana","Pick a year":"Seleccioni un any","Pick an emoji":"Trieu un emoji","Please select a time zone:":"Seleccioneu una zona horària:",Previous:"Anterior","Related resources":"Recursos relacionats",Search:"Cerca","Search results":"Resultats de cerca","Select a tag":"Seleccioneu una etiqueta",Settings:"Paràmetres","Settings navigation":"Navegació d'opcions","Show password":"Mostrar contrasenya","Smileys & Emotion":"Cares i emocions","Start slideshow":"Inicia la presentació",Submit:"Envia",Symbols:"Símbols","Travel & Places":"Viatges i llocs","Type to search time zone":"Escriviu per cercar la zona horària","Unable to search the group":"No es pot cercar el grup","Undo changes":"Desfés els canvis","Write message, @ to mention someone, : for emoji autocompletion …":"Escriu un missatge, @ per esmentar algú, : per a la compleció automàtica d'emojis..."}},{locale:"cs_CZ",translations:{"{tag} (invisible)":"{tag} (neviditelné)","{tag} (restricted)":"{tag} (omezené)",Actions:"Akce",Activities:"Aktivity","Animals & Nature":"Zvířata a příroda","Avatar of {displayName}":"Zástupný obrázek uživatele {displayName}","Avatar of {displayName}, {status}":"Zástupný obrázek uživatele {displayName}, {status}","Cancel changes":"Zrušit změny","Change title":"Změnit nadpis",Choose:"Zvolit","Clear text":"Čitelný text",Close:"Zavřít","Close modal":"Zavřít dialogové okno","Close navigation":"Zavřít navigaci","Close sidebar":"Zavřít postranní panel","Confirm changes":"Potvrdit změny",Custom:"Uživatelsky určené","Edit item":"Upravit položku","Error getting related resources":"Chyba při získávání souvisejících prostředků","External documentation for {title}":"Externí dokumentace k {title}",Favorite:"Oblíbené",Flags:"Příznaky","Food & Drink":"Jídlo a pití","Frequently used":"Často používané",Global:"Globální","Go back to the list":"Jít zpět na seznam","Hide password":"Skrýt heslo","Message limit of {count} characters reached":"Dosaženo limitu počtu ({count}) znaků zprávy","More items …":"Další položky…",Next:"Následující","No emoji found":"Nenalezeno žádné emoji","No results":"Nic nenalezeno",Objects:"Objekty",Open:"Otevřít",'Open link to "{resourceTitle}"':"Otevřít odkaz na „{resourceTitle}“","Open navigation":"Otevřít navigaci","Password is secure":"Heslo je bezpečné","Pause slideshow":"Pozastavit prezentaci","People & Body":"Lidé a tělo","Pick a date":"Vyberte datum","Pick a date and a time":"Vyberte datum a čas","Pick a month":"Vyberte měsíc","Pick a time":"Vyberte čas","Pick a week":"Vyberte týden","Pick a year":"Vyberte rok","Pick an emoji":"Vybrat emoji","Please select a time zone:":"Vyberte časovou zónu:",Previous:"Předchozí","Related resources":"Související prostředky",Search:"Hledat","Search results":"Výsledky hledání","Select a tag":"Vybrat štítek",Settings:"Nastavení","Settings navigation":"Pohyb po nastavení","Show password":"Zobrazit heslo","Smileys & Emotion":"Úsměvy a emoce","Start slideshow":"Spustit prezentaci",Submit:"Odeslat",Symbols:"Symboly","Travel & Places":"Cestování a místa","Type to search time zone":"Psaním vyhledejte časovou zónu","Unable to search the group":"Nedaří se hledat skupinu","Undo changes":"Vzít změny zpět","Write message, @ to mention someone, : for emoji autocompletion …":"Napište zprávu – pokud chcete někoho zmínit, napište před jeho uživatelským jménem @ (zavináč); automatické doplňování emotikonů zahájíte napsáním : (dvojtečky)…"}},{locale:"da",translations:{"{tag} (invisible)":"{tag} (usynlig)","{tag} (restricted)":"{tag} (begrænset)",Actions:"Handlinger",Activities:"Aktiviteter","Animals & Nature":"Dyr & Natur",Choose:"Vælg",Close:"Luk",Custom:"Brugerdefineret",Flags:"Flag","Food & Drink":"Mad & Drikke","Frequently used":"Ofte brugt","Message limit of {count} characters reached":"Begrænsning på {count} tegn er nået",Next:"Videre","No emoji found":"Ingen emoji fundet","No results":"Ingen resultater",Objects:"Objekter","Pause slideshow":"Suspender fremvisning","People & Body":"Mennesker & Menneskekroppen","Pick an emoji":"Vælg en emoji",Previous:"Forrige",Search:"Søg","Search results":"Søgeresultater","Select a tag":"Vælg et mærke",Settings:"Indstillinger","Settings navigation":"Naviger i indstillinger","Smileys & Emotion":"Smileys & Emotion","Start slideshow":"Start fremvisning",Symbols:"Symboler","Travel & Places":"Rejser & Rejsemål","Unable to search the group":"Kan ikke søge på denne gruppe","Write message, @ to mention someone …":"Skriv i meddelelse, @ for at nævne nogen  …"}},{locale:"de",translations:{"{tag} (invisible)":"{tag} (unsichtbar)","{tag} (restricted)":"{tag} (eingeschränkt)",Actions:"Aktionen",Activities:"Aktivitäten","Animals & Nature":"Tiere & Natur","Avatar of {displayName}":"Avatar von {displayName}","Avatar of {displayName}, {status}":"Avatar von {displayName}, {status}","Cancel changes":"Änderungen verwerfen","Change title":"Titel ändern",Choose:"Auswählen","Clear text":"Klartext",Close:"Schließen","Close modal":"Modal schließen","Close navigation":"Navigation schließen","Close sidebar":"Seitenleiste schließen","Confirm changes":"Änderungen bestätigen",Custom:"Benutzerdefiniert","Edit item":"Objekt bearbeiten","Error getting related resources":"Fehler beim Abrufen verwandter Ressourcen","External documentation for {title}":"Externe Dokumentation für {title}",Favorite:"Favorit",Flags:"Flaggen","Food & Drink":"Essen & Trinken","Frequently used":"Häufig verwendet",Global:"Global","Go back to the list":"Zurück zur Liste","Hide password":"Passwort verbergen","Message limit of {count} characters reached":"Nachrichtenlimit von {count} Zeichen erreicht","More items …":"Weitere Elemente …",Next:"Weiter","No emoji found":"Kein Emoji gefunden","No results":"Keine Ergebnisse",Objects:"Gegenstände",Open:"Öffnen",'Open link to "{resourceTitle}"':'Link zu "{resourceTitle}" öffnen',"Open navigation":"Navigation öffnen","Password is secure":"Passwort ist sicher","Pause slideshow":"Diashow pausieren","People & Body":"Menschen & Körper","Pick a date":"Ein Datum auswählen","Pick a date and a time":"Datum und Uhrzeit auswählen","Pick a month":"Einen Monat auswählen","Pick a time":"Eine Uhrzeit auswählen","Pick a week":"Eine Woche auswählen","Pick a year":"Ein Jahr auswählen","Pick an emoji":"Ein Emoji auswählen","Please select a time zone:":"Bitte wählen Sie eine Zeitzone:",Previous:"Vorherige","Related resources":"Verwandte Ressourcen",Search:"Suche","Search results":"Suchergebnisse","Select a tag":"Schlagwort auswählen",Settings:"Einstellungen","Settings navigation":"Einstellungen für die Navigation","Show password":"Passwort anzeigen","Smileys & Emotion":"Smileys & Emotionen","Start slideshow":"Diashow starten",Submit:"Einreichen",Symbols:"Symbole","Travel & Places":"Reisen & Orte","Type to search time zone":"Tippen, um Zeitzone zu suchen","Unable to search the group":"Die Gruppe konnte nicht durchsucht werden","Undo changes":"Änderungen rückgängig machen","Write message, @ to mention someone, : for emoji autocompletion …":"Nachricht schreiben, @, um jemanden zu erwähnen, : für die automatische Vervollständigung von Emojis … "}},{locale:"de_DE",translations:{"{tag} (invisible)":"{tag} (unsichtbar)","{tag} (restricted)":"{tag} (eingeschränkt)",Actions:"Aktionen",Activities:"Aktivitäten","Animals & Nature":"Tiere & Natur","Avatar of {displayName}":"Avatar von {displayName}","Avatar of {displayName}, {status}":"Avatar von {displayName}, {status}","Cancel changes":"Änderungen verwerfen","Change title":"Titel ändern",Choose:"Auswählen","Clear text":"Klartext",Close:"Schließen","Close modal":"Modal schließen","Close navigation":"Navigation schließen","Close sidebar":"Seitenleiste schließen","Confirm changes":"Änderungen bestätigen",Custom:"Benutzerdefiniert","Edit item":"Objekt bearbeiten","Error getting related resources":"Fehler beim Abrufen verwandter Ressourcen","External documentation for {title}":"Externe Dokumentation für {title}",Favorite:"Favorit",Flags:"Flaggen","Food & Drink":"Essen & Trinken","Frequently used":"Häufig verwendet",Global:"Global","Go back to the list":"Zurück zur Liste","Hide password":"Passwort verbergen","Message limit of {count} characters reached":"Nachrichtenlimit von {count} Zeichen erreicht","More items …":"Weitere Elemente …",Next:"Weiter","No emoji found":"Kein Emoji gefunden","No results":"Keine Ergebnisse",Objects:"Objekte",Open:"Öffnen",'Open link to "{resourceTitle}"':'Link zu "{resourceTitle}" öffnen',"Open navigation":"Navigation öffnen","Password is secure":"Passwort ist sicher","Pause slideshow":"Diashow pausieren","People & Body":"Menschen & Körper","Pick a date":"Ein Datum auswählen","Pick a date and a time":"Datum und Uhrzeit auswählen","Pick a month":"Einen Monat auswählen","Pick a time":"Eine Uhrzeit auswählen","Pick a week":"Eine Woche auswählen","Pick a year":"Ein Jahr auswählen","Pick an emoji":"Ein Emoji auswählen","Please select a time zone:":"Bitte eine Zeitzone auswählen:",Previous:"Vorherige","Related resources":"Verwandte Ressourcen",Search:"Suche","Search results":"Suchergebnisse","Select a tag":"Schlagwort auswählen",Settings:"Einstellungen","Settings navigation":"Einstellungen für die Navigation","Show password":"Passwort anzeigen","Smileys & Emotion":"Smileys & Emotionen","Start slideshow":"Diashow starten",Submit:"Einreichen",Symbols:"Symbole","Travel & Places":"Reisen & Orte","Type to search time zone":"Tippen, um eine Zeitzone zu suchen","Unable to search the group":"Die Gruppe kann nicht durchsucht werden","Undo changes":"Änderungen rückgängig machen","Write message, @ to mention someone, : for emoji autocompletion …":"Nachricht schreiben, @, um jemanden zu erwähnen, : für die automatische Vervollständigung von Emojis …"}},{locale:"el",translations:{"{tag} (invisible)":"{tag} (αόρατο)","{tag} (restricted)":"{tag} (περιορισμένο)",Actions:"Ενέργειες",Activities:"Δραστηριότητες","Animals & Nature":"Ζώα & Φύση","Avatar of {displayName}":"Άβαταρ του {displayName}","Cancel changes":"Ακύρωση αλλαγών",Choose:"Επιλογή",Close:"Κλείσιμο","Close navigation":"Κλείσιμο πλοήγησης","Confirm changes":"Επιβεβαίωση αλλαγών",Custom:"Προσαρμογή","Edit item":"Επεξεργασία","External documentation for {title}":"Εξωτερική τεκμηρίωση για {title}",Flags:"Σημαίες","Food & Drink":"Φαγητό & Ποτό","Frequently used":"Συχνά χρησιμοποιούμενο",Global:"Καθολικό","Go back to the list":"Επιστροφή στην αρχική λίστα ","Message limit of {count} characters reached":"Συμπληρώθηκε το όριο των {count} χαρακτήρων του μηνύματος",Next:"Επόμενο","No emoji found":"Δεν βρέθηκε emoji","No results":"Κανένα αποτέλεσμα",Objects:"Αντικείμενα","Open navigation":"Άνοιγμα πλοήγησης","Pause slideshow":"Παύση προβολής διαφανειών","People & Body":"Άνθρωποι & Σώμα","Pick an emoji":"Επιλέξτε ένα emoji","Please select a time zone:":"Παρακαλούμε επιλέξτε μια ζώνη ώρας:",Previous:"Προηγούμενο",Search:"Αναζήτηση","Search results":"Αποτελέσματα αναζήτησης","Select a tag":"Επιλογή ετικέτας",Settings:"Ρυθμίσεις","Settings navigation":"Πλοήγηση ρυθμίσεων","Smileys & Emotion":"Φατσούλες & Συναίσθημα","Start slideshow":"Έναρξη προβολής διαφανειών",Submit:"Υποβολή",Symbols:"Σύμβολα","Travel & Places":"Ταξίδια & Τοποθεσίες","Type to search time zone":"Πληκτρολογήστε για αναζήτηση ζώνης ώρας","Unable to search the group":"Δεν είναι δυνατή η αναζήτηση της ομάδας","Undo changes":"Αναίρεση Αλλαγών","Write message, @ to mention someone …":"Γράψτε ένα μήνυμα, και με το σύμβολο @, μνημονεύστε κάποιον …"}},{locale:"en_GB",translations:{"{tag} (invisible)":"{tag} (invisible)","{tag} (restricted)":"{tag} (restricted)",Actions:"Actions",Activities:"Activities","Animals & Nature":"Animals & Nature","Avatar of {displayName}":"Avatar of {displayName}","Avatar of {displayName}, {status}":"Avatar of {displayName}, {status}","Cancel changes":"Cancel changes","Change title":"Change title",Choose:"Choose",Close:"Close","Close modal":"Close modal","Close navigation":"Close navigation","Close sidebar":"Close sidebar","Confirm changes":"Confirm changes",Custom:"Custom","Edit item":"Edit item","External documentation for {title}":"External documentation for {title}",Favorite:"Favourite",Flags:"Flags","Food & Drink":"Food & Drink","Frequently used":"Frequently used",Global:"Global","Go back to the list":"Go back to the list",items:"items","Message limit of {count} characters reached":"Message limit of {count} characters reached","More {dashboardItemType} …":"More {dashboardItemType} …",Next:"Next","No emoji found":"No emoji found","No results":"No results",Objects:"Objects",Open:"Open","Open navigation":"Open navigation","Pause slideshow":"Pause slideshow","People & Body":"People & Body","Pick an emoji":"Pick an emoji","Please select a time zone:":"Please select a time zone:",Previous:"Previous",Search:"Search","Search results":"Search results","Select a tag":"Select a tag",Settings:"Settings","Settings navigation":"Settings navigation","Smileys & Emotion":"Smileys & Emotion","Start slideshow":"Start slideshow",Submit:"Submit",Symbols:"Symbols","Travel & Places":"Travel & Places","Type to search time zone":"Type to search time zone","Unable to search the group":"Unable to search the group","Undo changes":"Undo changes","Write message, @ to mention someone, : for emoji autocompletion …":"Write message, @ to mention someone, : for emoji autocompletion …"}},{locale:"eo",translations:{"{tag} (invisible)":"{tag} (kaŝita)","{tag} (restricted)":"{tag} (limigita)",Actions:"Agoj",Activities:"Aktiveco","Animals & Nature":"Bestoj & Naturo",Choose:"Elektu",Close:"Fermu",Custom:"Propra",Flags:"Flagoj","Food & Drink":"Manĝaĵo & Trinkaĵo","Frequently used":"Ofte uzataj","Message limit of {count} characters reached":"La limo je {count} da literoj atingita",Next:"Sekva","No emoji found":"La emoĝio forestas","No results":"La rezulto forestas",Objects:"Objektoj","Pause slideshow":"Payzi bildprezenton","People & Body":"Homoj & Korpo","Pick an emoji":"Elekti emoĝion ",Previous:"Antaŭa",Search:"Serĉi","Search results":"Serĉrezultoj","Select a tag":"Elektu etikedon",Settings:"Agordo","Settings navigation":"Agorda navigado","Smileys & Emotion":"Ridoj kaj Emocioj","Start slideshow":"Komenci bildprezenton",Symbols:"Signoj","Travel & Places":"Vojaĵoj & Lokoj","Unable to search the group":"Ne eblas serĉi en la grupo","Write message, @ to mention someone …":"Mesaĝi, uzu @ por mencii iun ..."}},{locale:"es",translations:{"{tag} (invisible)":"{tag} (invisible)","{tag} (restricted)":"{tag} (restringido)",Actions:"Acciones",Activities:"Actividades","Animals & Nature":"Animales y naturaleza","Avatar of {displayName}":"Avatar de {displayName}","Avatar of {displayName}, {status}":"Avatar de {displayName}, {status}","Cancel changes":"Cancelar cambios","Change title":"Cambiar título",Choose:"Elegir",Close:"Cerrar","Close modal":"Cerrar modal","Close navigation":"Cerrar navegación","Confirm changes":"Confirmar cambios",Custom:"Personalizado","Edit item":"Editar elemento","External documentation for {title}":"Documentacion externa de {title}",Favorite:"Favorito",Flags:"Banderas","Food & Drink":"Comida y bebida","Frequently used":"Usado con frecuenca",Global:"Global","Go back to the list":"Volver a la lista",items:"elementos","Message limit of {count} characters reached":"El mensaje ha alcanzado el límite de {count} caracteres","More {dashboardItemType} …":"Más {dashboardItemType} ...",Next:"Siguiente","No emoji found":"No hay ningún emoji","No results":" Ningún resultado",Objects:"Objetos",Open:"Abrir","Open navigation":"Abrir navegación","Pause slideshow":"Pausar la presentación ","People & Body":"Personas y cuerpos","Pick an emoji":"Elegir un emoji","Please select a time zone:":"Por favor elige un huso de horario:",Previous:"Anterior",Search:"Buscar","Search results":"Resultados de la búsqueda","Select a tag":"Seleccione una etiqueta",Settings:"Ajustes","Settings navigation":"Navegación por ajustes","Smileys & Emotion":"Smileys y emoticonos","Start slideshow":"Iniciar la presentación",Submit:"Enviar",Symbols:"Símbolos","Travel & Places":"Viajes y lugares","Type to search time zone":"Escribe para buscar un huso de horario","Unable to search the group":"No es posible buscar en el grupo","Undo changes":"Deshacer cambios","Write message, @ to mention someone, : for emoji autocompletion …":"Escribe un mensaje, @ para mencionar a alguien, : para autocompletado de emoji ..."}},{locale:"eu",translations:{"{tag} (invisible)":"{tag} (ikusezina)","{tag} (restricted)":"{tag} (mugatua)",Actions:"Ekintzak",Activities:"Jarduerak","Animals & Nature":"Animaliak eta Natura","Avatar of {displayName}":"{displayName}-(e)n irudia","Avatar of {displayName}, {status}":"{displayName} -(e)n irudia, {status}","Cancel changes":"Ezeztatu aldaketak","Change title":"Aldatu titulua",Choose:"Aukeratu",Close:"Itxi","Close modal":"Itxi modala","Close navigation":"Itxi nabigazioa","Close sidebar":"Itxi albo-barra","Confirm changes":"Baieztatu aldaketak",Custom:"Pertsonalizatua","Edit item":"Editatu elementua","External documentation for {title}":"Kanpoko dokumentazioa {title}(r)entzat",Favorite:"Gogokoa",Flags:"Banderak","Food & Drink":"Janaria eta edariak","Frequently used":"Askotan erabilia",Global:"Globala","Go back to the list":"Bueltatu zerrendara",items:"elementuak","Message limit of {count} characters reached":"Mezuaren {count} karaketere-limitera heldu zara","More {dashboardItemType} …":"{dashboardItemType} gehiago…",Next:"Hurrengoa","No emoji found":"Ez da emojirik aurkitu","No results":"Emaitzarik ez",Objects:"Objektuak",Open:"Ireki","Open navigation":"Ireki nabigazioa","Pause slideshow":"Pausatu diaporama","People & Body":"Jendea eta gorputza","Pick an emoji":"Aukeratu emoji bat","Please select a time zone:":"Mesedez hautatu ordu-zona bat:",Previous:"Aurrekoa",Search:"Bilatu","Search results":"Bilaketa emaitzak","Select a tag":"Hautatu etiketa bat",Settings:"Ezarpenak","Settings navigation":"Nabigazio ezarpenak","Smileys & Emotion":"Smileyak eta emozioa","Start slideshow":"Hasi diaporama",Submit:"Bidali",Symbols:"Sinboloak","Travel & Places":"Bidaiak eta lekuak","Type to search time zone":"Idatzi ordu-zona bat bilatzeko","Unable to search the group":"Ezin izan da taldea bilatu","Undo changes":"Aldaketak desegin","Write message, @ to mention someone, : for emoji autocompletion …":"Idatzi mezua, @ norbait aipatzeko, : emojia automatikoki idazteko"}},{locale:"fi_FI",translations:{"{tag} (invisible)":"{tag} (näkymätön)","{tag} (restricted)":"{tag} (rajoitettu)",Actions:"Toiminnot",Activities:"Aktiviteetit","Animals & Nature":"Eläimet & luonto","Avatar of {displayName}":"Käyttäjän {displayName} avatar","Avatar of {displayName}, {status}":"Käyttäjän {displayName} avatar, {status}","Cancel changes":"Peruuta muutokset",Choose:"Valitse",Close:"Sulje","Close navigation":"Sulje navigaatio","Confirm changes":"Vahvista muutokset",Custom:"Mukautettu","Edit item":"Muokkaa kohdetta","External documentation for {title}":"Ulkoinen dokumentaatio kohteelle {title}",Flags:"Liput","Food & Drink":"Ruoka & juoma","Frequently used":"Usein käytetyt",Global:"Yleinen","Go back to the list":"Siirry takaisin listaan","Message limit of {count} characters reached":"Viestin merkken enimmäisimäärä {count} täynnä ",Next:"Seuraava","No emoji found":"Emojia ei löytynyt","No results":"Ei tuloksia",Objects:"Esineet & asiat","Open navigation":"Avaa navigaatio","Pause slideshow":"Keskeytä diaesitys","People & Body":"Ihmiset & keho","Pick an emoji":"Valitse emoji","Please select a time zone:":"Valitse aikavyöhyke:",Previous:"Edellinen",Search:"Etsi","Search results":"Hakutulokset","Select a tag":"Valitse tagi",Settings:"Asetukset","Settings navigation":"Asetusnavigaatio","Smileys & Emotion":"Hymiöt & tunteet","Start slideshow":"Aloita diaesitys",Submit:"Lähetä",Symbols:"Symbolit","Travel & Places":"Matkustus & kohteet","Type to search time zone":"Kirjoita etsiäksesi aikavyöhyke","Unable to search the group":"Ryhmää ei voi hakea","Undo changes":"Kumoa muutokset","Write message, @ to mention someone, : for emoji autocompletion …":"Kirjoita viesti, @ mainitaksesi käyttäjän, : emojin automaattitäydennykseen…"}},{locale:"fr",translations:{"{tag} (invisible)":"{tag} (invisible)","{tag} (restricted)":"{tag} (restreint)",Actions:"Actions",Activities:"Activités","Animals & Nature":"Animaux & Nature","Avatar of {displayName}":"Avatar de {displayName}","Avatar of {displayName}, {status}":"Avatar de {displayName}, {status}","Cancel changes":"Annuler les modifications",Choose:"Choisir",Close:"Fermer","Close modal":"Fermer la fenêtre","Close navigation":"Fermer la navigation","Confirm changes":"Confirmer les modifications",Custom:"Personnalisé","Edit item":"Éditer l'élément","External documentation for {title}":"Documentation externe pour {title}",Flags:"Drapeaux","Food & Drink":"Nourriture & Boissons","Frequently used":"Utilisés fréquemment",Global:"Global","Go back to the list":"Retourner à la liste",items:"éléments","Message limit of {count} characters reached":"Limite de messages de {count} caractères atteinte","More {dashboardItemType} …":"Plus de {dashboardItemType} …",Next:"Suivant","No emoji found":"Pas d’émoji trouvé","No results":"Aucun résultat",Objects:"Objets",Open:"Ouvrir","Open navigation":"Ouvrir la navigation","Pause slideshow":"Mettre le diaporama en pause","People & Body":"Personnes & Corps","Pick an emoji":"Choisissez un émoji","Please select a time zone:":"Sélectionnez un fuseau horaire : ",Previous:"Précédent",Search:"Chercher","Search results":"Résultats de recherche","Select a tag":"Sélectionnez une balise",Settings:"Paramètres","Settings navigation":"Navigation dans les paramètres","Smileys & Emotion":"Smileys & Émotions","Start slideshow":"Démarrer le diaporama",Submit:"Valider",Symbols:"Symboles","Travel & Places":"Voyage & Lieux","Type to search time zone":"Saisissez les premiers lettres pour rechercher un fuseau horaire","Unable to search the group":"Impossible de chercher le groupe","Undo changes":"Annuler les changements","Write message, @ to mention someone, : for emoji autocompletion …":"Ecrire un message, @ pour mentionner quelqu'un, : pour l'auto-complétion des émoticônes"}},{locale:"gl",translations:{"{tag} (invisible)":"{tag} (invisíbel)","{tag} (restricted)":"{tag} (restrinxido)",Actions:"Accións",Activities:"Actividades","Animals & Nature":"Animais e natureza","Cancel changes":"Cancelar os cambios",Choose:"Escoller",Close:"Pechar","Confirm changes":"Confirma os cambios",Custom:"Personalizado","External documentation for {title}":"Documentación externa para {title}",Flags:"Bandeiras","Food & Drink":"Comida e bebida","Frequently used":"Usado con frecuencia","Message limit of {count} characters reached":"Acadouse o límite de {count} caracteres por mensaxe",Next:"Seguinte","No emoji found":"Non se atopou ningún «emoji»","No results":"Sen resultados",Objects:"Obxectos","Pause slideshow":"Pausar o diaporama","People & Body":"Persoas e corpo","Pick an emoji":"Escolla un «emoji»",Previous:"Anterir",Search:"Buscar","Search results":"Resultados da busca","Select a tag":"Seleccione unha etiqueta",Settings:"Axustes","Settings navigation":"Navegación polos axustes","Smileys & Emotion":"Sorrisos e emocións","Start slideshow":"Iniciar o diaporama",Submit:"Enviar",Symbols:"Símbolos","Travel & Places":"Viaxes e lugares","Unable to search the group":"Non foi posíbel buscar o grupo","Write message, @ to mention someone …":"Escriba a mensaxe, @ para mencionar a alguén…"}},{locale:"he",translations:{"{tag} (invisible)":"{tag} (נסתר)","{tag} (restricted)":"{tag} (מוגבל)",Actions:"פעולות",Activities:"פעילויות","Animals & Nature":"חיות וטבע",Choose:"בחירה",Close:"סגירה",Custom:"בהתאמה אישית",Flags:"דגלים","Food & Drink":"מזון ומשקאות","Frequently used":"בשימוש תדיר",Next:"הבא","No emoji found":"לא נמצא אמוג׳י","No results":"אין תוצאות",Objects:"חפצים","Pause slideshow":"השהיית מצגת","People & Body":"אנשים וגוף","Pick an emoji":"נא לבחור אמוג׳י",Previous:"הקודם",Search:"חיפוש","Search results":"תוצאות חיפוש","Select a tag":"בחירת תגית",Settings:"הגדרות","Smileys & Emotion":"חייכנים ורגשונים","Start slideshow":"התחלת המצגת",Symbols:"סמלים","Travel & Places":"טיולים ומקומות","Unable to search the group":"לא ניתן לחפש בקבוצה"}},{locale:"hu_HU",translations:{"{tag} (invisible)":"{tag} (láthatatlan)","{tag} (restricted)":"{tag} (korlátozott)",Actions:"Műveletek",Activities:"Tevékenységek","Animals & Nature":"Állatok és természet","Avatar of {displayName}":"{displayName} profilképe","Avatar of {displayName}, {status}":"{displayName} profilképe, {status}","Cancel changes":"Változtatások elvetése",Choose:"Válassszon",Close:"Bezárás","Close modal":"Ablak bezárása","Close navigation":"Navigáció bezárása","Confirm changes":"Változtatások megerősítése",Custom:"Egyéni","Edit item":"Elem szerkesztése","External documentation for {title}":"Külső dokumentáció ehhez: {title}",Flags:"Zászló","Food & Drink":"Étel és ital","Frequently used":"Gyakran használt",Global:"Globális","Go back to the list":"Ugrás vissza a listához",items:"elemek","Message limit of {count} characters reached":"{count} karakteres üzenetkorlát elérve","More {dashboardItemType} …":"Több {dashboardItemType}…",Next:"Következő","No emoji found":"Nem található emodzsi","No results":"Nincs találat",Objects:"Tárgyak",Open:"Megnyitás","Open navigation":"Navigáció megnyitása","Pause slideshow":"Diavetítés szüneteltetése","People & Body":"Emberek és test","Pick an emoji":"Válasszon egy emodzsit","Please select a time zone:":"Válasszon időzónát:",Previous:"Előző",Search:"Keresés","Search results":"Találatok","Select a tag":"Válasszon címkét",Settings:"Beállítások","Settings navigation":"Navigáció a beállításokban","Smileys & Emotion":"Mosolyok és érzelmek","Start slideshow":"Diavetítés indítása",Submit:"Beküldés",Symbols:"Szimbólumok","Travel & Places":"Utazás és helyek","Type to search time zone":"Gépeljen az időzóna kereséséhez","Unable to search the group":"A csoport nem kereshető","Undo changes":"Változtatások visszavonása","Write message, @ to mention someone, : for emoji autocompletion …":"Írjon üzenetet, @ valaki megemlítéséhez, : az emodzsik automatikus kiegészítéséhez…"}},{locale:"is",translations:{"{tag} (invisible)":"{tag} (ósýnilegt)","{tag} (restricted)":"{tag} (takmarkað)",Actions:"Aðgerðir",Activities:"Aðgerðir","Animals & Nature":"Dýr og náttúra",Choose:"Velja",Close:"Loka",Custom:"Sérsniðið",Flags:"Flögg","Food & Drink":"Matur og drykkur","Frequently used":"Oftast notað",Next:"Næsta","No emoji found":"Ekkert tjáningartákn fannst","No results":"Engar niðurstöður",Objects:"Hlutir","Pause slideshow":"Gera hlé á skyggnusýningu","People & Body":"Fólk og líkami","Pick an emoji":"Veldu tjáningartákn",Previous:"Fyrri",Search:"Leita","Search results":"Leitarniðurstöður","Select a tag":"Veldu merki",Settings:"Stillingar","Smileys & Emotion":"Broskallar og tilfinningar","Start slideshow":"Byrja skyggnusýningu",Symbols:"Tákn","Travel & Places":"Staðir og ferðalög","Unable to search the group":"Get ekki leitað í hópnum"}},{locale:"it",translations:{"{tag} (invisible)":"{tag} (invisibile)","{tag} (restricted)":"{tag} (limitato)",Actions:"Azioni",Activities:"Attività","Animals & Nature":"Animali e natura","Avatar of {displayName}":"Avatar di {displayName}","Avatar of {displayName}, {status}":"Avatar di {displayName}, {status}","Cancel changes":"Annulla modifiche",Choose:"Scegli",Close:"Chiudi","Close navigation":"Chiudi la navigazione","Confirm changes":"Conferma modifiche",Custom:"Personalizzato","Edit item":"Modifica l'elemento","External documentation for {title}":"Documentazione esterna per {title}",Flags:"Bandiere","Food & Drink":"Cibo e bevande","Frequently used":"Usati di frequente",Global:"Globale","Go back to the list":"Torna all'elenco","Message limit of {count} characters reached":"Limite dei messaggi di {count} caratteri raggiunto",Next:"Successivo","No emoji found":"Nessun emoji trovato","No results":"Nessun risultato",Objects:"Oggetti","Open navigation":"Apri la navigazione","Pause slideshow":"Presentazione in pausa","People & Body":"Persone e corpo","Pick an emoji":"Scegli un emoji","Please select a time zone:":"Si prega di selezionare un fuso orario:",Previous:"Precedente",Search:"Cerca","Search results":"Risultati di ricerca","Select a tag":"Seleziona un'etichetta",Settings:"Impostazioni","Settings navigation":"Navigazione delle impostazioni","Smileys & Emotion":"Faccine ed emozioni","Start slideshow":"Avvia presentazione",Submit:"Invia",Symbols:"Simboli","Travel & Places":"Viaggi e luoghi","Type to search time zone":"Digita per cercare un fuso orario","Unable to search the group":"Impossibile cercare il gruppo","Undo changes":"Cancella i cambiamenti","Write message, @ to mention someone, : for emoji autocompletion …":"Scrivi un messaggio, @ per menzionare qualcuno, : per il completamento automatico delle emoji ..."}},{locale:"ja_JP",translations:{"{tag} (invisible)":"{タグ} (不可視)","{tag} (restricted)":"{タグ} (制限付)",Actions:"操作",Activities:"アクティビティ","Animals & Nature":"動物と自然","Avatar of {displayName}":"{displayName} のアバター","Avatar of {displayName}, {status}":"{displayName}, {status} のアバター","Cancel changes":"変更をキャンセル","Change title":"タイトルを変更",Choose:"選択","Clear text":"テキストをクリア",Close:"閉じる","Close modal":"モーダルを閉じる","Close navigation":"ナビゲーションを閉じる","Close sidebar":"サイドバーを閉じる","Confirm changes":"変更を承認",Custom:"カスタム","Edit item":"編集","Error getting related resources":"関連リソースの取得エラー","External documentation for {title}":"{title} のための添付文書",Favorite:"お気に入り",Flags:"国旗","Food & Drink":"食べ物と飲み物","Frequently used":"よく使うもの",Global:"全体","Go back to the list":"リストに戻る","Hide password":"パスワードを非表示",items:"アイテム","Message limit of {count} characters reached":"{count} 文字のメッセージ上限に達しています","More {dashboardItemType} …":"{dashboardItemType} をさらに表示…",Next:"次","No emoji found":"絵文字が見つかりません","No results":"なし",Objects:"物",Open:"開く",'Open link to "{resourceTitle}"':'"{resourceTitle}"のリンクを開く',"Open navigation":"ナビゲーションを開く","Password is secure":"パスワードは保護されています","Pause slideshow":"スライドショーを一時停止","People & Body":"様々な人と体の部位","Pick a date":"日付を選択してください","Pick a date and a time":"日付と時刻を選択してください","Pick a month":"月を選択してください","Pick a time":"時間を選択してください","Pick a week":"週を選択してください","Pick a year":"年を選択してください","Pick an emoji":"絵文字を選択","Please select a time zone:":"タイムゾーンを選んで下さい：",Previous:"前","Related resources":"関連リソース",Search:"検索","Search results":"検索結果","Select a tag":"タグを選択",Settings:"設定","Settings navigation":"ナビゲーション設定","Show password":"パスワードを表示","Smileys & Emotion":"感情表現","Start slideshow":"スライドショーを開始",Submit:"提出",Symbols:"記号","Travel & Places":"旅行と場所","Type to search time zone":"タイムゾーン検索のため入力してください","Unable to search the group":"グループを検索できません","Undo changes":"変更を取り消し","Write message, @ to mention someone, : for emoji autocompletion …":"メッセージを書く、@で誰かを紹介する、: で絵文字を自動補完する ..."}},{locale:"lt_LT",translations:{"{tag} (invisible)":"{tag} (nematoma)","{tag} (restricted)":"{tag} (apribota)",Actions:"Veiksmai",Activities:"Veiklos","Animals & Nature":"Gyvūnai ir gamta",Choose:"Pasirinkti",Close:"Užverti",Custom:"Tinkinti","External documentation for {title}":"Išorinė {title} dokumentacija",Flags:"Vėliavos","Food & Drink":"Maistas ir gėrimai","Frequently used":"Dažniausiai naudoti","Message limit of {count} characters reached":"Pasiekta {count} simbolių žinutės riba",Next:"Kitas","No emoji found":"Nerasta jaustukų","No results":"Nėra rezultatų",Objects:"Objektai","Pause slideshow":"Pristabdyti skaidrių rodymą","People & Body":"Žmonės ir kūnas","Pick an emoji":"Pasirinkti jaustuką",Previous:"Ankstesnis",Search:"Ieškoti","Search results":"Paieškos rezultatai","Select a tag":"Pasirinkti žymę",Settings:"Nustatymai","Settings navigation":"Naršymas nustatymuose","Smileys & Emotion":"Šypsenos ir emocijos","Start slideshow":"Pradėti skaidrių rodymą",Submit:"Pateikti",Symbols:"Simboliai","Travel & Places":"Kelionės ir vietos","Unable to search the group":"Nepavyko atlikti paiešką grupėje","Write message, @ to mention someone …":"Rašykite žinutę, naudokite @ norėdami kažką paminėti…"}},{locale:"lv",translations:{"{tag} (invisible)":"{tag} (neredzams)","{tag} (restricted)":"{tag} (ierobežots)",Choose:"Izvēlēties",Close:"Aizvērt",Next:"Nākamais","No results":"Nav rezultātu","Pause slideshow":"Pauzēt slaidrādi",Previous:"Iepriekšējais","Select a tag":"Izvēlēties birku",Settings:"Iestatījumi","Start slideshow":"Sākt slaidrādi"}},{locale:"mk",translations:{"{tag} (invisible)":"{tag} (невидливо)","{tag} (restricted)":"{tag} (ограничено)",Actions:"Акции",Activities:"Активности","Animals & Nature":"Животни & Природа","Avatar of {displayName}":"Аватар на {displayName}","Avatar of {displayName}, {status}":"Аватар на {displayName}, {status}","Cancel changes":"Откажи ги промените","Change title":"Промени наслов",Choose:"Избери",Close:"Затвори","Close modal":"Затвори модал","Close navigation":"Затвори навигација","Confirm changes":"Потврди ги промените",Custom:"Прилагодени","Edit item":"Уреди","External documentation for {title}":"Надворешна документација за {title}",Favorite:"Фаворити",Flags:"Знамиња","Food & Drink":"Храна & Пијалоци","Frequently used":"Најчесто користени",Global:"Глобално","Go back to the list":"Врати се на листата",items:"ставки","Message limit of {count} characters reached":"Ограничувањето на должината на пораката од {count} карактери е надминато","More {dashboardItemType} …":"Повеќе {dashboardItemType} …",Next:"Следно","No emoji found":"Не се пронајдени емотикони","No results":"Нема резултати",Objects:"Објекти",Open:"Отвори","Open navigation":"Отвори навигација","Pause slideshow":"Пузирај слајдшоу","People & Body":"Луѓе & Тело","Pick an emoji":"Избери емотикон","Please select a time zone:":"Изберете временска зона:",Previous:"Предходно",Search:"Барај","Search results":"Резултати од барувањето","Select a tag":"Избери ознака",Settings:"Параметри","Settings navigation":"Параметри за навигација","Smileys & Emotion":"Смешковци & Емотикони","Start slideshow":"Стартувај слајдшоу",Submit:"Испрати",Symbols:"Симболи","Travel & Places":"Патувања & Места","Type to search time zone":"Напишете за да пребарате временска зона","Unable to search the group":"Неможе да се принајде групата","Undo changes":"Врати ги промените","Write message, @ to mention someone, : for emoji autocompletion …":"Напиши порака, @ за да спомнете некого, : за емотинони автоатско комплетирање ..."}},{locale:"my",translations:{"{tag} (invisible)":"{tag} (ကွယ်ဝှက်ထား)","{tag} (restricted)":"{tag} (ကန့်သတ်)",Actions:"လုပ်ဆောင်ချက်များ",Activities:"ပြုလုပ်ဆောင်တာများ","Animals & Nature":"တိရစ္ဆာန်များနှင့် သဘာဝ","Avatar of {displayName}":"{displayName} ၏ ကိုယ်ပွား","Cancel changes":"ပြောင်းလဲမှုများ ပယ်ဖျက်ရန်",Choose:"ရွေးချယ်ရန်",Close:"ပိတ်ရန်","Confirm changes":"ပြောင်းလဲမှုများ အတည်ပြုရန်",Custom:"အလိုကျချိန်ညှိမှု","External documentation for {title}":"{title} အတွက် ပြင်ပ စာရွက်စာတမ်း",Flags:"အလံများ","Food & Drink":"အစားအသောက်","Frequently used":"မကြာခဏအသုံးပြုသော",Global:"ကမ္ဘာလုံးဆိုင်ရာ","Message limit of {count} characters reached":"ကန့်သတ် စာလုံးရေ {count} လုံး ပြည့်ပါပြီ",Next:"နောက်သို့ဆက်ရန်","No emoji found":"အီမိုဂျီ ရှာဖွေမတွေ့နိုင်ပါ","No results":"ရလဒ်မရှိပါ",Objects:"အရာဝတ္ထုများ","Pause slideshow":"စလိုက်ရှိုး ခေတ္တရပ်ရန်","People & Body":"လူပုဂ္ဂိုလ်များနှင့် ခန္ဓာကိုယ်","Pick an emoji":"အီမိုဂျီရွေးရန်","Please select a time zone:":"ဒေသစံတော်ချိန် ရွေးချယ်ပေးပါ",Previous:"ယခင်",Search:"ရှာဖွေရန်","Search results":"ရှာဖွေမှု ရလဒ်များ","Select a tag":"tag ရွေးချယ်ရန်",Settings:"ချိန်ညှိချက်များ","Settings navigation":"ချိန်ညှိချက်အညွှန်း","Smileys & Emotion":"စမိုင်လီများနှင့် အီမိုရှင်း","Start slideshow":"စလိုက်ရှိုးအား စတင်ရန်",Submit:"တင်သွင်းရန်",Symbols:"သင်္ကေတများ","Travel & Places":"ခရီးသွားလာခြင်းနှင့် နေရာများ","Type to search time zone":"ဒေသစံတော်ချိန်များ ရှာဖွေရန် စာရိုက်ပါ","Unable to search the group":"အဖွဲ့အား ရှာဖွေ၍ မရနိုင်ပါ","Write message, @ to mention someone …":"စာရေးသားရန်၊ တစ်စုံတစ်ဦးအား @ အသုံးပြု ရည်ညွှန်းရန်..."}},{locale:"nb_NO",translations:{"{tag} (invisible)":"{tag} (usynlig)","{tag} (restricted)":"{tag} (beskyttet)",Actions:"Handlinger",Activities:"Aktiviteter","Animals & Nature":"Dyr og natur","Avatar of {displayName}":"Avataren til {displayName}","Avatar of {displayName}, {status}":"{displayName}'s avatar, {status}","Cancel changes":"Avbryt endringer","Change title":"Endre tittel",Choose:"Velg",Close:"Lukk","Close modal":"Lukk modal","Close navigation":"Lukk navigasjon","Close sidebar":"Lukk sidepanel","Confirm changes":"Bekreft endringer",Custom:"Tilpasset","Edit item":"Rediger","External documentation for {title}":"Ekstern dokumentasjon for {title}",Favorite:"Favoritt",Flags:"Flagg","Food & Drink":"Mat og drikke","Frequently used":"Ofte brukt",Global:"Global","Go back to the list":"Gå tilbake til listen",items:"enheter","Message limit of {count} characters reached":"Karakter begrensing {count} nådd i melding","More {dashboardItemType} …":"Mer {dashboardItemType} …",Next:"Neste","No emoji found":"Fant ingen emoji","No results":"Ingen resultater",Objects:"Objekter",Open:"Åpne","Open navigation":"Åpne navigasjon","Pause slideshow":"Pause lysbildefremvisning","People & Body":"Mennesker og kropp","Pick an emoji":"Velg en emoji","Please select a time zone:":"Vennligst velg tidssone",Previous:"Forrige",Search:"Søk","Search results":"Søkeresultater","Select a tag":"Velg en merkelapp",Settings:"Innstillinger","Settings navigation":"Navigasjonsinstillinger","Smileys & Emotion":"Smilefjes og følelser","Start slideshow":"Start lysbildefremvisning",Submit:"Send",Symbols:"Symboler","Travel & Places":"Reise og steder","Type to search time zone":"Tast for å søke etter tidssone","Unable to search the group":"Kunne ikke søke i gruppen","Undo changes":"Tilbakestill endringer","Write message, @ to mention someone, : for emoji autocompletion …":"Skriv melding, @ for å nevne noen, : for emoji-autofullføring…"}},{locale:"nl",translations:{"{tag} (invisible)":"{tag} (onzichtbaar)","{tag} (restricted)":"{tag} (beperkt)",Actions:"Acties",Activities:"Activiteiten","Animals & Nature":"Dieren & Natuur","Avatar of {displayName}":"Avatar van {displayName}","Avatar of {displayName}, {status}":"Avatar van {displayName}, {status}","Cancel changes":"Wijzigingen annuleren",Choose:"Kies",Close:"Sluiten","Close navigation":"Navigatie sluiten","Confirm changes":"Wijzigingen bevestigen",Custom:"Aangepast","Edit item":"Item bewerken","External documentation for {title}":"Externe documentatie voor {title}",Flags:"Vlaggen","Food & Drink":"Eten & Drinken","Frequently used":"Vaak gebruikt",Global:"Globaal","Go back to the list":"Ga terug naar de lijst","Message limit of {count} characters reached":"Berichtlimiet van {count} karakters bereikt",Next:"Volgende","No emoji found":"Geen emoji gevonden","No results":"Geen resultaten",Objects:"Objecten","Open navigation":"Navigatie openen","Pause slideshow":"Pauzeer diavoorstelling","People & Body":"Mensen & Lichaam","Pick an emoji":"Kies een emoji","Please select a time zone:":"Selecteer een tijdzone:",Previous:"Vorige",Search:"Zoeken","Search results":"Zoekresultaten","Select a tag":"Selecteer een label",Settings:"Instellingen","Settings navigation":"Instellingen navigatie","Smileys & Emotion":"Smileys & Emotie","Start slideshow":"Start diavoorstelling",Submit:"Verwerken",Symbols:"Symbolen","Travel & Places":"Reizen & Plaatsen","Type to search time zone":"Type om de tijdzone te zoeken","Unable to search the group":"Kan niet in de groep zoeken","Undo changes":"Wijzigingen ongedaan maken","Write message, @ to mention someone, : for emoji autocompletion …":"Schrijf bericht, @ om iemand te noemen, : voor emoji auto-aanvullen ..."}},{locale:"oc",translations:{"{tag} (invisible)":"{tag} (invisible)","{tag} (restricted)":"{tag} (limit)",Actions:"Accions",Choose:"Causir",Close:"Tampar",Next:"Seguent","No results":"Cap de resultat","Pause slideshow":"Metre en pausa lo diaporama",Previous:"Precedent","Select a tag":"Seleccionar una etiqueta",Settings:"Paramètres","Start slideshow":"Lançar lo diaporama"}},{locale:"pl",translations:{"{tag} (invisible)":"{tag} (niewidoczna)","{tag} (restricted)":"{tag} (ograniczona)",Actions:"Działania",Activities:"Aktywność","Animals & Nature":"Zwierzęta i natura","Avatar of {displayName}":"Awatar {displayName}","Avatar of {displayName}, {status}":"Awatar {displayName}, {status}","Cancel changes":"Anuluj zmiany","Change title":"Zmień tytuł",Choose:"Wybierz","Clear text":"Wyczyść tekst",Close:"Zamknij","Close modal":"Zamknij modal","Close navigation":"Zamknij nawigację","Close sidebar":"Zamknij pasek boczny","Confirm changes":"Potwierdź zmiany",Custom:"Zwyczajne","Edit item":"Edytuj element","Error getting related resources":"Błąd podczas pobierania powiązanych zasobów","External documentation for {title}":"Dokumentacja zewnętrzna dla {title}",Favorite:"Ulubiony",Flags:"Flagi","Food & Drink":"Jedzenie i picie","Frequently used":"Często używane",Global:"Globalnie","Go back to the list":"Powrót do listy","Hide password":"Ukryj hasło",items:"elementy","Message limit of {count} characters reached":"Przekroczono limit wiadomości wynoszący {count} znaków","More {dashboardItemType} …":"Więcej {dashboardItemType}…",Next:"Następny","No emoji found":"Nie znaleziono emotikonów","No results":"Brak wyników",Objects:"Obiekty",Open:"Otwórz",'Open link to "{resourceTitle}"':'Otwórz link do "{resourceTitle}"',"Open navigation":"Otwórz nawigację","Password is secure":"Hasło jest bezpieczne","Pause slideshow":"Wstrzymaj pokaz slajdów","People & Body":"Ludzie i ciało","Pick a date":"Wybierz datę","Pick a date and a time":"Wybierz datę i godzinę","Pick a month":"Wybierz miesiąc","Pick a time":"Wybierz czas","Pick a week":"Wybierz tydzień","Pick a year":"Wybierz rok","Pick an emoji":"Wybierz emoji","Please select a time zone:":"Wybierz strefę czasową:",Previous:"Poprzedni","Related resources":"Powiązane zasoby",Search:"Szukaj","Search results":"Wyniki wyszukiwania","Select a tag":"Wybierz etykietę",Settings:"Ustawienia","Settings navigation":"Ustawienia nawigacji","Show password":"Pokaż hasło","Smileys & Emotion":"Buźki i emotikony","Start slideshow":"Rozpocznij pokaz slajdów",Submit:"Wyślij",Symbols:"Symbole","Travel & Places":"Podróże i miejsca","Type to search time zone":"Wpisz, aby wyszukać strefę czasową","Unable to search the group":"Nie można przeszukać grupy","Undo changes":"Cofnij zmiany","Write message, @ to mention someone, : for emoji autocompletion …":"Napisz wiadomość, @ aby o kimś wspomnieć, : dla autouzupełniania emotikon…"}},{locale:"pt_BR",translations:{"{tag} (invisible)":"{tag} (invisível)","{tag} (restricted)":"{tag} (restrito) ",Actions:"Ações",Activities:"Atividades","Animals & Nature":"Animais & Natureza","Avatar of {displayName}":"Avatar de {displayName}","Avatar of {displayName}, {status}":"Avatar de {displayName}, {status}","Cancel changes":"Cancelar alterações","Change title":"Alterar título",Choose:"Escolher",Close:"Fechar","Close modal":"Fechar modal","Close navigation":"Fechar navegação","Close sidebar":"Fechar barra lateral","Confirm changes":"Confirmar alterações",Custom:"Personalizado","Edit item":"Editar item","External documentation for {title}":"Documentação externa para {title}",Favorite:"Favorito",Flags:"Bandeiras","Food & Drink":"Comida & Bebida","Frequently used":"Mais usados",Global:"Global","Go back to the list":"Volte para a lista",items:"itens","Message limit of {count} characters reached":"Limite de mensagem de {count} caracteres atingido","More {dashboardItemType} …":"Mais {dashboardItemType} …",Next:"Próximo","No emoji found":"Nenhum emoji encontrado","No results":"Sem resultados",Objects:"Objetos",Open:"Aberto","Open navigation":"Abrir navegação","Pause slideshow":"Pausar apresentação de slides","People & Body":"Pessoas & Corpo","Pick an emoji":"Escolha um emoji","Please select a time zone:":"Selecione um fuso horário: ",Previous:"Anterior",Search:"Pesquisar","Search results":"Resultados da pesquisa","Select a tag":"Selecionar uma tag",Settings:"Configurações","Settings navigation":"Navegação de configurações","Smileys & Emotion":"Smiles & Emoções","Start slideshow":"Iniciar apresentação de slides",Submit:"Enviar",Symbols:"Símbolo","Travel & Places":"Viagem & Lugares","Type to search time zone":"Digite para pesquisar o fuso horário ","Unable to search the group":"Não foi possível pesquisar o grupo","Undo changes":"Desfazer modificações","Write message, @ to mention someone, : for emoji autocompletion …":"Escreva mensagem, @ para mencionar alguém, : para autocompleção emoji..."}},{locale:"pt_PT",translations:{"{tag} (invisible)":"{tag} (invisivel)","{tag} (restricted)":"{tag} (restrito)",Actions:"Ações",Choose:"Escolher",Close:"Fechar",Next:"Seguinte","No results":"Sem resultados","Pause slideshow":"Pausar diaporama",Previous:"Anterior","Select a tag":"Selecionar uma etiqueta",Settings:"Definições","Start slideshow":"Iniciar diaporama","Unable to search the group":"Não é possível pesquisar o grupo"}},{locale:"ro",translations:{"{tag} (invisible)":"{tag} (invizibil)","{tag} (restricted)":"{tag} (restricționat)",Actions:"Acțiuni",Activities:"Activități","Animals & Nature":"Animale și natură","Avatar of {displayName}":"Avatarul lui {displayName}","Avatar of {displayName}, {status}":"Avatarul lui {displayName}, {status}","Cancel changes":"Anulează modificările","Change title":"Modificați titlul",Choose:"Alegeți",Close:"Închideți","Close modal":"Închideți modulul","Close navigation":"Închideți navigarea","Close sidebar":"Închide bara laterală","Confirm changes":"Confirmați modificările",Custom:"Personalizat","Edit item":"Editați elementul","External documentation for {title}":"Documentație externă pentru {title}",Favorite:"Favorit",Flags:"Marcaje","Food & Drink":"Alimente și băuturi","Frequently used":"Utilizate frecvent",Global:"Global","Go back to the list":"Întoarceți-vă la listă",items:"articole","Message limit of {count} characters reached":"Limita mesajului de {count} caractere a fost atinsă","More {dashboardItemType} …":"Mai multe {dashboardItemType} …",Next:"Următorul","No emoji found":"Nu s-a găsit niciun emoji","No results":"Nu există rezultate",Objects:"Obiecte",Open:"Deschideți","Open navigation":"Deschideți navigația","Pause slideshow":"Pauză prezentare de diapozitive","People & Body":"Oameni și corp","Pick an emoji":"Alege un emoji","Please select a time zone:":"Vă rugăm să selectați un fus orar:",Previous:"Anterior",Search:"Căutare","Search results":"Rezultatele căutării","Select a tag":"Selectați o etichetă",Settings:"Setări","Settings navigation":"Navigare setări","Smileys & Emotion":"Zâmbete și emoții","Start slideshow":"Începeți prezentarea de diapozitive",Submit:"Trimiteți",Symbols:"Simboluri","Travel & Places":"Călătorii și locuri","Type to search time zone":"Tastați pentru a căuta fusul orar","Unable to search the group":"Imposibilitatea de a căuta în grup","Undo changes":"Anularea modificărilor","Write message, @ to mention someone, : for emoji autocompletion …":"Scrieți un mesaj, @ pentru a menționa pe cineva, : pentru autocompletare emoji ..."}},{locale:"ru",translations:{"{tag} (invisible)":"{tag} (невидимое)","{tag} (restricted)":"{tag} (ограниченное)",Actions:"Действия ",Activities:"События","Animals & Nature":"Животные и природа ","Avatar of {displayName}":"Аватар {displayName}","Avatar of {displayName}, {status}":"Фотография {displayName}, {status}","Cancel changes":"Отменить изменения",Choose:"Выберите",Close:"Закрыть","Close modal":"Закрыть модальное окно","Close navigation":"Закрыть навигацию","Confirm changes":"Подтвердить изменения",Custom:"Пользовательское","Edit item":"Изменить элемент","External documentation for {title}":"Внешняя документация для {title}",Flags:"Флаги","Food & Drink":"Еда, напиток","Frequently used":"Часто используемый",Global:"Глобальный","Go back to the list":"Вернуться к списку",items:"элементов","Message limit of {count} characters reached":"Достигнуто ограничение на количество символов в {count}","More {dashboardItemType} …":"Больше {dashboardItemType} …",Next:"Следующее","No emoji found":"Эмодзи не найдено","No results":"Результаты отсуствуют",Objects:"Объекты",Open:"Открыть","Open navigation":"Открыть навигацию","Pause slideshow":"Приостановить показ слйдов","People & Body":"Люди и тело","Pick an emoji":"Выберите эмодзи","Please select a time zone:":"Пожалуйста, выберите часовой пояс:",Previous:"Предыдущее",Search:"Поиск","Search results":"Результаты поиска","Select a tag":"Выберите метку",Settings:"Параметры","Settings navigation":"Навигация по настройкам","Smileys & Emotion":"Смайлики и эмоции","Start slideshow":"Начать показ слайдов",Submit:"Утвердить",Symbols:"Символы","Travel & Places":"Путешествия и места","Type to search time zone":"Введите для поиска часового пояса","Unable to search the group":"Невозможно найти группу","Undo changes":"Отменить изменения","Write message, @ to mention someone, : for emoji autocompletion …":"Напишите сообщение, @ - чтобы упомянуть кого-то, : - для автозаполнения эмодзи …"}},{locale:"sk_SK",translations:{"{tag} (invisible)":"{tag} (neviditeľný)","{tag} (restricted)":"{tag} (obmedzený)",Actions:"Akcie",Activities:"Aktivity","Animals & Nature":"Zvieratá a príroda","Avatar of {displayName}":"Avatar {displayName}","Avatar of {displayName}, {status}":"Avatar {displayName}, {status}","Cancel changes":"Zrušiť zmeny",Choose:"Vybrať",Close:"Zatvoriť","Close navigation":"Zavrieť navigáciu","Confirm changes":"Potvrdiť zmeny",Custom:"Zvyk","Edit item":"Upraviť položku","External documentation for {title}":"Externá dokumentácia pre {title}",Flags:"Vlajky","Food & Drink":"Jedlo a nápoje","Frequently used":"Často používané",Global:"Globálne","Go back to the list":"Naspäť na zoznam","Message limit of {count} characters reached":"Limit správy na {count} znakov dosiahnutý",Next:"Ďalší","No emoji found":"Nenašli sa žiadne emodži","No results":"Žiadne výsledky",Objects:"Objekty","Open navigation":"Otvoriť navigáciu","Pause slideshow":"Pozastaviť prezentáciu","People & Body":"Ľudia a telo","Pick an emoji":"Vyberte si emodži","Please select a time zone:":"Prosím vyberte časovú zónu:",Previous:"Predchádzajúci",Search:"Hľadať","Search results":"Výsledky vyhľadávania","Select a tag":"Vybrať štítok",Settings:"Nastavenia","Settings navigation":"Navigácia v nastaveniach","Smileys & Emotion":"Smajlíky a emócie","Start slideshow":"Začať prezentáciu",Submit:"Odoslať",Symbols:"Symboly","Travel & Places":"Cestovanie a miesta","Type to search time zone":"Začníte písať pre vyhľadávanie časovej zóny","Unable to search the group":"Skupinu sa nepodarilo nájsť","Undo changes":"Vrátiť zmeny","Write message, @ to mention someone, : for emoji autocompletion …":"Napíšte správu, @ ak chcete niekoho spomenúť, : pre automatické dopĺňanie emotikonov…"}},{locale:"sl",translations:{"{tag} (invisible)":"{tag} (nevidno)","{tag} (restricted)":"{tag} (omejeno)",Actions:"Dejanja",Activities:"Dejavnosti","Animals & Nature":"Živali in Narava","Avatar of {displayName}":"Podoba {displayName}","Avatar of {displayName}, {status}":"Prikazna slika {displayName}, {status}","Cancel changes":"Prekliči spremembe","Change title":"Spremeni naziv",Choose:"Izbor","Clear text":"Počisti besedilo",Close:"Zapri","Close modal":"Zapri pojavno okno","Close navigation":"Zapri krmarjenje","Close sidebar":"Zapri stransko vrstico","Confirm changes":"Potrdi spremembe",Custom:"Po meri","Edit item":"Uredi predmet","Error getting related resources":"Napaka pridobivanja povezanih virov","External documentation for {title}":"Zunanja dokumentacija za {title}",Favorite:"Priljubljeno",Flags:"Zastavice","Food & Drink":"Hrana in Pijača","Frequently used":"Pogostost uporabe",Global:"Splošno","Go back to the list":"Vrni se na seznam","Hide password":"Skrij geslo","Message limit of {count} characters reached":"Dosežena omejitev {count} znakov na sporočilo.","More items …":"Več predmetov ...",Next:"Naslednji","No emoji found":"Ni najdenih izraznih ikon","No results":"Ni zadetkov",Objects:"Predmeti",Open:"Odpri",'Open link to "{resourceTitle}"':"Odpri povezavo do »{resourceTitle}«","Open navigation":"Odpri krmarjenje","Password is secure":"Geslo je varno","Pause slideshow":"Ustavi predstavitev","People & Body":"Ljudje in Telo","Pick a date":"Izbor datuma","Pick a date and a time":"Izbor datuma in časa","Pick a month":"Izbor meseca","Pick a time":"Izbor časa","Pick a week":"Izbor tedna","Pick a year":"Izbor leta","Pick an emoji":"Izbor izrazne ikone","Please select a time zone:":"Izbor časovnega pasu:",Previous:"Predhodni","Related resources":"Povezani viri",Search:"Iskanje","Search results":"Zadetki iskanja","Select a tag":"Izbor oznake",Settings:"Nastavitve","Settings navigation":"Krmarjenje nastavitev","Show password":"Pokaži geslo","Smileys & Emotion":"Izrazne ikone","Start slideshow":"Začni predstavitev",Submit:"Pošlji",Symbols:"Simboli","Travel & Places":"Potovanja in Kraji","Type to search time zone":"Vpišite niz za iskanje časovnega pasu","Unable to search the group":"Ni mogoče iskati po skupini","Undo changes":"Razveljavi spremembe","Write message, @ to mention someone, : for emoji autocompletion …":"Napišite sporočilo, za omembo pred ime postavite@, začnite z : za vstavljanje izraznih ikon …"}},{locale:"sr",translations:{"{tag} (invisible)":"{tag} (nevidljivo)","{tag} (restricted)":"{tag} (ograničeno)",Actions:"Radnje",Activities:"Aktivnosti","Animals & Nature":"Životinje i Priroda","Avatar of {displayName}":"Avatar za {displayName}","Avatar of {displayName}, {status}":"Avatar za {displayName}, {status}","Cancel changes":"Otkaži izmene","Change title":"Izmeni naziv",Choose:"Изаберите",Close:"Затвори","Close modal":"Zatvori modal","Close navigation":"Zatvori navigaciju","Close sidebar":"Zatvori bočnu traku","Confirm changes":"Potvrdite promene",Custom:"Po meri","Edit item":"Uredi stavku","External documentation for {title}":"Eksterna dokumentacija za {title}",Favorite:"Omiljeni",Flags:"Zastave","Food & Drink":"Hrana i Piće","Frequently used":"Često korišćeno",Global:"Globalno","Go back to the list":"Natrag na listu",items:"stavke","Message limit of {count} characters reached":"Dostignuto je ograničenje za poruke od {count} znakova","More {dashboardItemType} …":"Više  {dashboardItemType} …",Next:"Следеће","No emoji found":"Nije pronađen nijedan emodži","No results":"Нема резултата",Objects:"Objekti",Open:"Otvori","Open navigation":"Otvori navigaciju","Pause slideshow":"Паузирај слајд шоу","People & Body":"Ljudi i Telo","Pick an emoji":"Izaberi emodži","Please select a time zone:":"Molimo izaberite vremensku zonu:",Previous:"Претходно",Search:"Pretraži","Search results":"Rezultati pretrage","Select a tag":"Изаберите ознаку",Settings:"Поставке","Settings navigation":"Navigacija u podešavanjima","Smileys & Emotion":"Smajli i Emocije","Start slideshow":"Покрени слајд шоу",Submit:"Prihvati",Symbols:"Simboli","Travel & Places":"Putovanja i Mesta","Type to search time zone":"Ukucaj da pretražiš vremenske zone","Unable to search the group":"Nije moguće pretražiti grupu","Undo changes":"Poništi promene","Write message, @ to mention someone, : for emoji autocompletion …":"Napišite poruku, @ da pomenete nekoga, : za automatsko dovršavanje emodžija…"}},{locale:"sv",translations:{"{tag} (invisible)":"{tag} (osynlig)","{tag} (restricted)":"{tag} (begränsad)",Actions:"Åtgärder",Activities:"Aktiviteter","Animals & Nature":"Djur & Natur","Avatar of {displayName}":"{displayName}s avatar","Avatar of {displayName}, {status}":"{displayName}s avatar, {status}","Cancel changes":"Avbryt ändringar",Choose:"Välj",Close:"Stäng","Close navigation":"Stäng navigering","Confirm changes":"Bekräfta ändringar",Custom:"Anpassad","Edit item":"Ändra","External documentation for {title}":"Extern dokumentation för {title}",Flags:"Flaggor","Food & Drink":"Mat & Dryck","Frequently used":"Används ofta",Global:"Global","Go back to the list":"Gå tillbaka till listan","Message limit of {count} characters reached":"Meddelandegräns {count} tecken används",Next:"Nästa","No emoji found":"Hittade inga emojis","No results":"Inga resultat",Objects:"Objekt","Open navigation":"Öppna navigering","Pause slideshow":"Pausa bildspelet","People & Body":"Kropp & Själ","Pick an emoji":"Välj en emoji","Please select a time zone:":"Välj tidszon:",Previous:"Föregående",Search:"Sök","Search results":"Sökresultat","Select a tag":"Välj en tag",Settings:"Inställningar","Settings navigation":"Inställningsmeny","Smileys & Emotion":"Selfies & Känslor","Start slideshow":"Starta bildspelet",Submit:"Skicka",Symbols:"Symboler","Travel & Places":"Resor & Sevärdigheter","Type to search time zone":"Skriv för att välja tidszon","Unable to search the group":"Kunde inte söka i gruppen","Undo changes":"Ångra ändringar","Write message, @ to mention someone, : for emoji autocompletion …":"Skriv meddelande, @ för att nämna någon, : för automatiska emojiförslag ..."}},{locale:"tr",translations:{"{tag} (invisible)":"{tag} (görünmez)","{tag} (restricted)":"{tag} (kısıtlı)",Actions:"İşlemler",Activities:"Etkinlikler","Animals & Nature":"Hayvanlar ve Doğa","Avatar of {displayName}":"{displayName} avatarı","Avatar of {displayName}, {status}":"{displayName}, {status} avatarı","Cancel changes":"Değişiklikleri iptal et","Change title":"Başlığı değiştir",Choose:"Seçin","Clear text":"Metni temizle",Close:"Kapat","Close modal":"Üste açılan pencereyi kapat","Close navigation":"Gezinmeyi kapat","Close sidebar":"Yan çubuğu kapat","Confirm changes":"Değişiklikleri onayla",Custom:"Özel","Edit item":"Ögeyi düzenle","Error getting related resources":"İlgili kaynaklar alınırken sorun çıktı","External documentation for {title}":"{title} için dış belgeler",Favorite:"Sık kullanılanlara ekle",Flags:"Bayraklar","Food & Drink":"Yeme ve İçme","Frequently used":"Sık kullanılanlar",Global:"Evrensel","Go back to the list":"Listeye dön","Hide password":"Parolayı gizle",items:"ögeler","Message limit of {count} characters reached":"{count} karakter ileti sınırına ulaşıldı","More {dashboardItemType} …":"Diğer {dashboardItemType} ögeleri…",Next:"Sonraki","No emoji found":"Herhangi bir emoji bulunamadı","No results":"Herhangi bir sonuç bulunamadı",Objects:"Nesneler",Open:"Aç",'Open link to "{resourceTitle}"':'"{resourceTitle}" bağlantısını aç',"Open navigation":"Gezinmeyi aç","Password is secure":"Parola güvenli","Pause slideshow":"Slayt sunumunu duraklat","People & Body":"İnsanlar ve Beden","Pick a date":"Bir tarih seçin","Pick a date and a time":"Bir tarih ve saat seçin","Pick a month":"Bir ay seçin","Pick a time":"Bir saat seçin","Pick a week":"Bir hafta seçin","Pick a year":"Bir yıl seçin","Pick an emoji":"Bir emoji seçin","Please select a time zone:":"Lütfen bir saat dilimi seçin:",Previous:"Önceki","Related resources":"İlgili kaynaklar",Search:"Arama","Search results":"Arama sonuçları","Select a tag":"Bir etiket seçin",Settings:"Ayarlar","Settings navigation":"Gezinme ayarları","Show password":"Parolayı görüntüle","Smileys & Emotion":"İfadeler ve Duygular","Start slideshow":"Slayt sunumunu başlat",Submit:"Gönder",Symbols:"Simgeler","Travel & Places":"Gezi ve Yerler","Type to search time zone":"Saat dilimi aramak için yazmaya başlayın","Unable to search the group":"Grupta arama yapılamadı","Undo changes":"Değişiklikleri geri al","Write message, @ to mention someone, : for emoji autocompletion …":"İleti yazın, birini anmak için @, otomatik emoji tamamlamak için : kullanın…"}},{locale:"uk",translations:{"{tag} (invisible)":"{tag} (невидимий)","{tag} (restricted)":"{tag} (обмежений)",Actions:"Дії",Activities:"Діяльність","Animals & Nature":"Тварини та природа","Avatar of {displayName}":"Аватар {displayName}","Avatar of {displayName}, {status}":"Аватар {displayName}, {status}","Cancel changes":"Скасувати зміни","Change title":"Змінити назву",Choose:"ВиберітьВиберіть","Clear text":"Очистити текст",Close:"Закрити","Close modal":"Закрити модаль","Close navigation":"Закрити навігацію","Close sidebar":"Закрити бічну панель","Confirm changes":"Підтвердити зміни",Custom:"Власне","Edit item":"Редагувати елемент","External documentation for {title}":"Зовнішня документація для {title}",Favorite:"Улюблений",Flags:"Прапори","Food & Drink":"Їжа та напої","Frequently used":"Найчастіші",Global:"Глобальний","Go back to the list":"Повернутися до списку","Hide password":"Приховати пароль",items:"елементи","Message limit of {count} characters reached":"Вичерпано ліміт у {count} символів для повідомлення","More {dashboardItemType} …":"Більше {dashboardItemType}…",Next:"Вперед","No emoji found":"Емоційки відсутні","No results":"Відсутні результати",Objects:"Об'єкти",Open:"Відкрити","Open navigation":"Відкрити навігацію","Password is secure":"Пароль безпечний","Pause slideshow":"Пауза у показі слайдів","People & Body":"Люди та жести","Pick an emoji":"Виберіть емоційку","Please select a time zone:":"Виберіть часовий пояс:",Previous:"Назад",Search:"Пошук","Search results":"Результати пошуку","Select a tag":"Виберіть позначку",Settings:"Налаштування","Settings navigation":"Навігація у налаштуваннях","Show password":"Показати пароль","Smileys & Emotion":"Смайли та емоції","Start slideshow":"Почати показ слайдів",Submit:"Надіслати",Symbols:"Символи","Travel & Places":"Поїздки та місця","Type to search time zone":"Введіть для пошуку часовий пояс","Unable to search the group":"Неможливо шукати в групі","Undo changes":"Скасувати зміни","Write message, @ to mention someone, : for emoji autocompletion …":"Напишіть повідомлення, @, щоб згадати когось, : для автозаповнення емодзі…"}},{locale:"zh_CN",translations:{"{tag} (invisible)":"{tag} （不可见）","{tag} (restricted)":"{tag} （受限）",Actions:"行为",Activities:"活动","Animals & Nature":"动物 & 自然","Avatar of {displayName}":"{displayName}的头像","Avatar of {displayName}, {status}":"{displayName}的头像，{status}","Cancel changes":"取消更改",Choose:"选择",Close:"关闭","Close navigation":"关闭导航","Confirm changes":"确认更改",Custom:"自定义","Edit item":"编辑项目","External documentation for {title}":"{title}的外部文档",Flags:"旗帜","Food & Drink":"食物 & 饮品","Frequently used":"经常使用",Global:"全局","Go back to the list":"返回至列表","Message limit of {count} characters reached":"已达到 {count} 个字符的消息限制",Next:"下一个","No emoji found":"表情未找到","No results":"无结果",Objects:"物体","Open navigation":"开启导航","Pause slideshow":"暂停幻灯片","People & Body":"人 & 身体","Pick an emoji":"选择一个表情","Please select a time zone:":"请选择一个时区：",Previous:"上一个",Search:"搜索","Search results":"搜索结果","Select a tag":"选择一个标签",Settings:"设置","Settings navigation":"设置向导","Smileys & Emotion":"笑脸 & 情感","Start slideshow":"开始幻灯片",Submit:"提交",Symbols:"符号","Travel & Places":"旅游 & 地点","Type to search time zone":"打字以搜索时区","Unable to search the group":"无法搜索分组","Undo changes":"撤销更改","Write message, @ to mention someone, : for emoji autocompletion …":"写信息，@ 提到某人，: 用于表情符号自动完成 ..."}},{locale:"zh_HK",translations:{"{tag} (invisible)":"{tag} (隱藏)","{tag} (restricted)":"{tag} (受限)",Actions:"動作",Activities:"活動","Animals & Nature":"動物與自然","Avatar of {displayName}":"{displayName} 的頭像","Avatar of {displayName}, {status}":"{displayName} 的頭像，{status}","Cancel changes":"取消更改",Choose:"選擇",Close:"關閉","Close modal":"關閉模態","Close navigation":"關閉導航","Confirm changes":"確認更改",Custom:"自定義","Edit item":"編輯項目","External documentation for {title}":"{title} 的外部文檔",Flags:"旗幟","Food & Drink":"食物與飲料","Frequently used":"經常使用",Global:"全球的","Go back to the list":"返回清單",items:"項目","Message limit of {count} characters reached":"已達到訊息最多 {count} 字元限制","More {dashboardItemType} …":"更多 {dashboardItemType} …",Next:"下一個","No emoji found":"未找到表情符號","No results":"無結果",Objects:"物件","Open navigation":"開啟導航","Pause slideshow":"暫停幻燈片","People & Body":"人物","Pick an emoji":"選擇表情符號","Please select a time zone:":"請選擇時區：",Previous:"上一個",Search:"搜尋","Search results":"搜尋結果","Select a tag":"選擇標籤",Settings:"設定","Settings navigation":"設定值導覽","Smileys & Emotion":"表情","Start slideshow":"開始幻燈片",Submit:"提交",Symbols:"標誌","Travel & Places":"旅遊與景點","Type to search time zone":"鍵入以搜索時區","Unable to search the group":"無法搜尋群組","Undo changes":"取消更改","Write message, @ to mention someone, : for emoji autocompletion …":"寫訊息，使用 @ 來指代某人，使用：用於表情符號自動填充 ..."}},{locale:"zh_TW",translations:{"{tag} (invisible)":"{tag} (隱藏)","{tag} (restricted)":"{tag} (受限)",Actions:"動作",Activities:"活動","Animals & Nature":"動物與自然",Choose:"選擇",Close:"關閉",Custom:"自定義",Flags:"旗幟","Food & Drink":"食物與飲料","Frequently used":"最近使用","Message limit of {count} characters reached":"已達到訊息最多 {count} 字元限制",Next:"下一個","No emoji found":"未找到表情符號","No results":"無結果",Objects:"物件","Pause slideshow":"暫停幻燈片","People & Body":"人物","Pick an emoji":"選擇表情符號",Previous:"上一個",Search:"搜尋","Search results":"搜尋結果","Select a tag":"選擇標籤",Settings:"設定","Settings navigation":"設定值導覽","Smileys & Emotion":"表情","Start slideshow":"開始幻燈片",Symbols:"標誌","Travel & Places":"旅遊與景點","Unable to search the group":"無法搜尋群組","Write message, @ to mention someone …":"輸入訊息時可使用 @ 來標示某人..."}}].forEach((function(e){var t={};for(var a in e.translations)e.translations[a].pluralId?t[a]={msgid:a,msgid_plural:e.translations[a].pluralId,msgstr:e.translations[a].msgstr}:t[a]={msgid:a,msgstr:[e.translations[a]]};o.addTranslation(e.locale,{translations:{"":t}});}));var i=o.build(),n=(i.ngettext.bind(i),i.gettext.bind(i));},1205:function(e,t){t.Z=function(e){return Math.random().toString(36).replace(/[^a-z]+/g,"").slice(0,e||5)};},8384:function(e,t,a){var o=a(7537),i=a.n(o),n=a(3645),r=a.n(n)()(i());r.push([e.id,".material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.v-popper--theme-tooltip.v-popper__popper{position:absolute;z-index:100000;top:0;right:auto;left:auto;display:block;margin:0;padding:0;text-align:left;text-align:start;opacity:0;line-height:1.6;line-break:auto;filter:drop-shadow(0 1px 10px var(--color-box-shadow))}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-container{bottom:-10px;border-bottom-width:0;border-top-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-container{top:-10px;border-top-width:0;border-bottom-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=right] .v-popper__arrow-container{right:100%;border-left-width:0;border-right-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[data-popper-placement^=left] .v-popper__arrow-container{left:100%;border-right-width:0;border-left-color:var(--color-main-background)}.v-popper--theme-tooltip.v-popper__popper[aria-hidden=true]{visibility:hidden;transition:opacity .15s,visibility .15s;opacity:0}.v-popper--theme-tooltip.v-popper__popper[aria-hidden=false]{visibility:visible;transition:opacity .15s;opacity:1}.v-popper--theme-tooltip .v-popper__inner{max-width:350px;padding:5px 8px;text-align:center;color:var(--color-main-text);border-radius:var(--border-radius);background-color:var(--color-main-background)}.v-popper--theme-tooltip .v-popper__arrow-container{position:absolute;z-index:1;width:0;height:0;margin:0;border-style:solid;border-color:rgba(0,0,0,0);border-width:10px}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/directives/Tooltip/index.scss"],names:[],mappings:"AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCQA,0CACC,iBAAA,CACA,cAAA,CACA,KAAA,CACA,UAAA,CACA,SAAA,CACA,aAAA,CACA,QAAA,CACA,SAAA,CACA,eAAA,CACA,gBAAA,CACA,SAAA,CACA,eAAA,CAEA,eAAA,CACA,sDAAA,CAGA,iGACC,YAAA,CACA,qBAAA,CACA,6CAAA,CAID,oGACC,SAAA,CACA,kBAAA,CACA,gDAAA,CAID,mGACC,UAAA,CACA,mBAAA,CACA,+CAAA,CAID,kGACC,SAAA,CACA,oBAAA,CACA,8CAAA,CAID,4DACC,iBAAA,CACA,uCAAA,CACA,SAAA,CAED,6DACC,kBAAA,CACA,uBAAA,CACA,SAAA,CAKF,0CACC,eAAA,CACA,eAAA,CACA,iBAAA,CACA,4BAAA,CACA,kCAAA,CACA,6CAAA,CAID,oDACC,iBAAA,CACA,SAAA,CACA,OAAA,CACA,QAAA,CACA,QAAA,CACA,kBAAA,CACA,0BAAA,CACA,iBAhFY",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n/**\n* @copyright Copyright (c) 2016, John Molakvoæ <skjnldsv@protonmail.com>\n* @copyright Copyright (c) 2016, Robin Appelman <robin@icewind.nl>\n* @copyright Copyright (c) 2016, Jan-Christoph Borchardt <hey@jancborchardt.net>\n* @copyright Copyright (c) 2016, Erik Pellikka <erik@pellikka.org>\n* @copyright Copyright (c) 2015, Vincent Petry <pvince81@owncloud.com>\n*\n* Bootstrap v3.3.5 (http://getbootstrap.com)\n* Copyright 2011-2015 Twitter, Inc.\n* Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n*/\n\n$arrow-width: 10px;\n\n.v-popper--theme-tooltip {\n\t&.v-popper__popper {\n\t\tposition: absolute;\n\t\tz-index: 100000;\n\t\ttop: 0;\n\t\tright: auto;\n\t\tleft: auto;\n\t\tdisplay: block;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\ttext-align: left;\n\t\ttext-align: start;\n\t\topacity: 0;\n\t\tline-height: 1.6;\n\n\t\tline-break: auto;\n\t\tfilter: drop-shadow(0 1px 10px var(--color-box-shadow));\n\n\t\t// TOP\n\t\t&[data-popper-placement^='top'] .v-popper__arrow-container {\n\t\t\tbottom: -$arrow-width;\n\t\t\tborder-bottom-width: 0;\n\t\t\tborder-top-color: var(--color-main-background);\n\t\t}\n\n\t\t// BOTTOM\n\t\t&[data-popper-placement^='bottom'] .v-popper__arrow-container {\n\t\t\ttop: -$arrow-width;\n\t\t\tborder-top-width: 0;\n\t\t\tborder-bottom-color: var(--color-main-background);\n\t\t}\n\n\t\t// RIGHT\n\t\t&[data-popper-placement^='right'] .v-popper__arrow-container {\n\t\t\tright: 100%;\n\t\t\tborder-left-width: 0;\n\t\t\tborder-right-color: var(--color-main-background);\n\t\t}\n\n\t\t// LEFT\n\t\t&[data-popper-placement^='left'] .v-popper__arrow-container {\n\t\t\tleft: 100%;\n\t\t\tborder-right-width: 0;\n\t\t\tborder-left-color: var(--color-main-background);\n\t\t}\n\n\t\t// HIDDEN / SHOWN\n\t\t&[aria-hidden='true'] {\n\t\t\tvisibility: hidden;\n\t\t\ttransition: opacity .15s, visibility .15s;\n\t\t\topacity: 0;\n\t\t}\n\t\t&[aria-hidden='false'] {\n\t\t\tvisibility: visible;\n\t\t\ttransition: opacity .15s;\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t// CONTENT\n\t.v-popper__inner {\n\t\tmax-width: 350px;\n\t\tpadding: 5px 8px;\n\t\ttext-align: center;\n\t\tcolor: var(--color-main-text);\n\t\tborder-radius: var(--border-radius);\n\t\tbackground-color: var(--color-main-background);\n\t}\n\n\t// ARROW\n\t.v-popper__arrow-container {\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: $arrow-width;\n\t}\n}\n"],sourceRoot:""}]),t.Z=r;},2810:function(e,t,a){var o=a(7537),i=a.n(o),n=a(3645),r=a.n(n)()(i());r.push([e.id,".material-design-icon[data-v-7a49ed06]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.action-items[data-v-7a49ed06]{display:flex;align-items:center}.action-item[data-v-7a49ed06]{--open-background-color: var(--color-background-hover, $action-background-hover);position:relative;display:inline-block}.action-item.action-item--primary[data-v-7a49ed06]{--open-background-color: var(--color-primary-element-hover)}.action-item.action-item--secondary[data-v-7a49ed06]{--open-background-color: var(--color-primary-light-hover)}.action-item.action-item--error[data-v-7a49ed06]{--open-background-color: var(--color-error-hover)}.action-item.action-item--warning[data-v-7a49ed06]{--open-background-color: var(--color-warning-hover)}.action-item.action-item--success[data-v-7a49ed06]{--open-background-color: var(--color-success-hover)}.action-item.action-item--open .action-item__menutoggle[data-v-7a49ed06]{opacity:1;background-color:var(--open-background-color)}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/components/NcActions/NcActions.vue","webpack://./src/assets/variables.scss"],names:[],mappings:"AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCND,+BACC,YAAA,CACA,kBAAA,CAGD,8BACC,gFAAA,CACA,iBAAA,CACA,oBAAA,CAEA,mDACC,2DAAA,CAGD,qDACC,yDAAA,CAGD,iDACC,iDAAA,CAGD,mDACC,mDAAA,CAGD,mDACC,mDAAA,CAGD,yEACC,SCWa,CDVb,6CAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n\n.action-items {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.action-item {\n\t--open-background-color: var(--color-background-hover, $action-background-hover);\n\tposition: relative;\n\tdisplay: inline-block;\n\n\t&.action-item--primary {\n\t\t--open-background-color: var(--color-primary-element-hover);\n\t}\n\n\t&.action-item--secondary {\n\t\t--open-background-color: var(--color-primary-light-hover);\n\t}\n\n\t&.action-item--error {\n\t\t--open-background-color: var(--color-error-hover);\n\t}\n\n\t&.action-item--warning {\n\t\t--open-background-color: var(--color-warning-hover);\n\t}\n\n\t&.action-item--success {\n\t\t--open-background-color: var(--color-success-hover);\n\t}\n\n\t&.action-item--open .action-item__menutoggle {\n\t\topacity: $opacity_full;\n\t\tbackground-color: var(--open-background-color);\n\t}\n}\n","/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n\n// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556\n// recommended is 48px\n// 44px is what we choose and have very good visual-to-usability ratio\n$clickable-area: 44px;\n\n// background icon size\n// also used for the scss icon font\n$icon-size: 16px;\n\n// icon padding for a $clickable-area width and a $icon-size icon\n// ( 44px - 16px ) / 2\n$icon-margin: math.div($clickable-area - $icon-size, 2);\n\n// transparency background for icons\n$icon-focus-bg: rgba(127, 127, 127, .25);\n\n// popovermenu arrow width from the triangle center\n$arrow-width: 9px;\n\n// opacities\n$opacity_disabled: .5;\n$opacity_normal: .7;\n$opacity_full: 1;\n\n// menu round background hover feedback\n// good looking on dark AND white bg\n$action-background-hover: rgba(127, 127, 127, .25);\n\n// various structure data used in the \n// `AppNavigation` component\n$header-height: 50px;\n$navigation-width: 300px;\n\n// mobile breakpoint\n$breakpoint-mobile: 1024px;\n\n// top-bar spacing\n$topbar-margin: 4px;\n"],sourceRoot:""}]),t.Z=r;},8582:function(e,t,a){var o=a(7537),i=a.n(o),n=a(3645),r=a.n(n)()(i());r.push([e.id,".material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.v-popper--theme-dropdown.v-popper__popper.action-item__popper .v-popper__inner{border-radius:var(--border-radius-large);padding:4px;max-height:calc(100vh - 16px);overflow:auto}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/components/NcActions/NcActions.vue"],names:[],mappings:"AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCJD,gFACC,wCAAA,CACA,WAAA,CACA,6BAAA,CACA,aAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n\n// We overwrote the popover base class, so we can style\n// the popover__inner for actions only.\n.v-popper--theme-dropdown.v-popper__popper.action-item__popper .v-popper__inner {\n\tborder-radius: var(--border-radius-large);\n\tpadding: 4px;\n\tmax-height: calc(100vh - 16px);\n\toverflow: auto;\n}\n"],sourceRoot:""}]),t.Z=r;},7190:function(e,t,a){var o=a(7537),i=a.n(o),n=a(3645),r=a.n(n)()(i());r.push([e.id,".material-design-icon[data-v-7a8f3349]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.button-vue[data-v-7a8f3349]{position:relative;width:fit-content;overflow:hidden;border:0;padding:0;font-size:var(--default-font-size);font-weight:bold;min-height:44px;min-width:44px;display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:22px;transition:background-color .1s linear !important;transition:border .1s linear;background-color:var(--color-primary-element-lighter);color:var(--color-primary-light-text)}.button-vue *[data-v-7a8f3349]{cursor:pointer}.button-vue[data-v-7a8f3349]:focus{outline:none}.button-vue[data-v-7a8f3349]:disabled{cursor:default;opacity:.5;filter:saturate(0.7)}.button-vue:disabled *[data-v-7a8f3349]{cursor:default}.button-vue[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-primary-light-hover)}.button-vue[data-v-7a8f3349]:active{background-color:var(--color-primary-element-lighter)}.button-vue__wrapper[data-v-7a8f3349]{display:inline-flex;align-items:center;justify-content:space-around}.button-vue__icon[data-v-7a8f3349]{height:44px;width:44px;min-height:44px;min-width:44px;display:flex;justify-content:center;align-items:center}.button-vue__text[data-v-7a8f3349]{font-weight:bold;margin-bottom:1px;padding:2px 0}.button-vue--icon-only[data-v-7a8f3349]{width:44px !important}.button-vue--text-only[data-v-7a8f3349]{padding:0 12px}.button-vue--text-only .button-vue__text[data-v-7a8f3349]{margin-left:4px;margin-right:4px}.button-vue--icon-and-text[data-v-7a8f3349]{padding:0 16px 0 4px}.button-vue--wide[data-v-7a8f3349]{width:100%}.button-vue[data-v-7a8f3349]:focus-visible{outline:2px solid var(--color-main-text) !important}.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-7a8f3349]{outline:2px solid var(--color-primary-text);border-radius:var(--border-radius);background-color:rgba(0,0,0,0)}.button-vue--vue-primary[data-v-7a8f3349]{background-color:var(--color-primary-element);color:var(--color-primary-text)}.button-vue--vue-primary[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-primary-element-hover)}.button-vue--vue-primary[data-v-7a8f3349]:active{background-color:var(--color-primary-element)}.button-vue--vue-secondary[data-v-7a8f3349]{color:var(--color-primary-light-text);background-color:var(--color-primary-light)}.button-vue--vue-secondary[data-v-7a8f3349]:hover:not(:disabled){color:var(--color-primary-light-text);background-color:var(--color-primary-light-hover)}.button-vue--vue-tertiary[data-v-7a8f3349]{color:var(--color-main-text);background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color);background-color:var(--color-background-hover)}.button-vue--vue-tertiary-no-background[data-v-7a8f3349]{color:var(--color-main-text);background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary-no-background[data-v-7a8f3349]:hover:not(:disabled){background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary-on-primary[data-v-7a8f3349]{color:var(--color-primary-text);background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary-on-primary[data-v-7a8f3349]:hover:not(:disabled){background-color:rgba(0,0,0,0)}.button-vue--vue-success[data-v-7a8f3349]{background-color:var(--color-success);color:#fff}.button-vue--vue-success[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-success-hover)}.button-vue--vue-success[data-v-7a8f3349]:active{background-color:var(--color-success)}.button-vue--vue-warning[data-v-7a8f3349]{background-color:var(--color-warning);color:#fff}.button-vue--vue-warning[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-warning-hover)}.button-vue--vue-warning[data-v-7a8f3349]:active{background-color:var(--color-warning)}.button-vue--vue-error[data-v-7a8f3349]{background-color:var(--color-error);color:#fff}.button-vue--vue-error[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-error-hover)}.button-vue--vue-error[data-v-7a8f3349]:active{background-color:var(--color-error)}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/components/NcButton/NcButton.vue","webpack://./src/assets/variables.scss"],names:[],mappings:"AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCLD,6BACC,iBAAA,CACA,iBAAA,CACA,eAAA,CACA,QAAA,CACA,SAAA,CACA,kCAAA,CACA,gBAAA,CACA,eCcgB,CDbhB,cCagB,CDZhB,YAAA,CACA,kBAAA,CACA,sBAAA,CAGA,cAAA,CAIA,kBAAA,CACA,iDAAA,CACA,4BAAA,CAkBA,qDAAA,CACA,qCAAA,CAxBA,+BACC,cAAA,CAOD,mCACC,YAAA,CAGD,sCACC,cAAA,CAIA,UCMiB,CDJjB,oBAAA,CALA,wCACC,cAAA,CAUF,kDACC,iDAAA,CAKD,oCACC,qDAAA,CAGD,sCACC,mBAAA,CACA,kBAAA,CACA,4BAAA,CAGD,mCACC,WCpCe,CDqCf,UCrCe,CDsCf,eCtCe,CDuCf,cCvCe,CDwCf,YAAA,CACA,sBAAA,CACA,kBAAA,CAGD,mCACC,gBAAA,CACA,iBAAA,CACA,aAAA,CAID,wCACC,qBAAA,CAID,wCACC,cAAA,CACA,0DACC,eAAA,CACA,gBAAA,CAKF,4CACC,oBAAA,CAID,mCACC,UAAA,CAGD,2CACC,mDAAA,CACA,+EACC,2CAAA,CACA,kCAAA,CACA,8BAAA,CAOF,0CACC,6CAAA,CACA,+BAAA,CACA,+DACC,mDAAA,CAID,iDACC,6CAAA,CAKF,4CACC,qCAAA,CACA,2CAAA,CACA,iEACC,qCAAA,CACA,iDAAA,CAKF,2CACC,4BAAA,CACA,8BAAA,CACA,gEACC,6BAAA,CACA,8CAAA,CAKF,yDACC,4BAAA,CACA,8BAAA,CACA,8EACC,8BAAA,CAKF,sDACC,+BAAA,CACA,8BAAA,CAEA,2EACC,8BAAA,CAKF,0CACC,qCAAA,CACA,UAAA,CACA,+DACC,2CAAA,CAID,iDACC,qCAAA,CAKF,0CACC,qCAAA,CACA,UAAA,CACA,+DACC,2CAAA,CAID,iDACC,qCAAA,CAKF,wCACC,mCAAA,CACA,UAAA,CACA,6DACC,yCAAA,CAID,+CACC,mCAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n\n\n.button-vue {\n\tposition: relative;\n\twidth: fit-content;\n\toverflow: hidden;\n\tborder: 0;\n\tpadding: 0;\n\tfont-size: var(--default-font-size);\n\tfont-weight: bold;\n\tmin-height: $clickable-area;\n\tmin-width: $clickable-area;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t// Cursor pointer on element and all children\n\tcursor: pointer;\n\t& * {\n\t\tcursor: pointer;\n\t}\n\tborder-radius: math.div($clickable-area, 2);\n\ttransition: background-color 0.1s linear !important;\n\ttransition: border 0.1s linear;\n\n\t// No outline feedback for focus. Handled with a toggled class in js (see data)\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&:disabled {\n\t\tcursor: default;\n\t\t& * {\n\t\t\tcursor: default;\n\t\t}\n\t\topacity: $opacity_disabled;\n\t\t// Gives a wash out effect\n\t\tfilter: saturate($opacity_normal);\n\t}\n\n\t// Default button type\n\tbackground-color: var(--color-primary-element-lighter);\n\tcolor: var(--color-primary-light-text);\n\t&:hover:not(:disabled) {\n\t\tbackground-color: var(--color-primary-light-hover);\n\t}\n\n\t// Back to the default color for this button when active\n\t// TODO: add ripple effect\n\t&:active {\n\t\tbackground-color: var(--color-primary-element-lighter);\n\t}\n\n\t&__wrapper {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: space-around;\n\t}\n\n\t&__icon {\n\t\theight: $clickable-area;\n\t\twidth: $clickable-area;\n\t\tmin-height: $clickable-area;\n\t\tmin-width: $clickable-area;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&__text {\n\t\tfont-weight: bold;\n\t\tmargin-bottom: 1px;\n\t\tpadding: 2px 0;\n\t}\n\n\t// Icon-only button\n\t&--icon-only {\n\t\twidth: $clickable-area !important;\n\t}\n\n\t// Text-only button\n\t&--text-only {\n\t\tpadding: 0 12px;\n\t\t& .button-vue__text {\n\t\t\tmargin-left: 4px;\n\t\t\tmargin-right: 4px;\n\t\t}\n\t}\n\n\t// Icon and text button\n\t&--icon-and-text {\n\t\tpadding: 0 16px 0 4px;\n\t}\n\n\t// Wide button spans the whole width of the container\n\t&--wide {\n\t\twidth: 100%;\n\t}\n\n\t&:focus-visible {\n\t\toutline: 2px solid var(--color-main-text) !important;\n\t\t&.button-vue--vue-tertiary-on-primary {\n\t\t\toutline: 2px solid var(--color-primary-text);\n\t\t\tborder-radius: var(--border-radius);\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t// Button types\n\n\t// Primary\n\t&--vue-primary {\n\t\tbackground-color: var(--color-primary-element);\n\t\tcolor: var(--color-primary-text);\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-primary-element-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// TODO: add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-primary-element);\n\t\t}\n\t}\n\n\t// Secondary\n\t&--vue-secondary {\n\t\tcolor: var(--color-primary-light-text);\n\t\tbackground-color: var(--color-primary-light);\n\t\t&:hover:not(:disabled) {\n\t\t\tcolor: var(--color-primary-light-text);\n\t\t\tbackground-color: var(--color-primary-light-hover);\n\t\t}\n\t}\n\n\t// Tertiary\n\t&--vue-tertiary {\n\t\tcolor: var(--color-main-text);\n\t\tbackground-color: transparent;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color);\n\t\t\tbackground-color: var(--color-background-hover);\n\t\t}\n\t}\n\n\t// Tertiary, no background\n\t&--vue-tertiary-no-background {\n\t\tcolor: var(--color-main-text);\n\t\tbackground-color: transparent;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t// Tertiary on primary color (like the header)\n\t&--vue-tertiary-on-primary {\n\t\tcolor: var(--color-primary-text);\n\t\tbackground-color: transparent;\n\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t// Success\n\t&--vue-success {\n\t\tbackground-color: var(--color-success);\n\t\tcolor: white;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-success-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// : add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-success);\n\t\t}\n\t}\n\n\t// Warning\n\t&--vue-warning {\n\t\tbackground-color: var(--color-warning);\n\t\tcolor: white;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-warning-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// TODO: add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-warning);\n\t\t}\n\t}\n\n\t// Error\n\t&--vue-error {\n\t\tbackground-color: var(--color-error);\n\t\tcolor: white;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-error-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// TODO: add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-error);\n\t\t}\n\t}\n}\n\n","/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n\n// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556\n// recommended is 48px\n// 44px is what we choose and have very good visual-to-usability ratio\n$clickable-area: 44px;\n\n// background icon size\n// also used for the scss icon font\n$icon-size: 16px;\n\n// icon padding for a $clickable-area width and a $icon-size icon\n// ( 44px - 16px ) / 2\n$icon-margin: math.div($clickable-area - $icon-size, 2);\n\n// transparency background for icons\n$icon-focus-bg: rgba(127, 127, 127, .25);\n\n// popovermenu arrow width from the triangle center\n$arrow-width: 9px;\n\n// opacities\n$opacity_disabled: .5;\n$opacity_normal: .7;\n$opacity_full: 1;\n\n// menu round background hover feedback\n// good looking on dark AND white bg\n$action-background-hover: rgba(127, 127, 127, .25);\n\n// various structure data used in the \n// `AppNavigation` component\n$header-height: 50px;\n$navigation-width: 300px;\n\n// mobile breakpoint\n$breakpoint-mobile: 1024px;\n\n// top-bar spacing\n$topbar-margin: 4px;\n"],sourceRoot:""}]),t.Z=r;},8985:function(e,t,a){var o=a(7537),i=a.n(o),n=a(3645),r=a.n(n)()(i());r.push([e.id,".material-design-icon{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.resize-observer{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:rgba(0,0,0,0);pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}.v-popper--theme-dropdown.v-popper__popper{z-index:100000;top:0;left:0;display:block !important;filter:drop-shadow(0 1px 10px var(--color-box-shadow))}.v-popper--theme-dropdown.v-popper__popper .v-popper__inner{padding:0;color:var(--color-main-text);border-radius:var(--border-radius);overflow:hidden;background:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper .v-popper__arrow-container{position:absolute;z-index:1;width:0;height:0;border-style:solid;border-color:rgba(0,0,0,0);border-width:10px}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-container{bottom:-10px;border-bottom-width:0;border-top-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-container{top:-10px;border-top-width:0;border-bottom-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=right] .v-popper__arrow-container{left:-10px;border-left-width:0;border-right-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[data-popper-placement^=left] .v-popper__arrow-container{right:-10px;border-right-width:0;border-left-color:var(--color-main-background)}.v-popper--theme-dropdown.v-popper__popper[aria-hidden=true]{visibility:hidden;transition:opacity var(--animation-quick),visibility var(--animation-quick);opacity:0}.v-popper--theme-dropdown.v-popper__popper[aria-hidden=false]{visibility:visible;transition:opacity var(--animation-quick);opacity:1}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/components/NcPopover/NcPopover.vue"],names:[],mappings:"AAGA,sBACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCLD,iBACC,iBAAA,CACA,KAAA,CACA,MAAA,CACA,UAAA,CACA,UAAA,CACA,WAAA,CACA,WAAA,CACA,8BAAA,CACA,mBAAA,CACA,aAAA,CACA,eAAA,CACA,SAAA,CAGD,wBACC,aAAA,CACA,iBAAA,CACA,KAAA,CACA,MAAA,CACA,WAAA,CACA,UAAA,CACA,eAAA,CACA,mBAAA,CACA,UAAA,CAMA,2CACC,cAAA,CACA,KAAA,CACA,MAAA,CACA,wBAAA,CAEA,sDAAA,CAEA,4DACC,SAAA,CACA,4BAAA,CACA,kCAAA,CACA,eAAA,CACA,uCAAA,CAGD,sEACC,iBAAA,CACA,SAAA,CACA,OAAA,CACA,QAAA,CACA,kBAAA,CACA,0BAAA,CACA,iBA1BW,CA6BZ,kGACC,YAAA,CACA,qBAAA,CACA,6CAAA,CAGD,qGACC,SAAA,CACA,kBAAA,CACA,gDAAA,CAGD,oGACC,UAAA,CACA,mBAAA,CACA,+CAAA,CAGD,mGACC,WAAA,CACA,oBAAA,CACA,8CAAA,CAGD,6DACC,iBAAA,CACA,2EAAA,CACA,SAAA,CAGD,8DACC,kBAAA,CACA,yCAAA,CACA,SAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n\n\n.resize-observer {\n\tposition:absolute;\n\ttop:0;\n\tleft:0;\n\tz-index:-1;\n\twidth:100%;\n\theight:100%;\n\tborder:none;\n\tbackground-color:transparent;\n\tpointer-events:none;\n\tdisplay:block;\n\toverflow:hidden;\n\topacity:0\n}\n\n.resize-observer object {\n\tdisplay:block;\n\tposition:absolute;\n\ttop:0;\n\tleft:0;\n\theight:100%;\n\twidth:100%;\n\toverflow:hidden;\n\tpointer-events:none;\n\tz-index:-1\n}\n\n$arrow-width: 10px;\n\n.v-popper--theme-dropdown {\n\t&.v-popper__popper {\n\t\tz-index: 100000;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tdisplay: block !important;\n\n\t\tfilter: drop-shadow(0 1px 10px var(--color-box-shadow));\n\n\t\t.v-popper__inner {\n\t\t\tpadding: 0;\n\t\t\tcolor: var(--color-main-text);\n\t\t\tborder-radius: var(--border-radius);\n\t\t\toverflow: hidden;\n\t\t\tbackground: var(--color-main-background);\n\t\t}\n\n\t\t.v-popper__arrow-container {\n\t\t\tposition: absolute;\n\t\t\tz-index: 1;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t\tborder-color: transparent;\n\t\t\tborder-width: $arrow-width;\n\t\t}\n\n\t\t&[data-popper-placement^='top'] .v-popper__arrow-container {\n\t\t\tbottom: -$arrow-width;\n\t\t\tborder-bottom-width: 0;\n\t\t\tborder-top-color: var(--color-main-background);\n\t\t}\n\n\t\t&[data-popper-placement^='bottom'] .v-popper__arrow-container {\n\t\t\ttop: -$arrow-width;\n\t\t\tborder-top-width: 0;\n\t\t\tborder-bottom-color: var(--color-main-background);\n\t\t}\n\n\t\t&[data-popper-placement^='right'] .v-popper__arrow-container {\n\t\t\tleft: -$arrow-width;\n\t\t\tborder-left-width: 0;\n\t\t\tborder-right-color: var(--color-main-background);\n\t\t}\n\n\t\t&[data-popper-placement^='left'] .v-popper__arrow-container {\n\t\t\tright: -$arrow-width;\n\t\t\tborder-right-width: 0;\n\t\t\tborder-left-color: var(--color-main-background);\n\t\t}\n\n\t\t&[aria-hidden='true'] {\n\t\t\tvisibility: hidden;\n\t\t\ttransition: opacity var(--animation-quick), visibility var(--animation-quick);\n\t\t\topacity: 0;\n\t\t}\n\n\t\t&[aria-hidden='false'] {\n\t\t\tvisibility: visible;\n\t\t\ttransition: opacity var(--animation-quick);\n\t\t\topacity: 1;\n\t\t}\n\t}\n}\n\n"],sourceRoot:""}]),t.Z=r;},3645:function(e){e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var a="",o=void 0!==t[5];return t[4]&&(a+="@supports (".concat(t[4],") {")),t[2]&&(a+="@media ".concat(t[2]," {")),o&&(a+="@layer".concat(t[5].length>0?" ".concat(t[5]):""," {")),a+=e(t),o&&(a+="}"),t[2]&&(a+="}"),t[4]&&(a+="}"),a})).join("")},t.i=function(e,a,o,i,n){"string"==typeof e&&(e=[[null,e,void 0]]);var r={};if(o)for(var s=0;s<this.length;s++){var l=this[s][0];null!=l&&(r[l]=!0);}for(var c=0;c<e.length;c++){var u=[].concat(e[c]);o&&r[u[0]]||(void 0!==n&&(void 0===u[5]||(u[1]="@layer".concat(u[5].length>0?" ".concat(u[5]):""," {").concat(u[1],"}")),u[5]=n),a&&(u[2]?(u[1]="@media ".concat(u[2]," {").concat(u[1],"}"),u[2]=a):u[2]=a),i&&(u[4]?(u[1]="@supports (".concat(u[4],") {").concat(u[1],"}"),u[4]=i):u[4]="".concat(i)),t.push(u));}},t};},7537:function(e){e.exports=function(e){var t=e[1],a=e[3];if(!a)return t;if("function"==typeof btoa){var o=btoa(unescape(encodeURIComponent(JSON.stringify(a)))),i="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(o),n="/*# ".concat(i," */"),r=a.sources.map((function(e){return "/*# sourceURL=".concat(a.sourceRoot||"").concat(e," */")}));return [t].concat(r).concat([n]).join("\n")}return [t].join("\n")};},3379:function(e){var t=[];function a(e){for(var a=-1,o=0;o<t.length;o++)if(t[o].identifier===e){a=o;break}return a}function o(e,o){for(var n={},r=[],s=0;s<e.length;s++){var l=e[s],c=o.base?l[0]+o.base:l[0],u=n[c]||0,d="".concat(c," ").concat(u);n[c]=u+1;var m=a(d),p={css:l[1],media:l[2],sourceMap:l[3],supports:l[4],layer:l[5]};if(-1!==m)t[m].references++,t[m].updater(p);else {var g=i(p,o);o.byIndex=s,t.splice(s,0,{identifier:d,updater:g,references:1});}r.push(d);}return r}function i(e,t){var a=t.domAPI(t);return a.update(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap&&t.supports===e.supports&&t.layer===e.layer)return;a.update(e=t);}else a.remove();}}e.exports=function(e,i){var n=o(e=e||[],i=i||{});return function(e){e=e||[];for(var r=0;r<n.length;r++){var s=a(n[r]);t[s].references--;}for(var l=o(e,i),c=0;c<n.length;c++){var u=a(n[c]);0===t[u].references&&(t[u].updater(),t.splice(u,1));}n=l;}};},569:function(e){var t={};e.exports=function(e,a){var o=function(e){if(void 0===t[e]){var a=document.querySelector(e);if(window.HTMLIFrameElement&&a instanceof window.HTMLIFrameElement)try{a=a.contentDocument.head;}catch(e){a=null;}t[e]=a;}return t[e]}(e);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");o.appendChild(a);};},9216:function(e){e.exports=function(e){var t=document.createElement("style");return e.setAttributes(t,e.attributes),e.insert(t,e.options),t};},3565:function(e,t,a){e.exports=function(e){var t=a.nc;t&&e.setAttribute("nonce",t);};},7795:function(e){e.exports=function(e){var t=e.insertStyleElement(e);return {update:function(a){!function(e,t,a){var o="";a.supports&&(o+="@supports (".concat(a.supports,") {")),a.media&&(o+="@media ".concat(a.media," {"));var i=void 0!==a.layer;i&&(o+="@layer".concat(a.layer.length>0?" ".concat(a.layer):""," {")),o+=a.css,i&&(o+="}"),a.media&&(o+="}"),a.supports&&(o+="}");var n=a.sourceMap;n&&"undefined"!=typeof btoa&&(o+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n))))," */")),t.styleTagTransform(o,e,t.options);}(t,e,a);},remove:function(){!function(e){if(null===e.parentNode)return !1;e.parentNode.removeChild(e);}(t);}}};},4589:function(e){e.exports=function(e,t){if(t.styleSheet)t.styleSheet.cssText=e;else {for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(e));}};},5727:function(){},2102:function(){},2405:function(){},1900:function(e,t,a){function o(e,t,a,o,i,n,r,s){var l,c="function"==typeof e?e.options:e;if(t&&(c.render=t,c.staticRenderFns=a,c._compiled=!0),o&&(c.functional=!0),n&&(c._scopeId="data-v-"+n),r?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r);},c._ssrRegister=l):i&&(l=s?function(){i.call(this,(c.functional?this.parent:this).$root.$options.shadowRoot);}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(e,t){return l.call(t),u(e,t)};}else {var d=c.beforeCreate;c.beforeCreate=d?[].concat(d,l):[l];}return {exports:e,options:c}}a.d(t,{Z:function(){return o}});},754:function(e){e.exports=requireGettext();},9454:function(e){e.exports=require$$1;},4505:function(e){e.exports=require$$2;},2734:function(e){e.exports=requireVue_runtime_common();},1441:function(e){e.exports=require$$4;}},t={};function a(o){var i=t[o];if(void 0!==i)return i.exports;var n=t[o]={id:o,exports:{}};return e[o](n,n.exports,a),n.exports}a.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return a.d(t,{a:t}),t},a.d=function(e,t){for(var o in t)a.o(t,o)&&!a.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]});},a.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},a.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},a.nc=void 0;var o={};return function(){a.r(o),a.d(o,{default:function(){return M}});var e=a(8399),t=a(1481),i=a(336),n=a(1205),r=a(932),s=a(2734),l=a.n(s),c=a(1441),u=a.n(c);function d(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,o);}return a}function m(e){for(var t=1;t<arguments.length;t++){var a=null!=arguments[t]?arguments[t]:{};t%2?d(Object(a),!0).forEach((function(t){p(e,t,a[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):d(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t));}));}return e}function p(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e}function g(e){return function(e){if(Array.isArray(e))return A(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(e){if("string"==typeof e)return A(e,t);var a=Object.prototype.toString.call(e).slice(8,-1);return "Object"===a&&e.constructor&&(a=e.constructor.name),"Map"===a||"Set"===a?Array.from(e):"Arguments"===a||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)?A(e,t):void 0}}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function A(e,t){(null==t||t>e.length)&&(t=e.length);for(var a=0,o=new Array(t);a<t;a++)o[a]=e[a];return o}var v=".focusable",h={name:"NcActions",directives:{tooltip:i.default},components:{NcButton:e.default,DotsHorizontal:u(),NcPopover:t.default},props:{open:{type:Boolean,default:!1},forceMenu:{type:Boolean,default:!1},forceTitle:{type:Boolean,default:!1},menuTitle:{type:String,default:null},primary:{type:Boolean,default:!1},type:{type:String,validator:function(e){return -1!==["primary","secondary","tertiary","tertiary-no-background","tertiary-on-primary","error","warning","success"].indexOf(e)},default:null},defaultIcon:{type:String,default:""},ariaLabel:{type:String,default:(0, r.t)("Actions")},placement:{type:String,default:"bottom"},boundariesElement:{type:Element,default:function(){return document.querySelector("body")}},container:{type:String,default:"body"},disabled:{type:Boolean,default:!1},inline:{type:Number,default:0}},emits:["update:open","open","update:open","close","focus","blur"],data:function(){return {opened:this.open,focusIndex:0,randomId:"menu-".concat((0, n.Z)())}},computed:{triggerBtnType:function(){return this.type||(this.primary?"primary":this.menuTitle?"secondary":"tertiary")}},watch:{open:function(e){e!==this.opened&&(this.opened=e);}},methods:{isValidSingleAction:function(e){var t,a,o,i,n,r=null!==(t=null==e||null===(a=e.componentOptions)||void 0===a||null===(o=a.Ctor)||void 0===o||null===(i=o.extendOptions)||void 0===i?void 0:i.name)&&void 0!==t?t:null==e||null===(n=e.componentOptions)||void 0===n?void 0:n.tag;return ["NcActionButton","NcActionLink","NcActionRouter"].includes(r)},openMenu:function(e){this.opened||(this.opened=!0,this.$emit("update:open",!0),this.$emit("open"));},closeMenu:function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.opened&&(this.opened=!1,this.$refs.popover.clearFocusTrap({returnFocus:e}),this.$emit("update:open",!1),this.$emit("close"),this.opened=!1,this.focusIndex=0,this.$refs.menuButton.$el.focus());},onOpen:function(e){var t=this;this.$nextTick((function(){t.focusFirstAction(e);}));},onMouseFocusAction:function(e){if(document.activeElement!==e.target){var t=e.target.closest("li");if(t){var a=t.querySelector(v);if(a){var o=g(this.$refs.menu.querySelectorAll(v)).indexOf(a);o>-1&&(this.focusIndex=o,this.focusAction());}}}},onKeydown:function(e){(38===e.keyCode||9===e.keyCode&&e.shiftKey)&&this.focusPreviousAction(e),(40===e.keyCode||9===e.keyCode&&!e.shiftKey)&&this.focusNextAction(e),33===e.keyCode&&this.focusFirstAction(e),34===e.keyCode&&this.focusLastAction(e),27===e.keyCode&&(this.closeMenu(),e.preventDefault());},removeCurrentActive:function(){var e=this.$refs.menu.querySelector("li.active");e&&e.classList.remove("active");},focusAction:function(){var e=this.$refs.menu.querySelectorAll(v)[this.focusIndex];if(e){this.removeCurrentActive();var t=e.closest("li.action");e.focus(),t&&t.classList.add("active");}},focusPreviousAction:function(e){this.opened&&(0===this.focusIndex?this.closeMenu():(this.preventIfEvent(e),this.focusIndex=this.focusIndex-1),this.focusAction());},focusNextAction:function(e){if(this.opened){var t=this.$refs.menu.querySelectorAll(v).length-1;this.focusIndex===t?this.closeMenu():(this.preventIfEvent(e),this.focusIndex=this.focusIndex+1),this.focusAction();}},focusFirstAction:function(e){this.opened&&(this.preventIfEvent(e),this.focusIndex=0,this.focusAction());},focusLastAction:function(e){this.opened&&(this.preventIfEvent(e),this.focusIndex=this.$refs.menu.querySelectorAll(v).length-1,this.focusAction());},preventIfEvent:function(e){e&&(e.preventDefault(),e.stopPropagation());},onFocus:function(e){this.$emit("focus",e);},onBlur:function(e){this.$emit("blur",e);}},render:function(e){var t=this,a=(this.$slots.default||[]).filter((function(e){var t;return null==e||null===(t=e.componentOptions)||void 0===t?void 0:t.tag})),o=a.filter(this.isValidSingleAction);if(this.forceMenu&&o.length>0&&this.inline>0&&(l().util.warn("Specifying forceMenu will ignore any inline actions rendering."),o=[]),0!==a.length){var i=function(a){var o,i,n,r,s,l,c,u,d,p,g,A,v,h,b,f,C,y,k,S,w=(null==a||null===(o=a.data)||void 0===o||null===(i=o.scopedSlots)||void 0===i||null===(n=i.icon())||void 0===n?void 0:n[0])||e("span",{class:["icon",null==a||null===(r=a.componentOptions)||void 0===r||null===(s=r.propsData)||void 0===s?void 0:s.icon]}),j=t.forceTitle?t.menuTitle:"",P=null==a||null===(l=a.componentOptions)||void 0===l||null===(c=l.listeners)||void 0===c?void 0:c.click;return e("NcButton",{class:["action-item action-item--single",null==a||null===(u=a.data)||void 0===u?void 0:u.staticClass,null==a||null===(d=a.data)||void 0===d?void 0:d.class],attrs:{"aria-label":(null==a||null===(p=a.componentOptions)||void 0===p||null===(g=p.propsData)||void 0===g?void 0:g.ariaLabel)||(null==a||null===(A=a.componentOptions)||void 0===A||null===(v=A.children)||void 0===v||null===(h=v[0])||void 0===h?void 0:h.text)},props:m({type:t.type||(j?"secondary":"tertiary"),disabled:t.disabled||(null==a||null===(b=a.componentOptions)||void 0===b||null===(f=b.propsData)||void 0===f?void 0:f.disabled)},null==a||null===(C=a.componentOptions)||void 0===C?void 0:C.propsData),directives:[{name:"tooltip",value:null==a||null===(y=a.componentOptions)||void 0===y||null===(k=y.children)||void 0===k||null===(S=k[0])||void 0===S?void 0:S.text,modifiers:{auto:!0}}],on:m({focus:t.onFocus,blur:t.onBlur},!!P&&{click:function(e){P&&P(e);}})},[e("template",{slot:"icon"},[w]),j])},n=function(a){var o,i=(null===(o=t.$slots.icon)||void 0===o?void 0:o[0])||(t.defaultIcon?e("span",{class:["icon",t.defaultIcon]}):e("DotsHorizontal",{props:{size:20}}));return e("NcPopover",{ref:"popover",props:{delay:0,handleResize:!0,shown:t.opened,placement:t.placement,boundary:t.boundariesElement,container:t.container,popoverBaseClass:"action-item__popper"},attrs:{delay:0,handleResize:!0,shown:t.opened,placement:t.placement,boundary:t.boundariesElement,container:t.container,popoverBaseClass:"action-item__popper"},on:{show:t.openMenu,"after-show":t.onOpen,hide:t.closeMenu}},[e("NcButton",{class:"action-item__menutoggle",props:{type:t.triggerBtnType,disabled:t.disabled},slot:"trigger",ref:"menuButton",attrs:{"aria-haspopup":"menu","aria-label":t.ariaLabel,"aria-controls":t.opened?t.randomId:null,"aria-expanded":t.opened.toString()},on:{focus:t.onFocus,blur:t.onBlur}},[e("template",{slot:"icon"},[i]),t.menuTitle]),e("div",{class:{open:t.opened},attrs:{tabindex:"-1"},on:{keydown:t.onKeydown,mousemove:t.onMouseFocusAction},ref:"menu"},[e("ul",{attrs:{id:t.randomId,tabindex:"-1",role:"menu"}},[a])])])};if(1===a.length&&1===o.length&&!this.forceMenu)return i(o[0]);if(o.length>0&&this.inline>0){var r=o.slice(0,this.inline),s=a.filter((function(e){return !r.includes(e)}));return e("div",{class:["action-items","action-item--".concat(this.triggerBtnType)]},[].concat(g(r.map(i)),[s.length>0?e("div",{class:["action-item",{"action-item--open":this.opened}]},[n(s)]):null]))}return e("div",{class:["action-item action-item--default-popover","action-item--".concat(this.triggerBtnType),{"action-item--open":this.opened}]},[n(a)])}}},b=h,f=a(3379),C=a.n(f),y=a(7795),k=a.n(y),S=a(569),w=a.n(S),j=a(3565),P=a.n(j),N=a(9216),z=a.n(N),x=a(4589),E=a.n(x),T=a(2810),O={};O.styleTagTransform=E(),O.setAttributes=P(),O.insert=w().bind(null,"head"),O.domAPI=k(),O.insertStyleElement=z(),C()(T.Z,O),T.Z&&T.Z.locals&&T.Z.locals;var B=a(8582),D={};D.styleTagTransform=E(),D.setAttributes=P(),D.insert=w().bind(null,"head"),D.domAPI=k(),D.insertStyleElement=z(),C()(B.Z,D),B.Z&&B.Z.locals&&B.Z.locals;var F=a(1900),_=a(5727),I=a.n(_),G=(0, F.Z)(b,void 0,void 0,!1,null,"7a49ed06",null);"function"==typeof I()&&I()(G);var M=G.exports;}(),o}()}));
	
} (NcActions$1));

var NcActions = /*@__PURE__*/getDefaultExportFromCjs(NcActions$1.exports);

var NcButton$1 = {exports: {}};

(function (module, exports) {
	!function(t,n){module.exports=n();}(self,(function(){return function(){var t={7190:function(t,n,e){var o=e(7537),r=e.n(o),a=e(3645),i=e.n(a)()(r());i.push([t.id,".material-design-icon[data-v-7a8f3349]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.button-vue[data-v-7a8f3349]{position:relative;width:fit-content;overflow:hidden;border:0;padding:0;font-size:var(--default-font-size);font-weight:bold;min-height:44px;min-width:44px;display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:22px;transition:background-color .1s linear !important;transition:border .1s linear;background-color:var(--color-primary-element-lighter);color:var(--color-primary-light-text)}.button-vue *[data-v-7a8f3349]{cursor:pointer}.button-vue[data-v-7a8f3349]:focus{outline:none}.button-vue[data-v-7a8f3349]:disabled{cursor:default;opacity:.5;filter:saturate(0.7)}.button-vue:disabled *[data-v-7a8f3349]{cursor:default}.button-vue[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-primary-light-hover)}.button-vue[data-v-7a8f3349]:active{background-color:var(--color-primary-element-lighter)}.button-vue__wrapper[data-v-7a8f3349]{display:inline-flex;align-items:center;justify-content:space-around}.button-vue__icon[data-v-7a8f3349]{height:44px;width:44px;min-height:44px;min-width:44px;display:flex;justify-content:center;align-items:center}.button-vue__text[data-v-7a8f3349]{font-weight:bold;margin-bottom:1px;padding:2px 0}.button-vue--icon-only[data-v-7a8f3349]{width:44px !important}.button-vue--text-only[data-v-7a8f3349]{padding:0 12px}.button-vue--text-only .button-vue__text[data-v-7a8f3349]{margin-left:4px;margin-right:4px}.button-vue--icon-and-text[data-v-7a8f3349]{padding:0 16px 0 4px}.button-vue--wide[data-v-7a8f3349]{width:100%}.button-vue[data-v-7a8f3349]:focus-visible{outline:2px solid var(--color-main-text) !important}.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-7a8f3349]{outline:2px solid var(--color-primary-text);border-radius:var(--border-radius);background-color:rgba(0,0,0,0)}.button-vue--vue-primary[data-v-7a8f3349]{background-color:var(--color-primary-element);color:var(--color-primary-text)}.button-vue--vue-primary[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-primary-element-hover)}.button-vue--vue-primary[data-v-7a8f3349]:active{background-color:var(--color-primary-element)}.button-vue--vue-secondary[data-v-7a8f3349]{color:var(--color-primary-light-text);background-color:var(--color-primary-light)}.button-vue--vue-secondary[data-v-7a8f3349]:hover:not(:disabled){color:var(--color-primary-light-text);background-color:var(--color-primary-light-hover)}.button-vue--vue-tertiary[data-v-7a8f3349]{color:var(--color-main-text);background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color);background-color:var(--color-background-hover)}.button-vue--vue-tertiary-no-background[data-v-7a8f3349]{color:var(--color-main-text);background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary-no-background[data-v-7a8f3349]:hover:not(:disabled){background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary-on-primary[data-v-7a8f3349]{color:var(--color-primary-text);background-color:rgba(0,0,0,0)}.button-vue--vue-tertiary-on-primary[data-v-7a8f3349]:hover:not(:disabled){background-color:rgba(0,0,0,0)}.button-vue--vue-success[data-v-7a8f3349]{background-color:var(--color-success);color:#fff}.button-vue--vue-success[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-success-hover)}.button-vue--vue-success[data-v-7a8f3349]:active{background-color:var(--color-success)}.button-vue--vue-warning[data-v-7a8f3349]{background-color:var(--color-warning);color:#fff}.button-vue--vue-warning[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-warning-hover)}.button-vue--vue-warning[data-v-7a8f3349]:active{background-color:var(--color-warning)}.button-vue--vue-error[data-v-7a8f3349]{background-color:var(--color-error);color:#fff}.button-vue--vue-error[data-v-7a8f3349]:hover:not(:disabled){background-color:var(--color-error-hover)}.button-vue--vue-error[data-v-7a8f3349]:active{background-color:var(--color-error)}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/components/NcButton/NcButton.vue","webpack://./src/assets/variables.scss"],names:[],mappings:"AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCLD,6BACC,iBAAA,CACA,iBAAA,CACA,eAAA,CACA,QAAA,CACA,SAAA,CACA,kCAAA,CACA,gBAAA,CACA,eCcgB,CDbhB,cCagB,CDZhB,YAAA,CACA,kBAAA,CACA,sBAAA,CAGA,cAAA,CAIA,kBAAA,CACA,iDAAA,CACA,4BAAA,CAkBA,qDAAA,CACA,qCAAA,CAxBA,+BACC,cAAA,CAOD,mCACC,YAAA,CAGD,sCACC,cAAA,CAIA,UCMiB,CDJjB,oBAAA,CALA,wCACC,cAAA,CAUF,kDACC,iDAAA,CAKD,oCACC,qDAAA,CAGD,sCACC,mBAAA,CACA,kBAAA,CACA,4BAAA,CAGD,mCACC,WCpCe,CDqCf,UCrCe,CDsCf,eCtCe,CDuCf,cCvCe,CDwCf,YAAA,CACA,sBAAA,CACA,kBAAA,CAGD,mCACC,gBAAA,CACA,iBAAA,CACA,aAAA,CAID,wCACC,qBAAA,CAID,wCACC,cAAA,CACA,0DACC,eAAA,CACA,gBAAA,CAKF,4CACC,oBAAA,CAID,mCACC,UAAA,CAGD,2CACC,mDAAA,CACA,+EACC,2CAAA,CACA,kCAAA,CACA,8BAAA,CAOF,0CACC,6CAAA,CACA,+BAAA,CACA,+DACC,mDAAA,CAID,iDACC,6CAAA,CAKF,4CACC,qCAAA,CACA,2CAAA,CACA,iEACC,qCAAA,CACA,iDAAA,CAKF,2CACC,4BAAA,CACA,8BAAA,CACA,gEACC,6BAAA,CACA,8CAAA,CAKF,yDACC,4BAAA,CACA,8BAAA,CACA,8EACC,8BAAA,CAKF,sDACC,+BAAA,CACA,8BAAA,CAEA,2EACC,8BAAA,CAKF,0CACC,qCAAA,CACA,UAAA,CACA,+DACC,2CAAA,CAID,iDACC,qCAAA,CAKF,0CACC,qCAAA,CACA,UAAA,CACA,+DACC,2CAAA,CAID,iDACC,qCAAA,CAKF,wCACC,mCAAA,CACA,UAAA,CACA,6DACC,yCAAA,CAID,+CACC,mCAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n\n\n.button-vue {\n\tposition: relative;\n\twidth: fit-content;\n\toverflow: hidden;\n\tborder: 0;\n\tpadding: 0;\n\tfont-size: var(--default-font-size);\n\tfont-weight: bold;\n\tmin-height: $clickable-area;\n\tmin-width: $clickable-area;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t// Cursor pointer on element and all children\n\tcursor: pointer;\n\t& * {\n\t\tcursor: pointer;\n\t}\n\tborder-radius: math.div($clickable-area, 2);\n\ttransition: background-color 0.1s linear !important;\n\ttransition: border 0.1s linear;\n\n\t// No outline feedback for focus. Handled with a toggled class in js (see data)\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t&:disabled {\n\t\tcursor: default;\n\t\t& * {\n\t\t\tcursor: default;\n\t\t}\n\t\topacity: $opacity_disabled;\n\t\t// Gives a wash out effect\n\t\tfilter: saturate($opacity_normal);\n\t}\n\n\t// Default button type\n\tbackground-color: var(--color-primary-element-lighter);\n\tcolor: var(--color-primary-light-text);\n\t&:hover:not(:disabled) {\n\t\tbackground-color: var(--color-primary-light-hover);\n\t}\n\n\t// Back to the default color for this button when active\n\t// TODO: add ripple effect\n\t&:active {\n\t\tbackground-color: var(--color-primary-element-lighter);\n\t}\n\n\t&__wrapper {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: space-around;\n\t}\n\n\t&__icon {\n\t\theight: $clickable-area;\n\t\twidth: $clickable-area;\n\t\tmin-height: $clickable-area;\n\t\tmin-width: $clickable-area;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&__text {\n\t\tfont-weight: bold;\n\t\tmargin-bottom: 1px;\n\t\tpadding: 2px 0;\n\t}\n\n\t// Icon-only button\n\t&--icon-only {\n\t\twidth: $clickable-area !important;\n\t}\n\n\t// Text-only button\n\t&--text-only {\n\t\tpadding: 0 12px;\n\t\t& .button-vue__text {\n\t\t\tmargin-left: 4px;\n\t\t\tmargin-right: 4px;\n\t\t}\n\t}\n\n\t// Icon and text button\n\t&--icon-and-text {\n\t\tpadding: 0 16px 0 4px;\n\t}\n\n\t// Wide button spans the whole width of the container\n\t&--wide {\n\t\twidth: 100%;\n\t}\n\n\t&:focus-visible {\n\t\toutline: 2px solid var(--color-main-text) !important;\n\t\t&.button-vue--vue-tertiary-on-primary {\n\t\t\toutline: 2px solid var(--color-primary-text);\n\t\t\tborder-radius: var(--border-radius);\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t// Button types\n\n\t// Primary\n\t&--vue-primary {\n\t\tbackground-color: var(--color-primary-element);\n\t\tcolor: var(--color-primary-text);\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-primary-element-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// TODO: add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-primary-element);\n\t\t}\n\t}\n\n\t// Secondary\n\t&--vue-secondary {\n\t\tcolor: var(--color-primary-light-text);\n\t\tbackground-color: var(--color-primary-light);\n\t\t&:hover:not(:disabled) {\n\t\t\tcolor: var(--color-primary-light-text);\n\t\t\tbackground-color: var(--color-primary-light-hover);\n\t\t}\n\t}\n\n\t// Tertiary\n\t&--vue-tertiary {\n\t\tcolor: var(--color-main-text);\n\t\tbackground-color: transparent;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color);\n\t\t\tbackground-color: var(--color-background-hover);\n\t\t}\n\t}\n\n\t// Tertiary, no background\n\t&--vue-tertiary-no-background {\n\t\tcolor: var(--color-main-text);\n\t\tbackground-color: transparent;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t// Tertiary on primary color (like the header)\n\t&--vue-tertiary-on-primary {\n\t\tcolor: var(--color-primary-text);\n\t\tbackground-color: transparent;\n\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t// Success\n\t&--vue-success {\n\t\tbackground-color: var(--color-success);\n\t\tcolor: white;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-success-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// : add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-success);\n\t\t}\n\t}\n\n\t// Warning\n\t&--vue-warning {\n\t\tbackground-color: var(--color-warning);\n\t\tcolor: white;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-warning-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// TODO: add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-warning);\n\t\t}\n\t}\n\n\t// Error\n\t&--vue-error {\n\t\tbackground-color: var(--color-error);\n\t\tcolor: white;\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground-color: var(--color-error-hover);\n\t\t}\n\t\t// Back to the default color for this button when active\n\t\t// TODO: add ripple effect\n\t\t&:active {\n\t\t\tbackground-color: var(--color-error);\n\t\t}\n\t}\n}\n\n","/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n\n// https://uxplanet.org/7-rules-for-mobile-ui-button-design-e9cf2ea54556\n// recommended is 48px\n// 44px is what we choose and have very good visual-to-usability ratio\n$clickable-area: 44px;\n\n// background icon size\n// also used for the scss icon font\n$icon-size: 16px;\n\n// icon padding for a $clickable-area width and a $icon-size icon\n// ( 44px - 16px ) / 2\n$icon-margin: math.div($clickable-area - $icon-size, 2);\n\n// transparency background for icons\n$icon-focus-bg: rgba(127, 127, 127, .25);\n\n// popovermenu arrow width from the triangle center\n$arrow-width: 9px;\n\n// opacities\n$opacity_disabled: .5;\n$opacity_normal: .7;\n$opacity_full: 1;\n\n// menu round background hover feedback\n// good looking on dark AND white bg\n$action-background-hover: rgba(127, 127, 127, .25);\n\n// various structure data used in the \n// `AppNavigation` component\n$header-height: 50px;\n$navigation-width: 300px;\n\n// mobile breakpoint\n$breakpoint-mobile: 1024px;\n\n// top-bar spacing\n$topbar-margin: 4px;\n"],sourceRoot:""}]),n.Z=i;},3645:function(t){t.exports=function(t){var n=[];return n.toString=function(){return this.map((function(n){var e="",o=void 0!==n[5];return n[4]&&(e+="@supports (".concat(n[4],") {")),n[2]&&(e+="@media ".concat(n[2]," {")),o&&(e+="@layer".concat(n[5].length>0?" ".concat(n[5]):""," {")),e+=t(n),o&&(e+="}"),n[2]&&(e+="}"),n[4]&&(e+="}"),e})).join("")},n.i=function(t,e,o,r,a){"string"==typeof t&&(t=[[null,t,void 0]]);var i={};if(o)for(var c=0;c<this.length;c++){var u=this[c][0];null!=u&&(i[u]=!0);}for(var s=0;s<t.length;s++){var l=[].concat(t[s]);o&&i[l[0]]||(void 0!==a&&(void 0===l[5]||(l[1]="@layer".concat(l[5].length>0?" ".concat(l[5]):""," {").concat(l[1],"}")),l[5]=a),e&&(l[2]?(l[1]="@media ".concat(l[2]," {").concat(l[1],"}"),l[2]=e):l[2]=e),r&&(l[4]?(l[1]="@supports (".concat(l[4],") {").concat(l[1],"}"),l[4]=r):l[4]="".concat(r)),n.push(l));}},n};},7537:function(t){t.exports=function(t){var n=t[1],e=t[3];if(!e)return n;if("function"==typeof btoa){var o=btoa(unescape(encodeURIComponent(JSON.stringify(e)))),r="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(o),a="/*# ".concat(r," */"),i=e.sources.map((function(t){return "/*# sourceURL=".concat(e.sourceRoot||"").concat(t," */")}));return [n].concat(i).concat([a]).join("\n")}return [n].join("\n")};},3379:function(t){var n=[];function e(t){for(var e=-1,o=0;o<n.length;o++)if(n[o].identifier===t){e=o;break}return e}function o(t,o){for(var a={},i=[],c=0;c<t.length;c++){var u=t[c],s=o.base?u[0]+o.base:u[0],l=a[s]||0,d="".concat(s," ").concat(l);a[s]=l+1;var A=e(d),v={css:u[1],media:u[2],sourceMap:u[3],supports:u[4],layer:u[5]};if(-1!==A)n[A].references++,n[A].updater(v);else {var f=r(v,o);o.byIndex=c,n.splice(c,0,{identifier:d,updater:f,references:1});}i.push(d);}return i}function r(t,n){var e=n.domAPI(n);return e.update(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap&&n.supports===t.supports&&n.layer===t.layer)return;e.update(t=n);}else e.remove();}}t.exports=function(t,r){var a=o(t=t||[],r=r||{});return function(t){t=t||[];for(var i=0;i<a.length;i++){var c=e(a[i]);n[c].references--;}for(var u=o(t,r),s=0;s<a.length;s++){var l=e(a[s]);0===n[l].references&&(n[l].updater(),n.splice(l,1));}a=u;}};},569:function(t){var n={};t.exports=function(t,e){var o=function(t){if(void 0===n[t]){var e=document.querySelector(t);if(window.HTMLIFrameElement&&e instanceof window.HTMLIFrameElement)try{e=e.contentDocument.head;}catch(t){e=null;}n[t]=e;}return n[t]}(t);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");o.appendChild(e);};},9216:function(t){t.exports=function(t){var n=document.createElement("style");return t.setAttributes(n,t.attributes),t.insert(n,t.options),n};},3565:function(t,n,e){t.exports=function(t){var n=e.nc;n&&t.setAttribute("nonce",n);};},7795:function(t){t.exports=function(t){var n=t.insertStyleElement(t);return {update:function(e){!function(t,n,e){var o="";e.supports&&(o+="@supports (".concat(e.supports,") {")),e.media&&(o+="@media ".concat(e.media," {"));var r=void 0!==e.layer;r&&(o+="@layer".concat(e.layer.length>0?" ".concat(e.layer):""," {")),o+=e.css,r&&(o+="}"),e.media&&(o+="}"),e.supports&&(o+="}");var a=e.sourceMap;a&&"undefined"!=typeof btoa&&(o+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a))))," */")),n.styleTagTransform(o,t,n.options);}(n,t,e);},remove:function(){!function(t){if(null===t.parentNode)return !1;t.parentNode.removeChild(t);}(n);}}};},4589:function(t){t.exports=function(t,n){if(n.styleSheet)n.styleSheet.cssText=t;else {for(;n.firstChild;)n.removeChild(n.firstChild);n.appendChild(document.createTextNode(t));}};},2102:function(){},1900:function(t,n,e){function o(t,n,e,o,r,a,i,c){var u,s="function"==typeof t?t.options:t;if(n&&(s.render=n,s.staticRenderFns=e,s._compiled=!0),o&&(s.functional=!0),a&&(s._scopeId="data-v-"+a),i?(u=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(i);},s._ssrRegister=u):r&&(u=c?function(){r.call(this,(s.functional?this.parent:this).$root.$options.shadowRoot);}:r),u)if(s.functional){s._injectStyles=u;var l=s.render;s.render=function(t,n){return u.call(n),l(t,n)};}else {var d=s.beforeCreate;s.beforeCreate=d?[].concat(d,u):[u];}return {exports:t,options:s}}e.d(n,{Z:function(){return o}});}},n={};function e(o){var r=n[o];if(void 0!==r)return r.exports;var a=n[o]={id:o,exports:{}};return t[o](a,a.exports,e),a.exports}e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,{a:n}),n},e.d=function(t,n){for(var o in n)e.o(n,o)&&!e.o(t,o)&&Object.defineProperty(t,o,{enumerable:!0,get:n[o]});},e.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},e.nc=void 0;var o={};return function(){function t(t,n){var e=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);n&&(o=o.filter((function(n){return Object.getOwnPropertyDescriptor(t,n).enumerable}))),e.push.apply(e,o);}return e}function n(n){for(var e=1;e<arguments.length;e++){var o=null!=arguments[e]?arguments[e]:{};e%2?t(Object(o),!0).forEach((function(t){r(n,t,o[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(n,Object.getOwnPropertyDescriptors(o)):t(Object(o)).forEach((function(t){Object.defineProperty(n,t,Object.getOwnPropertyDescriptor(o,t));}));}return n}function r(t,n,e){return n in t?Object.defineProperty(t,n,{value:e,enumerable:!0,configurable:!0,writable:!0}):t[n]=e,t}e.r(o),e.d(o,{default:function(){return w}});var a={name:"NcButton",props:{disabled:{type:Boolean,default:!1},type:{type:String,validator:function(t){return -1!==["primary","secondary","tertiary","tertiary-no-background","tertiary-on-primary","error","warning","success"].indexOf(t)},default:"secondary"},nativeType:{type:String,validator:function(t){return -1!==["submit","reset","button"].indexOf(t)},default:"button"},wide:{type:Boolean,default:!1},ariaLabel:{type:String,default:null},href:{type:String,default:null},to:{type:[String,Object],default:null},exact:{type:Boolean,default:!1}},data:function(){return {slots:this.$slots}},computed:{rootElement:function(){return this.to?n({is:"router-link",tag:"button",to:this.to,exact:this.exact},this.$attrs):this.href?n({is:"a",href:this.href},this.$attrs):n({is:"button"},this.$attrs)},hasText:function(){var t,n,e;return void 0!==(null===(t=this.slots)||void 0===t?void 0:t.default)&&(null===(n=this.slots)||void 0===n||null===(e=n.default[0])||void 0===e?void 0:e.text)},hasIcon:function(){return void 0!==this.slots.icon},iconOnly:function(){return this.hasIcon&&!this.hasText},textOnly:function(){return !this.hasIcon&&this.hasText},iconAndText:function(){return this.hasIcon&&this.hasText},text:function(){return this.hasText?this.slots.default[0].text.trim():null},buttonClassObject:function(){var t;return r(t={"button-vue--icon-only":this.iconOnly,"button-vue--text-only":this.textOnly,"button-vue--icon-and-text":this.iconAndText},"button-vue--vue-".concat(this.type),this.type),r(t,"button-vue--wide",this.wide),t}},beforeUpdate:function(){this.slots=this.$slots;},mounted:function(){this.text||this.ariaLabel||console.warn("You need to fill either the text or the ariaLabel props in the button component.",{text:this.text,ariaLabel:this.ariaLabel},this);}},i=e(3379),c=e.n(i),u=e(7795),s=e.n(u),l=e(569),d=e.n(l),A=e(3565),v=e.n(A),f=e(9216),p=e.n(f),C=e(4589),b=e.n(C),h=e(7190),g={};g.styleTagTransform=b(),g.setAttributes=v(),g.insert=d().bind(null,"head"),g.domAPI=s(),g.insertStyleElement=p(),c()(h.Z,g),h.Z&&h.Z.locals&&h.Z.locals;var m=e(1900),y=e(2102),x=e.n(y),k=(0, m.Z)(a,(function(){var t=this,n=t._self._c;return n("root-element",t._g(t._b({staticClass:"button-vue",class:t.buttonClassObject,attrs:{"aria-label":t.ariaLabel,type:t.nativeType,disabled:t.disabled}},"root-element",t.rootElement,!1),t.$listeners),[n("span",{staticClass:"button-vue__wrapper"},[t.hasIcon?n("span",{staticClass:"button-vue__icon"},[t._t("icon")],2):t._e(),t._v(" "),t.hasText?n("span",{staticClass:"button-vue__text"},[t._t("default")],2):t._e()])])}),[],!1,null,"7a8f3349",null);"function"==typeof x()&&x()(k);var w=k.exports;}(),o}()}));
	
} (NcButton$1));

var NcButton = /*@__PURE__*/getDefaultExportFromCjs(NcButton$1.exports);

var NcProgressBar$1 = {exports: {}};

(function (module, exports) {
	!function(r,e){module.exports=e();}(self,(function(){return function(){var r={291:function(r,e,t){var n=t(7537),a=t.n(n),o=t(3645),s=t.n(o)()(a());s.push([r.id,".material-design-icon[data-v-3d7aaa3a]{display:flex;align-self:center;justify-self:center;align-items:center;justify-content:center}.progress-bar[data-v-3d7aaa3a]{display:block;width:100%;background:var(--color-background-dark);border:0;padding:0;height:var(--progress-bar-height);border-radius:calc(var(--progress-bar-height)/2)}.progress-bar[data-v-3d7aaa3a]::-webkit-progress-bar{height:var(--progress-bar-height)}.progress-bar[data-v-3d7aaa3a]::-webkit-progress-value{background:linear-gradient(40deg, var(--color-primary-element) 0%, var(--color-primary-element-light) 100%);border-radius:calc(var(--progress-bar-height)/2)}.progress-bar[data-v-3d7aaa3a]::-moz-progress-bar{background:linear-gradient(40deg, var(--color-primary-element) 0%, var(--color-primary-element-light) 100%);border-radius:calc(var(--progress-bar-height)/2)}.progress-bar--error[data-v-3d7aaa3a]::-moz-progress-bar{background:var(--color-error) !important}.progress-bar--error[data-v-3d7aaa3a]::-webkit-progress-value{background:var(--color-error) !important}","",{version:3,sources:["webpack://./src/assets/material-icons.css","webpack://./src/components/NcProgressBar/NcProgressBar.vue"],names:[],mappings:"AAGA,uCACC,YAAA,CACA,iBAAA,CACA,mBAAA,CACA,kBAAA,CACA,sBAAA,CCLD,+BACC,aAAA,CACA,UAAA,CACA,uCAAA,CACA,QAAA,CACA,SAAA,CACA,iCAAA,CACA,gDAAA,CACA,qDACC,iCAAA,CAED,uDACC,2GAAA,CACA,gDAAA,CAED,kDACC,2GAAA,CACA,gDAAA,CAIA,yDACC,wCAAA,CAED,8DACC,wCAAA",sourcesContent:["/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n\tdisplay: flex;\n\talign-self: center;\n\tjustify-self: center;\n\talign-items: center;\n\tjustify-content: center;\n}\n","@use 'sass:math'; $scope_version:\"bb2125f\"; @import 'variables'; @import 'material-icons';\n\n\n.progress-bar {\n\tdisplay: block;\n\twidth: 100%;\n\tbackground: var(--color-background-dark);\n\tborder: 0;\n\tpadding: 0;\n\theight: var(--progress-bar-height);\n\tborder-radius: calc(var(--progress-bar-height) / 2);\n\t&::-webkit-progress-bar {\n\t\theight: var(--progress-bar-height);\n\t}\n\t&::-webkit-progress-value {\n\t\tbackground: linear-gradient(40deg, var(--color-primary-element) 0%, var(--color-primary-element-light) 100%);\n\t\tborder-radius: calc(var(--progress-bar-height) / 2);\n\t}\n\t&::-moz-progress-bar {\n\t\tbackground: linear-gradient(40deg, var(--color-primary-element) 0%, var(--color-primary-element-light) 100%);\n\t\tborder-radius: calc(var(--progress-bar-height) / 2);\n\t}\n\t&--error {\n\t\t// Override previous values\n\t\t&::-moz-progress-bar {\n\t\t\tbackground: var(--color-error) !important;\n\t\t}\n\t\t&::-webkit-progress-value {\n\t\t\tbackground: var(--color-error) !important;\n\t\t}\n\t}\n}\n\n"],sourceRoot:""}]),e.Z=s;},3645:function(r){r.exports=function(r){var e=[];return e.toString=function(){return this.map((function(e){var t="",n=void 0!==e[5];return e[4]&&(t+="@supports (".concat(e[4],") {")),e[2]&&(t+="@media ".concat(e[2]," {")),n&&(t+="@layer".concat(e[5].length>0?" ".concat(e[5]):""," {")),t+=r(e),n&&(t+="}"),e[2]&&(t+="}"),e[4]&&(t+="}"),t})).join("")},e.i=function(r,t,n,a,o){"string"==typeof r&&(r=[[null,r,void 0]]);var s={};if(n)for(var i=0;i<this.length;i++){var c=this[i][0];null!=c&&(s[c]=!0);}for(var u=0;u<r.length;u++){var l=[].concat(r[u]);n&&s[l[0]]||(void 0!==o&&(void 0===l[5]||(l[1]="@layer".concat(l[5].length>0?" ".concat(l[5]):""," {").concat(l[1],"}")),l[5]=o),t&&(l[2]?(l[1]="@media ".concat(l[2]," {").concat(l[1],"}"),l[2]=t):l[2]=t),a&&(l[4]?(l[1]="@supports (".concat(l[4],") {").concat(l[1],"}"),l[4]=a):l[4]="".concat(a)),e.push(l));}},e};},7537:function(r){r.exports=function(r){var e=r[1],t=r[3];if(!t)return e;if("function"==typeof btoa){var n=btoa(unescape(encodeURIComponent(JSON.stringify(t)))),a="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(n),o="/*# ".concat(a," */"),s=t.sources.map((function(r){return "/*# sourceURL=".concat(t.sourceRoot||"").concat(r," */")}));return [e].concat(s).concat([o]).join("\n")}return [e].join("\n")};},3379:function(r){var e=[];function t(r){for(var t=-1,n=0;n<e.length;n++)if(e[n].identifier===r){t=n;break}return t}function n(r,n){for(var o={},s=[],i=0;i<r.length;i++){var c=r[i],u=n.base?c[0]+n.base:c[0],l=o[u]||0,p="".concat(u," ").concat(l);o[u]=l+1;var d=t(p),f={css:c[1],media:c[2],sourceMap:c[3],supports:c[4],layer:c[5]};if(-1!==d)e[d].references++,e[d].updater(f);else {var g=a(f,n);n.byIndex=i,e.splice(i,0,{identifier:p,updater:g,references:1});}s.push(p);}return s}function a(r,e){var t=e.domAPI(e);return t.update(r),function(e){if(e){if(e.css===r.css&&e.media===r.media&&e.sourceMap===r.sourceMap&&e.supports===r.supports&&e.layer===r.layer)return;t.update(r=e);}else t.remove();}}r.exports=function(r,a){var o=n(r=r||[],a=a||{});return function(r){r=r||[];for(var s=0;s<o.length;s++){var i=t(o[s]);e[i].references--;}for(var c=n(r,a),u=0;u<o.length;u++){var l=t(o[u]);0===e[l].references&&(e[l].updater(),e.splice(l,1));}o=c;}};},569:function(r){var e={};r.exports=function(r,t){var n=function(r){if(void 0===e[r]){var t=document.querySelector(r);if(window.HTMLIFrameElement&&t instanceof window.HTMLIFrameElement)try{t=t.contentDocument.head;}catch(r){t=null;}e[r]=t;}return e[r]}(r);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");n.appendChild(t);};},9216:function(r){r.exports=function(r){var e=document.createElement("style");return r.setAttributes(e,r.attributes),r.insert(e,r.options),e};},3565:function(r,e,t){r.exports=function(r){var e=t.nc;e&&r.setAttribute("nonce",e);};},7795:function(r){r.exports=function(r){var e=r.insertStyleElement(r);return {update:function(t){!function(r,e,t){var n="";t.supports&&(n+="@supports (".concat(t.supports,") {")),t.media&&(n+="@media ".concat(t.media," {"));var a=void 0!==t.layer;a&&(n+="@layer".concat(t.layer.length>0?" ".concat(t.layer):""," {")),n+=t.css,a&&(n+="}"),t.media&&(n+="}"),t.supports&&(n+="}");var o=t.sourceMap;o&&"undefined"!=typeof btoa&&(n+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o))))," */")),e.styleTagTransform(n,r,e.options);}(e,r,t);},remove:function(){!function(r){if(null===r.parentNode)return !1;r.parentNode.removeChild(r);}(e);}}};},4589:function(r){r.exports=function(r,e){if(e.styleSheet)e.styleSheet.cssText=r;else {for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r));}};},8070:function(){}},e={};function t(n){var a=e[n];if(void 0!==a)return a.exports;var o=e[n]={id:n,exports:{}};return r[n](o,o.exports,t),o.exports}t.n=function(r){var e=r&&r.__esModule?function(){return r.default}:function(){return r};return t.d(e,{a:e}),e},t.d=function(r,e){for(var n in e)t.o(e,n)&&!t.o(r,n)&&Object.defineProperty(r,n,{enumerable:!0,get:e[n]});},t.o=function(r,e){return Object.prototype.hasOwnProperty.call(r,e)},t.r=function(r){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(r,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(r,"__esModule",{value:!0});},t.nc=void 0;var n={};return function(){t.r(n),t.d(n,{default:function(){return C}});var r={name:"NcProgressBar",props:{value:{type:Number,default:0,validator:function(r){return r>=0&&r<=100}},size:{type:String,default:"small",validator:function(r){return -1!==["small","medium"].indexOf(r)}},error:{type:Boolean,default:!1}},computed:{height:function(){return "small"===this.size?"4px":"6px"}}},e=t(3379),a=t.n(e),o=t(7795),s=t.n(o),i=t(569),c=t.n(i),u=t(3565),l=t.n(u),p=t(9216),d=t.n(p),f=t(4589),g=t.n(f),v=t(291),A={};A.styleTagTransform=g(),A.setAttributes=l(),A.insert=c().bind(null,"head"),A.domAPI=s(),A.insertStyleElement=d(),a()(v.Z,A),v.Z&&v.Z.locals&&v.Z.locals;var m=t(8070),b=t.n(m),h=function(r,e,t,n,a,o,s,i){var c,u="function"==typeof r?r.options:r;if(e&&(u.render=e,u.staticRenderFns=[],u._compiled=!0),u._scopeId="data-v-3d7aaa3a",c);return {exports:r,options:u}}(r,(function(){var r=this;return (0, r._self._c)("progress",{staticClass:"progress-bar vue",class:{"progress-bar--error":r.error},style:{"--progress-bar-height":r.height},attrs:{max:"100"},domProps:{value:r.value}})}));"function"==typeof b()&&b()(h);var C=h.exports;}(),n}()}));
	
} (NcProgressBar$1));

var NcProgressBar = /*@__PURE__*/getDefaultExportFromCjs(NcProgressBar$1.exports);

var Cancel = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"material-design-icon cancel-icon",attrs:{"aria-hidden":!_vm.title,"aria-label":_vm.title,"role":"img"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'span',_vm.$attrs,false),[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22 2 17.5 2 12 6.5 2 12 2M12 4C10.1 4 8.4 4.6 7.1 5.7L18.3 16.9C19.3 15.5 20 13.8 20 12C20 7.6 16.4 4 12 4M16.9 18.3L5.7 7.1C4.6 8.4 4 10.1 4 12C4 16.4 7.6 20 12 20C13.9 20 15.6 19.4 16.9 18.3Z"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])])])},
staticRenderFns: [],
  name: "CancelIcon",
  emits: ['click'],
  props: {
    title: {
      type: String,
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};

var Plus = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"material-design-icon plus-icon",attrs:{"aria-hidden":!_vm.title,"aria-label":_vm.title,"role":"img"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'span',_vm.$attrs,false),[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])])])},
staticRenderFns: [],
  name: "PlusIcon",
  emits: ['click'],
  props: {
    title: {
      type: String,
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};

var Upload = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"material-design-icon upload-icon",attrs:{"aria-hidden":!_vm.title,"aria-label":_vm.title,"role":"img"},on:{"click":function($event){return _vm.$emit('click', $event)}}},'span',_vm.$attrs,false),[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e()])])])},
staticRenderFns: [],
  name: "UploadIcon",
  emits: ['click'],
  props: {
    title: {
      type: String,
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};

var gettextExports = requireGettext();

const gtBuilder = gettextExports.getGettextBuilder()
    .detectLocale();
const translations = process.env.TRANSLATIONS;
translations.forEach(data => gtBuilder.addTranslation(data.locale, data.json));
const gt = gtBuilder.build();
gt.ngettext.bind(gt);
const t = gt.gettext.bind(gt);

var css = "\n.upload-picker__menu-icon {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 44px;\n\theight: 44px;\n\topacity: 1;\n}\n.upload-picker__menu-icon svg {\n\tfill: currentColor;\n\tmax-width: 20px;\n\tmax-height: 20px;\n}\n";
n(css,{});

var ActionIcon = {
	props: {
		svg: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			cleanSvg: '',
		}
	},

	beforeMount() {
		this.sanitizeSVG();
	},

	methods: {
		async sanitizeSVG() {
			if (!this.svg) {
				return
			}
			this.cleanSvg = await sanitizeSVG(this.svg);
		},
	},

	render(createElement) {
		if (!this.cleanSvg) {
			return
		}

		return createElement('span', {
			class: 'upload-picker__menu-icon',
			domProps: {
				innerHTML: this.cleanSvg,
			},
		})
	},
};

/** @type {Uploader} */
const uploadManager = getUploader();

var UploadPicker = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"upload-picker",class:{'upload-picker--uploading': _vm.isUploading, 'upload-picker--paused': _vm.isPaused},attrs:{"data-upload-picker":""}},[(_vm.newFileMenuEntries.length === 0)?_c('NcButton',{attrs:{"disabled":_vm.disabled,"data-upload-picker-add":""},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Plus',{attrs:{"title":"","size":20,"decorative":""}})]},proxy:true}],null,false,2954875042)},[_vm._v("\n\t\t"+_vm._s(_vm.addLabel)+"\n\t")]):_c('NcActions',{attrs:{"menu-title":_vm.addLabel},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Plus',{attrs:{"title":"","size":20,"decorative":""}})]},proxy:true}])},[_vm._v(" "),_c('NcActionButton',{attrs:{"data-upload-picker-add":""},on:{"click":_vm.onClick},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Upload',{attrs:{"title":"","size":20,"decorative":""}})]},proxy:true}])},[_vm._v("\n\t\t\t"+_vm._s(_vm.uploadLabel)+"\n\t\t")]),_vm._v(" "),_vm._l((_vm.newFileMenuEntries),function(entry){return _c('NcActionButton',{key:entry.id,staticClass:"upload-picker__menu-entry",attrs:{"icon":entry.iconClass},on:{"click":entry.handler},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ActionIcon',{attrs:{"svg":entry.iconSvgInline}})]},proxy:true}],null,true)},[_vm._v("\n\t\t\t"+_vm._s(entry.displayName)+"\n\t\t")])})],2),_vm._v(" "),_c('div',{staticClass:"upload-picker__progress"},[_c('NcProgressBar',{attrs:{"error":_vm.hasFailure,"value":_vm.progress,"size":"medium"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.timeLeft))])],1),_vm._v(" "),(_vm.isUploading)?_c('NcButton',{staticClass:"upload-picker__cancel",attrs:{"type":"tertiary","aria-label":_vm.cancelLabel,"data-upload-picker-cancel":""},on:{"click":_vm.onCancel},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Cancel',{attrs:{"title":"","size":20}})]},proxy:true}],null,false,4076886712)}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"input",attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple,"data-upload-picker-input":""},on:{"change":_vm.onPick}})],1)},
staticRenderFns: [],
	name: 'UploadPicker',
	components: {
		NcActionButton,
		ActionIcon,
		NcActions,
		NcButton,
		Cancel,
		Plus,
		NcProgressBar,
		Upload,
	},

	props: {
		accept: {
			type: Array,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		destination: {
			type: String,
			default: null,
		},
		root: {
			type: String,
			default: null,
		},
		context: {
			type: Object,
			default: undefined,
		},
	},

	data() {
		return {
			addLabel: t('Add'),
			cancelLabel: t('Cancel uploads'),
			uploadLabel: t('Upload files'),

			eta: null,
			timeLeft: '',

			newFileMenuEntries: getNewFileMenuEntries(this.context),
			uploadManager,
		}
	},

	computed: {
		totalQueueSize() {
			return this.uploadManager.info?.size || 0
		},
		uploadedQueueSize() {
			return this.uploadManager.info?.progress || 0
		},
		progress() {
			return Math.round(this.uploadedQueueSize / this.totalQueueSize * 100) || 0
		},

		queue() {
			return this.uploadManager.queue
		},

		hasFailure() {
			return this.queue?.filter(upload => upload.status === Status$1.FAILED).length !== 0
		},
		isUploading() {
			return this.queue?.length > 0
		},
		isAssembling() {
			return this.queue?.filter(upload => upload.status === Status$1.ASSEMBLING).length !== 0
		},
		isPaused() {
			return this.uploadManager.info?.status === Status.PAUSED
		},
	},

	watch: {
		/**
		 * If the context change, we need to refresh the menu
		 *
		 * @param {FileInfo} context the current NewFileMenu context
		 */
		context(context) {
			this.setContext(context);
		},

		totalQueueSize(size) {
			this.eta = simpleEta({ min: 0, max: size });
			this.updateStatus();
		},

		uploadedQueueSize(size) {
			this.eta.report(size);
			this.updateStatus();
		},

		destination(destination) {
			this.setDestination(destination);
		},

		root(path) {
			this.setRoot(path);
		},

		queue(queue, oldQueue) {
			if (queue.length < oldQueue.length) {
				this.$emit('uploaded', oldQueue.filter(upload => !queue.includes(upload)));
			}
		},

		hasFailure(hasFailure) {
			if (hasFailure) {
				this.$emit('failed', this.queue);
			}
		},

		isPaused(isPaused) {
			if (isPaused) {
				this.$emit('paused', this.queue);
			} else {
				this.$emit('resumed', this.queue);
			}
		},
	},

	beforeMount() {
		this.setDestination(this.destination);
		this.setRoot(this.root);

		this.setContext(this.context);
		logger.debug('UploadPicker initialised');
	},

	methods: {
		/**
		 * Trigger file picker
		 */
		onClick() {
			this.$refs.input.click();
		},

		/**
		 * Start uploading
		 */
		async onPick() {
			const files = [...this.$refs.input.files];
			files.forEach(file => {
				uploadManager.upload(file.name, file);
			});
			this.$refs.form.reset();
		},

		/**
		 * Cancel ongoing queue
		 */
		onCancel() {
			this.uploadManager.queue.forEach(upload => {
				upload.cancel();
			});
			this.$refs.form.reset();
		},

		updateStatus() {
			if (this.isPaused) {
				this.timeLeft = t('paused');
				return
			}

			const estimate = Math.round(this.eta.estimate());

			if (estimate === Infinity) {
				this.timeLeft = t('estimating time left');
				return
			}
			if (estimate < 10) {
				this.timeLeft = t('a few seconds left');
				return
			}
			if (estimate > 60) {
				const date = new Date(0);
				date.setSeconds(estimate);
				const time = date.toISOString().slice(11, 11 + 8);
				this.timeLeft = t('{time} left', { time }); // TRANSLATORS time has the format 00:00:00
				return
			}
			this.timeLeft = t('{seconds} seconds left', { seconds: estimate });
		},

		setDestination(destination) {
			logger.debug(`Destination path set to ${destination}`);
			this.uploadManager.destination = destination;
		},

		setRoot(path) {
			logger.debug(`Root path set to ${path}`);
			this.uploadManager.root = path;
		},

		setContext(context) {
			logger.debug('Context changed to', context);
			this.newFileMenuEntries = getNewFileMenuEntries(context);
		},
	},
};

var _uploader;
/**
 * Get an Uploader instance
 */
function getUploader() {
    const isPublic = document.querySelector('input[name="isPublic"][value="1"]') !== null;
    if (_uploader instanceof Uploader) {
        return _uploader;
    }
    // Init uploader
    _uploader = new Uploader(isPublic);
    return _uploader;
}
/**
 * Upload a file
 * This will init an Uploader instance if none exists.
 * You will be able to retrieve it with `getUploader`
 */
function upload(destinationPath, file) {
    // Init uploader and start uploading
    const uploader = getUploader();
    uploader.upload(destinationPath, file);
    return uploader;
}

export { Upload$1 as Upload, UploadPicker, Status$1 as UploadStatus, Status as UploaderStatus, getUploader, upload };
//# sourceMappingURL=index.esm.js.map
